/* eslint-disable prettier/prettier */

import { tokens } from '@/locales/tokens/index'
import { articles } from '../../components/CodePreferencesModal/CodePreferencesList'

export const fr = {
  [tokens.common.welcome]: 'Bienvenue',
  [tokens.common.welcomeLogin]: 'Bienvenue sur Nabu',
  [tokens.common.welcomeLoginText]:
    "Nabu est le copilote douane qui vous permet d'accéder, de gérer et d'exécuter efficacement vos formalités et données douanières.",
  [tokens.common.nabuLogo]: 'Logo Nabu',
  [tokens.common.login]: 'Se connecter',
  [tokens.common.clear]: 'Effacer',
  [tokens.common.createdAt]: 'Créé',
  [tokens.common.created]: 'Créé',
  [tokens.common.updatedAt]: 'Dernière mise à jour',
  [tokens.common.clientOrganization]: 'Organisation client',
  [tokens.common.selectUser]: 'Choisir un utilisateur',
  [tokens.common.theActionWasSuccessful]: "L'action a réussi",
  [tokens.common.theActionWasSuccessful]: "L'action a réussi",
  [tokens.common.notes]: 'Notes',
  [tokens.common.loginError]:
    "Oups, il semble que l'email ou le mot de passe que vous avez saisi soit incorrect. Veuillez revérifier et réessayer.",
  [tokens.common.unknownError]: 'Erreur inconnue',
  [tokens.common.emailSendError]:
    "Oups, il semble que l'envoi d'email n'a pas fonctionné. Veuillez recommencer.",
  [tokens.common.returnToLoginPage]: 'Retourner à la page de connexion',
  [tokens.common.logout]: 'Se déconnecter',
  [tokens.common.impersonatingAs]: 'Connecté en tant que <bold>{{name}}</bold>',
  [tokens.common.stopImpersonation]: 'Terminer',
  [tokens.common.impersonationTimeLeft]: 'encore {{minutes}} min',
  [tokens.common.impersonationExpired]: 'La session « en tant que » a expiré.',
  [tokens.common.impersonationClosed]: 'La session « en tant que » a été fermée.',
  [tokens.common.impersonationOpening]: 'Ouverture de la session…',
  [tokens.common.impersonationLinkInvalid]:
    'Ce lien a expiré ou a déjà servi. Relancez « Se connecter en tant que » depuis la console.',
  [tokens.common.unknownUser]: 'Utilisateur inconnu',
  [tokens.common.noItemFound]: 'Aucun objet trouvé',
  [tokens.common.noAccount]: "Vous n'avez pas de compte ?",
  [tokens.common.needAccountHelp]:
    'Si vous avez des difficultés à vous connecter, ou si vous voulez créer un nouveau compte :',
  [tokens.common.questionForgotPassword]: 'Mot de passe oublié ?',
  [tokens.common.forgotPassword]: 'Mot de passe oublié',
  [tokens.common.selectAGroup]: 'Choisir une agence',
  [tokens.common.selectAConfiguration]: 'Choisir une configuration',
  [tokens.common.passwordConfirmation]: 'Confirmer le mot de passe',
  [tokens.common.forgotPasswordText]:
    "Entrez l'adresse e-mail associée à votre compte",
  [tokens.common.anErrorOccurred]: 'Une erreur est survenue',
  [tokens.common.enterNewPassword]: 'Configurer un nouveau mot de passe',
  [tokens.common.emailSent]: 'Un email vous a été envoyé',
  [tokens.common.passwordResetEmailConfirmTitle]:
    'E-mail de réinitialisation envoyé',
  [tokens.common.passwordResetEmailConfirmDescription]:
    'Si un compte est associé à cette adresse, vous recevrez un e-mail contenant un lien pour réinitialiser votre mot de passe. Pensez à vérifier vos courriers indésirables.',
  [tokens.common.passwordChangedSuccessTitle]: 'Mot de passe réinitialisé',
  [tokens.common.passwordChangedSuccessDescription]:
    'Vous pouvez vous connecter avec votre nouveau mot de passe.',
  [tokens.common.recoveryLinkInvalidTitle]: "Ce lien n'est plus valide",
  [tokens.common.recoveryLinkInvalidDescription]:
    "Il a expiré, a déjà servi, ou un e-mail plus récent l'a remplacé : seul le dernier lien reçu fonctionne.",
  [tokens.common.requestNewLink]: 'Recevoir un nouveau lien',
  [tokens.common.exportTypeRequired]: 'Le type de déclaration est requis',
  [tokens.common.exportTypeUnknown]: 'Type de déclaration inconnu',
  [tokens.common.contactUs]: 'Contactez-nous',
  [tokens.common.confirm]: 'Confirmer',
  [tokens.common.currentOwner]: 'Référent actuel',
  [tokens.common.currentGroup]: 'Agence actuelle',
  [tokens.common.validate]: 'Valider',
  [tokens.common.delete]: 'Supprimer',
  [tokens.common.noOptions]: 'Aucune option',
  [tokens.common.cancel]: 'Annuler',
  [tokens.common.errorRenameModelName]:
    "Le nom du modèle n'a pas pu être renommé",
  [tokens.common.next]: 'Suivant',
  [tokens.common.continue]: 'Continuer',
  [tokens.common.back]: 'Retour',
  [tokens.common.close]: 'Fermer',
  [tokens.common.create]: 'Créer',
  [tokens.common.upload]: 'Upload',
  [tokens.common.sentDocuments]: 'Dossiers envoyés',
  [tokens.common.sentFolders]: 'Dossiers envoyés',
  [tokens.common.tableConsolidated]: 'Tableau consolidé',
  [tokens.common.tableNotConsolidated]: 'Tableau non consolidé',
  [tokens.common.numberofLinesSent]: 'Nombre total de lignes envoyées :',
  [tokens.common.send]: 'Envoyer',
  [tokens.common.add]: 'Ajouter',
  [tokens.common.languageChanged]: 'Langue modifiée',
  [tokens.common.manager]: 'Manager',
  [tokens.common.guest]: 'Invité',
  [tokens.common.admin]: 'Administrateur',
  [tokens.common.user]: 'Utilisateur',
  [tokens.common.superadmin]: 'Staff Nabu',
  [tokens.common.mail]: 'Adresse email',
  [tokens.common.email]: 'Email',
  [tokens.common.role]: 'Rôle',
  [tokens.common.date]: 'Date',
  [tokens.common.name]: 'Nom',
  [tokens.common.member]: 'Membre',
  [tokens.common.members]: 'Membres',
  [tokens.common.administrator]: 'Administrateur',
  [tokens.common.administrators]: 'Administrateurs',
  [tokens.common.sendInvite]: 'Envoyer une invitation',
  [tokens.common.inviteMember]: 'Inviter un membre',
  [tokens.common.inviteMembers]: 'Inviter des membres',
  [tokens.common.inviteAdministrator]: 'Inviter un administrateur',
  [tokens.common.inviteAdministrators]: 'Inviter des administrateurs',
  [tokens.common.atLeastOneInvitedPeople]: 'Inviter au moins une personne',
  [tokens.common.maxOneInvitedPeople]: 'Inviter maximum un admin',
  [tokens.common.inviteSomeAdministrators]: 'Inviter un administrateur',
  [tokens.common.sendInvitation]: 'Envoyer une invitation',
  [tokens.common.deleteInvitation]: "Supprimer l'invitation",
  [tokens.common.socialName]: 'Raison sociale',
  [tokens.common.registrationNumber]: 'Numéro de Siret',
  [tokens.common.country]: 'Pays',
  [tokens.common.organization]: 'Organisation',
  [tokens.common.organizationAndEstablishments]: 'Organisation & Etablissement',
  [tokens.common.somethingWentWrong]: "Quelque chose n'a pas fonctionné...",
  [tokens.common.general]: 'Général',
  [tokens.common.lastName]: 'Nom',
  [tokens.common.firstName]: 'Prénom',
  [tokens.common.function]: 'Fonction',
  [tokens.common.preferences]: 'Préférences',
  [tokens.common.password]: 'Mot de passe',
  [tokens.common.position]: 'Fonction',
  [tokens.common.language]: 'Langue',
  [tokens.common.help]: 'Aide',
  [tokens.common.helpAndSupport]: 'Aide & support',
  [tokens.common.supportChat]: 'Discuter avec le support',
  [tokens.common.supportChatUnread]: 'Messages non lus : {{count}}',
  [tokens.common.supportChatMoveHint]: 'glisser ou flèches pour déplacer',
  [tokens.common.active]: 'Actif',
  [tokens.common.group]: 'Agence',
  [tokens.common.groups]: 'Agences',
  [tokens.common.groupSettings]: 'Configuration agence',
  [tokens.common.selectGroup]: 'Sélectionner une agence',
  [tokens.common.userSettings]: 'Configuration utilisateur',
  [tokens.common.collaborators]: 'Collaborateurs',
  [tokens.common.update]: 'Modifier',
  [tokens.common.actions]: 'Actions',
  [tokens.common.parameters]: 'Paramètres',
  [tokens.common.external]: 'Extérieur',
  [tokens.common.validEmail]: 'Doit être un email valide',
  [tokens.common.required]: 'nécessaire',
  [tokens.common.emailRequired]: "L'email est obligatoire",
  [tokens.common.passwordRequired]: 'Mot de passe obligatoire',
  [tokens.common.matchPasswordsRequired]:
    'Les mots de passe doivent correspondre',
  [tokens.common.passwordRuleLowercase]: 'Au moins une lettre minuscule',
  [tokens.common.passwordRuleUppercase]: 'Au moins une lettre majuscule',
  [tokens.common.passwordRuleDigit]: 'Au moins un chiffre',
  [tokens.common.passwordRuleSpecial]:
    'Au moins un caractère spécial (@, $, !, %, *, ?, &)',
  [tokens.common.passwordRuleLength]: 'Entre 8 et 16 caractères',
  [tokens.common.passwordConfirmationRequired]:
    'Confirmez votre nouveau mot de passe',
  [tokens.common.oldPasswordRequired]: "L'ancien mot de passe est requis",
  [tokens.common.newPasswordRequired]: 'Un nouveau mot de passe est requis',
  [tokens.common.warningRulesForNewPassword]:
    'Le mot de passe doit contenir au moins une lettre minuscule, une lettre majuscule, un chiffre, un caractère spécial (@, $, !, %, *, ?, &) et être entre 8 et 16 caractères.',
  [tokens.common.firstNameRequired]: 'Le prénom est requis',
  [tokens.common.lastNameRequired]: 'Le nom de famille est requis',
  [tokens.common.roleRequired]: 'Le rôle est requis',
  [tokens.common.languageRequired]: 'La langue est requise',
  [tokens.common.organizationRequired]: "L'organisation est requise",
  [tokens.common.groupRequired]: "L'agence est requise",
  [tokens.common.socialNameRequired]: 'Le nom social est requis',
  [tokens.common.registrationNumberRequired]:
    "Le numéro d'enregistrement est requis",
  [tokens.common.countryRequired]: 'Le pays est requis',
  [tokens.common.affiliatedGroup]: 'Sélectionner les agences à affilier',
  [tokens.common.share]: 'Partager',
  [tokens.common.registeredCustomsRepresentative]:
    'Représentant des Douanes Enregistré',
  [tokens.common.customsManager]: 'Responsable des Douanes',
  [tokens.common.customsTeamManager]: "Responsable de l'équipe des Douanes",
  [tokens.common.informationSystemsManager]:
    "Responsable des Systèmes d'Information",
  [tokens.common.nabuAdministrator]: 'Administrateur de Nabu',
  [tokens.common.french]: 'Français',
  [tokens.common.english]: 'Anglais',
  [tokens.common.german]: 'Allemand',
  [tokens.common.administrator]: 'Administrateur',
  [tokens.common.basicInformation]: 'Informations de base',
  [tokens.common.personalInformation]: 'Information personelle',
  [tokens.common.companyInformation]: 'Informations de l‘entreprise',
  [tokens.common.organizationAndGroups]: 'Organisation et Agences',
  [tokens.common.establishmentsAndGroups]: 'Établissements & agences',
  [tokens.common.settings]: 'Paramètres',
  [tokens.common.save]: 'Enregistrer',
  [tokens.common.saving]: 'Enregistrement…',
  [tokens.common.saved]: 'Enregistré',
  [tokens.common.generalInformation]: 'Informations Générales',
  [tokens.common.offices]: 'Etablissements',
  [tokens.common.edit]: 'Editer',
  [tokens.common.accessInformations]: 'Accéder aux informations',
  [tokens.common.changePassword]: 'Changement de mot de passe',
  [tokens.common.oldPassword]: 'Ancien mot de passe',
  [tokens.common.newPassword]: 'Nouveau mot de passe',
  [tokens.common.passwordChangeSuccess]: 'Changement de mot de passe réussi',
  [tokens.common.passwordChangeError]:
    "Une erreur s'est produite lors du changement de votre mot de passe.",
  [tokens.common.fileName]: 'Nom de dossier',
  [tokens.common.step]: 'Etape',
  [tokens.common.none]: 'aucun',
  [tokens.common.deleteAccount]: 'Supprimer le compte',
  [tokens.common.deleteAccountWarning]:
    'La suppression de votre compte et de toutes vos données est irréversible.',
  [tokens.common.name]: 'Nom',
  [tokens.common.client]: 'Client',
  [tokens.common.date]: 'Date',
  [tokens.common.status]: 'Statut',
  [tokens.common.actions]: 'Actions',
  [tokens.common.option10]: '10',
  [tokens.common.option20]: '20',
  [tokens.common.option50]: '50',
  [tokens.common.smartPreparationAnnouncement]:
    'La <bold>préparation intelligente</bold> arrive sur Nabu : moins de saisie manuelle, plus de temps pour l’essentiel.',
  [tokens.common.smartPreparationBadge]: 'Nouveau',
  [tokens.common.smartPreparationTry]: 'Essayer',
  [tokens.common.smartPreparationLearnMore]: 'En savoir plus',
  [tokens.common.search]: 'Chercher',
  [tokens.common.yes]: 'Oui',
  [tokens.common.searchByCaseName]: 'Rechercher par nom de dossier',
  [tokens.common.all]: 'Tous',
  [tokens.common.pending]: 'Demandes',
  [tokens.common.from]: 'Du',
  [tokens.common.to]: 'À',
  [tokens.common.import]: 'Import',
  [tokens.common.export]: 'Export',
  [tokens.common.transit]: 'Transit',
  [tokens.common.view]: 'Vue',
  [tokens.common.folder]: 'Dossier',
  [tokens.common.customDeclaration]: 'Déclaration Douanière',
  [tokens.common.billOfLading]: 'Bill of Lading',
  [tokens.common.exported]: 'Exporter',
  [tokens.common.toTreat]: 'A traiter',
  [tokens.common.archived]: 'Supprimé',
  [tokens.common.inProgress]: 'En cours',
  [tokens.common.classification]: 'Classification',
  [tokens.common.category]: 'Catégorie',
  [tokens.common.searchByName]: 'Rechercher un dossier',
  [tokens.common.layerName]: 'Nom du modèle',
  [tokens.common.modelName]: 'Modèle client',
  [tokens.common.modelSearchPlaceholder]: 'Rechercher un modèle',
  [tokens.common.modelTabName]: 'Nom du modèle',
  [tokens.common.modelTabType]: 'Type de modèle',
  [tokens.common.declarationType]: 'Type Décl.',
  [tokens.common.flowTabExporter]: 'Expéditeur',
  [tokens.common.flowTabCreatedBy]: 'Crée par',
  [tokens.common.flowTabDate]: 'Date de création',
  [tokens.common.modelDeleteOneTitle]: "Suppression d'un modèle",
  [tokens.common.modelDeleteOneText]:
    'Êtes-vous sûr de vouloir supprimer ce modèle ?',
  [tokens.common.modelDeleteMultipleTitle]: 'Suppression de plusieurs modèles',
  [tokens.common.modelDeleteMultipleText]:
    'Êtes-vous sûr de vouloir supprimer ces modèles ?',
  [tokens.common.modelHasBeenDeleted]: 'Le modèle a été supprimé',
  [tokens.common.modelHasNotBeenDeleted]: "Le modèle n'a pas été supprimé",
  [tokens.common.modelShareToOtherGroup]:
    'Partager le modèle avec une autre agence',
  [tokens.common.modelShareToOtherGroupText]:
    "Ajouter ce modèle aux modèles visibles par d'autres agences dans votre organisation.",
  [tokens.common.teamName]: "Nom de l'équipe",
  [tokens.common.office]: 'Etablissement',
  [tokens.common.declaration]: 'Déclaration',
  [tokens.common.loggedIn]:
    'Bienvenue à nouveau ! Vous vous êtes connecté avec succès.',
  [tokens.common.permissionError]:
    "Désolé, vous n'avez pas la permission d'accéder à cette page.",
  [tokens.common.permissionAndAccess]: 'Permission/Accès',
  [tokens.common.fieldNotFound]: 'Champ non trouvé',
  [tokens.common.failToSave]: "Echec d'enregistrement",
  [tokens.common.team]: 'Equipe',
  [tokens.common.profil]: 'Profil',
  [tokens.common.security]: 'Sécurité',
  [tokens.common.metrics]: 'Suivi de performance',
  [tokens.common.copiedToClipBoard]: 'Copié dans le presse-papiers',
  [tokens.common.mailHook]: 'Mail Hook',
  [tokens.common.regenerateMailHook]: 'Regénérer le mail hook',
  [tokens.common.mailHookDescription]:
    'Adresse e-mail Nabu connectée à la boîte de réception de dossier de votre équipe',
  [tokens.common.copy]: 'copier',
  [tokens.common.holdToConfirmNudge]: 'Maintenez appuyé',
  [tokens.common.holdToConfirmHint]:
    'Maintenez le bouton, ou la touche Espace ou Entrée, environ une seconde pour confirmer.',
  [tokens.common.confirmed]: 'Confirmé',
  [tokens.common.copied]: 'Copié',
  [tokens.common.copyFailed]: 'Échec',
  [tokens.common.selectAction]: 'Choisir une action',
  [tokens.common.setup]: 'Configuration',
  [tokens.common.setups]: 'Configurations',
  [tokens.common.addSetup]: 'Ajouter une configuration',
  [tokens.common.noSetup]: 'Aucune configuration disponible',
  [tokens.common.noSetupGroup]:
    'Aucune configuration disponible pour cette agence',
  [tokens.common.editSetup]: 'Editer une configuration',
  [tokens.common.createSetup]: 'Créer une configuration',
  [tokens.common.download]: 'Télécharger',
  [tokens.common.file]: 'Fichier',
  [tokens.common.files]: 'Fichiers',
  [tokens.common.regularCustomer]: 'Client régulier',
  [tokens.common.punctualCustomer]: 'Client ponctuel',
  [tokens.common.creationOfNewFolder]: "Création d'un nouveau dossier",
  [tokens.common.folderCreationInProgress]: 'Dossier en cours de création',
  [tokens.common.emailFrom]: 'Expéditeur',
  [tokens.common.workInProgress]: 'Dossier en cours',
  [tokens.common.document]: 'Document',
  [tokens.common.model]: 'Modèle',
  [tokens.common.models]: 'Modèles',
  [tokens.common.information]: 'Informations',
  [tokens.common.exportConfiguration]: 'Configuration',
  [tokens.common.userSettings]: "Paramètres d'utilisateur",
  [tokens.common.confirmationRequired]: 'Confirmation requise',
  [tokens.common.rowsPerPage]: 'Lignes par page',
  [tokens.common.displayedRows]: '{{from}}-{{to}} sur {{count}}',
  [tokens.common.details]: 'Détails',
  [tokens.common.backToHome]: "Retour à la page d'accueil",
  [tokens.common.message401]: '401 : Authorisation requis',
  [tokens.common.message404]: '404 : Page non trouvée',
  [tokens.common.message500]: '500 : Erreur serveur',
  [tokens.common.titleErrorPage]: 'Erreur inconnue',
  [tokens.common.messageErrorPage]:
    "Il semble qu'une erreur inattendue s'est produite, veuillez réessayer.",
  [tokens.common.key]: 'Champ',
  [tokens.common.configurations]: 'Configurations',
  [tokens.common.configuration]: 'Configuration',
  [tokens.common.userSettingsNoParameter]: 'Aucun paramètre disponible',
  [tokens.common.commonError]: "Une erreur s'est produite",
  [tokens.common.author]: 'Auteur',
  [tokens.common.noFiles]: 'Aucun fichier disponible',
  [tokens.common.notification]: 'Notification',
  [tokens.common.createdBy]: 'Créé par',
  [tokens.common.sendBy]: 'Envoyé par',
  [tokens.common.updateSucceeded]: 'Mise à jour réussie',
  [tokens.common.updateFailed]: 'Mise à jour échouée',
  [tokens.common.filesDropInputWrongFormat]:
    'Type de fichier non pris en charge !',
  [tokens.common.hintMessageFirstText]: 'Utilisez',
  [tokens.common.hintMessageSecondText]: 'Espace',
  [tokens.common.hintMessageThirdText]: 'pour ajouter un mot-clé,',
  [tokens.common.hintMessageFourthText]: 'pour rechercher une phrase exacte.',
  [tokens.common.thisActionCannotBeUndone]: 'Cette action est irréversible',
  [tokens.common.remove]: 'Supprimer',
  [tokens.common.unknown]: 'Inconnu',
  [tokens.common.updateDeclarationOwner]: 'Changer le référent',
  [tokens.common.changeOwnerForCurrentDeclaration]:
    'Changer le référent pour cette déclaration',
  [tokens.common.declarationOwner]: 'Référent de la déclaration',
  [tokens.common.deselect]: 'Désélectionner',
  [tokens.common.expandAll]: 'Tout déplier',
  [tokens.common.collapseAll]: 'Tout replier',
  [tokens.common.validated]: 'Validé',
  [tokens.common.week]: 'Semaine',
  [tokens.common.month]: 'Mois',
  [tokens.common.seeDetails]: 'Voir les détails',
  [tokens.common.hideDetails]: 'Masquer les détails',
  [tokens.common.start]: 'Début',
  [tokens.common.end]: 'Fin',
  [tokens.common.clearAll]: 'Tout effacer',
  [tokens.common.noCustomersSelected]: 'Aucun client sélectionné',
  [tokens.common.articles]: 'Articles',
  [tokens.common.commodityCodesFilled]: 'NDP renseignées',
  [tokens.common.dossierDrawerPosition]: 'Dossier {{index}} sur {{total}}',
  [tokens.common.dossierDrawerPrevious]: 'Dossier précédent',
  [tokens.common.dossierDrawerNext]: 'Dossier suivant',
  [tokens.common.dossierDrawerCopyReference]: 'Copier la référence',
  [tokens.common.dossierDrawerOverview]: 'Aperçu',
  [tokens.common.dossierDrawerActivity]: 'Activité',
  [tokens.common.dossierDrawerPreparation]: 'Préparation',
  [tokens.common.dossierDrawerStepReceived]: 'Reçu',
  [tokens.common.dossierDrawerStepPrefilled]: 'Pré-rempli',
  [tokens.common.dossierDrawerStepToTreat]: 'À traiter',
  [tokens.common.dossierDrawerStepCompleted]: 'Complété',
  [tokens.common.dossierDrawerParties]: 'Parties',
  [tokens.common.dossierDrawerDetails]: 'Détails',
  [tokens.common.dossierDrawerComplete]: 'Complet',
  [tokens.common.dossierDrawerAddTag]: 'Ajouter un tag',
  [tokens.common.dossierDrawerNoFiles]: 'Aucun fichier',
  [tokens.common.dossierDrawerNoActivity]: 'Aucune activité',
  [tokens.common.inlineEditSaveFailed]: 'Impossible d\'enregistrer « {{value}} », la valeur précédente est revenue.',
  [tokens.common.inlineEditRetry]: 'Réessayer',
  [tokens.common.inlineEditCancel]: 'Annuler la modification',
  [tokens.common.inlineEditHintDisplay]: 'Activer pour modifier.',
  [tokens.common.inlineEditHintEdit]: 'Entrée enregistre, Échap annule.',
  [tokens.common.inlineEditHintEditMultiline]: 'Entrée enregistre, Maj+Entrée va à la ligne, Échap annule.',
  [tokens.common.inlineEditSaving]: '{{label}} : enregistrement…',
  [tokens.common.inlineEditSaved]: '{{label}} : enregistré',
  [tokens.common.dossierDrawerNameLabel]: 'Nom du dossier',
  [tokens.common.dossierNameRequired]: 'Le nom ne peut pas être vide',
  [tokens.common.mode]: 'Mode',
  [tokens.common.delivered]: 'Livré',
  [tokens.common.lastModified]: 'Dernière modification',
  [tokens.common.lastModifiedAt]: 'Dernière modification',
  [tokens.common.tags]: 'Tags',
  [tokens.common.type]: 'Type',
  [tokens.common.downloadArchive]: "Télécharger l'archive",
  [tokens.common.downloadValueDetail]: 'Télécharger le détail de valeur',
  [tokens.common.viewDetail]: 'Accéder au dossier',
  [tokens.common.show]: 'Afficher',
  [tokens.common.hide]: 'Masquer',
  [tokens.common.noteSucccessfullySaved]: 'Note enregistrée avec succès',
  [tokens.common.errorOccuredWhileSavingNote]:
    "Une erreur s'est produite lors de l'enregistrement de la note",
  [tokens.common.offline]:
    'Votre connexion au réseau semble interrompue. Veuillez vérifier votre accès Internet et réessayer.',
  [tokens.common.online]: 'Votre connexion est rétablie.',
  [tokens.common.maintenanceTitle]: 'Maintenance programmée',
  [tokens.common.maintenanceUntil]: "Nabu est en maintenance jusqu'au {{date}} à {{time}}.",
  [tokens.common.maintenanceNoEnd]: 'Nabu est momentanément indisponible pour maintenance.',
  [tokens.common.maintenanceSessionKept]:
    'Votre session est conservée. Inutile de recharger la page : Nabu se rouvrira de lui-même dès la fin de la maintenance.',
  [tokens.common.newVersionAvailableMessage]:
    'Une nouvelle version est disponible. Rafraîchissez la page pour en bénéficier.',
  [tokens.common.refreshPageForNewVersion]: 'Rafraîchir',
  [tokens.common.noTags]: 'Aucun tags',
  [tokens.common.declarant]: 'Déclarant',
  [tokens.common.editComment]: 'Editer le commentaire',
  [tokens.common.deleteComment]: 'Supprimer le commentaire',
  [tokens.common.addAComment]: 'Ajouter un commentaire',
  [tokens.common.areYouSureYouWantToDeleteThisComment]:
    'Etes-vous sûr de vouloir supprimer ce commentaire ?',
  [tokens.common.urgent]: 'Urgent',
  [tokens.common.sendUrgent]: 'Envoyer urgent',
  [tokens.common.putFileErrorStatus]: 'Mettre le dossier en état d’erreur',
  [tokens.common.subscribers]: 'Abonnés',
  [tokens.common.typeAnEmailAndPressEnter]:
    'Tapez un email et appuyez sur Entrée',
  [tokens.common.autoMode]: 'Automatique (système)',
  [tokens.common.darkMode]: 'Mode sombre',
  [tokens.common.lightMode]: 'Mode clair',
  [tokens.common.theme]: 'Thème',

  [tokens.events.declarationReceivedBy]:
    'Réception de la demande par {{source}}',
  [tokens.events.creationAndExtractionOfDeclaration]:
    'Création et pré-remplissage du dossier {{reference}}',
  [tokens.events.missingDataIdentified]: 'Données manquantes identifiées',
  [tokens.events.missingDataAddedFromDataLibrary]:
    'Données enrichies par le Data Library',
  [tokens.events.informationRequested]: 'Données demandées',
  [tokens.events.informationReceived]: 'Données renseignées',
  [tokens.events.declarationValidationsCompleted]:
    'Contrôles de la déclaration validés',
  [tokens.events.declarationFinalized]: 'Dossier {{reference}} finalisé',
  [tokens.events.declarationFinalizedBy]:
    'Dossier {{reference}} finalisé par {{accountName}}',
  [tokens.events.declarationSent]:
    'Envoi de la déclaration {{reference}} vers {{clientDestinationName}}',
  [tokens.events.processingStopped]: 'Traitement arrêté',

  [tokens.batchImportHistory.historyDrawerTitle]:
    'Historique de la déclaration',
  [tokens.batchImportHistory.historyOpenTooltip]:
    "Voir l'historique de la déclaration",
  [tokens.batchImportHistory.historySearchPlaceholder]:
    "Rechercher dans l'historique…",
  [tokens.batchImportHistory.historySearchEmpty]:
    'Aucun résultat pour cette recherche',
  [tokens.batchImportHistory.historyEmpty]: 'Aucune entrée dans l’historique',
  [tokens.batchImportHistory.historyLoadError]:
    "Impossible de charger l'historique",
  [tokens.batchImportHistory.historyRetry]: 'Réessayer',
  [tokens.batchImportHistory.historyExpand]: 'Afficher le détail',
  [tokens.batchImportHistory.historyCollapse]: 'Masquer le détail',
  [tokens.batchImportHistory.historyActorSystem]: 'Système',
  [tokens.batchImportHistory.historyActorUnknownUser]: 'Utilisateur',
  [tokens.batchImportHistory.historyFieldsCount]: '{{count}} champ',
  [tokens.batchImportHistory.historyFieldsCount_other]: '{{count}} champs',
  [tokens.batchImportHistory.historyReplacedFields]: 'Champs remplacés',
  [tokens.batchImportHistory.historyEmptyValue]: 'vide',
  [tokens.batchImportHistory.historyRowSuffix]: ' (ligne {{row}})',
  [tokens.batchImportHistory.historyActionDeclarationModified]:
    'Modification de la déclaration',
  [tokens.batchImportHistory.historyActionDeclarationCreated]:
    'Déclaration créée',
  [tokens.batchImportHistory.historyActionDeclarationSent]:
    'Déclaration envoyée',
  [tokens.batchImportHistory.historyActionAutomationRun]:
    'Automatisation du tableau lancée',
  [tokens.batchImportHistory.historyActionExtractionRerun]:
    'Extraction relancée',
  [tokens.batchImportHistory.historyActionClassificationRerun]:
    'Classification refaite',
  [tokens.batchImportHistory.historyActionMerge]: 'Fusion effectuée',
  [tokens.batchImportHistory.historyActionMergeColumnsTitle]:
    'Colonnes fusionnées',
  [tokens.batchImportHistory.historyActionMergeBatchImportsTitle]:
    'Dossiers fusionnés',
  [tokens.batchImportHistory.historyActionMarkedError]: 'Dossier mis en erreur',
  [tokens.batchImportHistory.historyActionTagAdded]: 'Tag ajouté',
  [tokens.batchImportHistory.historyActionClientChanged]: 'Client modifié',
  [tokens.batchImportHistory.historyActionRowDeleted]:
    "Ligne d'articles supprimée",
  [tokens.batchImportHistory.historyActionFileAdded]: 'Fichier ajouté',
  [tokens.batchImportHistory.historyFilesCount]: '{{count}} fichier',
  [tokens.batchImportHistory.historyFilesCount_other]: '{{count}} fichiers',
  [tokens.batchImportHistory.historyDeletedRowValues]: 'Contenu de la ligne',
  [tokens.batchImportHistory.historyRowLabel]: 'ligne {{row}}',
  [tokens.batchImportHistory.historyDocumentsCount]: '{{count}} document',
  [tokens.batchImportHistory.historyDocumentsCount_other]:
    '{{count}} documents',
  [tokens.batchImportHistory.historyMergeColumns]:
    '{{count}} colonne fusionnée',
  [tokens.batchImportHistory.historyMergeColumns_other]:
    '{{count}} colonnes fusionnées',
  [tokens.batchImportHistory.historyMergeBatchImports]:
    '{{count}} dossier fusionné',
  [tokens.batchImportHistory.historyMergeBatchImports_other]:
    '{{count}} dossiers fusionnés',
  [tokens.batchImportHistory.historyMarkedErrorManual]:
    'Marqué en erreur manuellement',
  [tokens.batchImportHistory.historyMarkedErrorUploadFailed]:
    'Échec de l’envoi des documents',
  [tokens.batchImportHistory.historyMarkedErrorMissingSuffix]: 'manquant',
  [tokens.batchImportHistory.historyFilterAll]: 'Tout',
  [tokens.batchImportHistory.historyFilterCorrections]: 'Corrections',
  [tokens.batchImportHistory.historyUndoCorrection]:
    'Annuler cette correction',
  [tokens.batchImportHistory.historyRedoCorrection]: 'Rétablir',
  [tokens.batchImportHistory.historyRevertedAt]: 'annulée à {{time}}',
  [tokens.batchImportHistory.historyCorrectionSet]: 'Valeur corrigée',
  [tokens.batchImportHistory.historyCorrectionClear]: 'Valeur effacée',
  [tokens.batchImportHistory.historyCorrectionValidate]:
    'Déclaration validée',
  [tokens.batchImportHistory.historyCorrectionReviewConfirmed]:
    'Vérification confirmée',
  [tokens.batchImportHistory.historyCorrectionReviewReopened]: 'Point rouvert',
  [tokens.batchImportHistory.historyCorrectionAddTuple]: 'Occurrence ajoutée',
  [tokens.batchImportHistory.historyCorrectionRemoveTuple]:
    'Occurrence retirée',
  [tokens.batchImportHistory.historyCorrectionClearColumn]: 'Colonne vidée',
  [tokens.batchImportHistory.historyCorrectionSetColumn]: 'Colonne remplie',
  [tokens.batchImportHistory.historyCorrectionAddLine]: 'Article ajouté',
  [tokens.batchImportHistory.historyCorrectionRemoveLine]: 'Article retiré',
  [tokens.batchImportHistory.historyCorrectionUnvalidate]: 'Révision ouverte',
  [tokens.batchImportHistory.historyCorrectionAbandonRevision]:
    'Révision abandonnée : retour à la version envoyée',

  [tokens.configuration.configurationNameWarning]:
    'Le nom de la configuration est requis',
  [tokens.configuration.addAField]: 'Ajouter un champ',
  [tokens.configuration.typeTransportWarning]: "Le type d'export est requis",
  [tokens.configuration.nameTransportWarning]: 'Le nom du logiciel est requis',
  [tokens.configuration.addressTransportWarning]:
    'Une URL ou une adresse FTP est requise.',
  [tokens.configuration.portTransportWarning]: 'Le port est requis.',
  [tokens.configuration.emailAuthenticationTransportWarning]:
    "L'email pour l'authentification est requis.",
  [tokens.configuration.passwordAuthenticationTransportWarning]:
    'Le mot de passe est requis.',
  [tokens.configuration.configurationSaved]: 'Configuration enregistrée',
  [tokens.configuration.configurationName]: 'Nom de la configuration',
  [tokens.configuration.softwareName]: 'Nom du logiciel',
  [tokens.configuration.typeTransport]: 'Méthode de transport',
  [tokens.configuration.addressTransport]: 'API URL ou SFTP',
  [tokens.configuration.portTransport]: 'Port',
  [tokens.configuration.emailAuthenticationTransport]: 'Email',
  [tokens.configuration.passwordAuthenticationTransport]: 'Mot de passe',
  [tokens.configuration.pleaseChooseAGroupAndAConfiguration]:
    'Veuillez choisir une agence et une configuration',
  [tokens.configuration.pleaseChooseAConfiguration]:
    'Veuillez choisir une configuration',
  [tokens.configuration.noSettingsFoundForConfiguration]:
    'Aucun paramètre trouvé pour la configuration sélectionnée',
  [tokens.configuration.noSettingsAvailableForConfiguration]:
    'Aucun paramètre disponible pour la configuration sélectionnée',
  [tokens.configuration.availableSettingKeys]: 'Paramètres disponibles',
  [tokens.configuration.youHaveUnsavedConfigurationChanges]:
    'Vous avez des modifications de configuration non enregistrées.',
  [tokens.configuration.cannotRemoveLastTupleItem]:
    'Au moins un élément doit être conservé.',

  [tokens.upload.dropText]: 'Déposez vos fichiers ici',
  [tokens.upload.declarationType]: 'Type de déclaration',
  [tokens.upload.exportService]: 'Logiciel de déclaration en douane',
  [tokens.upload.model]: 'Modèle',
  [tokens.upload.emailHookText]: 'ou envoyez vos documents sur ',
  [tokens.upload.atLeastOneFileRequired]: 'Au moins un fichier est requis',
  [tokens.upload.warningOnNumberFilesMinimum]: 'Au moins un fichier est requis',
  [tokens.upload.warningOnNumberFilesMaximum]: 'Un seul fichier est attendu',
  [tokens.upload.requiredFiles]: 'Fichiers requis',
  [tokens.upload.requiredCustomerType]: 'Type de client est requis',
  [tokens.upload.requiredRecordName]: 'Nom de dossier requis',
  [tokens.upload.warningOnRecordNameLength]:
    'Le nom de dossier doit comporter au plus 255 caractères.',
  [tokens.upload.requiredExportConfiguration]: 'Logiciel de déclaration requis',
  [tokens.upload.requiredDeclarationType]: 'Type de déclaration requis',
  [tokens.upload.requiredModelConfiguration]: 'Modèle requis',
  [tokens.upload.requiredGroup]: 'Agence requise',
  [tokens.upload.noModelFound]: 'Aucun modèle trouvé',
  [tokens.upload.modelWarning]:
    'Attention : un changement de modèle peut entraîner l’écrasement de certaines données déjà présentes dans votre déclaration.',
  [tokens.upload.agenticLabel]: 'Agentic',
  [tokens.upload.nfRequired]: 'REQUIS',
  [tokens.upload.wizardStepFilesLabel]: 'Fichiers',
  [tokens.upload.wizardStepFilesSubtitle]: 'Déposez la liasse à traiter.',
  [tokens.upload.wizardStepFolderLabel]: 'Dossier',
  [tokens.upload.wizardStepFolderSubtitle]:
    'Nom, rattachement, client et tags.',
  [tokens.upload.wizardPreparationSectionTitle]: 'Préparation',
  [tokens.upload.wizardPreparationModeStandardTitle]: 'Préparation classique',
  [tokens.upload.wizardPreparationModeStandardDescription]:
    'Lecture algorithmique des documents. Les champs sont pré-remplis, vous validez chaque écran.',
  [tokens.upload.wizardPreparationModeIntelligentTitle]: 'Préparation intelligente',
  [tokens.upload.wizardPreparationModeIntelligentDescription]:
    'Nabu prépare votre dossier : il l’organise, le complète, lève les anomalies et vous soumet le résultat.',
  [tokens.upload.wizardPreparationModeNewBadge]: 'Nouveau',
  [tokens.upload.wizardFilesStepGuidance]:
    'Création rapide, ou « Options » pour nommer et rattacher le dossier.',
  [tokens.upload.wizardFilesStepGuidanceClassic]:
    'Passez aux options pour renseigner le dossier.',
  [tokens.upload.wizardStepCounter]: 'Étape {{step}} sur {{total}}',
  [tokens.upload.wizardCompleteRequiredFields]:
    'Complétez les champs signalés.',
  [tokens.upload.wizardAddAtLeastOneFile]:
    'Ajoutez au moins un fichier pour continuer.',
  [tokens.upload.wizardSubmitting]:
    'Envoi des fichiers en cours, ne fermez pas cette fenêtre.',
  [tokens.upload.wizardCreating]: 'Création…',
  [tokens.upload.wizardCreated]: 'Dossier créé',
  [tokens.upload.wizardDropTitle]: 'Glissez vos fichiers ici',
  [tokens.upload.wizardDropTitleActive]: 'Déposez pour ajouter',
  [tokens.upload.wizardDropSubtitle]:
    'ou cliquez pour parcourir · PDF, images, XLSX · 20 Mo max',
  [tokens.upload.wizardAddFiles]: 'Ajouter des fichiers',
  [tokens.upload.wizardRemoveFile]: 'Retirer ce fichier du dossier',
  [tokens.upload.wizardFilesCount]: '{{count}} fichier',
  [tokens.upload.wizardFilesCount_other]: '{{count}} fichiers',
  [tokens.upload.wizardFolderNamePlaceholder]: 'Ex. Liasse Delmas 88431',
  [tokens.upload.wizardFolderNameSuggested]:
    'Pré-rempli avec le nom du premier fichier, modifiable.',
  [tokens.upload.wizardAgencyLabel]: 'Agence / équipe',
  [tokens.upload.wizardAgencyHint]:
    'Organisation ou agence : détermine les types de déclaration et les modèles disponibles. En préparation intelligente, votre agence la plus utilisée pour vos dossiers. Sinon, votre organisation.',
  [tokens.upload.wizardAgencyOrganizationBadge]: 'Organisation',
  [tokens.upload.wizardAgencyClearToOrganization]:
    'Revenir à l’organisation',
  [tokens.upload.wizardNoAgencyOption]: 'Aucune agence accessible',
  [tokens.upload.wizardTypePlaceholder]: 'Choisir un type',
  [tokens.upload.wizardTypePrefilledHint]: 'Pré-rempli, modifiable.',
  [tokens.upload.wizardTypeTooltip]:
    'Sans choix, le sens (import/export) est détecté automatiquement depuis les documents. Modifiable ensuite via la pastille sous le titre du dossier.',
  [tokens.upload.wizardChooseGroupFirst]: "Choisissez d'abord une agence.",
  [tokens.upload.wizardWorkflowLabel]: 'Modèle',
  [tokens.upload.wizardWorkflowHint]: 'Configuration prête à l’emploi.',
  [tokens.upload.wizardWorkflowTooltip]:
    'Pré-remplit les champs récurrents dès la création. Les valeurs extraites des documents ne seront pas écrasées.',
  [tokens.upload.wizardWorkflowPlaceholder]: 'Aucun modèle',
  [tokens.upload.wizardNoWorkflowForCombination]:
    'Aucun modèle pour cette combinaison. Traitement manuel.',
  [tokens.upload.wizardClientHint]: 'Nom ou référence.',
  [tokens.upload.wizardClientSearchPlaceholder]: 'Rechercher un client',
  [tokens.upload.wizardNoClientOption]: 'Aucun client',
  [tokens.upload.wizardNoClientFound]: 'Aucun client trouvé',
  [tokens.upload.wizardNoWorkflowFound]: 'Aucun modèle trouvé',
  [tokens.upload.wizardOptionsLoading]: 'Chargement…',
  [tokens.upload.wizardTagsHint]: 'Pour retrouver le dossier dans les filtres.',
  [tokens.upload.wizardTagsPlaceholder]: 'Ajouter des tags',
  [tokens.upload.wizardOptionsButton]: 'Options',
  [tokens.upload.wizardQuickCreateButton]: 'Création rapide',
  [tokens.upload.wizardQuickCreateButtonInAgency]:
    'Création rapide dans {{agency}}',
  [tokens.upload.wizardQuickCreateTooltip]:
    'Crée le dossier immédiatement dans {{agency}}.',
  [tokens.upload.wizardCreateFolderButton]: 'Créer le dossier',

  [tokens.documents.creationWindowRecent]: 'Dossiers créés ces {{days}} derniers jours',
  [tokens.documents.creationWindowAll]: 'Tout l’historique',
  [tokens.documents.creationWindowShowAll]: 'Voir tout l’historique',
  [tokens.documents.creationWindowShowRecent]: 'Revenir aux {{days}} derniers jours',
  [tokens.documents.collaborators]: 'Collaborateurs',
  [tokens.documents.statusExported]: 'Envoyé',
  [tokens.documents.createNewFlowFromThisDeclaration]:
    'Créer un nouveau flux pour cette déclaration',
  [tokens.documents.statusToRead]: 'À consulter',
  [tokens.documents.statusToTreat]: 'À traiter',
  [tokens.documents.statusToSend]: 'À envoyer',
  [tokens.documents.statusError]: 'Erreur',
  [tokens.documents.statusAbandoned]: 'Abandonné',
  [tokens.documents.statusExportFailed]: 'Envoi échoué',
  [tokens.documents.batchImportErrorTitle]: 'Dossier en erreur',
  [tokens.documents.batchImportAbandonedTitle]: 'Dossier abandonné',
  [tokens.documents.batchImportAbandonedWhatToDo]:
    'Si la déclaration est toujours à faire, recréez le dossier avec les mêmes fichiers.',
  [tokens.documents.batchImportErrorReasonProcessingTimeout]:
    'Le traitement automatique n’a pas abouti dans le délai de 15 minutes.',
  [tokens.documents.batchImportErrorReasonWorkflowLost]: 'Le traitement s’est interrompu sans terminer.',
  [tokens.documents.batchImportErrorReasonWorkflowStuck]: 'Le traitement s’est bloqué.',
  [tokens.documents.batchImportErrorReasonFilesTimeout]: 'Aucun fichier n’a été reçu dans le délai imparti.',
  [tokens.documents.batchImportErrorReasonHumanTimeout]:
    'Le dossier attendait une action pour repartir, et le délai est écoulé.',
  [tokens.documents.batchImportErrorReasonNoUsableDocument]:
    'Aucun document exploitable n’a été trouvé dans le dossier.',
  [tokens.documents.batchImportErrorReasonStepFailed]:
    'Une étape du traitement a échoué.',
  [tokens.documents.batchImportErrorReasonNoTypedDocument]:
    "Aucune pièce n'a été reconnue. Le dossier ne peut pas être traité automatiquement.",
  [tokens.documents.batchImportErrorReasonNoGroupConfiguration]:
    "Aucune configuration n'est disponible pour ce groupe. Contactez votre administrateur.",
  [tokens.documents.batchImportErrorReasonBlockingDiagnostic]:
    'Une pièce empêche de préparer la déclaration.',
  [tokens.documents.batchImportErrorReasonEmptyDeclaration]:
    "Aucune donnée exploitable n'a été trouvée dans les pièces pour remplir la déclaration. Le dossier ne peut pas être traité automatiquement.",
  [tokens.documents.batchImportErrorReasonRepeatedBlock]:
    "Le même blocage s'est reproduit après relance. Contactez le support.",
  [tokens.documents.batchImportErrorReasonUnknown]: 'Le traitement n’a pas abouti.',
  [tokens.documents.batchImportErrorStoppedAt]:
    'Arrêté à {{time}}, à l’étape {{step}}.',
  [tokens.documents.batchImportErrorStoppedAtStep]:
    'Arrêté à l’étape {{step}}.',
  [tokens.documents.batchImportErrorStoppedAtTime]:
    'Arrêté à {{time}}.',
  [tokens.documents.batchImportErrorEarlierStepsSucceeded]:
    'Les étapes précédentes avaient réussi.',
  [tokens.documents.batchImportErrorStepAwaitingUploads]: 'Réception',
  [tokens.documents.batchImportErrorStepFileProcessing]: 'Lecture des documents',
  [tokens.documents.batchImportErrorStepExtraction]: 'Extraction',
  [tokens.documents.batchImportErrorStepMapping]: 'Mise en forme',
  [tokens.documents.batchImportErrorWhatToDo]: 'Que faire ?',
  [tokens.documents.batchImportErrorWhatToDoFilesMissing]:
    'Aucun fichier n’est arrivé pour ce dossier. Recréez-le en y joignant les documents.',
  [tokens.documents.batchImportErrorContactSupport]:
    'Contactez le support en indiquant la référence ci-dessus.',
  [tokens.documents.batchImportErrorContactButton]: 'Nous contacter',
  [tokens.documents.batchImportErrorSupportMessage]:
    'Bonjour, mon dossier s’est arrêté en erreur et je souhaite le faire reprendre.',
  [tokens.documents.batchImportErrorRecreate]:
    'Vous pouvez aussi recréer le dossier avec les mêmes fichiers.',
  [tokens.documents.batchImportErrorRetryButton]: 'Relancer',
  [tokens.documents.batchImportErrorRetryFailed]:
    'La relance a échoué. Réessayez ou contactez le support.',
  [tokens.documents.batchImportErrorNotified]: 'Notre équipe technique a été notifiée.',
  [tokens.documents.statusSent]: 'Envoyé',
  [tokens.documents.visualizeDocuments]: 'Visualiser les documents',
  [tokens.documents.downloadDeclarationXML]:
    'Télécharger la déclaration au format XML',
  [tokens.documents.downloadDetailValue]: 'Télécharger le détail de valeur',
  [tokens.documents.downloadOrginalDocuments]:
    'Télécharger les documents originaux',
  [tokens.documents.declarationExportNotFound]:
    "L'export de la déclaration est introuvable.",
  [tokens.documents.valueDetailExportNotFound]:
    "Le détail de valeur n'est pas disponible pour cette déclaration.",
  [tokens.documents.typeDocument]: 'Type de document',
  [tokens.documents.nameDocument]: 'Nom du document',
  [tokens.documents.statusExtraction]: 'Extraction',
  [tokens.documents.statusInProgress]: 'Chargement',
  [tokens.documents.statusArchived]: 'Archivé',
  [tokens.documents.statusUploaded]: 'Chargé',
  [tokens.documents.statusUnknown]: 'Inconnu',
  [tokens.documents.removeRecordTitle]: "Suppression d'un dossier",
  [tokens.documents.removeRecordsTitle]: 'Suppression de plusieurs dossiers',
  [tokens.documents.removeRecordText]:
    'Êtes-vous sûr de vouloir supprimer {{count}} dossier ?',
  [tokens.documents.removeRecordsText]:
    'Êtes-vous sûr de vouloir supprimer {{count}} dossiers ? Cette action est irréversible.',
  [tokens.documents.deleteFolderTitle]: 'Supprimer « {{name}} » ?',
  [tokens.documents.deleteFolderUnnamedTitle]: 'Supprimer ce dossier ?',
  [tokens.documents.deleteFoldersTitle]: 'Supprimer {{count}} dossiers ?',
  [tokens.documents.deleteFolderText]:
    'Le dossier et ses pièces jointes seront supprimés. Cette action est irréversible.',
  [tokens.documents.deleteFoldersText]:
    '{{names}} seront supprimés avec leurs pièces jointes. Cette action est irréversible.',
  [tokens.documents.deleteFoldersUnnamedText]:
    'Ces dossiers et leurs pièces jointes seront supprimés. Cette action est irréversible.',
  [tokens.documents.deleteFoldersOthers]: '{{count}} autre',
  [tokens.documents.deleteFoldersOthers_other]: '{{count}} autres',
  [tokens.documents.deleteFolderQuotedName]: '« {{name}} »',
  [tokens.documents.deleteFolderConfirm]: 'Supprimer',
  [tokens.documents.removePendingRecordTitle]:
    "Suppression d'un dossier en attente",
  [tokens.documents.removePendingRecordsTitle]:
    'Suppression de plusieurs dossiers en attente',
  [tokens.documents.removePendingRecordText]:
    'Êtes vous sûr de vouloir supprimer ce dossier en attente ?',
  [tokens.documents.removePendingRecordsText]:
    'Êtes vous sûr de vouloir supprimer ces dossiers en attente ?',
  [tokens.documents.documentHasBeenDeleted]: 'Le dossier a été supprimé',
  [tokens.documents.documentHasBeenDeleted_other]:
    'Les dossiers ont été supprimés',
  [tokens.documents.documentHasNotBeenDeleted]:
    "Le dossier n'a pas été supprimé",
  [tokens.documents.documentHasNotBeenDeleted_other]:
    "Les dossiers n'ont pas été supprimés",
  [tokens.documents.documentHasBeenUpdated]: 'Le dossier a été mis à jour',
  [tokens.documents.noDocumentFound]: 'Aucun dossier trouvé',
  [tokens.documents.starting]: 'Démarrage',
  [tokens.documents.bulkSelectedCount]: 'dossier sélectionné',
  [tokens.documents.bulkSelectedCount_other]: 'dossiers sélectionnés',
  [tokens.documents.bulkDuplicate]: 'Dupliquer',
  [tokens.documents.bulkApplyTag]: 'Appliquer un tag',
  [tokens.documents.bulkDownloadDocuments]: 'Télécharger les documents',
  [tokens.documents.bulkDelete]: 'Supprimer',
  [tokens.documents.foldersDuplicated]: '{{count}} dossier dupliqué',
  [tokens.documents.foldersDuplicated_other]: '{{count}} dossiers dupliqués',
  [tokens.documents.foldersNotDuplicated]: 'La duplication du dossier a échoué',
  [tokens.documents.foldersNotDuplicated_other]:
    'La duplication des dossiers a échoué',
  [tokens.documents.tagsAppliedToFolders]:
    'Les tags ont été appliqués à {{count}} dossier',
  [tokens.documents.tagsAppliedToFolders_other]:
    'Les tags ont été appliqués à {{count}} dossiers',
  [tokens.documents.bulkDownloadStarted]: 'Le téléchargement a démarré',
  [tokens.documents.bulkDownloadError]:
    'Impossible de télécharger les documents sélectionnés',
  [tokens.documents.bulkDownloadOutputFiles]:
    'Télécharger les fichiers de sortie',
  [tokens.documents.bulkDownloadOutputFilesPartial]:
    '{{count}} dossier sans déclaration générée a été ignoré',
  [tokens.documents.bulkDownloadOutputFilesPartial_other]:
    '{{count}} dossiers sans déclaration générée ont été ignorés',
  [tokens.documents.bulkDownloadOutputFilesNone]:
    'Aucun dossier sélectionné n’a de déclaration générée',
  [tokens.documents.bulkDownloadOutputFilesError]:
    'Impossible de télécharger les fichiers de sortie des dossiers sélectionnés',
  [tokens.documents.attachmentCount]: '{{count}} PJ',
  [tokens.documents.revisionInProgress]: 'En révision',

  [tokens.export.confirmExportTitle]: "Confirmation d'envoi",
  [tokens.export.confirmExportText]:
    'Êtes vous sûr de vouloir envoyer ce dossier?',
  [tokens.export.confirmExport]: 'Envoyer',
  [tokens.export.successToExport]: 'Le dossier a été envoyé avec succès',
  [tokens.export.notExtracted]: 'Non extrait',

  [tokens.teams.removeFromGroup]: "Retirer de l'agence",
  [tokens.teams.youHaveNoTeam]: "Vous n'avez pas d'équipe",
  [tokens.teams.createATeam]: 'Créer une équipe',
  [tokens.teams.noRole]: 'Aucun rôle',
  [tokens.teams.teamName]: "Nom de l'équipe",

  [tokens.nav.account]: 'Compte',
  [tokens.nav.settings]: 'Paramètres',
  [tokens.nav.managementConsole]: 'Console administration',
  [tokens.nav.analytics]: 'Analytics',
  [tokens.nav.auth]: 'Authentification',
  [tokens.nav.browse]: 'Browse',
  [tokens.nav.create]: 'Créer',
  [tokens.nav.customers]: 'Clients',
  [tokens.nav.dashboard]: 'Tableau de bord',
  [tokens.nav.gobackToDeclaration]: 'Retour aux dossiers en cours',
  [tokens.nav.database]: 'Base de données',
  [tokens.nav.customerFlow]: 'Centre de données',
  [tokens.nav.customer]: 'Client',
  [tokens.nav.data]: 'Données',
  [tokens.nav.models]: 'Modèles',
  [tokens.nav.referentials]: 'Référentiels',
  [tokens.nav.automation]: 'Automatisation',
  [tokens.nav.workflows]: 'Workflows',
  [tokens.nav.backoffice]: "Panneau d'administration",
  [tokens.nav.details]: 'Détails',
  [tokens.nav.edit]: 'Editer',
  [tokens.nav.error]: 'Erreur',
  [tokens.nav.feed]: 'Feed',
  [tokens.nav.fileManager]: 'File Manager',
  [tokens.nav.forgotPassword]: 'Mot de passe oublié',
  [tokens.nav.list]: 'Liste',
  [tokens.nav.login]: 'Connection',
  [tokens.nav.mcpConsent]: 'Autorisation MCP',
  [tokens.nav.impersonate]: 'Connexion en tant que',
  [tokens.nav.mail]: 'Mail',
  [tokens.nav.management]: 'Management',
  [tokens.nav.orderList]: 'Commande',
  [tokens.nav.overview]: 'Overview',
  [tokens.nav.organizations]: 'Organisations',
  [tokens.nav.pages]: 'Pages',
  [tokens.nav.postCreate]: 'Post Create',
  [tokens.nav.postDetails]: 'Post Details',
  [tokens.nav.postList]: 'Post List',
  [tokens.nav.pricing]: 'Pricing',
  [tokens.nav.productList]: 'Products',
  [tokens.nav.fieldList]: 'Dossiers',
  [tokens.nav.fieldToRead]: 'A consulter',
  [tokens.nav.fieldToManage]: 'A traiter',
  [tokens.nav.fieldDeleted]: 'Supprimés',
  [tokens.nav.pendingField]: 'En cours',
  [tokens.nav.fieldExported]: 'Envoyés',
  [tokens.nav.pendingDocuments]: 'Dossiers en cours',
  [tokens.nav.sentDocuments]: 'Dossiers envoyés',
  [tokens.nav.removedDocuments]: 'Documents supprimés',
  [tokens.nav.profile]: 'Profile',
  [tokens.nav.register]: 'Register',
  [tokens.nav.resetPassword]: 'Reset Password',
  [tokens.nav.connectors]: 'Connecteurs',
  [tokens.nav.users]: 'Utilisateurs',
  [tokens.nav.expandSideNav]: 'Développer le menu',
  [tokens.nav.collapseSideNav]: 'Réduire le menu',
  [tokens.nav.accountMenuTooltip]: 'Menu compte',

  [tokens.activity.lastActivity]: 'Dernières activités',
  [tokens.activity.subTitleLastActivity]: 'Basé sur la période sélectionnée',
  [tokens.activity.seeSentDocuments]: 'Voir les dossiers envoyés',
  [tokens.activity.seeDocumentsToManage]: 'Voir les documents',
  [tokens.activity.seeDocuments]: 'Voir les dossiers',
  [tokens.activity.exportedDocuments]: 'Dossiers envoyés',

  [tokens.dashboard.all]: 'Tous',
  [tokens.dashboard.pending]: 'En attente',
  [tokens.dashboard.toBeProcessed]: 'À traiter',
  [tokens.dashboard.inProgress]: 'En cours',
  [tokens.dashboard.completed]: 'Complété',
  [tokens.dashboard.error]: 'Erreur',
  [tokens.dashboard.abandoned]: 'Abandonné',
  [tokens.dashboard.canceled]: 'Annulé',
  [tokens.dashboard.rejected]: 'Rejeté',
  [tokens.dashboard.returned]: 'Retourné',
  [tokens.dashboard.uploading]: 'Téléchargement',
  [tokens.dashboard.extracting]: 'Extraction',
  [tokens.dashboard.batchImport]: 'Dossier',
  [tokens.dashboard.pendingRecords]: 'Dossiers en cours',
  [tokens.dashboard.recordsToManage]: 'Dossiers à traiter',
  [tokens.dashboard.exportedRecords]: 'Dossiers envoyés',
  [tokens.dashboard.seeRecords]: 'Voir les dossiers',
  [tokens.dashboard.seeExportedRecords]: 'Voir les exports',
  [tokens.dashboard.createOrganization]: 'Créer une organisation',
  [tokens.dashboard.organizationCreated]:
    "L'organisation a été créée avec succès",
  [tokens.dashboard.createOffice]: 'Créer un établissement',
  [tokens.dashboard.officeCreated]: "L'établissement a été créé avec succès",
  [tokens.dashboard.officeDeleted]:
    "L'établissement a été supprimé avec succès",
  [tokens.dashboard.userCreated]: "L'utilisateur a été créé avec succès",
  [tokens.dashboard.deleteOrganization]: "Supprimer l'organisation",
  [tokens.dashboard.deleteUser]: "Supprimer l'utilisateur",
  [tokens.dashboard.userUpdated]: "L'utilisateur a été modifié avec succès",
  [tokens.dashboard.organizationAndGroups]: 'Organisation et Agences',
  [tokens.dashboard.selectGroups]: 'Sélectionner les agences à affilier',
  [tokens.dashboard.inviteCollaborators]: 'Inviter des collaborateurs',
  [tokens.dashboard.externalCollaborator]: 'Collaborateur extérieur',
  [tokens.dashboard.removeCollaborator]: 'Retirer le collaborateur',
  [tokens.dashboard.removeOrganizationTitle]: 'Supprimer une organisation',
  [tokens.dashboard.removeOrganizationText]:
    'Voulez-vous vraiment supprimer cette organisation ?',
  [tokens.dashboard.removeUserTitle]: 'Supprimer un utilisateur',
  [tokens.dashboard.removeUserText]:
    'Voulez-vous vraiment supprimer cet utilisateur ?',
  [tokens.dashboard.sendInvitationEmailTitle]: 'Envoyer une invitation',
  [tokens.dashboard.sendInvitationEmailText]:
    'Etes vous sur de vouloir envoyer une invitation à cet utilisateur ?',
  [tokens.dashboard.manageDocuments]: 'Gérer les documents',
  [tokens.dashboard.dropFilesHere]: 'Déposez vos fichiers ici',
  [tokens.dashboard.useNewFolderButton]:
    'ou utilisez le bouton "Nouveau Dossier"',
  [tokens.dashboard.newFolderButton]: 'Nouveau Dossier',
  [tokens.dashboard.folderInformation]: 'Informations du dossier',
  [tokens.dashboard.folderName]: 'Nom du Dossier',
  [tokens.dashboard.customer]: 'Client',
  [tokens.dashboard.exportService]: 'Logiciel de déclaration en douane',
  [tokens.dashboard.typeDeclarationService]: 'Type de déclaration',
  [tokens.dashboard.addNewCustomer]: 'Ajouter un nouveau client',
  [tokens.dashboard.customerName]: 'Nom du client',
  [tokens.dashboard.createNewCustomer]: 'Créer un nouveau client',
  [tokens.dashboard.punctualCustomer]: 'Client ponctuel',
  [tokens.dashboard.regularCustomer]: 'Client régulier',
  [tokens.dashboard.theEmailWasCopiedToYourClipboard]:
    'Le mail a été copié dans le presse-papiers !',
  [tokens.dashboard.fastTrackFirstText]: 'Fast track',
  [tokens.dashboard.fastTrackSecondText]:
    "(passer l’étape de classification si votre seul document est une facture ou un document d'accompagnement export)",
  [tokens.dashboard.fastTrackTooltipText]:
    'Sélectionnez un type de déclaration',
  [tokens.dashboard.isCurrentlyInAnErrorState]:
    "est actuellement dans un état d'erreur",
  [tokens.dashboard.declarationInErrorState]: "Declaration en état d'erreur",
  [tokens.dashboard.itsLastReportedStateWas]: 'Son dernier état était',
  [tokens.dashboard.ourTechnicalTeamHasBeenNotified]:
    'Notre équipe technique a été notifiée',
  [tokens.dashboard.pleaseContactCustomerServiceForFurtherInformation]:
    "Veuillez nous contacter notre service client pour plus d'information",
  [tokens.dashboard.created]: 'Création',
  [tokens.dashboard.clientOrganization]: 'Organisation client',
  [tokens.dashboard.reference]: 'Référence dossier Nabu',
  [tokens.dashboard.customerReference]: 'Référence dossier clients',
  [tokens.dashboard.noReference]: 'Aucune référence dossier',
  [tokens.dashboard.type]: 'Type',
  [tokens.dashboard.timing]: 'Livraison',
  [tokens.dashboard.clientName]: 'Client',
  [tokens.dashboard.status]: 'État',
  [tokens.dashboard.noDeclarationsFound]: 'Aucune déclaration trouvée',
  [tokens.dashboard.searchForADeclaration]: 'Cherche un dossier',
  [tokens.dashboard.searchNameMaxLengthHint]:
    'La recherche est limitée à {{max}} caractères.',
  [tokens.dashboard.tracking]: 'Suivi',
  [tokens.dashboard.pastDue]: 'Hors délai',
  [tokens.dashboard.importer]: 'Importateur',
  [tokens.dashboard.exporter]: 'Exportateur',
  [tokens.dashboard.noExporterIndicated]: 'Aucun exportateur',
  [tokens.dashboard.noImporterIndicated]: 'Aucun importateur',
  [tokens.dashboard.emailSender]: "Expéditeur de l'email",
  [tokens.dashboard.emailSubject]: "Objet de l'email",
  [tokens.dashboard.emailSendingDate]: "Date d'envoi",
  [tokens.dashboard.details]: 'Détails',
  [tokens.dashboard.viewDetails]: 'Voir détails',
  [tokens.dashboard.openInfoPanel]: 'Ouvrir le panneau d’informations',
  [tokens.dashboard.tags]: 'Tags',
  [tokens.dashboard.tag]: 'Tag',
  [tokens.dashboard.noTags]: 'Aucun tag',
  [tokens.dashboard.addTag]: 'Ajouter un tag',
  [tokens.dashboard.createTag]: 'Créer un tag',
  [tokens.dashboard.tagName]: 'Nom du tag',
  [tokens.dashboard.source]: 'Source',
  [tokens.dashboard.description]: 'Description',
  [tokens.dashboard.group]: 'Agence',
  [tokens.dashboard.declarant]: 'Déclarant',
  [tokens.dashboard.filter]: 'Filtres',
  [tokens.dashboard.clearAll]: 'Tout effacer',
  [tokens.dashboard.addFilter]: 'AJOUTER UN FILTRE',
  [tokens.dashboard.allFilterActive]: 'Tous les filtres actifs',
  [tokens.dashboard.allTypes]: 'Types: tous',
  [tokens.dashboard.user]: 'Utilisateur',
  [tokens.dashboard.sendDate]: 'Date d’envoi',
  [tokens.dashboard.apply]: 'Appliquer',
  [tokens.dashboard.search]: 'Rechercher',
  [tokens.dashboard.noResults]: 'Aucun résultat trouvé',
  [tokens.dashboard.lastDay]: 'Il y a 1 jour',
  [tokens.dashboard.last3Days]: 'Il y a 3 jours',
  [tokens.dashboard.lastWeek]: 'Il y a 1 semaine',
  [tokens.dashboard.lastMonth]: 'Il y a 1 mois',
  [tokens.dashboard.last3Months]: 'Il y a 3 mois',
  [tokens.dashboard.lastYear]: 'Il y a 1 an',
  [tokens.dashboard.customDateRange]: 'Dates personnalisées',
  [tokens.dashboard.saveFilter]: 'Sauvegarder la recherche',
  [tokens.dashboard.customizeView]: 'Personnaliser la vue',
  [tokens.dashboard.customizeViewTitle]: 'Personnaliser la vue',
  [tokens.dashboard.customizeViewSubtitle]: 'Glissez pour réordonner, activez pour afficher',
  [tokens.dashboard.columnRequired]: 'obligatoire',
  [tokens.dashboard.visibleColumnsCount]: '{{count}} colonnes affichées',
  [tokens.dashboard.sortAscending]: 'Tri croissant',
  [tokens.dashboard.sortDescending]: 'Tri décroissant',
  [tokens.dashboard.savedFilters]: 'Recherches sauvegardées',
  [tokens.dashboard.filterName]: 'Nom de la recherche',
  [tokens.dashboard.noSavedFilters]: 'Aucune recherche sauvegardée',
  [tokens.dashboard.noSavedSearches]: 'Aucune recherche sauvegardée',
  [tokens.dashboard.unknown]: 'Inconnu',
  [tokens.dashboard.from]: 'Du',
  [tokens.dashboard.to]: 'Au',

  [tokens.dashboardV2.kicker]: 'Accueil · {{date}}',
  [tokens.dashboardV2.greeting]: 'Bonjour {{name}}',
  [tokens.dashboardV2.searchPlaceholder]: 'Rechercher un dossier',
  [tokens.dashboardV2.searchNoResults]: 'Aucun dossier pour « {{query}} »',
  [tokens.dashboardV2.searchLoading]: 'Chargement…',
  [tokens.dashboardV2.exportTitle]:
    'Exporter toutes les données du tableau de bord (CSV)',
  [tokens.dashboardV2.customizeStart]: 'Personnaliser la disposition des blocs',
  [tokens.dashboardV2.customizeStop]: 'Terminer la personnalisation',

  [tokens.dashboardV2.kpiToProcessLabel]: 'À traiter',
  [tokens.dashboardV2.kpiToProcessSub]: "dossiers en attente d'action",
  [tokens.dashboardV2.kpiErrorLabel]: 'En erreur',
  [tokens.dashboardV2.kpiSentLabel]: 'Envoyés ce mois',
  [tokens.dashboardV2.kpiSentSub]: 'vs. même période M-1',
  [tokens.dashboardV2.kpiSentPrevious]:
    '{{period}} : {{formattedCount}} dossier envoyé.',
  [tokens.dashboardV2.kpiSentPrevious_other]:
    '{{period}} : {{formattedCount}} dossiers envoyés.',
  [tokens.dashboardV2.kpiSentPreviousNone]:
    '{{period}} : aucun dossier envoyé.',
  [tokens.dashboardV2.kpiSentFewer]: 'Soit {{diff}} de moins ({{pct}}).',
  [tokens.dashboardV2.kpiSentMore]: 'Soit {{diff}} de plus ({{pct}}).',
  [tokens.dashboardV2.kpiSentSame]: 'Autant que ce mois-ci.',
  [tokens.dashboardV2.kpiTrendFrom]: '{{date}} : {{formattedCount}} dossier.',
  [tokens.dashboardV2.kpiTrendFrom_other]: '{{date}} : {{formattedCount}} dossiers.',
  [tokens.dashboardV2.kpiTrendToday]: "Aujourd'hui : {{formattedCount}}, soit {{pct}}.",
  [tokens.dashboardV2.kpiTrendTodaySame]: "Aujourd'hui : {{formattedCount}}, sans changement.",
  [tokens.dashboardV2.kpiTrendTodayOnly]: "Aujourd'hui : {{formattedCount}}.",
  [tokens.dashboardV2.seeDossiers]: 'Voir les dossiers',

  [tokens.dashboardV2.activityTitle]: 'Dernières activités',
  [tokens.dashboardV2.activitySubtitle]: 'Vos 10 derniers dossiers',
  [tokens.dashboardV2.seeAll]: 'Voir tout',
  [tokens.dashboardV2.filterAll]: 'Tout',
  [tokens.dashboardV2.filterToProcess]: 'À traiter',
  [tokens.dashboardV2.filterSent]: 'Envoyé',
  [tokens.dashboardV2.filterError]: 'En erreur',
  [tokens.dashboardV2.colName]: 'Nom du dossier',
  [tokens.dashboardV2.colType]: 'Type',
  [tokens.dashboardV2.colStatus]: 'Statut',
  [tokens.dashboardV2.colDate]: 'Date',
  [tokens.dashboardV2.emptyCategory]: 'Aucun dossier dans cette catégorie',
  [tokens.dashboardV2.staleTooltip]: 'En attente depuis {{duration}}',
  [tokens.dashboardV2.staleBadgeMinutes]: '+{{count}} min',
  [tokens.dashboardV2.staleBadgeHours]: '+{{count}} h',
  [tokens.dashboardV2.staleBadgeDays]: '+{{count}} j',
  [tokens.dashboardV2.staleBadgeWeeks]: '+{{count}} sem',
  [tokens.dashboardV2.staleBadgeMonths]: '+{{count}} mois',

  [tokens.dashboardV2.aiTitle]: "Ce que l'IA a fait pour vous",
  [tokens.dashboardV2.aiSubtitle]: 'Ce mois-ci',
  [tokens.dashboardV2.aiHeadlineSuffix]: 'actions IA effectuées',
  [tokens.dashboardV2.aiHeadlineSub]: 'sur {{count}} déclarations',
  [tokens.dashboardV2.aiCreditsFooter]: '{{count}} crédits consommés',
  [tokens.dashboardV2.aiEmptyTitle]: 'Aucune automatisation configurée',
  [tokens.dashboardV2.aiEmptyBody]:
    'Configurez une automatisation pour pré-remplir vos lignes articles à partir de vos fichiers fournisseurs.',
  [tokens.dashboardV2.aiEmptyCta]: 'Créer une automatisation',
  [tokens.dashboardV2.aiRowPrefilled]: "Lignes d'articles pré-remplies",
  [tokens.dashboardV2.aiRowPrefilledMeta]:
    'sur {{total}} · {{corrected}} corrigées à la main',
  [tokens.dashboardV2.aiRowAnomalies]: 'Anomalies levées automatiquement',
  [tokens.dashboardV2.aiRowAnomaliesMeta]: 'dont {{blocking}} écarts bloquants',
  [tokens.dashboardV2.aiRowSuggestions]: 'Suggestions acceptées',
  [tokens.dashboardV2.aiRowSuggestionsMeta]:
    'sur {{total}} proposées · {{pct}} %',
  [tokens.dashboardV2.aiRowFields]: 'Champs complétés depuis les documents',
  [tokens.dashboardV2.aiRowFieldsMeta]: '{{count}} documents extraits',

  [tokens.dashboardV2.teamTitle]: "Activité de l'équipe",
  [tokens.dashboardV2.teamSubtitle]:
    'Agence {{agency}} · {{count}} déclarants · {{processed}} dossiers traités {{period}}',
  [tokens.dashboardV2.teamSubtitleStats]:
    '· {{count}} déclarants · {{processed}} dossiers traités {{period}}',
  [tokens.dashboardV2.teamRangeWeek]: 'Cette semaine',
  [tokens.dashboardV2.teamRangeMonth]: 'Ce mois',
  [tokens.dashboardV2.teamLateBadge]: '{{count}} en retard',
  [tokens.dashboardV2.teamOverloadBadge]: '{{count}} en surcharge',
  [tokens.dashboardV2.teamAgencySelect]: 'Agence',
  [tokens.dashboardV2.teamEmpty]: 'Aucun déclarant dans cette agence.',
  [tokens.dashboardV2.teamError]: "Impossible de charger l'activité de l'équipe.",
  [tokens.dashboardV2.teamUnknownMember]: 'Sans nom',
  [tokens.dashboardV2.colDeclarant]: 'Déclarant',
  [tokens.dashboardV2.colProcessed]: 'Traités',
  [tokens.dashboardV2.colInProgress]: 'En cours',
  [tokens.dashboardV2.colLate]: 'Retard',
  [tokens.dashboardV2.colRate]: 'Cadence / j',
  [tokens.dashboardV2.colLoad]: 'Charge',
  [tokens.dashboardV2.lateTooltip]:
    'Un dossier en retard est un dossier non envoyé, créé depuis plus de quatre heures.',
  [tokens.dashboardV2.rateTooltip]:
    'Dossiers traités par jour ouvré en moyenne. Objectif : {{target}} par déclarant. Elle mesure son rythme de traitement.',
  [tokens.dashboardV2.loadTooltip]:
    "Dossiers en cours par rapport à une capacité de {{capacity}}. Au-delà de 100 %, le déclarant gère plus de dossiers qu'il ne peut en suivre correctement et est en surcharge.",

  [tokens.dashboardV2.fluxTitle]: 'Volume & flux',
  [tokens.dashboardV2.fluxSubtitle]:
    '12 mois glissants · ventilation Import / Export / Transit',
  [tokens.dashboardV2.fluxEmpty]: 'Aucun volume sur les 12 derniers mois.',
  [tokens.dashboardV2.fluxError]: 'Impossible de charger le volume par flux.',
  [tokens.dashboardV2.fluxMonthlyLabel]: 'Évolution mensuelle',
  [tokens.dashboardV2.fluxAllFlows]: 'Tous les flux',
  [tokens.dashboardV2.fluxBreakdownLabel]: 'Répartition 12 mois',
  [tokens.dashboardV2.fluxTotalLabel]: 'Total',
  [tokens.dashboardV2.fluxTotalUnit]: 'déclarations',
  [tokens.dashboardV2.fluxTooltipDeclarations]: 'Déclarations :',
  [tokens.dashboardV2.typeImport]: 'Import',
  [tokens.dashboardV2.typeExport]: 'Export',
  [tokens.dashboardV2.typeTransit]: 'Transit',

  [tokens.dashboardV2.cplxTitle]: 'Performance par complexité',
  [tokens.dashboardV2.cplxSubtitle]: 'Benchmark {{base}} s + {{perLine}} s / ligne',
  [tokens.dashboardV2.cplxTierSmall]: 'Petite',
  [tokens.dashboardV2.cplxTierMedium]: 'Moyenne',
  [tokens.dashboardV2.cplxTierLarge]: 'Grande',
  [tokens.dashboardV2.cplxColDossiers]: 'Dossiers',
  [tokens.dashboardV2.cplxColBenchmark]: 'Benchmark',
  [tokens.dashboardV2.cplxColMeasured]: 'Nabu mesuré',
  [tokens.dashboardV2.cplxColGain]: 'Gain',
  [tokens.dashboardV2.cplxMeasuredSub]: '{{sampled}}/{{total}} mesurés',
  [tokens.dashboardV2.cplxAvgTimeLabel]: 'Temps moyen par dossier',
  [tokens.dashboardV2.cplxLegendBenchmark]: 'Benchmark',
  [tokens.dashboardV2.cplxLegendMeasured]: 'Nabu mesuré',
  [tokens.dashboardV2.cplxTooltipBenchmark]: 'Benchmark {{lines}} lignes :',
  [tokens.dashboardV2.cplxTooltipMeasured]: 'Nabu :',

  [tokens.dashboardV2.editBannerText]:
    "Glissez un bloc sur le bord d'un autre pour partager la ligne (jusqu'à 3), ou entre deux lignes pour l'isoler. L'œil masque un bloc.",
  [tokens.dashboardV2.resetCta]: 'Réinitialiser',
  [tokens.dashboardV2.doneCta]: 'Terminé',
  [tokens.dashboardV2.newRowLabel]: 'Nouvelle ligne',
  [tokens.dashboardV2.dropNewRowBottom]:
    'Déposer ici pour une nouvelle ligne en bas',
  [tokens.dashboardV2.hideBlock]: 'Masquer ce bloc',
  [tokens.dashboardV2.showBlock]: 'Afficher ce bloc',
  [tokens.dashboardV2.dragHandleTitle]: 'Glisser pour déplacer ce bloc',

  [tokens.dashboardV2.sectionKpi]: 'Indicateurs du jour',
  [tokens.dashboardV2.sectionActivity]: 'Dernières activités',
  [tokens.dashboardV2.sectionAi]: "Ce que l'IA a fait pour vous",
  [tokens.dashboardV2.sectionTeam]: "Activité de l'équipe",
  [tokens.dashboardV2.sectionFlux]: 'Volume & flux',
  [tokens.dashboardV2.sectionComplexity]: 'Performance par complexité',

  [tokens.backoffice.importLayer]: 'Importer un modèle de document',
  [tokens.backoffice.chooseLayerName]: 'Choisir un nom de modèle de document',
  [tokens.backoffice.createUser]: 'Créer un utilisateur',
  [tokens.backoffice.deleteUser]: 'Utilisateur supprimé avec succès',
  [tokens.backoffice.successSendEmailMessage]:
    "Email d'invitation envoyé avec succès",
  [tokens.backoffice.users]: 'Utilisateurs',
  [tokens.backoffice.deleteOrganization]:
    "L'organisation supprimée avec succès",

  [tokens.backoffice.selectDocumentType]: 'Type de document',
  [tokens.backoffice.onlyFirstPage]:
    'Seule la première page pourra être utilisée.',
  [tokens.backoffice.acceptedFormats]: 'Formats acceptés',
  [tokens.backoffice.maxSize]: 'Taille maximale',
  [tokens.backoffice.exportConfig]: 'Configurations',
  [tokens.backoffice.layerNameIsRequired]: 'Le nom du modèle est obligatoire',
  [tokens.backoffice.documentTypeIsRequired]:
    'Le type de document est obligatoire',
  [tokens.backoffice.exportConfigurationIsRequired]:
    "La configuration d'envoie est requise",

  [tokens.organizations.organizationsTitle]: 'Organisations',
  [tokens.organizations.organizationTitle]: 'Organisation',

  [tokens.declarationProgress.title]: 'Nabu prépare votre dossier',
  [tokens.declarationProgress.subtitleReady]:
    'Vous pourrez compléter la déclaration dès qu’elle sera prête.',
  [tokens.declarationProgress.subtitleWaitingHuman]:
    'Une étape attend une intervention de votre part.',
  [tokens.declarationProgress.groupDocuments]: 'Vos pièces',
  [tokens.declarationProgress.groupData]: 'Lecture des données',
  [tokens.declarationProgress.groupDeclaration]: 'Votre déclaration',
  [tokens.declarationProgress.stateDone]: 'Terminé',
  [tokens.declarationProgress.stateRunning]: 'En cours…',
  [tokens.declarationProgress.stateBlocked]: 'En attente de vous',
  [tokens.declarationProgress.statePending]: 'En attente…',
  [tokens.declarationProgress.stepAwaitingUploadsLabel]:
    'Réception des fichiers',
  [tokens.declarationProgress.stepAwaitingUploadsHint]:
    'Dépôt et dézippage en cours…',
  [tokens.declarationProgress.stepFileProcessingLabel]: 'Lecture des pages',
  [tokens.declarationProgress.stepFileProcessingHint]:
    'Redressement, océrisation et reconnaissance des documents…',
  [tokens.declarationProgress.stepAwaitingClassificationLabel]:
    'Type de chaque document',
  [tokens.declarationProgress.stepAwaitingClassificationHint]:
    'Un document attend d’être typé.',
  [tokens.declarationProgress.stepExtractionLabel]: 'Extraction des données',
  [tokens.declarationProgress.stepExtractionHint]:
    'Lecture des pièces et rapprochement entre elles…',
  [tokens.declarationProgress.stepAwaitingReviewLabel]: 'Relecture d’une pièce',
  [tokens.declarationProgress.stepAwaitingReviewHint]:
    'Une lecture est jugée peu fiable et attend un œil.',
  [tokens.declarationProgress.stepAwaitingConfigurationLabel]:
    'Type de déclaration',
  [tokens.declarationProgress.stepAwaitingConfigurationHint]:
    'Le dossier attend sa configuration.',
  [tokens.declarationProgress.stepMappingLabel]: 'Génération de la déclaration',
  [tokens.declarationProgress.stepMappingHint]:
    'Déductions, référentiels et remplissage du formulaire…',
  [tokens.declarationProgress.stepInstructionRoutineLabel]: 'Application des instructions',
  [tokens.declarationProgress.stepInstructionRoutineHint]:
    'L’Assistant Nabu applique vos instructions automatiques à la déclaration…',
  [tokens.declarationProgress.stepAwaitingDeclarationLabel]: 'Déclaration prête',
  [tokens.declarationProgress.stepAwaitingDeclarationHint]:
    'Prête à être complétée.',
  [tokens.declarationProgress.resumeTitle]: 'Choisir le type de déclaration',
  [tokens.declarationProgress.resumeHint]:
    "Nabu n'a pas pu déduire le type de déclaration de ce dossier. Choisissez-le : les pièces déjà lues sont réutilisées.",
  [tokens.declarationProgress.resumeAction]: 'Générer la déclaration',
  [tokens.declarationProgress.resumeError]: 'La relance a échoué.',
  [tokens.declarationProgress.detailFiles]: 'Fichiers reçus : {{count}}',
  [tokens.declarationProgress.stepAssemblyLabel]: 'Assemblage des données',
  [tokens.declarationProgress.stepAssemblyHint]: 'Rapprochement des pièces selon le type choisi…',
  [tokens.declarationProgress.detailAssembly]: 'Envois : {{count}} · référence : {{backbone}}',
  [tokens.declarationProgress.detailAssemblyPlanner]: 'décidé par Nabu (confiance {{confidence}} %)',
  [tokens.declarationProgress.detailPages]: 'Pages lues : {{processed}} / {{total}}',
  [tokens.declarationProgress.detailDocuments]: '{{count}} documents : {{types}}',
  [tokens.declarationProgress.detailRead]: 'Pièces lues : {{read}} / {{total}}',
  [tokens.declarationProgress.detailBlocked]: 'À vérifier : {{document}} ({{reason}})',
  [tokens.declarationProgress.detailChosenAutomatically]: 'déduit des pièces',
  [tokens.declarationProgress.detailParties]: 'Vendeurs : {{sellers}} · Acheteurs : {{buyers}}',
  [tokens.declarationProgress.decType_import]: 'Import',
  [tokens.declarationProgress.decType_export]: 'Export',
  [tokens.declarationProgress.decType_ens]: 'Sûreté (ENS)',
  [tokens.declarationProgress.decType_transit]: 'Transit',

  [tokens.declarationValidationProgress.sectionRequired]: 'Champs obligatoires',
  [tokens.declarationValidationProgress.sectionBlocking]: 'Contrôles bloquants',

  [tokens.tariffClassification.statusValid]: 'Valide',
  [tokens.tariffClassification.statusIncomplete]: 'Incomplet',
  [tokens.tariffClassification.statusUnknown]: 'Inconnu',
  [tokens.tariffClassification.statusMissing]: 'À classer',
  [tokens.tariffClassification.authorAuto]: 'Auto',
  [tokens.tariffClassification.received]: 'reçu {{code}}',
  [tokens.tariffClassification.residual]: 'branche résiduelle',
  [tokens.tariffClassification.apply]: 'Appliquer {{code}}',
  [tokens.tariffClassification.cancel]: 'Annuler',
  [tokens.tariffClassification.close]: 'Fermer',
  [tokens.tariffClassification.productName]: 'Tarifill',
  [tokens.tariffClassification.colArticles]: 'Articles',
  [tokens.tariffClassification.bannerTitle]: 'Compléter {{count}} codes avec la branche « autres »',
  [tokens.tariffClassification.bannerTitle_one]: 'Compléter 1 code avec la branche « autres »',
  [tokens.tariffClassification.bannerBody]: 'Chapitres autorisés : {{chapters}} (liste de démonstration).',
  [tokens.tariffClassification.preview]: 'Vérifier et compléter',
  [tokens.tariffClassification.dialogTitle]: 'Compléter {{count}} codes vers Autres',
  [tokens.tariffClassification.dialogTitle_one]: 'Compléter 1 code vers Autres',
  [tokens.tariffClassification.dialogIntro]: 'Chaque code reçu est complété vers la branche résiduelle « Autres » sous son préfixe. Vérifiez le libellé avant de confirmer.',
  [tokens.tariffClassification.colReceived]: 'Reçu',
  [tokens.tariffClassification.colCompleted]: 'Déclaré après complétion',
  [tokens.tariffClassification.colLabel]: 'Libellé',
  [tokens.tariffClassification.skippedOutOfScope]: '{{count}} codes hors des chapitres autorisés restent à choisir vous-même.',
  [tokens.tariffClassification.skippedOutOfScope_one]: '1 code hors des chapitres autorisés reste à choisir vous-même.',
  [tokens.tariffClassification.skippedAmbiguous]: '{{count}} codes sans branche « Autres » unique restent à choisir vous-même.',
  [tokens.tariffClassification.skippedAmbiguous_one]: '1 code sans branche « Autres » unique reste à choisir vous-même.',
  [tokens.tariffClassification.autoNote]: 'Les codes resteront marqués « Auto » avec leur code reçu, et pourront être annulés.',
  [tokens.tariffClassification.confirm]: 'Compléter {{count}} codes',
  [tokens.tariffClassification.confirm_one]: 'Compléter 1 code',
  [tokens.tariffClassification.done]: '{{count}} codes complétés vers Autres',
  [tokens.tariffClassification.done_one]: '1 code complété vers Autres',
  [tokens.tariffClassification.undo]: 'Annuler',
  [tokens.tariffClassification.reasonAuto]: 'Tarifill : complété vers Autres',
  [tokens.tariffClassification.reasonUser]: 'Tarifill : code choisi',
  [tokens.tariffClassification.reasonUndo]: 'Tarifill : retour au code reçu',
  [tokens.tariffClassification.tourStepIntroTitle]: 'Tarifill, le classement tarifaire',
  [tokens.tariffClassification.tourStepIntroBody]: 'Tarifill vous aide à déclarer un code marchandise complet et valide pour chaque article. Rangez la fenêtre à gauche ou à droite, ou laissez-la flotter au-dessus de la grille. Suivez l’exemple pas à pas, sur votre dossier.',
  [tokens.tariffClassification.tourStepPreviewTitle]: 'Compléter vers « Autres » en une fois',
  [tokens.tariffClassification.tourStepPreviewBody]: 'Cet encart apparaît quand des codes incomplets peuvent être complétés vers leur branche « Autres », dans les chapitres autorisés pour votre organisation (sans risque : mécanique, plastiques…).',
  [tokens.tariffClassification.tourStepPreviewButtonTitle]: 'Vérifier et compléter',
  [tokens.tariffClassification.tourStepPreviewButtonBody]: 'Rien ne change avant votre accord : l’aperçu montre chaque complétion avant de l’appliquer. Ouvrons-le.',
  [tokens.tariffClassification.tourStepPreviewTitleTitle]: 'L’aperçu',
  [tokens.tariffClassification.tourStepPreviewTitleBody]: 'Combien de codes seront complétés, et dans quels chapitres autorisés.',
  [tokens.tariffClassification.tourStepPreviewTableTitle]: 'Une ligne par code reçu',
  [tokens.tariffClassification.tourStepPreviewTableBody]: '« Reçu » : le code tel qu’il est arrivé. « Déclaré après complétion » : le code à 10 chiffres. « Libellé » : ce qu’il couvre. « Articles » : combien d’articles le portent.',
  [tokens.tariffClassification.tourStepPreviewCheckboxTitle]: 'Exclure un code',
  [tokens.tariffClassification.tourStepPreviewCheckboxBody]: 'Décochez une ligne pour la laisser de côté : elle ne sera pas complétée et restera à traiter.',
  [tokens.tariffClassification.tourStepPreviewCompletedTitle]: 'Les chiffres ajoutés',
  [tokens.tariffClassification.tourStepPreviewCompletedBody]: 'Les chiffres que Tarifill ajoute sont surlignés : vous voyez d’un coup d’œil ce qui change.',
  [tokens.tariffClassification.tourStepPreviewLabelTitle]: 'Vérifier le libellé',
  [tokens.tariffClassification.tourStepPreviewLabelBody]: 'Le libellé du code et son chemin dans la nomenclature : relisez-les avant de confirmer.',
  [tokens.tariffClassification.tourStepPreviewSkippedTitle]: 'Ce qui reste à vous',
  [tokens.tariffClassification.tourStepPreviewSkippedBody]: 'Les codes hors des chapitres autorisés, ou sans branche « Autres » unique, ne sont pas complétés : ils restent dans « À traiter », pour votre choix.',
  [tokens.tariffClassification.tourStepPreviewAutoTitle]: 'Toujours traçable',
  [tokens.tariffClassification.tourStepPreviewAutoBody]: 'Les codes complétés sont marqués ✦ dans la grille et « Auto » dans Corrigés, avec le code reçu. Vous pouvez les annuler tant que la déclaration n’est pas envoyée.',
  [tokens.tariffClassification.tourStepPreviewConfirmTitle]: 'Confirmer',
  [tokens.tariffClassification.tourStepPreviewConfirmBody]: 'Un clic complète tous les codes cochés en un seul geste, visible dans l’historique. Un message propose ensuite « Annuler ».',
  [tokens.tariffClassification.tourStepCardTitle]: 'Un article, une carte',
  [tokens.tariffClassification.tourStepCardBody]: 'La désignation, le code reçu et son état. Ouverte, la carte dit ce qui existe et ce qui manque. Voici un article de votre dossier qui a plusieurs suites.',
  [tokens.tariffClassification.tourStepFiltersTitle]: 'Retrouver un article',
  [tokens.tariffClassification.tourStepFiltersBody]: 'Cherchez par numéro d’article, code ou mots de la désignation, filtrez par état ou par chapitre. Les articles à traiter viennent d’abord, par lots de 20.',
  [tokens.tariffClassification.tourStepReviewTitle]: 'Traiter en série',
  [tokens.tariffClassification.tourStepReviewBody]: 'Sur un gros dossier, les articles à compléter par groupe de même code et produit, au clavier : 1 à 9 applique une suite et passe au groupe suivant, ← → change de groupe, Échap revient à la liste.',
  [tokens.tariffClassification.tourStepDirectoryTargetTitle]: 'Pour qui on cherche',
  [tokens.tariffClassification.tourStepDirectoryTargetBody]: 'L’article auquel s’appliquera le code choisi.',
  [tokens.tariffClassification.tourStepDirectorySearchTitle]: 'Chercher',
  [tokens.tariffClassification.tourStepDirectorySearchBody]: 'Des chiffres (« 7318 15 ») ou des débuts de mots (« vis acier »), sans souci des accents. Les codes du dossier sortent en premier.',
  [tokens.tariffClassification.tourStepDirectoryScopeTitle]: 'Toute la nomenclature, ou nos articles',
  [tokens.tariffClassification.tourStepDirectoryScopeBody]: '« Toute la nomenclature » pour chercher ou parcourir les codes ; « Nos articles » pour voir les codes du dossier, regroupés.',
  [tokens.tariffClassification.tourStepGridTitle]: 'Dans la grille',
  [tokens.tariffClassification.tourStepGridBody]: 'Dans la case code, un badge dit où en est le code : Complet, Incomplet (plusieurs suites possibles), Inconnu (absent de la nomenclature) ou Auto (une seule suite possible : un clic sur le badge la pose). ✦ signale un code supposé par une machine, à vérifier. Au survol, quoi faire. Un clic dans la case ouvre Tarifill.',
  [tokens.tariffClassification.tourStepHelpTitle]: 'Revoir ce tour',
  [tokens.tariffClassification.tourStepHelpBody]: 'Ce bouton relance la visite à tout moment.',
  [tokens.tariffClassification.clearSearch]: 'Effacer la recherche',
  [tokens.tariffClassification.openTaric]: 'Voir sur TARIC',
  [tokens.tariffClassification.openTaricTooltip]: 'Fiche TARIC de {{code}} (Commission européenne) : ses mesures européennes pour l’origine de l’article',
  [tokens.tariffClassification.openRitaTooltip]: 'RITA (douane.gouv.fr) s’ouvre avec {{code}} prérempli : lancez la recherche pour voir aussi les mesures nationales',
  [tokens.tariffClassification.incompleteCount]: '{{count}} codes incomplets',
  [tokens.tariffClassification.incompleteCount_one]: '1 code incomplet',
  [tokens.tariffClassification.openInOtherWindow]: 'Ouvrir dans une autre fenêtre',
  [tokens.tariffClassification.openedInOtherWindow]: 'Tarifill est ouvert dans une autre fenêtre : un clic dans la case code y ouvre l’article.',
  [tokens.tariffClassification.otherWindowDisabled]: 'Tarifill n’est pas activé pour votre compte.',
  [tokens.tariffClassification.measureStateConditional]: 'Conditionnelle',
  [tokens.tariffClassification.measureStateInapplicable]: 'Inapplicable',
  [tokens.tariffClassification.browsePosition]: '{{position}} sur {{count}}',
  [tokens.tariffClassification.browsePrevious]: 'Article précédent (↑)',
  [tokens.tariffClassification.browseNext]: 'Article suivant (↓)',
  [tokens.tariffClassification.toCheck]: 'À vérifier',
  [tokens.tariffClassification.cellComplete]: 'Complet',
  [tokens.tariffClassification.cellAuto]: 'Auto',
  [tokens.tariffClassification.cellCompleteHint]: 'Code TARIC complet. Cliquez pour l’ouvrir dans Tarifill.',
  [tokens.tariffClassification.cellAutoHint]: 'Une seule suite possible : {{code}}. Cliquez pour compléter.',
  [tokens.tariffClassification.cellIncompleteHint]: '{{count}} suites possibles. Cliquez pour choisir dans Tarifill.',
  [tokens.tariffClassification.cellUnknownHint]: 'Aucun niveau de ce code n’existe. Cliquez pour le chercher dans Tarifill.',
  [tokens.tariffClassification.verifDecisionsTitle]: '{{count}} décisions de classement à prendre',
  [tokens.tariffClassification.verifDecisionsTitle_one]: '1 décision de classement à prendre',
  [tokens.tariffClassification.verifCompleteTitle]: 'Classement tarifaire complet',
  [tokens.tariffClassification.verifOpenTarifill]: 'Ouvrir Tarifill',
  [tokens.tariffClassification.verifContextLead]: 'Classement tarifaire :',
  [tokens.tariffClassification.verifContextLines]: 'lignes classées',
  [tokens.tariffClassification.verifContextRest]: '· reste à décider :',
  [tokens.tariffClassification.verifGroupChoice]: 'Choix du code',
  [tokens.tariffClassification.verifGroupAuto]: 'Une seule suite possible',
  [tokens.tariffClassification.verifPillChoice]: 'Choisir le code dans Tarifill',
  [tokens.tariffClassification.verifPillAuto]: 'Vérifier la suite proposée dans Tarifill',
  [tokens.tariffClassification.verifAnalysis]: 'Détail de l’analyse',
  [tokens.tariffClassification.verifRead]: 'Codes lus',
  [tokens.tariffClassification.verifReadValue]: '{{count}} codes, format normalisé',
  [tokens.tariffClassification.verifReadValue_one]: '1 code, format normalisé',
  [tokens.tariffClassification.verifValidStart]: 'Début de code valide',
  [tokens.tariffClassification.verifValidStartValue]: '{{count}} sur {{total}}',
  [tokens.tariffClassification.verifAuto]: 'Suite unique trouvée',
  [tokens.tariffClassification.verifAutoValue]: '{{count}} articles',
  [tokens.tariffClassification.verifAutoValue_one]: '1 article',
  [tokens.tariffClassification.completedByTarifill]: 'Complété par Tarifill avec la branche « autres »',
  [tokens.tariffClassification.receivedShort]: 'reçu',
  [tokens.tariffClassification.noDesignation]: 'Sans désignation',
  [tokens.tariffClassification.directoryLink]: 'Annuaire',
  [tokens.tariffClassification.treeLoading]: 'Chargement du chapitre…',
  [tokens.tariffClassification.treeFailed]: 'Le chapitre n’a pas pu être chargé.',
  [tokens.tariffClassification.tourStepDirectoryTreeTitle]: 'L’arborescence',
  [tokens.tariffClassification.tourStepDirectoryTreeBody]: 'Sans recherche, la nomenclature comme sur RITA, ouverte sur le code de l’article : codes déclarables en vert, et la pastille du nombre d’articles du dossier sous chaque niveau. Choisissez un code, puis « Appliquer ».',
  [tokens.tariffClassification.measuresDemoNote]: 'Mesures, droits et données RITA fictifs, à la forme prévue par TEC-1834 : le back ne les expose pas encore.',
  [tokens.tariffClassification.groupSplit]: 'Même code reçu pour {{count}} produits différents : à classer séparément.',
  [tokens.tariffClassification.moreDesignations]: '+{{count}} autres',
  [tokens.tariffClassification.reviewStart]: 'Traiter en série',
  [tokens.tariffClassification.reviewPosition]: 'Groupe {{position}} sur {{count}}',
  [tokens.tariffClassification.reviewDone]: 'Tous les groupes de la sélection sont traités.',
  [tokens.tariffClassification.reviewProgress]: '{{done}} sur {{total}} traités',
  [tokens.tariffClassification.reviewExit]: 'Quitter la série',
  [tokens.tariffClassification.reviewPrevious]: 'Précédent',
  [tokens.tariffClassification.reviewSkip]: 'Passer',
  [tokens.tariffClassification.reviewHintPick]: 'appliquer un code',
  [tokens.tariffClassification.reviewHintMove]: 'changer de groupe',
  [tokens.tariffClassification.keyEscape]: 'Échap',
  [tokens.tariffClassification.filterChapter]: 'Chapitre',
  [tokens.tariffClassification.filterAllChapters]: 'Tous les chapitres',
  [tokens.tariffClassification.chapterOption]: 'Chapitre {{chapter}} · {{count}} art.',
  [tokens.tariffClassification.showNext]: 'Afficher {{count}} de plus ({{remaining}} restants)',
  [tokens.tariffClassification.levelChapter]: 'Chapitre',
  [tokens.tariffClassification.levelHeading]: 'Position',
  [tokens.tariffClassification.levelSubheading]: 'Sous-position SH',
  [tokens.tariffClassification.levelCn]: 'Nomenclature combinée',
  [tokens.tariffClassification.levelTaric]: 'TARIC',
  [tokens.tariffClassification.askAssistant]: 'Demander à l’assistant',
  [tokens.tariffClassification.openRita]: 'Voir sur RITA',
  [tokens.tariffClassification.assistantPromptReceived]: 'Aide-moi à classer {{count}} articles reçus avec le code {{code}}.',
  [tokens.tariffClassification.assistantPromptReceived_one]: 'Aide-moi à classer un article reçu avec le code {{code}}.',
  [tokens.tariffClassification.assistantPromptMissing]: 'Aide-moi à classer {{count}} articles reçus sans code.',
  [tokens.tariffClassification.assistantPromptMissing_one]: 'Aide-moi à classer un article reçu sans code.',
  [tokens.tariffClassification.assistantPromptDesignations]: 'Désignations : {{list}}.',
  [tokens.tariffClassification.assistantPromptOrigin]: 'Origine : {{origin}}.',
  [tokens.tariffClassification.assistantPromptBranches]: 'Branches possibles dans la nomenclature : {{list}}.',
  [tokens.tariffClassification.assistantPromptAsk]: 'Propose le code marchandise à 10 chiffres le plus probable, explique ton raisonnement et dis ce que je dois vérifier avant de le déclarer.',
  [tokens.tariffClassification.missingDigits]: 'il manque {{count}} chiffres',
  [tokens.tariffClassification.missingDigits_one]: 'il manque 1 chiffre',
  [tokens.tariffClassification.notInNomenclature]: 'absent de la nomenclature',
  [tokens.tariffClassification.pickCandidate]: 'Choisissez le code, il s’applique aux {{count}} articles',
  [tokens.tariffClassification.pickCandidate_one]: 'Choisissez le code de l’article',
  [tokens.tariffClassification.help]: 'Comment ça marche',
  [tokens.tariffClassification.tourTitle]: 'Découvrir Tarifill',
  [tokens.tariffClassification.openTarifill]: 'Le classement tarifaire du dossier : Tarifill repère les codes marchandise incomplets ou inconnus, propose les branches de la nomenclature et garde la trace de chaque correction.',
  [tokens.tariffClassification.groupArticles]: '{{count}} articles',
  [tokens.tariffClassification.groupArticles_one]: '1 article',
  [tokens.tariffClassification.noCode]: 'Aucun code',
  [tokens.tariffClassification.searchInDirectory]: 'Chercher dans l’annuaire',
  [tokens.tariffClassification.directoryPlaceholder]: 'N’importe quel code ou mot-clé',
  [tokens.tariffClassification.directoryScopeAll]: 'Toute la nomenclature',
  [tokens.tariffClassification.directoryExtend]: 'Chercher aussi dans les autres chapitres',
  [tokens.tariffClassification.directoryNoResult]: 'Aucun code ne correspond.',
  [tokens.tariffClassification.directoryResults]: '{{count}} résultats',
  [tokens.tariffClassification.directoryResults_one]: '1 résultat',
  [tokens.tariffClassification.determinedDerived]: 'Déduit',
  [tokens.tariffClassification.determinedMasterData]: 'Référentiel',
  [tokens.tariffClassification.determinedDefault]: 'Règle',
  [tokens.tariffClassification.determinationTitle]: 'Déterminé par Nabu',
  [tokens.tariffClassification.determinationDerived]: 'Ce code n’est pas imprimé tel quel sur les pièces : Nabu l’a déduit.',
  [tokens.tariffClassification.determinationMasterData]: 'Repris du référentiel client {{name}}.',
  [tokens.tariffClassification.determinationMasterDataUnnamed]: 'Repris du référentiel client.',
  [tokens.tariffClassification.determinationDefault]: 'Posé par une règle, les pièces ne portant pas de code.',
  [tokens.tariffClassification.stateReady]: 'Prêt',
  [tokens.tariffClassification.statePartial]: 'À compléter',
  [tokens.tariffClassification.stateUnknown]: 'Introuvable',
  [tokens.tariffClassification.filterAll]: 'Tous',
  [tokens.tariffClassification.filterPartial]: 'À compléter',
  [tokens.tariffClassification.filterReady]: 'Prêts',
  [tokens.tariffClassification.filterUnknown]: 'Introuvables',
  [tokens.tariffClassification.readyArticles]: 'articles prêts',
  [tokens.tariffClassification.readyArticles_one]: 'article prêt',
  [tokens.tariffClassification.listSearchPlaceholder]: 'Article, code ou désignation',
  [tokens.tariffClassification.listEmpty]: 'Aucun article ne correspond.',
  [tokens.tariffClassification.articleNumber]: 'Article {{index}}',
  [tokens.tariffClassification.articleShort]: 'n° {{index}}',
  [tokens.tariffClassification.receivedCode]: 'Code reçu',
  [tokens.tariffClassification.noCodeShort]: 'aucun',
  [tokens.tariffClassification.originShort]: 'origine {{origin}}',
  [tokens.tariffClassification.partialIntro]: '{{prefix}} existe. Il manque le dernier niveau : {{count}} suites possibles.',
  [tokens.tariffClassification.partialIntro_one]: '{{prefix}} existe. Il manque le dernier niveau : une seule suite est possible.',
  [tokens.tariffClassification.partialPrefixOf]: '{{prefix}} (code reçu {{received}})',
  [tokens.tariffClassification.unknownIntro]: 'Aucun niveau de {{code}} n’existe dans la nomenclature. Cherchez le bon code dans l’annuaire.',
  [tokens.tariffClassification.missingIntro]: 'Cet article n’a pas de code. Cherchez-le dans l’annuaire.',
  [tokens.tariffClassification.nextLevels]: '{{count}} suites',
  [tokens.tariffClassification.nextLevels_one]: '1 suite',
  [tokens.tariffClassification.costAfterComplete]: 'Le coût estimé et les mesures s’affichent une fois le code complet.',
  [tokens.tariffClassification.openDirectoryFor]: 'Voir dans l’annuaire',
  [tokens.tariffClassification.openDetail]: 'Fiche de l’article',
  [tokens.tariffClassification.openTreeHere]: 'ouvrir l’arborescence ici',
  [tokens.tariffClassification.backToArticles]: 'Articles',
  [tokens.tariffClassification.pathTitle]: 'Chemin dans la nomenclature',
  [tokens.tariffClassification.costTitle]: 'Coût estimé à l’import',
  [tokens.tariffClassification.costNormal]: 'Taux normal',
  [tokens.tariffClassification.costPreference]: 'Préférence {{origin}}',
  [tokens.tariffClassification.costSituation]: 'Situation douanière',
  [tokens.tariffClassification.costOrigin]: 'Pays d’origine',
  [tokens.tariffClassification.costTerritory]: 'Territoire d’application',
  [tokens.tariffClassification.costTerritoryValue]: 'France continentale (CONTI)',
  [tokens.tariffClassification.costPreferentialOrigin]: 'Origine préférentielle',
  [tokens.tariffClassification.costNomenclature]: 'Nomenclature de dédouanement',
  [tokens.tariffClassification.costAdditionalCodes]: 'Codes additionnels',
  [tokens.tariffClassification.costValueData]: 'Données valeur',
  [tokens.tariffClassification.costInvoiced]: 'Valeur facturée',
  [tokens.tariffClassification.costCustomsValue]: 'Valeur en douane',
  [tokens.tariffClassification.costVatValue]: 'Valeur TVA',
  [tokens.tariffClassification.costCif]: 'Base CIF',
  [tokens.tariffClassification.costCifNo]: 'Non, fret non réparti',
  [tokens.tariffClassification.costNetMass]: 'Masse nette',
  [tokens.tariffClassification.costColCode]: 'Code',
  [tokens.tariffClassification.costColTax]: 'Taxation pré-calculée',
  [tokens.tariffClassification.costColRate]: 'Taux',
  [tokens.tariffClassification.costColAmount]: 'Montant',
  [tokens.tariffClassification.costDuty]: 'Droits de douane',
  [tokens.tariffClassification.costDutyThirdCountry]: 'TARIC · tiers pays',
  [tokens.tariffClassification.costDutyPreference]: 'TARIC · préférence {{agreement}}',
  [tokens.tariffClassification.costVat]: 'TVA à l’importation',
  [tokens.tariffClassification.costVatBasis]: 'RITA · sur la valeur TVA',
  [tokens.tariffClassification.costTotal]: 'Coût estimé',
  [tokens.tariffClassification.costNoValue]: 'Montants non chiffrés : la valeur en douane est inconnue (devise sans taux de change ou montant absent).',
  [tokens.tariffClassification.costRatesAt]: 'taux en vigueur au {{date}}',
  [tokens.tariffClassification.costCompareRita]: 'Comparer sur RITA',
  [tokens.tariffClassification.measuresSectionTitle]: 'Mesures et documents',
  [tokens.tariffClassification.measuresCount]: '{{count}} mesures',
  [tokens.tariffClassification.measuresCount_one]: '1 mesure',
  [tokens.tariffClassification.documentsCount]: '{{count}} documents',
  [tokens.tariffClassification.documentsCount_one]: '1 document',
  [tokens.tariffClassification.measureSourceTaric]: 'TARIC',
  [tokens.tariffClassification.measureSourceRita]: 'France · RITA',
  [tokens.tariffClassification.measureNationalCode]: 'Code additionnel national à choisir',
  [tokens.tariffClassification.measureVat]: 'TVA à l’import',
  [tokens.tariffClassification.documentToProvide]: 'Document à fournir :',
  [tokens.tariffClassification.documentRequired]: '{{document}}.',
  [tokens.tariffClassification.proofOptional]: '{{document}}, seulement si la préférence est demandée.',
  [tokens.tariffClassification.proofRequired]: '{{document}}. Requise : la préférence est demandée.',
  [tokens.tariffClassification.directoryFor]: 'Pour',
  [tokens.tariffClassification.directoryScopeOurs]: 'Nos articles · {{count}}',
  [tokens.tariffClassification.directoryOursPlaceholder]: 'Article, code ou libellé du dossier',
  [tokens.tariffClassification.directoryOursEmpty]: 'Aucun article du dossier ne correspond.',
  [tokens.tariffClassification.directoryChooseArticle]: 'Choisir un article…',
  [tokens.tariffClassification.inDossier]: 'Dans le dossier',
  [tokens.tariffClassification.dossierArticles]: 'Articles du dossier',
  [tokens.tariffClassification.viewInTree]: 'Voir dans l’arborescence',
  [tokens.tariffClassification.completeInTree]: 'Compléter dans l’arborescence',
  [tokens.tariffClassification.usedByArticles]: 'Utilisé par {{count}} articles du dossier',
  [tokens.tariffClassification.usedByArticles_one]: 'Utilisé par 1 article du dossier',
  [tokens.tariffClassification.chapterCode]: 'Chapitre {{chapter}}',
  [tokens.tariffClassification.treeSearched]: 'Nomenclature recherchée :',
  [tokens.tariffClassification.treeNone]: 'aucune',
  [tokens.tariffClassification.tourStepCardApplyTitle]: 'Appliquer',
  [tokens.tariffClassification.tourStepCardApplyBody]: 'Le code choisi va dans la case de l’article, en un geste de l’historique. « Annuler » rend le code d’avant.',
  [tokens.tariffClassification.tourStepCardCostTitle]: 'Coût et mesures',
  [tokens.tariffClassification.tourStepCardCostBody]: 'Un code complet montre le coût estimé à l’import (droits et TVA, avec ou sans préférence) et les mesures et documents qu’il déclenche. Jamais un faux chiffre : ce qui ne se calcule pas reste en x xxx,xx €.',
  [tokens.tariffClassification.tourStepCardOptionsTitle]: 'Choisir la suite',
  [tokens.tariffClassification.tourStepCardOptionsBody]: 'Chaque suite avec son libellé officiel. « Branche résiduelle » marque « autres », cochée d’avance dans les chapitres sans risque. Les drapeaux ouvrent le code sur TARIC (mesures européennes) ou RITA (mesures françaises).',
  [tokens.tariffClassification.tourStepCardPathTitle]: 'Les niveaux reconnus',
  [tokens.tariffClassification.tourStepCardPathBody]: 'Chaque niveau coché existe dans la nomenclature ; un clic ouvre l’annuaire à ce niveau. La puce orange compte les suites possibles. Le livre ouvre l’annuaire pour l’article, le i sa fiche.',
  [tokens.tariffClassification.tourStepDetailBrowseTitle]: 'La fiche d’un article',
  [tokens.tariffClassification.tourStepDetailBrowseBody]: 'Une page par article. Les flèches ↑ ↓, ou celles du clavier, passent à l’article voisin sans revenir à la liste ; la grille suit. « Articles » ramène à la liste.',
  [tokens.tariffClassification.tourStepDetailCodeTitle]: 'Le code en grand',
  [tokens.tariffClassification.tourStepDetailCodeBody]: 'Le code déclaré, son état, d’où il vient (déduit, référentiel, règle) et le code reçu s’il a changé.',
  [tokens.tariffClassification.tourStepDetailPathTitle]: 'Le chemin complet',
  [tokens.tariffClassification.tourStepDetailPathBody]: 'Du chapitre au code, chaque niveau avec son libellé. Un clic ouvre l’annuaire à ce niveau.',
  [tokens.tariffClassification.tourStepDirectoryButtonTitle]: 'L’annuaire',
  [tokens.tariffClassification.tourStepDirectoryButtonBody]: 'Ce bouton ouvre l’annuaire pour tout le dossier ; depuis une carte ou une fiche, il s’ouvre pour l’article.',
  [tokens.tariffClassification.tourStepSummaryTitle]: 'Où en est le dossier',
  [tokens.tariffClassification.tourStepSummaryBody]: 'Combien d’articles sont prêts, et une barre : un trait par article, vert s’il est prêt, orange s’il est à compléter, rouge s’il est introuvable.',
  [tokens.declarationKeyboard.shortcutSourceDocument]: 'Document source (plein écran)',
  [tokens.declarationKeyboard.shortcutDauRecap]: 'Récap DAU',
  [tokens.declarationKeyboard.shortcutShowHints]: 'Ouvrir / fermer les raccourcis',
  [tokens.declarationKeyboard.hintsDialogTitle]: 'Raccourcis clavier',
  [tokens.declarationKeyboard.panelSubtitle]: 'Se ferme au prochain clic ou avec Échap',
  [tokens.declarationKeyboard.panelSearchPlaceholder]: 'Rechercher un raccourci',
  [tokens.declarationKeyboard.panelSearchEmpty]: 'Aucun raccourci pour « {{query}} »',
  [tokens.declarationKeyboard.panelContextBadge]: 'Contexte actuel',
  [tokens.declarationKeyboard.panelClose]: 'Fermer (Échap)',
  [tokens.declarationKeyboard.panelFooterToggle]: '<key/> ouvrir / fermer',
  [tokens.declarationKeyboard.shortcutStepNavigation]: 'Onglet précédent / suivant',
  [tokens.declarationKeyboard.shortcutFocusSearch]: 'Rechercher un champ',
  [tokens.declarationKeyboard.shortcutOpenSettings]: 'Réglages',
  [tokens.declarationKeyboard.shortcutCopyNabuNumber]: 'Copier le numéro Nabu',
  [tokens.declarationKeyboard.shortcutOpenHistory]: 'Historique de la déclaration',
  [tokens.declarationKeyboard.shortcutMoveCell]: 'Cellule voisine',
  [tokens.declarationKeyboard.shortcutEditCell]: 'Modifier la cellule',
  [tokens.declarationKeyboard.shortcutLeaveCell]: 'Quitter la saisie',
  [tokens.declarationKeyboard.keyEnter]: 'Entrée',
  [tokens.declarationKeyboard.keyEscape]: 'Échap',
  [tokens.declarationKeyboard.keySpace]: 'Espace',
  [tokens.declarationKeyboard.shortcutToggleArticleGrid]:
    'Activer ou désactiver la navigation du tableau',
  [tokens.declarationKeyboard.shortcutOpenTarifill]: 'Ouvrir ou fermer Tarifill',
  [tokens.declarationKeyboard.categoryNavigate]: 'Se déplacer · {{command}} + touche',
  [tokens.declarationKeyboard.categoryOpen]: 'Ouvrir et agir · {{commandShift}} + initiale',
  [tokens.declarationKeyboard.categoryEdit]: 'Corriger',
  [tokens.declarationKeyboard.categoryAssistant]: 'Assistant Nabu',
  [tokens.declarationKeyboard.categoryGrid]: 'Dans le tableau',
  [tokens.declarationKeyboard.categoryDocument]: 'Dans le document source',
  [tokens.declarationKeyboard.shortcutSourceDocumentSwitch]: 'Document précédent ou suivant',
  [tokens.declarationKeyboard.shortcutSourceDocumentPage]: 'Page précédente ou suivante',
  [tokens.declarationKeyboard.shortcutSourceDocumentZoom]: 'Agrandir ou réduire',
  [tokens.declarationKeyboard.shortcutSourceDocumentResetZoom]: 'Revenir à 100 %',
  [tokens.declarationKeyboard.shortcutSourceDocumentRotate]: 'Pivoter la page à droite ou à gauche',
  [tokens.declarationKeyboard.shortcutSourceDocumentSearch]: 'Rechercher dans le document',
  [tokens.declarationKeyboard.shortcutSourceDocumentPan]: 'Maintenir et glisser pour se déplacer',
  [tokens.declarationKeyboard.copyNabuNumberTooltip]: 'Copier le numéro Nabu',

  [tokens.declarationUi.saving]: 'Enregistrement…',
  [tokens.declarationUi.stateGenerated]: 'À préparer',
  [tokens.declarationUi.stateInReview]: 'En cours de correction',
  [tokens.declarationUi.stateReady]: 'Validée, envoi en attente des autres déclarations',
  [tokens.declarationUi.stateSent]: 'Transmise',
  [tokens.declarationUi.stateAccepted]: 'Acceptée',
  [tokens.declarationUi.stateRejected]: 'Rejetée',
  [tokens.declarationUi.stateSuperseded]: 'Remplacée',
  [tokens.declarationUi.fieldRequiredError]: 'Champ obligatoire non renseigné',
  [tokens.declarationUi.catalogLoading]: 'Chargement…',
  [tokens.declarationUi.fieldMaxLengthError]:
    '{{max}} caractères maximum, {{count}} saisis',
  [tokens.declarationUi.fieldRejected]: '« {{value}} » non enregistré : {{reason}}',
  [tokens.declarationUi.sourceManualTooltip]:
    'Saisie par un opérateur humain sur cet écran.',
  [tokens.declarationUi.sourceRoutineTooltip]:
    'Écrite par la routine « {{routine}} », instruction « {{instruction}} ».',
  [tokens.declarationUi.sourceComputed]: 'Calculé',
  [tokens.declarationUi.sourceDerived]: 'Déduit',
  [tokens.declarationUi.sourceMasterData]: 'Référentiel client',
  [tokens.declarationUi.sourceDefault]: 'Valeur par défaut',
  [tokens.declarationUi.sourceManual]: 'Saisi',
  [tokens.declarationUi.sourceConsolidated]: 'Consolidé',
  [tokens.declarationUi.sourceRemote]: 'Retour douane',
  [tokens.declarationUi.sourceSetting]: 'Réglage',
  [tokens.declarationUi.sourceSettingFlux]: 'Réglage du modèle « {{name}} »',
  [tokens.declarationUi.sourceSettingFluxUnnamed]: 'Réglage du modèle',
  [tokens.declarationUi.sourceSettingGroup]: 'Réglage de l’agence',
  [tokens.declarationUi.sourceSettingUser]: 'Réglage de l’utilisateur',
  [tokens.declarationUi.sourcePieceSaid]: 'La pièce disait « {{value}} »',
  [tokens.declarationUi.evidenceExtracted]: 'Valeur lue',

  [tokens.declarationUi.title]: 'Déclaration',
  [tokens.declarationUi.loading]: 'Chargement de la déclaration…',
  [tokens.declarationUi.notFound]: "Ce dossier n'a pas de déclaration agentique.",
  [tokens.declarationUi.error]: 'La déclaration n’a pas pu être chargée.',
  [tokens.declarationUi.interfaceClassic]: 'Documents à gauche',
  [tokens.declarationUi.interfaceSections]: 'Sections',
  [tokens.declarationUi.showDocument]: 'Afficher le document',
  [tokens.declarationUi.showOrigin]: 'Afficher la source',
  [tokens.declarationUi.hideDocument]: 'Masquer le document',
  [tokens.declarationUi.validate]: 'Valider la déclaration',
  [tokens.declarationUi.validateAndSend]: 'Valider et envoyer',
  [tokens.declarationUi.validated]: 'Déclaration validée',
  [tokens.declarationUi.blockedHint]: 'Corrigez les anomalies bloquantes pour valider',
  [tokens.declarationUi.progressRequired]: 'champs obligatoires',
  [tokens.declarationUi.sectionCountRequired]:
    '{{filled}} des {{total}} champs obligatoires de cette section',
  [tokens.declarationUi.sectionCountRequired_one]:
    '{{filled}} des {{total}} champ obligatoire de cette section',
  [tokens.declarationUi.sectionCountOptional]:
    ' · {{optional}} champs facultatifs non renseignés, qui n’empêchent pas de valider',
  [tokens.declarationUi.sectionCountOptional_one]:
    ' · {{optional}} champ facultatif non renseigné, qui n’empêche pas de valider',
  [tokens.declarationUi.progressFilled]: 'renseignés',
  [tokens.declarationUi.anomalies]: 'Points de vigilance',
  [tokens.declarationUi.severityBlocking]: 'Bloquant',
  [tokens.declarationUi.severityInfo]: 'Info',
  [tokens.declarationUi.seeDetail]: 'Voir le détail',
  [tokens.declarationUi.hideDetail]: 'Masquer',
  [tokens.declarationUi.seeInfos]: 'Voir les points d’info',
  [tokens.declarationUi.hideInfos]: 'Masquer les points d’info',
  [tokens.declarationUi.linesConcerned]: 'Lignes concernées',
  [tokens.declarationUi.totalMismatchTitle]:
    'Le total du document et la somme des lignes ne correspondent pas',
  [tokens.declarationUi.totalMismatchTitleReference]:
    'Le total retenu et la somme des lignes ne correspondent pas',
  [tokens.declarationUi.totalMismatchValues]:
    'Document : {{reference}} · Somme des lignes ({{count}}) : {{lines}} · Écart : {{gap}}',
  [tokens.declarationUi.totalMismatchValuesReference]:
    'Total retenu : {{reference}} · Somme des lignes ({{count}}) : {{lines}} · Écart : {{gap}}',
  [tokens.declarationUi.totalLinesMissingTitle]:
    'Le document annonce un total, mais aucune ligne n’a de valeur',
  [tokens.declarationUi.totalLinesMissingValues]:
    'Document : {{reference}} · Lignes renseignées : 0 sur {{count}}',
  [tokens.declarationUi.totalNoticeHint]:
    'Pour information, l’envoi n’est pas bloqué. Vérifiez les valeurs des articles ou le total du document.',
  [tokens.declarationUi.lineCount]: 'Nombre de lignes',
  [tokens.declarationUi.goToLine]: 'Aller à la ligne',
  [tokens.declarationUi.completion]: 'Complétion · champs obligatoires',
  [tokens.declarationUi.searchField]: 'Chercher une donnée',
  [tokens.declarationUi.onlyBlocking]: 'Champs obligatoires manquants',
  [tokens.declarationUi.expandAll]: 'Déplier les sections à compléter',
  [tokens.declarationUi.nothingToExpand]: 'Aucune section à compléter',
  [tokens.declarationUi.collapseAll]: 'Replier toutes les sections',
  [tokens.declarationUi.expandRubrique]: 'Déplier la rubrique',
  [tokens.declarationUi.collapseRubrique]: 'Replier la rubrique',
  [tokens.declarationUi.mailThread]: "Fil d'e-mails",
  [tokens.declarationUi.emailSource]: 'E-mail source',
  [tokens.declarationUi.collapseRail]: 'Replier le panneau',
  [tokens.declarationUi.expandRail]: 'Déplier le panneau',
  [tokens.declarationUi.noMatch]: 'Aucune donnée ne correspond.',
  [tokens.declarationUi.noFieldsInStep]: 'Aucun champ dans cette étape.',
  [tokens.declarationUi.fieldSearchRecent]: 'Recherches récentes',
  [tokens.declarationUi.fieldSearchToComplete]: 'À compléter',
  [tokens.declarationUi.fieldSearchToCompleteHint]: 'Ne montrer que les champs obligatoires vides ou en erreur',
  [tokens.declarationUi.fieldSearchMissing]: 'Manquant',
  [tokens.declarationUi.fieldSearchInError]: 'En erreur',
  [tokens.declarationUi.fieldSearchSynonymsProcedure]: 'régime procédure code régime 4000 4200 1000 1040',
  [tokens.declarationUi.fieldSearchSynonymsIncoterm]: 'incoterm conditions de livraison EXW FCA FAS FOB CFR CIF CPT CIP DAP DPU DDP',
  [tokens.declarationUi.fieldSearchSynonymsCustomsOffice]: 'bureau de douane bureau de dédouanement bureau de sortie',
  [tokens.declarationUi.fieldSearchSynonymsIdentification]: 'EORI SIRET numéro d\'identification identifiant TVA',
  [tokens.declarationUi.fieldSearchSynonymsSupportingDocument]: 'document d\'accompagnement justificatif certificat licence facture N380 N935 N325 EUR.1',
  [tokens.declarationUi.fieldSearchSynonymsPreviousDocument]: 'document précédent document antérieur apurement',
  [tokens.declarationUi.fieldSearchSynonymsContainer]: 'conteneur container TC',
  [tokens.declarationUi.fieldSearchSynonymsTransport]: 'transport moyen de transport mode de transport navire avion camion immatriculation vol',
  [tokens.declarationUi.fieldSearchSynonymsLocationOfGoods]: 'localisation des marchandises emplacement MADT magasin',
  [tokens.declarationUi.fieldSearchSynonymsConsignee]: 'destinataire',
  [tokens.declarationUi.fieldSearchSynonymsExporter]: 'exportateur expéditeur',
  [tokens.declarationUi.fieldSearchSynonymsImporter]: 'importateur',
  [tokens.declarationUi.fieldSearchSynonymsRepresentative]: 'représentant mandataire commissionnaire',
  [tokens.declarationUi.fieldSearchSynonymsDeclarant]: 'déclarant',
  [tokens.declarationUi.fieldSearchSynonymsReference]: 'référence LRN UCR numéro de dossier',
  [tokens.declarationUi.fieldSearchSynonymsDeclarationType]: 'type de déclaration',
  [tokens.declarationUi.fieldSearchSynonymsOrigin]: 'origine pays d\'origine',
  [tokens.declarationUi.keyboardNext]: 'champ suivant',
  [tokens.declarationUi.keyboardCommit]: 'valider',
  [tokens.declarationUi.fields]: 'Champs',
  [tokens.declarationUi.add]: 'Ajouter',
  [tokens.declarationUi.remove]: 'Retirer',
  [tokens.declarationUi.noOccurrence]: 'Aucune occurrence',
  [tokens.declarationUi.sourceDocument]: 'Document source',
  [tokens.declarationUi.control]: 'Contrôle & validation',
  [tokens.declarationUi.notOnDocument]:
    'aucun total imprimé trouvé · comparaison indisponible',
  [tokens.declarationUi.notIdentified]: 'non identifié',
  [tokens.declarationUi.clear]: 'Effacer',
  [tokens.declarationUi.howObtained]: 'Comment cette valeur a été obtenue',
  [tokens.declarationUi.noAnomaly]: 'Aucune anomalie : la déclaration est prête.',
  [tokens.declarationUi.fix]: 'Corriger cette anomalie',
  [tokens.declarationUi.guidedReview]: 'Revue guidée',
  [tokens.declarationUi.locate]: 'Localiser',
  [tokens.declarationUi.previous]: 'Précédent',
  [tokens.declarationUi.next]: 'Suivant',
  [tokens.declarationUi.close]: 'Fermer',
  [tokens.declarationUi.totals]: 'Totaux',
  [tokens.declarationUi.documentTotal]: 'Total du document',
  [tokens.declarationUi.linesTotal]: 'Somme des lignes',
  [tokens.declarationUi.verdictEqual]: 'Identique',
  [tokens.declarationUi.verdictDiffers]: 'Écart',
  [tokens.declarationUi.verdictMissing]: 'Aucun total sur les documents',
  [tokens.declarationUi.verdictLinesMissing]: 'Lignes non renseignées',
  [tokens.declarationUi.totalEmpty]: 'Aucune ligne ne porte cette grandeur, et aucune pièce ne l\'imprime',
  [tokens.declarationUi.referenceManual]: 'Saisi',
  [tokens.declarationUi.referenceLines]: 'Somme des lignes retenue',
  [tokens.declarationUi.referenceReading]: 'Retenu',
  [tokens.declarationUi.alsoReadOn]: 'aussi lu sur',
  [tokens.declarationUi.enterTotal]: 'Saisir le total',
  [tokens.declarationUi.editTotal]: 'Modifier le total',
  [tokens.declarationUi.enterPlaceholder]: 'Saisir',
  [tokens.declarationUi.readOn]: 'Lu sur',
  [tokens.declarationUi.computedSum]: 'Somme des totaux de {{count}} pièces',
  [tokens.declarationUi.readShort]: 'lu',
  [tokens.declarationUi.pageShort]: 'p. {{page}}',
  [tokens.declarationUi.notDeclared]: 'non déclaré',
  [tokens.declarationUi.verdictGap]: 'Écart de {{value}}',
  [tokens.declarationUi.offerKeepLines]: 'Retenir la somme des lignes ({{value}})',
  [tokens.declarationUi.offerKeepReading]: 'Retenir {{value}} ({{piece}})',
  [tokens.declarationUi.offerClearReference]: 'Revenir au total lu',
  [tokens.declarationUi.distributeTotal]: 'Répartir sur les articles',
  [tokens.declarationUi.distributeTitle]: 'Répartir le total sur les articles',
  [tokens.declarationUi.distributeSummary]: 'Répartir {{amount}} sur {{count}} articles.',
  [tokens.declarationUi.distributeSummary_one]: 'Répartir {{amount}} sur {{count}} article.',
  [tokens.declarationUi.distributeEvenly]: 'En parts égales',
  [tokens.declarationUi.distributeProrata]: 'Au prorata de',
  [tokens.declarationUi.distributePackages]: '{{amount}} sur le premier article, les autres articles passent à 0 : aucune pièce n’imprime sa part des colis.',
  [tokens.declarationUi.distributePackagesPerDocument]: 'Chaque pièce sur son premier article',
  [tokens.declarationUi.distributePackagesPerDocumentHint]: 'La part de chaque pièce, 0 sur ses autres articles',
  [tokens.declarationUi.distributePackagesFirstLine]: 'Tout sur le premier article',
  [tokens.declarationUi.distributePackagesFirstLineHint]: '{{amount}} sur le premier article, 0 sur les autres',
  [tokens.declarationUi.distributeOverwrite]: 'Les {{count}} valeurs déjà présentes seront remplacées.',
  [tokens.declarationUi.distributeOverwrite_one]: 'La valeur déjà présente sera remplacée.',
  [tokens.declarationUi.distributeConfirm]: 'Répartir',
  [tokens.declarationUi.distributeInvoice]: 'Répartir sur cette pièce',
  [tokens.declarationUi.distributeInvoiceUndo]: 'Annuler la répartition sur cette pièce',
  [tokens.declarationUi.distributeMenuTitle]:
    'Répartir {{amount}} sur les {{count}} articles de {{invoice}}',
  [tokens.declarationUi.distributeMenuTitle_one]:
    'Répartir {{amount}} sur l’article de {{invoice}}',
  [tokens.declarationUi.distributeEqualOption]: 'À parts égales',
  [tokens.declarationUi.distributeEqualHint]: 'La même part pour chaque article',
  [tokens.declarationUi.distributeProrataOption]: 'Au prorata : {{label}}',
  [tokens.declarationUi.distributeProrataHint]:
    'Selon la valeur de chaque article dans cette colonne',
  [tokens.declarationUi.distributeFirstLineOption]: 'Tout sur le premier article',
  [tokens.declarationUi.distributeFirstLineHint]: 'Les autres articles de la facture passent à 0',
  [tokens.declarationUi.revertConfirmText]: 'Annuler « {{title}} » annule aussi :',
  [tokens.declarationUi.revertConfirmTextGeneric]: 'Annuler ce geste annule aussi :',
  [tokens.declarationUi.revertDialogTitleGeneric]: 'Annuler un geste',
  [tokens.declarationUi.revertKeep]: 'Garder',
  [tokens.declarationUi.revertConfirm]: 'Annuler les {{count}} gestes',
  [tokens.declarationUi.undoLast]: 'Annuler',
  [tokens.declarationUi.redoLast]: 'Rétablir',
  [tokens.declarationUi.sourceDistributed]: 'Réparti',
  [tokens.declarationUi.articlesFilled]: '{{filled}}/{{total}} articles renseignés',
  [tokens.declarationUi.articles]: 'Articles',
  [tokens.declarationUi.columns]: 'Colonnes',
  [tokens.declarationUi.allColumns]: 'Toutes les colonnes',
  [tokens.declarationUi.usefulColumns]: 'Colonnes renseignées',
  [tokens.declarationUi.addLine]: 'Ajouter un article',
  [tokens.declarationUi.addColumn]: 'Ajouter une colonne',
  [tokens.declarationUi.addColumnSpecific]: 'Ajouter une colonne spécifique',
  [tokens.declarationUi.searchArticles]: 'Rechercher un article',
  [tokens.declarationUi.ocrPasteHint]: '{{count}} valeurs copiées. Cliquez une case du tableau.',
  [tokens.declarationUi.ocrPasteSame]: 'Tout dans cette case',
  [tokens.declarationUi.ocrPasteDown]: 'Une valeur par case, vers le bas',
  [tokens.declarationUi.ocrPasteRight]: 'Une valeur par case, vers la droite',
  [tokens.declarationUi.ocrPasteDismiss]: 'Fermer',
  [tokens.declarationUi.ocrPasteTruncated]: '{{count}} valeurs n’ont pas trouvé de case.',
  [tokens.declarationUi.noLineMatch]: 'Aucun article ne correspond à la recherche.',
  [tokens.declarationUi.linesGroupCount]: '{{count}} articles',
  [tokens.declarationUi.linesGroupCount_one]: '{{count}} article',
  [tokens.declarationUi.linesGroupOther]: 'Autres articles',
  [tokens.declarationUi.linesGroupUnknownPiece]: 'Pièce inconnue',
  [tokens.declarationUi.linesGroupCollapse]: 'Replier la facture',
  [tokens.declarationUi.linesGroupExpand]: 'Déplier la facture',
  [tokens.declarationUi.linesGroupCollapsePiece]: 'Replier la pièce',
  [tokens.declarationUi.linesGroupExpandPiece]: 'Déplier la pièce',
  [tokens.declarationUi.linesGroupsToolbar]: 'Factures',
  [tokens.declarationUi.linesGroupsToolbarPieces]: 'Pièces',
  [tokens.declarationUi.linesGroupsCollapseAll]: 'Tout replier',
  [tokens.declarationUi.linesGroupsExpandAll]: 'Tout déplier',
  [tokens.declarationUi.invoiceTotalsTitle]: 'Totaux par facture',
  [tokens.declarationUi.invoiceTotalsTitlePieces]: 'Totaux par pièce',
  [tokens.declarationUi.invoiceTotalsLines]: 'Somme des lignes articles : {{value}}',
  [tokens.declarationUi.invoiceTotalsNotPrinted]: 'Somme des lignes articles, sans chiffre propre',
  [tokens.declarationUi.filterColumns]: 'Filtrer {{count}} colonnes…',
  [tokens.declarationUi.columnTypeText]: 'Texte',
  [tokens.declarationUi.columnTypeNumber]: 'Nombre',
  [tokens.declarationUi.columnTypeInteger]: 'Entier',
  [tokens.declarationUi.columnTypeDate]: 'Date',
  [tokens.declarationUi.columnTypeDateTime]: 'Date/heure',
  [tokens.declarationUi.columnTypeBoolean]: 'Booléen',
  [tokens.declarationUi.columnTypeCode]: 'Code',
  [tokens.declarationUi.noColumnMatch]: 'Aucune colonne correspondante',
  [tokens.declarationUi.removeColumn]: 'Retirer la colonne',
  [tokens.declarationUi.setColumn]: 'Appliquer une valeur à toute la colonne',
  [tokens.declarationUi.setColumnTitle]: '« {{label}} » sur les {{count}} articles',
  [tokens.declarationUi.setColumnTitle_one]: '« {{label}} » sur l’article',
  [tokens.declarationUi.setColumnReplaces]: '{{count}} valeurs existantes seront remplacées',
  [tokens.declarationUi.setColumnReplaces_one]: '1 valeur existante sera remplacée',
  [tokens.declarationUi.setColumnApply]: 'Appliquer',
  [tokens.declarationUi.reorderColumn]: 'Réordonner la colonne',
  [tokens.declarationUi.pinColumn]: 'Figer la colonne',
  [tokens.declarationUi.unpinColumn]: 'Libérer la colonne',
  [tokens.declarationUi.noLines]: 'Aucune ligne d’article.',
  [tokens.declarationUi.documents]: 'Documents',
  [tokens.declarationUi.piecePages]: 'p. {{range}}',
  [tokens.declarationUi.pieceSheet]: 'feuille {{index}}',
  [tokens.declarationUi.pieceFilePages]: '{{count}} p.',
  [tokens.declarationUi.pieceFileSheets]: '{{count}} feuilles',
  [tokens.declarationUi.pieceDated]: 'du {{date}}',
  [tokens.declarationUi.pieceNumberNotRead]: 'N° non lu',
  [tokens.declarationUi.pieceNotUsed]: 'Non utilisée par la déclaration',
  [tokens.declarationUi.pieceEmail]: 'Email',
  [tokens.declarationUi.previousPiece]: 'Pièce précédente',
  [tokens.declarationUi.nextPiece]: 'Pièce suivante',
  [tokens.declarationUi.pieceNavHint]: 'Pièce précédente / suivante, dans cet ordre',
  [tokens.declarationUi.previousPage]: 'Page précédente',
  [tokens.declarationUi.nextPage]: 'Page suivante',
  [tokens.declarationUi.scrollToTop]: 'Haut du document',
  [tokens.declarationUi.scrollToBottom]: 'Bas du document',
  [tokens.declarationUi.resizeForm]: 'Redimensionner le formulaire',
  [tokens.declarationUi.zoomIn]: 'Agrandir',
  [tokens.declarationUi.zoomOut]: 'Réduire',
  [tokens.declarationUi.resetZoom]: 'Taille réelle',
  [tokens.declarationUi.rotateLeft]: 'Pivoter la page à gauche',
  [tokens.declarationUi.rotateRight]: 'Pivoter la page à droite',
  [tokens.declarationUi.fitPage]: 'Ajuster à la page',
  [tokens.declarationUi.showThumbnails]: 'Afficher les miniatures',
  [tokens.declarationUi.hideThumbnails]: 'Masquer les miniatures',
  [tokens.declarationUi.searchInDocument]: 'Rechercher dans le document',
  [tokens.declarationUi.searchPlaceholder]: 'Rechercher dans la pièce…',
  [tokens.declarationUi.searchLoading]: 'Lecture du texte…',
  [tokens.declarationUi.searchNoResult]: 'Aucun résultat',
  [tokens.declarationUi.searchPrevious]: 'Résultat précédent',
  [tokens.declarationUi.searchNext]: 'Résultat suivant',
  [tokens.declarationUi.searchClose]: 'Fermer la recherche',
  [tokens.declarationUi.openOriginal]: 'Ouvrir le fichier d’origine',
  [tokens.declarationUi.noDocument]: 'Aucun document.',
  [tokens.declarationUi.previewUnavailable]: 'Aperçu indisponible',
  [tokens.declarationUi.loadingPreview]: 'Chargement…',
  [tokens.declarationUi.citation]: 'Citation',
  [tokens.declarationUi.origin]: 'Source',
  [tokens.declarationUi.openCalendar]: 'Ouvrir le calendnaire',
  [tokens.declarationUi.empty]: 'Non renseigné',
  [tokens.declarationUi.required]: 'Obligatoire',
  [tokens.declarationUi.outOfForm]: 'Lues hors formulaire',
  [tokens.declarationUi.conflictReload]:
    'La déclaration a changé pendant votre saisie. L’écran vient d’être rechargé : reprenez votre correction.',
  [tokens.declarationUi.rejected]: 'Correction refusée',
  [tokens.declarationUi.operationSum]: 'Somme',
  [tokens.declarationUi.operationProduct]: 'Produit',
  [tokens.declarationUi.operationProrata]: 'Prorata',
  [tokens.declarationUi.operationRequalification]: 'Requalification',
  [tokens.declarationUi.computedFromReadings]:
    '{{operation}} de {{count}} lecture(s) : {{terms}}',
  [tokens.declarationUi.pageNumber]: 'page {{page}}',
  [tokens.declarationUi.prepareDeclarationTitle]: 'Panneau de contrôle',
  [tokens.declarationUi.reviewIntro]: 'Complétez les champs manquants, puis vérifiez les écarts avec les pièces. Chaque correction est enregistrée automatiquement.',
  [tokens.declarationUi.reviewUnblocked]: 'Les contrôles bloquants sont levés. La validation reste une action explicite.',
  [tokens.declarationUi.reviewGroupBlocking]: 'À compléter',
  [tokens.declarationUi.reviewGroupToCheck]: 'À vérifier',
  [tokens.declarationUi.reviewGroupInfo]: 'Informations',
  [tokens.declarationUi.reviewGroupDecided]: 'Décisions enregistrées',
  [tokens.declarationUi.reviewIssueCount]: '{{count}} points',
  [tokens.declarationUi.reviewIssueCount_one]: '{{count}} point',
  [tokens.declarationUi.reviewLines]: 'Articles : {{lines}}',
  [tokens.declarationUi.reviewComplete]: 'Compléter ({{count}})',
  [tokens.declarationUi.reviewCheckValues]: 'Vérifier les valeurs',
  [tokens.declarationUi.reviewShowReadings]: 'Voir les lectures',
  [tokens.declarationUi.reviewHideReadings]: 'Réduire',
  [tokens.declarationUi.reviewPieceFallback]: 'Pièce {{index}}',
  [tokens.declarationUi.reviewPageUnavailable]: 'La page exacte des lectures contradictoires n’est pas disponible. Vérifiez les pièces du dossier.',
  [tokens.declarationUi.reviewVerified]: 'Vérifié',
  [tokens.declarationUi.reviewReopen]: 'Rouvrir ce point',
  [tokens.declarationUi.reviewTabToProcess]: 'À traiter',
  [tokens.declarationUi.labelValue]: '{{label}} : {{value}}',
  [tokens.declarationUi.quoted]: '« {{text}} »',
  [tokens.declarationUi.clearColumnTooltip]: 'Vider la colonne « {{column}} » sur les {{count}} articles',
  [tokens.declarationUi.clearColumnTooltip_one]: 'Vider la colonne « {{column}} » sur l’article',
  [tokens.declarationUi.clearColumn]: 'Vider la colonne',
  [tokens.declarationUi.removeArticle]: 'Supprimer l’article',
  [tokens.declarationUi.manualCorrectionNote]: 'Lecture d’origine : {{value}} · valeur corrigée manuellement',
  [tokens.declarationUi.totalsFamilyBilling]: 'Facturation',
  [tokens.declarationUi.totalsFamilyPackaging]: 'Colisage',
  [tokens.declarationUi.addTuple]: 'Ajouter',
  [tokens.declarationUi.removeTuple]: 'Retirer',
  [tokens.declarationUi.prepareDeclarationButton]: 'Vérifications',
  [tokens.declarationUi.prepareWindowPin]: 'Épingler à la page',
  [tokens.declarationUi.prepareWindowPinLeft]: 'Épingler à gauche',
  [tokens.declarationUi.prepareWindowPinRight]: 'Épingler à droite',
  [tokens.declarationUi.prepareWindowUnpin]: 'Détacher',
  [tokens.declarationUi.pinPreferencesHint]:
    'Épinglez cette fenêtre pour travailler à côté. Pour choisir sa place à chaque ouverture, réglez-la dans vos préférences.',
  [tokens.declarationUi.pinPreferencesHintAction]: 'Ouvrir les préférences',
  [tokens.declarationUi.pinPreferencesHintClose]: 'Fermer',
  [tokens.declarationUi.pinPreferencesHintDocked]:
    'Fenêtre épinglée pour cette session. Pour qu\'elle s\'ouvre ici à chaque fois, réglez-la dans vos préférences.',
  [tokens.declarationUi.pinPreferencesHintDockedFromPreferences]:
    'Cette fenêtre s\'ouvre ici grâce à vos préférences : modifiez-les à tout moment.',
  [tokens.declarationUi.prepareWindowClose]: 'Fermer',
  [tokens.declarationUi.prepareWindowResize]: 'Redimensionner le panneau',
  [tokens.declarationUi.consolidate]: 'Consolider',
  [tokens.declarationUi.consolidateArticles]: 'Consolider les articles',
  [tokens.declarationUi.unconsolidate]: 'Annuler la consolidation',
  [tokens.declarationUi.consolidationTitle]: 'Regrouper les articles par',
  [tokens.declarationUi.confirm]: 'Confirmer',
  [tokens.declarationUi.cancel]: 'Annuler',
  [tokens.declarationUi.linesTab]: 'Lignes ({{count}})',
  [tokens.declarationUi.articlesTab]: 'Articles ({{count}})',
  [tokens.declarationUi.showSourceLines]: 'Afficher les {{count}} lignes d’origine',
  [tokens.declarationUi.showConsolidatedArticles]: 'Afficher les {{count}} articles consolidés',
  [tokens.declarationUi.mergedLines]: '{{count}} lignes',
  [tokens.declarationUi.unkeyedLines]: '{{count}} lignes restent seules (clé manquante)',
  [tokens.declarationUi.unkeyedLines_one]: '{{count}} ligne reste seule (clé manquante)',
  [tokens.declarationUi.sourceLinesTitle]: 'Lignes {{numbers}}',
  [tokens.declarationUi.expandArticleLines]: 'Déplier les lignes',
  [tokens.declarationUi.collapseArticleLines]: 'Replier les lignes',
  [tokens.declarationUi.expandAllArticles]: 'Tout déplier',
  [tokens.declarationUi.collapseAllArticles]: 'Tout replier',
  [tokens.declarationUi.expandAllSourceLines]: 'Déplier les lignes d’origine',
  [tokens.declarationUi.collapseAllSourceLines]: 'Replier les lignes d’origine',
  [tokens.declarationUi.validatedDeliveryPending]:
    "Déclaration validée. L'envoi partira quand toutes les déclarations du dossier seront validées.",
  [tokens.declarationUi.deliveryRunning]: 'Envoi en cours…',
  [tokens.declarationUi.deliverySucceeded]: 'Envoyée le {{date}}',
  [tokens.declarationUi.updatedAgo]: 'Modifié {{relative}}',
  [tokens.declarationUi.updatedAtTooltip]: 'Dernière modification : {{date}}',
  [tokens.declarationUi.deliveryFailed]: 'Envoi en échec : {{reason}}',
  [tokens.declarationUi.deliveryEntry]: 'Envoi {{index}}',
  [tokens.declarationUi.declarationsValidatedCount]: '{{validated}} / {{total}} validées',
  [tokens.declarationUi.sendRecapTitle]: 'Envoi de {{total}} déclarations :',
  [tokens.declarationUi.commentsTitle]: 'Commentaires',
  [tokens.declarationUi.commentsButtonUnread]: 'Commentaires : {{count}} non lus',
  [tokens.declarationUi.commentsEmptyTitle]: 'Lancez la conversation',
  [tokens.declarationUi.commentsEmptyHint]: 'Toute l\'équipe du dossier voit ces messages. Activez Urgent pour prévenir aussi l\'équipe Nabu.',
  [tokens.declarationUi.commentsPlaceholder]: 'Écrire à l\'équipe…',
  [tokens.declarationUi.commentsSend]: 'Envoyer',
  [tokens.declarationUi.commentsSendUrgent]: 'Envoyer en urgent',
  [tokens.declarationUi.commentsUrgentLabel]: 'Urgent',
  [tokens.declarationUi.commentsUrgentHint]: 'L\'équipe Nabu sera prévenue immédiatement.',
  [tokens.declarationUi.commentsNewlineHint]: '⇧↵ nouvelle ligne',
  [tokens.declarationUi.commentsEditHint]: '↵ enregistrer · Échap annuler',
  [tokens.declarationUi.commentsUnknownAuthor]: 'Utilisateur inconnu',
  [tokens.declarationUi.commentsEdited]: 'modifié',
  [tokens.declarationUi.commentsEdit]: 'Modifier',
  [tokens.declarationUi.commentsDelete]: 'Supprimer',
  [tokens.declarationUi.commentsDeleteConfirm]: 'Supprimer pour tout le monde ?',
  [tokens.declarationUi.commentsSave]: 'Enregistrer',
  [tokens.declarationUi.commentsCancel]: 'Annuler',
  [tokens.declarationUi.commentsError]: 'Le commentaire n\'a pas pu être enregistré. Réessayez.',
  [tokens.declarationUi.commentsSending]: 'Envoi…',
  [tokens.declarationUi.commentsSendFailed]: 'Non envoyé.',
  [tokens.declarationUi.commentsRetry]: 'Réessayer',
  [tokens.declarationUi.commentsDiscard]: 'Abandonner',
  [tokens.declarationUi.commentsToday]: 'Aujourd\'hui',
  [tokens.declarationUi.commentsYesterday]: 'Hier',
  [tokens.declarationUi.commentsNew]: 'Nouveaux',
  [tokens.declarationUi.commentsClose]: 'Fermer',
  [tokens.declarationUi.dossierTabDetails]: 'Dossier',
  [tokens.declarationUi.dossierProperties]: 'Propriétés',
  [tokens.declarationUi.dossierActions]: 'Actions',
  [tokens.declarationUi.dossierOwner]: 'Référent',
  [tokens.declarationUi.dossierOwnerError]: 'Le référent n\'a pas pu être changé.',
  [tokens.declarationUi.dossierModel]: 'Modèle',
  [tokens.declarationUi.dossierType]: 'Type',
  [tokens.declarationUi.dossierClient]: 'Client',
  [tokens.declarationUi.dossierTags]: 'Tags',
  [tokens.declarationUi.dossierTagsError]: 'Les tags n\'ont pas pu être enregistrés.',
  [tokens.declarationUi.dossierNoModel]: 'Aucun modèle',
  [tokens.declarationUi.dossierModelChange]: 'Changer de modèle',
  [tokens.declarationUi.dossierModelRemove]: 'Retirer le modèle',
  [tokens.declarationUi.dossierModelApply]: 'Appliquer',
  [tokens.declarationUi.dossierModelKeepsCorrections]: 'Les cases réglées par le modèle seront mises à jour. Vos corrections sont conservées ; pour revenir en arrière, rechoisissez l’ancien modèle.',
  [tokens.declarationUi.dossierModelApplied]: 'Modèle appliqué : {{changed}} case(s) mise(s) à jour, {{kept}} correction(s) conservée(s).',
  [tokens.declarationUi.dossierModelError]: 'Le modèle n\'a pas pu être appliqué.',
  [tokens.declarationUi.dossierTypeChange]: 'Changer le type de déclaration',
  [tokens.declarationUi.dossierTypeFromTo]: 'Le type passe de {{from}} à {{to}}.',
  [tokens.declarationUi.dossierTypeWarning]: 'La déclaration est régénérée sans relire les pièces. Vos corrections ne seront pas reprises, et le modèle sera retiré.',
  [tokens.declarationUi.dossierTypeApply]: 'Changer et régénérer',
  [tokens.declarationUi.dossierTypeError]: 'Le type n\'a pas pu être changé.',
  [tokens.declarationUi.dossierAddFile]: 'Ajouter un fichier',
  [tokens.declarationUi.dossierAddFileHint]: 'Un PDF, une image (PNG, JPEG) ou un tableur (XLSX, XLS, XLSM, CSV). Seul ce fichier est lu : les pièces déjà lues ne sont pas relues.',
  [tokens.declarationUi.dossierAddFileChoose]: 'Choisir un fichier',
  [tokens.declarationUi.dossierAddFileUnsupported]: 'Ce type de fichier n\'est pas accepté. Les archives et les e-mails passent par la création d\'un dossier.',
  [tokens.declarationUi.dossierAddFileWarning]: 'La déclaration est régénérée avec ce fichier. Vos corrections ne seront pas reprises.',
  [tokens.declarationUi.dossierAddFileApply]: 'Ajouter et régénérer',
  [tokens.declarationUi.dossierAddFileError]: 'Le fichier n\'a pas pu être ajouté.',
  [tokens.declarationUi.relaunchStarted]: 'Régénération lancée.',
  [tokens.declarationUi.relaunchReading]: 'Lecture en cours : la déclaration se régénère. Elle reste en lecture seule jusque-là.',
  [tokens.declarationUi.reviseAction]: 'Réviser la déclaration',
  [tokens.declarationUi.reviseDialogTitle]: 'Réviser la déclaration envoyée',
  [tokens.declarationUi.reviseDialogText]: 'La déclaration redevient modifiable. Une fois corrigée, la valider renverra tout le dossier.',
  [tokens.declarationUi.reviseReasonLabel]: 'Motif (facultatif)',
  [tokens.declarationUi.reviseConfirm]: 'Rouvrir la déclaration',
  [tokens.declarationUi.reviseError]: 'La déclaration n’a pas pu être rouverte.',
  [tokens.declarationUi.revisionOpenBanner]: 'Révision en cours : cette déclaration envoyée est de nouveau modifiable. La valider renverra tout le dossier.',
  [tokens.declarationUi.dossierApplyAutomation]: 'Appliquer une automatisation',
  [tokens.declarationUi.automationTitle]: 'Appliquer une automatisation',
  [tokens.declarationUi.automationChoose]: 'Référentiel client',
  [tokens.declarationUi.automationPreview]: 'Voir les propositions',
  [tokens.declarationUi.automationArticle]: 'Article {{number}}',
  [tokens.declarationUi.automationOverwritesCorrection]: 'Correction écrasée',
  [tokens.declarationUi.automationIgnored]: '{{count}} proposition(s) hors formulaire ignorée(s).',
  [tokens.declarationUi.automationRejected]: 'Refusées : {{count}}',
  [tokens.declarationUi.automationNothing]: 'Cette automatisation n\'a rien à changer sur cette déclaration.',
  [tokens.declarationUi.automationApply]: 'Appliquer ({{count}})',
  [tokens.declarationUi.automationApplied]: 'Automatisation appliquée : {{count}} case(s) posée(s).',
  [tokens.declarationUi.automationConflict]: 'La déclaration a changé entre-temps : relancez l\'aperçu.',
  [tokens.declarationUi.automationRunError]: 'L\'automatisation n\'a pas pu être lancée.',
  [tokens.declarationUi.automationApplyError]: 'L\'automatisation n\'a pas pu être appliquée.',
  [tokens.declarationUi.automationNone]: 'Aucune automatisation active pour ce dossier.',
  [tokens.declarationUi.commentsDetach]: 'Ouvrir les commentaires dans une fenêtre, à côté du formulaire',

  [tokens.declarationEvents.eventValidate]: 'Validation de la déclaration',
  [tokens.declarationEvents.routineActor]:
    'Routine « {{routine}} », instruction « {{instruction}} »',
  [tokens.declarationEvents.eventReviewIssue]: 'Décision de vérification',
  [tokens.declarationEvents.eventAddTuple]: 'Ajout d’une occurrence',
  [tokens.declarationEvents.eventRemoveTuple]: 'Retrait d’une occurrence',
  [tokens.declarationEvents.eventAddLine]: 'Ajout d’un article',
  [tokens.declarationEvents.eventRemoveLine]: 'Retrait d’un article',
  [tokens.declarationEvents.eventModifyOccurrence]: 'Modification d’une occurrence',
  [tokens.declarationEvents.eventClearColumn]: '{{label}} · colonne entière vidée',
  [tokens.declarationEvents.eventSetColumn]: '{{label}} · {{value}} sur toute la colonne',
  [tokens.declarationEvents.eventClear]: '{{label}} · vidée',
  [tokens.declarationEvents.eventSetValue]: '{{label}} : {{value}}',
  [tokens.declarationEvents.reasonInvalidFormat]:
    'cette valeur ne respecte pas le format attendu (type, longueur ou bornes)',
  [tokens.declarationEvents.reasonNotInCatalog]:
    'cette valeur n’appartient pas à la liste officielle du champ',
  [tokens.declarationEvents.reasonStaleIssue]:
    'ce point a changé : abandonnez cette décision, puis examinez les nouvelles valeurs',
  [tokens.declarationEvents.reasonReasonRequired]: 'une justification est nécessaire',
  [tokens.declarationEvents.reasonLocked]: 'ce champ est verrouillé',
  [tokens.declarationEvents.reasonUnknownPath]: 'ce champ ne fait plus partie du formulaire',
  [tokens.declarationEvents.reasonMissingTuple]:
    'ajoutez une occurrence avant de remplir ce champ',
  [tokens.declarationEvents.reasonFallback]:
    'cette correction ne correspond plus au formulaire ; rechargez les valeurs avant de la reprendre',
  [tokens.declarationEvents.applyRejectedCorrections]:
    'Certaines corrections ont été refusées ; les autres sont enregistrées.',
  [tokens.declarationEvents.applyConflict]:
    'La déclaration a été modifiée ailleurs. Vos corrections sont conservées. Vérifiez la nouvelle version avant de les réappliquer.',
  [tokens.declarationEvents.applySaveRetryable]:
    'Enregistrement impossible. Vos corrections sont conservées dans cet écran.',
  [tokens.declarationEvents.applySaveNotRetryable]:
    'Le serveur a refusé cet envoi. Réessayer n’y changera rien. Signalez-le, vos valeurs restent affichées.',
  [tokens.declarationEvents.applyServerReason]:
    'Raison donnée par le serveur : {{detail}}',
  [tokens.declarationEvents.applyInsufficientCredits]:
    'Crédits insuffisants pour valider ce dossier : {{required}} requis, {{balance}} disponible(s). Vos corrections sont enregistrées ; rechargez vos crédits puis réessayez.',
  [tokens.declarationEvents.applySubscriptionRequired]:
    'Aucun abonnement actif : activez-le pour valider ce dossier, puis réessayez. Vos corrections sont enregistrées.',
  [tokens.declarationEvents.applySessionExpired]:
    'Votre session a expiré : reconnectez-vous. Les corrections listées ci-dessous n’ont pas été enregistrées.',
  [tokens.declarationEvents.applyForbidden]:
    'Vous n’avez pas accès à ce dossier : le serveur a refusé l’envoi.',
  [tokens.declarationEvents.applyNotFound]:
    'Cette déclaration est introuvable : elle a peut-être été remplacée. Rechargez la page.',
  [tokens.declarationEvents.applyContactAdmin]:
    'Contactez un administrateur de votre organisation pour gérer l’abonnement et les crédits.',
  [tokens.declarationEvents.rechargeCredits]:
    'Recharger mes crédits',
  [tokens.declarationEvents.openSubscription]:
    'Voir l’abonnement',
  [tokens.declarationEvents.retryReapply]: 'Réappliquer',
  [tokens.declarationEvents.retry]: 'Réessayer',
  [tokens.declarationEvents.discardCorrections]: 'Abandonner ces corrections',
  [tokens.declarationEvents.eventConsolidate]: 'Consolidation par {{keys}}',
  [tokens.declarationEvents.eventUnconsolidate]: 'Annulation de la consolidation',
  [tokens.declarationEvents.reasonUnknownKey]: 'cette colonne ne peut pas servir au regroupement',
  [tokens.declarationEvents.reasonRequiredKeyMissing]: 'une clé de regroupement obligatoire a été décochée',
  [tokens.declarationEvents.reasonNoKeys]: 'choisissez au moins une colonne de regroupement',
  [tokens.declarationEvents.historyUnconsolidated]: 'Consolidation annulée',
  [tokens.declarationEvents.reasonRejectedWithDetail]: 'valeur refusée : {{detail}}',
  [tokens.declarationEvents.eventSetTotalReferenceManual]: '{{total}} · référence saisie : {{value}}',
  [tokens.declarationEvents.eventSetTotalReferenceLines]: '{{total}} · référence : somme des lignes retenue',
  [tokens.declarationEvents.eventSetTotalReferenceReading]: '{{total}} · référence : lecture de {{documentId}} retenue',
  [tokens.declarationEvents.eventClearTotalReference]: '{{total}} · référence retirée',
  [tokens.declarationEvents.reasonUnknownTotal]: 'ce total n’existe pas dans le rapprochement',
  [tokens.declarationEvents.reasonInvalidValue]: 'cette valeur n’est pas un nombre valide',
  [tokens.declarationEvents.reasonNoLines]: 'aucune ligne ne porte cette grandeur',
  [tokens.declarationEvents.reasonUnknownReading]: 'cette lecture n’est plus disponible',
  [tokens.declarationEvents.eventDistributeTotal]: '{{total}} · réparti sur les articles',
  [tokens.declarationEvents.reasonWrongTotal]: 'ce total ne se répartit pas sur les articles',
  [tokens.declarationEvents.reasonNoReference]: 'aucun total à répartir',
  [tokens.declarationEvents.reasonUnknownWeight]: 'la clé de répartition n’existe pas',
  [tokens.declarationEvents.reasonIncompleteWeights]: 'la clé de répartition manque sur les articles {{articles}}',
  [tokens.declarationEvents.gestureDistribute]: 'Ventilation · {{total}}',
  [tokens.declarationEvents.gestureClearColumn]: 'Colonne vidée · {{label}}',
  [tokens.declarationEvents.gestureSetColumn]: 'Colonne remplie · {{label}}',
  [tokens.declarationEvents.gestureApplySettings]: 'Modèle appliqué · {{count}} case(s)',
  [tokens.declarationEvents.gestureApplyAutomation]: 'Automatisation appliquée · {{count}} case(s)',
  [tokens.declarationEvents.gestureAddLines]: 'Ajout de {{count}} articles',
  [tokens.declarationEvents.gestureValue]: 'Valeur corrigée · {{label}}',
  [tokens.declarationEvents.gestureValueCleared]: 'Valeur effacée · {{label}}',
  [tokens.declarationEvents.gestureValues]: '{{count}} valeurs corrigées',
  [tokens.declarationEvents.gestureTotalReference]: 'Référence du total · {{total}}',
  [tokens.declarationEvents.gestureTotalReferenceCleared]: 'Retour au total lu · {{total}}',
  [tokens.declarationEvents.gestureRevert]: 'Annulation · {{title}}',
  [tokens.declarationEvents.gestureRevertMore]: ' (+{{count}} gestes)',
  [tokens.declarationEvents.gestureRevertMore_one]: ' (+1 geste)',
  [tokens.declarationEvents.gestureLine]: '{{label}} (ligne {{row}})',
  [tokens.declarationEvents.gestureGeneric]: 'Modification de la déclaration',
  [tokens.declarationEvents.gestureUnvalidate]: 'Révision ouverte',
  [tokens.declarationEvents.gestureAbandonRevision]: 'Révision abandonnée : retour à la version envoyée',
  [tokens.declarationEvents.eventRevert]: 'Annulation d’un geste',
  [tokens.declarationEvents.reasonStaleRevert]: 'l’historique a changé entre-temps : rouvrez-le et recommencez',
  [tokens.declarationEvents.reasonBarrier]: 'un geste plus récent ne peut pas être défait : impossible de revenir avant lui',
  [tokens.declarationEvents.reasonAlreadyReverted]: 'ce geste est déjà annulé',
  [tokens.declarationEvents.reasonNotRevertible]: 'ce geste ne peut pas être annulé',
  [tokens.declarationEvents.reasonUnknownGesture]: 'ce geste n’existe plus',
  [tokens.declarationEvents.reasonAmbiguousTuple]: 'plusieurs occurrences sur les articles {{articles}} : laquelle porte la valeur ?',
  [tokens.declarationEvents.reasonLockedArticles]: 'case verrouillée sur les articles {{articles}}',
  [tokens.declarationEvents.reasonUnknownLine]: 'cette ligne n’existe pas',
  [tokens.declarationEvents.reasonUnknownTuple]: 'cette occurrence n’existe pas',
  [tokens.declarationEvents.reasonUnknownCategory]: 'ce groupe n’existe pas',
  [tokens.declarationEvents.reasonWrongLevel]: 'ce champ n’est pas à ce niveau',
  [tokens.declarationEvents.reasonEmptyValue]: 'la valeur est vide',
  [tokens.declarationEvents.reasonUnknownEvent]: 'cette correction n’est pas reconnue',
  [tokens.declarationEvents.assistantEventArticle]: '{{label}} (article {{row}})',
  [tokens.declarationEvents.assistantEventClear]: 'Vider {{label}}',
  [tokens.declarationEvents.assistantEventSetColumn]: 'Mettre {{value}} dans toute la colonne {{label}}',
  [tokens.declarationEvents.assistantEventClearColumn]: 'Vider toute la colonne {{label}}',
  [tokens.declarationEvents.assistantEventCopyColumn]: 'Recopier la colonne {{from}} dans {{to}}',
  [tokens.declarationEvents.assistantEventWhere]:
    '{{action}}, {{scope}}',
  [tokens.declarationEvents.assistantEventSetColumnWhere]:
    'Mettre {{value}} dans la colonne {{label}}, {{scope}}',
  [tokens.declarationEvents.assistantEventClearColumnWhere]:
    'Vider la colonne {{label}}, {{scope}}',
  [tokens.declarationEvents.assistantEventCopyColumnUnchanged]:
    'Sans {{from}}, laissés tels quels : articles {{rows}}',
  [tokens.declarationEvents.assistantEventCopyColumnUnchanged_one]:
    'Sans {{from}}, laissé tel quel : article {{rows}}',
  [tokens.declarationEvents.assistantEventScopeEquals]:
    'sur les articles où {{label}} = {{value}}',
  [tokens.declarationEvents.assistantEventScopeIn]:
    'sur les articles où {{label}} vaut {{values}}',
  [tokens.declarationEvents.assistantEventScopeEmpty]:
    'sur les articles où {{label}} est vide',
  [tokens.declarationEvents.assistantEventScopeFilled]:
    'sur les articles où {{label}} est rempli',
  [tokens.declarationEvents.assistantEventMapColumn]:
    'Remplacer dans la colonne {{to}} : {{pairs}}',
  [tokens.declarationEvents.assistantEventMapColumnFrom]:
    'Remplir la colonne {{to}} depuis {{from}} : {{pairs}}',
  [tokens.declarationEvents.assistantEventMapColumnUnchanged]:
    'Hors de la table, laissés tels quels : articles {{rows}}',
  [tokens.declarationEvents.assistantEventMapColumnUnchanged_one]:
    'Hors de la table, laissé tel quel : article {{rows}}',
  [tokens.declarationEvents.assistantEventComputeColumn]:
    'Calculer la colonne {{to}} = {{formula}}',
  [tokens.declarationEvents.assistantEventComputeColumnUnchanged]:
    'Sans nombre pour le calcul, laissés tels quels : articles {{rows}}',
  [tokens.declarationEvents.assistantEventComputeColumnUnchanged_one]:
    'Sans nombre pour le calcul, laissé tel quel : article {{rows}}',
  [tokens.declarationEvents.assistantEventFormatColumnPadEnd]:
    'Compléter la colonne {{label}} à {{length}} caractères avec « {{padWith}} » à la fin',
  [tokens.declarationEvents.assistantEventFormatColumnPadStart]:
    'Compléter la colonne {{label}} à {{length}} caractères avec « {{padWith}} » au début',
  [tokens.declarationEvents.assistantEventFormatColumnTruncate]:
    'Garder les {{length}} premiers caractères de la colonne {{label}}',
  [tokens.declarationEvents.assistantEventFormatColumnUnchanged]:
    'Vides ou déjà à {{length}} caractères, laissés tels quels : articles {{rows}}',
  [tokens.declarationEvents.assistantEventFormatColumnUnchanged_one]:
    'Vide ou déjà à {{length}} caractères, laissé tel quel : article {{rows}}',
  [tokens.declarationEvents.assistantEventAddLine]: 'Ajouter un article',
  [tokens.declarationEvents.assistantEventAddLineValues]: 'Ajouter un article : {{values}}',
  [tokens.declarationEvents.assistantEventRemoveLine]: 'Retirer l’article {{row}}',
  [tokens.declarationEvents.assistantEventDistributeEqual]:
    'Répartir le total {{total}} sur tous les articles, à parts égales',
  [tokens.declarationEvents.assistantEventDistributeBy]:
    'Répartir le total {{total}} sur tous les articles, au prorata de {{weight}}',
  [tokens.declarationEvents.assistantEventDistributePackages]:
    'Mettre les colis sur le premier article de chaque document, 0 sur les autres',
  [tokens.declarationEvents.assistantEventScopeDocument]:
    'sur les articles du document {{document}}',
  [tokens.declarationEvents.assistantEventDistributeAmount]:
    'montant saisi : {{value}}',
  [tokens.declarationEvents.assistantEventDistributeFirstLine]:
    'Mettre le total {{total}} sur le premier article, 0 sur les autres',
  [tokens.declarationEvents.assistantEventDistributeFirstLinePerDocument]:
    'Mettre le total {{total}} de chaque document sur son premier article, 0 sur les autres',
  [tokens.declarationEvents.assistantEventDistributeEqualScoped]:
    'Répartir le total {{total}} à parts égales',
  [tokens.declarationEvents.assistantEventDistributeByScoped]:
    'Répartir le total {{total}} au prorata de {{weight}}',
  [tokens.declarationEvents.assistantEventDistributeFromValue]:
    'Chiffre réparti : {{value}}, saisi',
  [tokens.declarationEvents.assistantEventDistributeFromDocument]:
    'Chiffre réparti : {{value}}, part de {{document}}',
  [tokens.declarationEvents.assistantEventDistributeFromReference]:
    'Chiffre réparti : {{value}}, le chiffre retenu du total',
  [tokens.declarationEvents.assistantEventConsolidate]: 'Regrouper les articles par {{keys}}',
  [tokens.declarationEvents.assistantEventUnconsolidate]: 'Défaire le regroupement des articles',
  [tokens.declarationEvents.assistantEventTotalManual]: 'Retenir pour {{total}} : {{value}} (saisi)',
  [tokens.declarationEvents.assistantEventTotalLines]: 'Retenir pour {{total}} : la somme des lignes',
  [tokens.declarationEvents.assistantEventTotalReading]: 'Retenir pour {{total}} : la lecture de {{document}}',
  [tokens.declarationEvents.assistantEventTotalRead]: 'Revenir au total lu pour {{total}}',
  [tokens.declarationEvents.assistantEventRevert]:
    'Annuler la modification du {{date}} à {{time}} ({{count}} changements)',
  [tokens.declarationEvents.assistantEventRevert_one]:
    'Annuler la modification du {{date}} à {{time}} ({{count}} changement)',
  [tokens.declarationEvents.assistantEventRevertUnknown]: 'Annuler une modification de l’assistant',
  [tokens.declarationEvents.assistantEventRevertDependents]:
    '{{action}} et {{count}} modifications qui en dépendent',
  [tokens.declarationEvents.assistantEventRevertDependents_one]:
    '{{action}} et {{count}} modification qui en dépend',
  [tokens.declarationEvents.assistantValueTrue]: 'oui',
  [tokens.declarationEvents.assistantValueFalse]: 'non',
  [tokens.declarationEvents.assistantSuggestionBlocked]:
    'Pourquoi la déclaration est-elle bloquée ?',
  [tokens.declarationEvents.assistantSuggestionMissing]:
    'Remplis {{fields}} à partir des documents',
  [tokens.declarationEvents.assistantSuggestionMissingUnnamed]:
    'Remplis les champs obligatoires manquants à partir des documents',
  [tokens.declarationEvents.assistantSuggestionLines]:
    'Complète la colonne {{column}} sur les {{count}} articles où elle est vide',
  [tokens.declarationEvents.assistantSuggestionLines_one]:
    'Complète la colonne {{column}} sur l’article où elle est vide',
  [tokens.declarationEvents.assistantSuggestionLinesColumns]:
    'Complète les colonnes {{columns}} sur les articles où elles sont vides',
  [tokens.declarationEvents.assistantSuggestionFormat]:
    'Corrige les valeurs au mauvais format : {{fields}}',
  [tokens.declarationEvents.assistantSuggestionConflict]:
    'Les documents se contredisent sur {{fields}} : quelles valeurs retenir ?',
  [tokens.declarationEvents.assistantSuggestionConflict_one]:
    'Les documents se contredisent sur {{fields}} : quelle valeur retenir ?',
  [tokens.declarationEvents.assistantSuggestionConflictUnnamed]:
    'Les documents se contredisent : quelles valeurs retenir ?',
  [tokens.declarationEvents.assistantSuggestionGap]:
    'Explique les écarts sur {{totals}}',
  [tokens.declarationEvents.assistantSuggestionGap_one]:
    'Explique l’écart sur {{totals}}',
  [tokens.declarationEvents.assistantSuggestionDistribute]:
    'Répartis {{totals}} sur les articles',
  [tokens.declarationEvents.assistantSuggestionWeights]:
    'Vérifie la cohérence des poids entre les documents',
  [tokens.declarationEvents.assistantSuggestionTotals]:
    'Vérifie les totaux de la déclaration',
  [tokens.declarationEvents.assistantSuggestionHistory]:
    'Résume l’historique du dossier',
  [tokens.declarationEvents.assistantSuggestionSummary]: 'Résume ce dossier',
  [tokens.declarationEvents.assistantSuggestionNamesTwo]:
    '{{first}} et {{second}}',
  [tokens.declarationEvents.assistantSuggestionNamesMore]:
    '{{first}}, {{second}} et {{count}} autres',
  [tokens.declarationEvents.assistantSuggestionNamesMore_one]:
    '{{first}}, {{second}} et {{count}} autre',
  [tokens.declarationEvents.assistantSuggestionNamesOneMore]:
    '{{first}} et {{count}} autres',
  [tokens.declarationEvents.assistantSuggestionNamesOneMore_one]:
    '{{first}} et {{count}} autre',

  [tokens.extraction.index]: 'Index',
  [tokens.extraction.selectAnErrorState]: "Sélectionner un état d'erreur",
  [tokens.extraction.exportDeclaration]: 'Envoyer déclaration',
  [tokens.extraction.dauRecapButtonLabel]: 'DAU',
  [tokens.extraction.dauRecapButtonTooltip]:
    'Mettre en forme la déclaration au format DAU.',
  [tokens.extraction.dauRecapNoArticlesTooltip]:
    'Aucun article à récapituler',
  [tokens.extraction.dauRecapUnavailableSchemaTooltip]:
    'Récapitulatif non disponible pour ce type de dossier',
  [tokens.extraction.dauRecapPrintButton]: 'Imprimer',
  [tokens.extraction.dauRecapCloseButton]: 'Fermer',
  [tokens.extraction.dauRecapModalSubtitle]:
    'Document Administratif Unique · {{articleCount}} article{{articlePlural}} · {{pageCount}} page{{pagePlural}}',
  [tokens.extraction.dauRecapCloseHint]: 'pour fermer',
  [tokens.extraction.dauRecapPreviousPage]: 'Page précédente',
  [tokens.extraction.dauRecapNextPage]: 'Page suivante',
  [tokens.extraction.dauRecapZoomOut]: 'Réduire',
  [tokens.extraction.dauRecapZoomIn]: 'Agrandir',
  [tokens.extraction.validateThisDataset]:
    'Valider ce jeu de données ({{current}}/{{total}})',
  [tokens.extraction.validateDatasetSuccess]:
    'Jeu de données validé ({{current}}/{{total}})',
  [tokens.extraction.dataset]: 'Jeu de données',
  [tokens.extraction.validateDatasetModalTitle]:
    'Valider le jeu de données {{current}}/{{total}} ?',
  [tokens.extraction.validateDatasetModalDescription]:
    'Les données de ce jeu seront validées. Vous pourrez ensuite passer au jeu de données suivant.',
  [tokens.extraction.datasetsValidatedProgress]:
    '{{validated}}/{{total}} jeux de données validés',
  [tokens.extraction.datasetsRemainingProgress]:
    'Il en reste {{remaining}}',
  [tokens.extraction.datasetsAllValidatedReady]:
    'Tous validés, prêt à envoyer',
  [tokens.extraction.goToNextDataset]:
    'Passer au jeu de données suivant',
  [tokens.extraction.datasetValidationGuidanceBanner]:
    'Jeu de données {{validated}}/{{total}} validé. {{remaining}} jeu(x) restant(s). Vous avez été redirigé vers le jeu de données {{next}}.',
  [tokens.extraction.multiDatasetSendRecapTitle]:
    'Envoi de {{total}} jeux de données :',
  [tokens.extraction.agentRationale]: 'Généré par agent',
  [tokens.extraction.agentRationaleTooltip]:
    "Instructions laissées par l'agent",
  [tokens.extraction.showSidebar]: 'Afficher formulaire',
  [tokens.extraction.hideSidebar]: 'Cacher formulaire',
  [tokens.extraction.enlargeViewer]:
    'Masquer le formulaire et agrandir le visualiseur',
  [tokens.extraction.shrinkViewer]: 'Réafficher le formulaire',
  [tokens.extraction.enlargeTableOverlay]: 'Afficher le tableau en plein écran',
  [tokens.extraction.shrinkTableOverlay]: 'Quitter le plein écran',
  [tokens.extraction.enlargeTableWidth]: 'Étendre le tableau sur la largeur',
  [tokens.extraction.shrinkTableWidth]: 'Réduire la largeur du tableau',
  [tokens.extraction.enlargeTable]:
    'Masquer le visualiseur et agrandir le tableau',
  [tokens.extraction.shrinkTable]: 'Réafficher le visualiseur',
  [tokens.extraction.scrollToDocumentTop]: 'Revenir en haut du document',
  [tokens.extraction.scrollToDocumentBottom]: 'Aller en bas du document',
  [tokens.extraction.validateTheMerge]: 'Valider la fusion',
  [tokens.extraction.suggestedColumnIsMissing]:
    'Colonne conseillée est manquante',
  [tokens.extraction.thereAreOverlappingFields]:
    "Il y a {{count}} champs qui s'occupent cette même zone dans la page.",
  [tokens.extraction.clickHereToSeeFurtherEditingOptions]:
    "Cliquez pour voir plus d'options pour éditer ce champ.",
  [tokens.extraction.default]: 'Défaut',
  [tokens.extraction.anUnusedDocumentWasFound]:
    'Document qui semble superflu : {{code}}',
  [tokens.extraction.additionalCodeNotValid]:
    'Code additionnel non valide : {{code}}',
  [tokens.extraction.noTaxComponentSelected]:
    'Aucune mesure de taxe a été chosie',
  [tokens.extraction.columnEmpty]: 'Colonne vide',
  [tokens.extraction.valueRequiredToSpread]: 'Valeur requise pour ventiler',
  [tokens.extraction.documentColumnIsEmpty]:
    'Toutes les cellules de la colonne "{{columnName}}" pour le document "{{documentName}}" sont vides',
  [tokens.extraction.theDocumentTotalAndTheTableTotalAreDifferent]:
    'Le total indiqué dans le document et la somme des cellules du tableau ne sont pas égaux.',
  [tokens.extraction.theDocumentTotalAndTheTableTotalAreEqual]:
    'Le total indiqué dans le document et la somme des cellules du tableau sont égaux.',
  [tokens.extraction.valuesMissing]: 'Cellules vides',
  [tokens.extraction.noDutyComponentSelected]:
    'Aucune mesure de droit de douane a été chosie',
  [tokens.extraction.additionalCodeIsMissingACertificate]:
    'Code additionnel manque un certificate : {{code}}',
  [tokens.extraction.countryOfOriginUnknown]: "Pays d'origine inconnu",
  [tokens.extraction.countryOfDestinationUnknown]:
    'Pays de destination inconnu',
  [tokens.extraction.downloadRowsAsExcelWorksheet]:
    'Télécharger ces lignes en format Excel',
  [tokens.extraction.convertRowsToFees]: 'Convertir ces lignes en frais',
  [tokens.extraction.convertRowsToRefunds]: 'Convertir ces lignes en remises',
  [tokens.extraction.createNewDeclarationFromRows]:
    'Créer une nouvelle déclaration à partir de ces lignes',
  [tokens.extraction.countryUnknown]: 'Pays inconnu',
  [tokens.extraction.failedToRetrieveTaricCodeDataForCode]:
    'Impossible de récupérer les données TARIC pour {{code}}',
  [tokens.extraction.findAColumn]: 'Chercher une colonne',
  [tokens.extraction.changeColumnName]: 'Changer le nom de la colonne',
  [tokens.extraction.rowsToValidate]: '{{count}} ligne à valider',
  [tokens.extraction.rowsToValidate_other]: '{{count}} lignes à valider',
  [tokens.extraction.closeDebug]: 'Fermer debug',
  [tokens.extraction.legalInformationAboutCode]:
    'Informations légales sur le code {{code}}',
  [tokens.extraction.legalInformationAboutMeasure]:
    'Informations légales sur le mesure {{measure}}',
  [tokens.extraction.legalInformation]: 'Informations légales',
  [tokens.extraction.datasourceOrigin]: 'Source des données',
  [tokens.extraction.propertiesInheritedFromCode]:
    'Informations venant du code',
  [tokens.extraction.selectedLines]: '{{count}} ligne sélectionnée',
  [tokens.extraction.selectedLines_other]: '{{count}} lignes sélectionnées',
  [tokens.extraction.selectedLines_zero]: '{{count}} lignes sélectionnées',
  [tokens.extraction.notFound]: 'Non trouvé',
  [tokens.extraction.fields]: 'Champs',
  [tokens.extraction.totaux]: 'Totaux',
  [tokens.extraction.assistant]: 'Assistant',
  [tokens.extraction.articles]: 'Articles',
  [tokens.extraction.rows]: 'Lignes',
  [tokens.extraction.errors]: 'Erreurs',
  [tokens.extraction.mergeValidationExplanation]:
    'Vous pouvez vérifier ici la correspondance entre les lignes du colisage (source) et celles de la facture (destination). Les lignes présentant des anomalies sont colorées.<br>Cliquez sur une ligne pour afficher les sources correspondantes et corrigez les associations avant de poursuivre la fusion.',
  [tokens.extraction.mergeValidationCaseOneExplanation]:
    '<b>Aucune source associée</b> : Cette ligne de la facture n’est reliée à aucun article du colisage. Sélectionnez une ou plusieurs lignes du tableau source à associer.<br><b>Action suggérée :</b> Sélectionner une ligne du colisage manuellement.',
  [tokens.extraction.mergeValidationCaseTwoExplanation]:
    '<b>Plusieurs sources associées</b> : Plusieurs articles du colisage sont actuellement liés à cette ligne de facture. Vérifiez la correspondance et ne conservez qu’une seule ligne source valide.<br><b>Action suggérée :</b> Désélectionner les sources en trop.',
  [tokens.extraction.mergeValidationCaseThreeExplanation]:
    '<b>Source utilisée plusieurs fois</b> : Une même ligne du colisage est associée à plusieurs lignes de facture. Chaque source ne peut être liée qu’à une seule destination.<br><b>Action suggérée :</b> Ajuster les associations pour ne garder qu’un seul lien par source.',
  [tokens.extraction.mergeValidationCaseFourExplanation]:
    '<b>Associations multiples invalides</b> : Plusieurs lignes de colisage et de facture sont liées entre elles de manière croisée. Ces correspondances ne peuvent pas être fusionnées automatiquement.<br><b>Action suggérée :</b> Corriger manuellement les associations pour garantir une correspondance 1:1.',
  [tokens.extraction.mergeSourceDuplicateExplanation]:
    'Une ligne dans le tableau source sera associée à plusieurs lignes dans le tableau de destination, ce qui peut entraîner des données incorrectes dans le tableau de destination. Ligne ',
  [tokens.extraction.mergeSourceDuplicateExplanation2]:
    'dans le tableau source sera associée aux lignes ',
  [tokens.extraction.mergeDestinationDuplicateExplanation]:
    'Plusieurs lignes dans le tableau source seront associées à la même ligne dans le tableau de destination, ce qui crée des données de fusion ambiguës. Lignes ',
  [tokens.extraction.readyToMerge]: 'Prêt à fusionner',
  [tokens.extraction.mergeSuccess]:
    'Les lignes ont été fusionnées avec succès.',
  [tokens.extraction.mergeError]:
    'La fusion n’a pas pu être effectuée. Vérifiez les lignes signalées et corrigez les anomalies avant de relancer l’opération.',
  [tokens.extraction.mapToRow]: ' sont associées à la ligne ',
  [tokens.extraction.inTheDestinationTable]: ' dans le tableau de destination.',
  [tokens.extraction.mergeDestinationUnmapped]:
    'Une ou plusieurs lignes dans le tableau de destination - lignes',
  [tokens.extraction.and]: ' et ',
  [tokens.extraction.mergeImpossible]: 'Fusion impossible.',
  [tokens.extraction.willNotReceiveAnyDataFromTheMerge]:
    ' ne vont pas recevoir des données du fusion.',
  [tokens.extraction.packages]: 'Colis',
  [tokens.extraction.chooseClassification]: 'Choisir une classification',
  [tokens.extraction.productCodes]: 'Nomenclatures',
  [tokens.extraction.totalDeclaredValue]: 'Valeur totale',
  [tokens.extraction.exceptions]: 'Exceptions',
  [tokens.extraction.editCells]: 'Editer les cellules',
  [tokens.extraction.updateDeclarationExportType]:
    'Changer le type de la déclaration',
  [tokens.extraction.changeExportTypeForCurrentDeclaration]:
    'Changer le type pour cette déclaration',
  [tokens.extraction.deleteTable]: 'Supprimer tableau',
  [tokens.extraction.articlesTable]: "Tableau d'articles",
  [tokens.extraction.showArticlesTable]: "Afficher le tableau d'articles",
  [tokens.extraction.hideArticlesTable]: "Masquer le tableau d'articles",
  [tokens.extraction.anyColumnsToMatchNotPresentWillBeCreated]:
    "Tout <b>Colonnes à matcher</b> non présentes dans le tableau d'Articles seront créées.",
  [tokens.extraction.whenCopyingARowFromSourceOnlyCopyValuesWillBeCopied]:
    "Quand on copie une rangée du tableau source vers le tableau d'Articles, seules les valeurs pour les <b>Colonnes à copier</b> seront copiées.",
  [tokens.extraction.chooseTheTableYouWantToMergeIntoTheMainArticlesTable]:
    "Sélectionnez le tableau que vous voulez merger dans le tableau d'Articles",
  [tokens.extraction.deleteTablePage]: 'Supprimer le tableau sur cette page',
  [tokens.extraction.deleteAllTablePages]:
    'Supprimer les tableaux sur toutes les pages',
  [tokens.extraction.noExceptionsFound]: 'Aucune exception trouvée',
  [tokens.extraction.noDescriptionFound]: 'Aucune description trouvée',
  [tokens.extraction.noConditionsFound]: 'Aucune condition trouvée',
  [tokens.extraction.noColumnsFound]: 'Aucune colonne trouvée',
  [tokens.extraction.whyMergeKeysNeeded]:
    'Pour pouvoir fusionner, il nous faut des colonnes qui sont présentes dans les 2 tableaux.',
  [tokens.extraction.noClassification]: 'Non classifiée',
  [tokens.extraction.informations]: 'Informations',
  [tokens.extraction.products]: 'Articles',
  [tokens.extraction.legalContext]: 'Contexte légal',
  [tokens.extraction.missingProduct]: 'Article manquant',
  [tokens.extraction.certificateCode]: 'Code certificat',
  [tokens.extraction.informationOnCodesAndDuties]:
    'Information sur codes et droits',
  [tokens.extraction.addInformation]: 'Ajouter une information',
  [tokens.extraction.convertRowsToAdditions]: 'Convertir ces lignes en frais',
  [tokens.extraction.deleteArticleRowTitle]: 'Supprimer cet article ?',
  [tokens.extraction.deleteArticleRowMessage]:
    'Ligne {{row}} : la suppression est définitive. Les totaux de la déclaration seront recalculés.',
  [tokens.extraction.deleteArticleRowTooltip]: 'Supprimer cette ligne',
  [tokens.extraction.convertRowsToDeductions]:
    'Convertir ces lignes en remises',
  [tokens.extraction.addElement]: 'Ajouter un élément',
  [tokens.extraction.customInformation]: 'Informations douanières',
  [tokens.extraction.documentInformation]: 'Document',
  [tokens.extraction.shippingInformation]: "Information d'expédition",
  [tokens.extraction.transactionDetails]: 'Détails de la transaction',
  [tokens.extraction.findField]: 'Chercher un champ',
  [tokens.extraction.cellTooSmall]: 'Cellule trop petite',
  [tokens.extraction.cellNotValid]: 'Cellule non valide',
  [tokens.extraction.groupByHSCode]: 'Grouper par HS Code',
  [tokens.extraction.doYouWantToGroupTokensByHSCode]:
    'Voulez-vous grouper par HS Code ?',
  [tokens.extraction.yes]: 'Oui',
  [tokens.extraction.no]: 'Non',
  [tokens.extraction.addData]: 'Ajouter des données',
  [tokens.extraction.addRow]: 'Ajouter rangée',
  [tokens.extraction.tableRows]: 'Lignes du tableau',
  [tokens.extraction.deleteRow]: 'Supprimer rangée',
  [tokens.extraction.rowTotalAmountIsMissing]:
    'Montant total de la ligne manquant',
  [tokens.extraction.invoices]: 'Factures',
  [tokens.extraction['commercial-invoice']]: 'Facture',
  [tokens.extraction.packings]: 'Colisage',
  [tokens.extraction.sourceTable]: 'Tableau source',
  [tokens.extraction.mergeOptions]: 'Paramètres de fusion',
  [tokens.extraction['packing-list']]: 'Colisage',
  [tokens.extraction['packing-list-description']]:
    'Données combinées de toutes les listes de colisage',
  [tokens.extraction['hscodes-list']]: 'HS Codes',
  [tokens.extraction['hscodes-list-description']]:
    'Données combinées de toutes les positions tarifaires',
  [tokens.extraction['bill-of-lading']]: 'Bill of lading',
  [tokens.extraction['bill-of-lading-description']]:
    'Données combinées de toutes les bill of lading',
  [tokens.extraction['delivery-note']]: 'Note de livraison',
  [tokens.extraction['delivery-note-description']]:
    'Données combinées de toutes les notes de livraison',
  [tokens.extraction['articles-table-description']]:
    'Lignes articles à exporter, basé sur la facture commerciale',
  [tokens.extraction.mergeTables]: 'Fusion',
  [tokens.extraction.extraction]: 'Extraction',
  [tokens.extraction.clearColumnValuesForDocument]:
    'Supprimer les valeurs de toutes les cellules de "{{columnName}}" sur toutes les lignes de "{{documentTitle}}."',
  [tokens.extraction.spreadOverDocumentLinesSelect]:
    'Ventiler la valeur "{{value}}" sur les lignes de "{{documentTitle}}" pour la colonne "{{columnName}}". Vous devez choisir une stratégie.',
  [tokens.extraction.spreadOverDocumentLinesAuto]:
    'Ventiler la valeur "{{value}}" sur les lignes de "{{documentTitle}}" pour la colonne "{{columnName}}". La stratégie "{{strategyName}}" sera utilisée.',
  [tokens.extraction.spreadOverDocumentLinesSelectSingle]:
    'Ventiler la valeur "{{value}}" sur toutes les lignes du document pour la colonne "{{columnName}}". Vous devez choisir une stratégie.',
  [tokens.extraction.spreadOverDocumentLinesAutoSingle]:
    'Ventiler la valeur "{{value}}" sur toutes les lignes du document pour la colonne "{{columnName}}". La stratégie "{{strategyName}}" sera utilisée.',
  [tokens.extraction.documentCellsClearedSuccessfully]:
    'Les valeurs des cellules de la colonne pour le document ont été supprimées.',
  [tokens.extraction.errorClearingDocumentCells]:
    'Erreur lors de la suppression des cellules',
  [tokens.extraction.noPostProcessFound]:
    'Aucun stratégie de ventilation trouvée',
  [tokens.extraction.source]: 'Source',
  [tokens.extraction.sourceTooltip]: 'Valeur extraite du document source.',
  [tokens.extraction.packageTypeNotSourced]: 'Type de colis non sourcée',
  [tokens.extraction.weightUnitNotSourced]: 'Unité de poids non sourcée',
  [tokens.extraction.packageTypeNotSourced]: "Type d'unité non sourcée",
  [tokens.extraction.currencyNotSourced]: 'Devise non sourcée',
  [tokens.extraction.declaration]: 'Déclaration',
  [tokens.extraction.declarationTooltip]: "Valeur issue du tableau d'articles.",
  [tokens.extraction.documentTotalNotFound]:
    'Aucune valeur pour "{{columnName}}" n\'était trouvé dans "{{documentName}}". Remplir la valeur ici ou sélectionnez-la dans le document et classifier comme "{{columnName}}".',
  [tokens.extraction.documentTotalNotFoundSingle]:
    'Aucune valeur pour "{{columnName}}" n\'était trouvé dans le document. Remplir la valeur ici ou sélectionnez-la dans le document et classifier comme "{{columnName}}".',
  [tokens.extraction.columnToMatchExplanation]:
    "Une ligne dans le tableau de la liste d'emballage sera copiée dans une ligne du tableau si elles ont les mêmes valeurs pour chaque <b>colonne à faire correspondre</b>.",
  [tokens.extraction.thisActionWillClearAllCellsInTheDocumentColumn]:
    'Cette action supprimera les valeurs de toutes les cellules de la colonne "{{columnName}}" pour le document {{documentTitle}}. Cette action est irreversible. Voulez-vous continuer ?',
  [tokens.extraction.columnsToMatch]: 'Colonnes à matcher',
  [tokens.extraction.columnsToCopy]: 'Colonnes à copier',
  [tokens.extraction.validation]: 'Validation',
  [tokens.extraction.notSourced]: 'Non-sourcé',
  [tokens.extraction.nothingToShow]: 'Rien à afficher',
  [tokens.extraction.createNewFieldHere]:
    'Créer un nouveau champ à cet emplacement',
  [tokens.extraction.showOtherFieldsHere]:
    'Montrer les autres champs à cet emplacement',
  [tokens.extraction.convertSelectionToTable]:
    'Transformer ce champ en tableau',
  [tokens.extraction.drawingHintField]: 'Champ',
  [tokens.extraction.drawingHintArticleGrid]: 'Grille articles',
  [tokens.extraction.drawingHintArticleColumn]: 'Colonne articles',
  [tokens.extraction.drawingHintPageAlreadyHasArticleGrid]:
    'Grille déjà présente sur cette page',
  [tokens.extraction.drawingRejectedAgenticField]:
    'Sur un dossier sans zone sur le document, tracez une grille articles (rectangle large, plus de 70 % de la largeur de page).',
  [tokens.extraction.drawingRejectedPageAlreadyHasArticleGrid]:
    'Une grille articles existe déjà sur cette page du document.',
  [tokens.extraction.validateRequiresFieldSelection]:
    'Sélectionnez un champ avant de valider.',
  [tokens.extraction.convertTableToSelection]:
    'Transformer ce tableau en champ',
  [tokens.extraction.table]: 'Tableau',
  [tokens.extraction.field]: 'Champ',
  [tokens.extraction.tables]: 'Tableaux',
  [tokens.extraction.grids]: 'Grilles',
  [tokens.extraction.grid]: 'Grille',
  [tokens.extraction.excelGridModeTooltip]:
    'Tracez le tableau sur la feuille (au moins 70 % de la largeur en colonnes)',
  [tokens.extraction.excelGridModeInstructions]:
    'Mode grille : sur la feuille Excel, cliquez-glissez pour délimiter le tableau. La sélection doit couvrir au moins 70 % de la largeur de la feuille (en colonnes). Ajustez ensuite le rectangle aux poignées orange si besoin.',
  [tokens.extraction.excelCellsModeTooltip]:
    'Sélectionnez les cellules et les champs sur la feuille Excel',
  [tokens.extraction.gridModeTooltip]:
    'Ajustez la grille du tableau sur le document',
  [tokens.extraction.gridModeInstructions]:
    'Mode grille : redimensionnez le cadre et déplacez les séparateurs de lignes sur le document.',
  [tokens.extraction.cellsModeTooltip]:
    'Sélectionnez et éditez les cellules de la grille sur le document',
  [tokens.extraction.cells]: 'Cellules',
  [tokens.extraction.displayTheTable]: 'Afficher le tableau',
  [tokens.extraction.save]: 'Sauvegarder',
  [tokens.extraction.noOtherFormatsAvailable]: 'Aucun autre format disponible',
  [tokens.extraction.downloadTestFile]: 'Télécharger le fichier test',
  [tokens.extraction.exportTo]: 'Envoyer vers',
  [tokens.extraction.on]: 'sur',
  [tokens.extraction.completedFields]: 'Champs complétés',
  [tokens.extraction.workComplete]: 'Dossier complet',
  [tokens.extraction.newField]: 'Nouveau champ',
  [tokens.extraction.convertIntoField]: 'Convertir en champ',
  [tokens.extraction.convertIntoTable]: 'Convertir en tableau',
  [tokens.extraction.newTable]: 'Nouveau tableau',
  [tokens.extraction.duplicate]: 'Dupliquer',
  [tokens.extraction.mustBeString]: 'Doit être du texte',
  [tokens.extraction.areYouSureYouWantToCopyDeclaration]:
    'Etes-vous sûr de vouloir de dupliquer cette déclaration',
  [tokens.extraction.thereWasAnErrorCopyingTheDeclaration]:
    'Il y a eu une erreur lors de la duplication',
  [tokens.extraction.mustMatchFormatDateTime]:
    'Doit avoir format date / heure correct',
  [tokens.extraction.mustMatchFormatDate]: 'Doit avoir format date correct',
  [tokens.extraction.mustNotHaveMoreThanCharacters]:
    'Doit pas avoir plus que {{ count }} caractères',
  [tokens.extraction.mustNotHaveFewerThanCharacters]:
    'Doit pas avoir plus que {{ count }} caractères',
  [tokens.extraction.pleaseEnterBetweenXAndYCharacters]:
    'Veuillez entrer entre {{min}} et {{max}} caractères',
  [tokens.extraction.pleaseEnterExactlyXCharacters]:
    'Veuillez entrer exactement {{count}} caractères',
  [tokens.extraction.pleaseEnterAWholeNumber]:
    'Veuillez entrer un nombre entier',
  [tokens.extraction.updatingData]: 'Mise à jour des données',
  [tokens.extraction.mustBeInAlpha2]:
    'Doit être au format alpha-2. Exemple pour France ⇒ FR.',
  [tokens.extraction.doitTreAuFormatAlpha2ExemplePourFranceFr]:
    'Doit être au format alpha-2. Exemple pour France ⇒ FR.',
  [tokens.extraction.pleaseEnterExactly10CharactersInFormat]:
    'Veuillez entrer exactement 10 caractères au format JJ/MM/AAAA',
  [tokens.extraction.pleaseEnterANumber]: 'Veuillez entrer un nombre',
  [tokens.extraction.pleaseEnterAMaximumOf]:
    'Veuillez entrer un maximum de {{count}} caractères',
  [tokens.extraction.pleaseSelectFromTheGivenValues]:
    'Veuillez choisir parmi les options proposées',
  [tokens.extraction.unknownTaricCode]: 'Code TARIC inconnu : {{code}}',
  [tokens.extraction.pleaseEnterAValueThatConsistsOfLetters]:
    'Veuillez entrer une valeur composée de lettres (majuscules ou minuscules), de chiffres et de tirets, et ayant une longueur maximale de 35 caractères',
  [tokens.extraction.pleaseEnterAValidSiretNumber]:
    'Veuillez entrer un numéro SIRET',
  [tokens.extraction['18LettersAndNumbersMaximum']]:
    '18 lettres et chiffres maximum',
  [tokens.extraction.mustBeInteger]: 'Doit être un nombre',
  [tokens.extraction.mustBeNumber]: 'Doit être un chiffre',
  [tokens.extraction.createTable]: 'Créer un tableau',
  [tokens.extraction.loadingExtractionInformation]:
    'Nabu extrait les données de vos documents',
  [tokens.extraction.emailAttachments]: '{{count}} pièce jointe',
  [tokens.extraction.emailAttachments_other]: '{{count}} pièces jointes',
  [tokens.extraction.deleteColumn]: 'Supprimer la colonne',
  [tokens.extraction.loadingBackToDashboard]:
    'Vous pouvez retourner sur votre tableau de bord en attendant',
  [tokens.extraction.notAccessibleForOrganization]:
    "Ce document n'est pas accessible pour cette organisation. Veuillez vous connecter avec le compte correspondant.",
  [tokens.managementConsole
    .tableAutomationsSelectHelperText]: `Dans la colonne « Row » à droite, sélectionnez les lignes du worksheet que vous souhaitez utiliser en cliquant et en faisant glisser.<br/>Vous pouvez sélectionner plusieurs plages, à condition qu’elles ne se chevauchent pas.<br/>Une fois terminé, cliquez sur le bouton « Valider » pour passer à l’étape suivante.`,
  [tokens.extraction.doYouWantToDeleteTable]:
    'Etes-vous certain de vouloir supprimer les tableaux de toutes les pages ? Toutes les données des tableaux - extraites et ajoutées manuellement - seront perdues.',
  [tokens.extraction.doYouWantToDeleteTableOnCurrentPage]:
    'Etes-vous certain de vouloir supprimer le tableau de cette page ? Toutes données du tableau - extraites et ajoutées manuellement - seront perdues.',
  [tokens.extraction.editTable]: 'Éditer le tableau',
  [tokens.extraction.editCells]: 'Éditer les cellules - Crtl+Alt',
  [tokens.extraction.downloadOriginalFilesForThisDossier]:
    'Télécharger les fichiers originaux pour ce dossier',
  [tokens.extraction.editGrid]: 'Éditer la grille — Ctrl+Alt',
  [tokens.extraction.editField]: 'Editer les champs',
  [tokens.extraction.noClientOrganization]: 'Aucune Organisation Client',
  [tokens.extraction.additionSummaryTitle]: 'Frais',
  [tokens.extraction.deductionSummaryTitle]: 'Remises',
  [tokens.extraction.statisticalValueSummaryTitle]: 'Valeur statistique',
  [tokens.extraction.totauxSummaryTitle]: 'Totaux',
  [tokens.extraction.totauxSummaryInfo]:
    'Montants agrégés du dossier : valeur des articles, frais, masses et valeur statistique.',
  [tokens.extraction.totalsRubriqueFacturation]: 'Facturation',
  [tokens.extraction.totalsRubriqueColisage]: 'Colisage',
  [tokens.extraction.totalsArticlesBadge]: 'article',
  [tokens.extraction.totalsArticlesBadge_other]: 'articles',
  [tokens.extraction.statisticalValueSummaryInfo]:
    'Valeur de la marchandise au point de sortie du territoire français, calculée selon l’incoterm.',
  [tokens.extraction.statisticalValueAutoBadge]: 'Auto',
  [tokens.extraction.statisticalValueManualBadge]: 'Manuel',
  [tokens.extraction.statisticalValueIncotermLabel]:
    'Incoterm du dossier : {{code}}',
  [tokens.extraction.statisticalValueIncotermFolderLabel]:
    'Incoterm du dossier :',
  [tokens.extraction.statisticalValueIncotermNotSet]: 'Aucun incoterm renseigné',
  [tokens.extraction.statisticalValueIncotermNotSetHelp]:
    'Renseignez l’incoterm du dossier pour appliquer les règles de calcul automatique.',
  [tokens.extraction.statisticalValueIncotermFcaDescription]:
    '{{code}} : valeur marchandise + transport jusqu’à la frontière française (ajout).',
  [tokens.extraction.statisticalValueIncotermFobDescription]:
    '{{code}} : valeur marchandise sans transport international.',
  [tokens.extraction.statisticalValueIncotermCifDescription]:
    '{{code}} : valeur marchandise incluant le transport jusqu’à la frontière.',
  [tokens.extraction.statisticalValueManualEntry]: 'Saisie manuelle',
  [tokens.extraction.statisticalValueManualEntryHelpOff]:
    'Valeur calculée automatiquement selon l’incoterm.',
  [tokens.extraction.statisticalValueManualEntryHelpOn]:
    'Valeur libre. Repassez en auto pour recalculer.',
  [tokens.extraction.statisticalValueManualInputPlaceholder]:
    '{{value}} (valeur calculée)',
  [tokens.extraction.statisticalValueManualCalculatedHint]:
    'Valeur calculée ({{description}}) : {{value}} {{currency}}. Cliquez pour la reprendre, ou saisissez-en une autre.',
  [tokens.extraction.statisticalValueManualReuseCalculatedValue]:
    'Reprendre la valeur calculée',
  [tokens.extraction.statisticalValueTransportAbroad]: 'Transport hors France',
  [tokens.extraction.statisticalValueTransportAbroadHelp]:
    'Part réalisée au-delà de la frontière, exclue de l’ajout.',
  [tokens.extraction.statisticalValueBreakdownArticles]: 'Montant articles',
  [tokens.extraction.statisticalValueBreakdownTransport]:
    'Transport jusqu’à la frontière française',
  [tokens.extraction.statisticalValueBreakdownMiscFees]: 'Frais divers',
  [tokens.extraction.noStatisticalValueDocumentsFound]:
    'Aucun document trouvé pour la valeur statistique',
  [tokens.extraction.conversionSourcedFrom]:
    'Conversion sourcée de {{source}} le {{date}}',
  [tokens.extraction.deleteTableOnlyInThePage]:
    'Suppression du tableau sur cette page',
  [tokens.extraction.deleteTableInAllPage]:
    'Suppression du tableau sur toutes les pages',
  [tokens.extraction.doYouWantToDeleteColumn]:
    'Etes-vous certain de vouloir supprimer cette colonne ? Toutes données de la colonne - extraites et ajoutées manuellement - seront perdues.',
  [tokens.extraction.doYouWantToDeleteColumnAndDeconsolidate]:
    'Etes-vous certain de vouloir supprimer cette colonne ? Toutes données de la colonne - extraites et ajoutées manuellement - seront perdues et les articles ne seront plus consolidés',
  [tokens.extraction.doYouWantToDeleteRow]:
    'Etes-vous certain de vouloir supprimer cette rangée ? Toutes données de la rangée - extraites et ajoutées manuellement - seront perdues.',
  [tokens.extraction.doYouWantToEditColumnAndDeconsolidate]:
    'Etes-vous certain de vouloir éditer cette rangée ? les articles ne seront plus consolidés',
  [tokens.extraction.doYouWantToDeleteGroupedColumns]:
    "Important - cette colonne fait partie d'une colonne groupée. Toutes les autres colonnes dans le groupe seront aussi supprimées, et toutes les données pour toutes les colonnes seront perdues. Etes-vous sûr de vouloir supprimer cette colonne ?",
  [tokens.extraction.addOriginOfArticles]: "l'origine",
  [tokens.extraction.addHSCodeOfArticles]: 'le HS Code',
  [tokens.extraction.addCodePrefOfArticles]: 'le code préférence tarifaire',
  [tokens.extraction.addOriginCountryCode]: "le Code de pays d'origine",
  [tokens.extraction.codePreferenceModalTitle]: 'Code Préférences',
  [tokens.extraction.codePreferenceCopy]: 'Le code du champ a bien été copié',
  [tokens.extraction.preferenceCode]: 'Code préférence',
  [tokens.extraction.ofItems]: 'des articles',
  [tokens.extraction.add]: 'Ajouter',
  [tokens.extraction.emptyTable]: 'Le tableau est vide',
  [tokens.extraction.emptyTableHintLine1]:
    'Cliquez sur les libellés des colonnes en haut de la grille,',
  [tokens.extraction.emptyTableHintLine2]:
    "puis choisissez une classification pour chaque colonne afin d'alimenter le tableau.",
  [tokens.extraction.addToTable]: 'Ajouter au tableau',
  [tokens.extraction.addColumn]: 'Ajouter une colonne',
  [tokens.extraction.declarationState]: 'État de votre déclaration',
  [tokens.extraction.returnToDeclarations]: 'Retour aux dossiers',
  [tokens.extraction.updateDeclaration]: 'Modifier la déclaration',
  [tokens.extraction.declarationUploading]:
    'Votre déclaration est en cours de dépot',
  [tokens.extraction.declarationUploaded]: 'Le dossier a bien été transmis',
  [tokens.extraction.youWillBeRedirectedToModelCreation]:
    'Vous allez être redirigé vers la création de modèle dans 10s',
  [tokens.extraction.youWillBeRedirectedToTheDashboard]:
    'Vous allez être redirigé vers le dashboard dans 10s',
  [tokens.extraction.declarationUploadFailed]: "L'envoi du dossier a échoué",
  [tokens.extraction.failedToLoadOptions]: 'Le chargement des options a échoué',
  [tokens.extraction.checkDeclarationAndRetry]:
    'Veuillez vérifier les informations du dossier et réessayer',
  [tokens.extraction.checkDeclaration]:
    'Veuillez vérifier les informations du dossier',
  [tokens.extraction.retryExport]: "Réessayer l'envoi",
  [tokens.extraction.exportRetryDialogMessage]:
    "L'envoi de cette déclaration a échoué. Vous pouvez réessayer l'envoi maintenant.",
  [tokens.extraction.exportFailedMessage]:
    "L'envoi de cette déclaration a échoué.",
  [tokens.extraction.exportRetryInitiated]:
    "La nouvelle tentative d'envoi a été initiée avec succès.",
  [tokens.extraction.missingValuesInColumn]:
    '{{count}} valeur(s) manquante(s) dans la colonne "{{column}}" pour effectuer ce calcul',
  [tokens.extraction.columnMissing]:
    'Il manque les valeurs de la colonne "{{column}}" pour effectuer ce calcul',
  [tokens.extraction.warningOriginX]:
    "l'origine x du tableau recouvre des cellules",
  [tokens.extraction.warningOriginY]:
    "l'origine y du tableau recouvre des cellules",
  [tokens.extraction.warningTouchingCellsOnX]:
    'la largeur se réduit trop, touchant les cellules existantes',
  [tokens.extraction.warningTouchingCellsOnY]:
    'la hauteur se réduit trop, touchant les cellules existantes',
  [tokens.extraction.warningBottomRowTooSmall]:
    'la ligne du bas est trop petite',
  [tokens.extraction.warningTopRowTooSmall]: 'la ligne du haut est trop petite',
  [tokens.extraction.warningTableLeavesPage]: 'le tableau sort de la page',
  [tokens.extraction.consolidate]: 'Consolider',
  [tokens.extraction.consolidated]: 'Consolidé',
  [tokens.extraction.deconsolidate]: 'Dé-consolider',
  [tokens.extraction.clickOnTheButtonToUndoConsolidation]:
    'Le tableau a été consolidé - cliquez sur le bouton ci-dessous pour le déconsolider.',
  [tokens.extraction.selectTheColumnsToBeUsedForConsolidation]:
    'Choisir les colonnes à utiliser pour la consolidation',
  [tokens.extraction.sendingConfirmation]: "Confirmation d'envoi",
  [tokens.extraction.createModelInfo]:
    "Cela vous permet de sauvegarder les informations de cette déclaration afin de pouvoir les réutiliser. Lors de la création d'un nouveau dossier, sélectionnez simplement un modèle dans la liste pour appliquer les paramètres enregistrés.",
  [tokens.extraction.sendingFileQuestion]:
    'Êtes-vous sûr de vouloir envoyer cette déclaration ?',
  [tokens.extraction.saveModelQuestion]:
    'Souhaitez-vous créer un nouveau modèle à partir de cette déclaration ?',
  [tokens.extraction.consolidateAndVerify]: 'Consolider et vérifier',
  [tokens.extraction.consolidateAndSend]: 'Consolider et envoyer',
  [tokens.extraction.consolidateAndSendOptions]:
    'Autres options de consolidation et d’envoi',
  [tokens.extraction.sendWithoutConsolidating]: 'Envoyer sans consolider',
  [tokens.extraction.declarationQualityQuestion]:
    "Comment s'est passée cette déclaration ?",
  [tokens.extraction.declarationQualityVeryDissatisfied]: 'Très insatisfait',
  [tokens.extraction.declarationQualityVerySatisfied]: 'Très satisfait',
  [tokens.extraction.declarationQualityAddRemark]:
    'Ajouter une remarque (facultatif)',
  [tokens.extraction.declarationQualityRemarkPlaceholder]:
    'Partagez vos remarques sur cette extraction…',
  [tokens.extraction.createNewModel]: 'Créer un nouveau modèle',
  [tokens.extraction.redirectCreateModel]:
    'Redirection vers la création du modèle',
  [tokens.extraction.modelFieldsAreFixed]:
    'Les informations ci-dessous ne sont pas modifiables. Vous pouvez uniquement ajouter ou retirer un ou des champs à votre modèle.',
  [tokens.extraction.selectAllFields]: 'Selectionner tous les champs',
  [tokens.extraction.modelDetail]: 'Identification du modèle',
  [tokens.extraction.modelCreation]: "Création d'un modèle",
  [tokens.extraction.modelCreated]: 'Modèle créé',
  [tokens.extraction.modelCreationFailed]: 'Échec création modèle',
  [tokens.extraction.noModelApplied]: 'Aucun modèle appliqué',
  [tokens.extraction.glideHeaderSum]: 'Somme',
  [tokens.extraction.glideHeaderArticleNumber]: "Nombre d'articles",
  [tokens.extraction.checkFieldModalFirstTextWarning]: 'Attention !',
  [tokens.extraction.checkFieldModalFirstText]:
    'Mettre à jour ce champs remplacera toutes les valeurs pour "',
  [tokens.extraction.checkFieldModalFirstTextEnding]: '" dans votre tableau.',
  [tokens.extraction.checkFieldModalSecondText]:
    'Toutes vos valeurs actuelles seront perdues !',
  [tokens.extraction.checkFieldModalFieldUpdated]: 'Updated table',
  [tokens.extraction.checkFieldModalConsolidatedTitle]:
    'Consolidation des articles',
  [tokens.extraction.checkFieldModalConsolidatedFirstText]:
    'Vous allez envoyer votre déclaration sans avoir consolidé les articles.',
  [tokens.extraction.consolidationRequired]:
    'La consolidation de la déclaration est obligatoire avant de valider',
  [tokens.extraction.checkFieldModalConsolidatedSecondText]:
    "Souhaitez vous modifier votre déclaration ou l'envoyer sans consolider ?",
  [tokens.extraction.checkFieldModalConsolidatedUpdatedButton]:
    'Retourner à la déclaration',
  [tokens.extraction.checkFieldModalConsolidatedSendButton]:
    'Envoyer sans consolider',
  [tokens.extraction.checkFieldModalFieldUpdated]: 'Tableau mis à jour',
  [tokens.extraction.checkFieldModalDependenciesWarning]: 'Attention !',
  [tokens.extraction.resetLabelBox]: 'Reset',
  [tokens.extraction.productDescription]: 'Description produit',
  [tokens.extraction.noAdditionalCodesAvailableForThisTaricCode]:
    'Aucun code additionnel trouvé pour ce code TARIC',
  [tokens.extraction.addAnAdditionalCode]: 'Ajouter un code supplémentaire',
  [tokens.extraction.additionalCodes]: 'Codes supplémentaires',
  [tokens.extraction.noResult]: 'Aucun résultat',
  [tokens.extraction.previousResult]: 'Résultat précédent',
  [tokens.extraction.nextResult]: 'Résultat suivant',
  [tokens.extraction.searchByKeywords]: 'Chercher par mot clé',
  [tokens.extraction.currentChoice]: 'Sélection actuelle',
  [tokens.extraction.selectItem]: 'Sélectionner',
  [tokens.extraction.itemDescription]: 'Déscription article',
  [tokens.extraction.searchAnotherHsCode]: 'Chercher un autre code',
  [tokens.extraction.moreDetails]: '+ détails',
  [tokens.extraction.seeLess]: '- détails',
  [tokens.extraction.previousRow]: 'Ligne précédente',
  [tokens.extraction.nextRow]: 'Ligne prochaine',
  [tokens.extraction.row]: 'Ligne',
  [tokens.extraction.mustBeEqualToOneOfTheAllowedValues]:
    'Doit être égal à une des valeurs proposées',
  [tokens.extraction.editDescription]: 'Modifier la description',
  [tokens.extraction.replaceDescriptionByTaricCodeDescription]:
    'Substituer la description du code Taric',
  [tokens.extraction.applyValueToAllRows]:
    'Appliquer cette valuer à toutes les lignes',
  [tokens.extraction.revertToInitialCode]: 'Revenir vers le code initial',
  [tokens.extraction.noAdditionalCodesSelected]:
    'Aucun code supplémentaire sélectionné',
  [tokens.extraction.additionalCodesSelected]:
    '{{count}} code supplémentaire sélectionné',
  [tokens.extraction.additionalCodesSelected_other]:
    '{{count}} codes supplémentaires sélectionnés',
  [tokens.extraction.copyValueToEntireColumn]:
    'Copier la valeur de cette cellule à la colonne entière',
  [tokens.extraction.copyValueToEntireColumnShortcut]:
    'Dupliquer sur facture actuelle (Ctrl+Shift+C)',
  [tokens.extraction.copyToCurrentDocumentColumn]:
    'Dupliquer sur facture actuelle',
  [tokens.extraction.copyToAllDocumentsColumn]:
    'Dupliquer sur toutes les factures',
  [tokens.extraction.copyToCurrentDocumentColumnShortcut]:
    'Dupliquer sur facture actuelle (Ctrl+Shift+C)',
  [tokens.extraction.copyToColumnOptions]: 'Options de duplication',
  [tokens.extraction.areYouSureYouWantToCopyThisCellValueToAllColumns]:
    'Etes-vous sûr de vouloir remplacer avec la valeur de cette cellule les valeurs de toutes les cellules de la colonne ?',
  [tokens.extraction
    .areYouSureYouWantToCopyThisCellValueToCurrentDocumentColumn]:
    'Etes-vous sûr de vouloir remplacer les valeurs de la colonne sur la facture actuelle ?',
  [tokens.extraction.areYouSureYouWantToCopyThisCellValueToAllDocumentsColumns]:
    'Etes-vous sûr de vouloir remplacer les valeurs de la colonne sur toutes les factures du dossier ?',
  [tokens.extraction.taricCodeNotFound]: 'Code TARIC non trouvé',
  [tokens.extraction.noArticleDescription]: 'Aucune description produit trouvé',
  [tokens.extraction.updateDeclarationModel]:
    'Changer le modèle pour cette déclaration ',
  [tokens.extraction.removeModel]: 'Supprimer le modèle',
  [tokens.extraction.changeModel]: 'Changer le modèle',
  [tokens.extraction.additionalCode]: 'Code additionnel',
  [tokens.extraction.changeModelForCurrentDeclaration]:
    'Changer le modèle pour cette déclaration.',
  [tokens.extraction.applyItemToDeclaration]:
    'Ajouter ces codes à cette déclaration',
  [tokens.extraction.redoClassificationStep]: 'Refaire la classification',
  [tokens.extraction.noDuty]: 'Aucun droits trouvés',
  [tokens.extraction.currency]: 'devise',
  [tokens.extraction.hoverOverAResultToSeeDetails]:
    'Passez votre souris sur un résultat pour voir les détails',
  [tokens.extraction.searchAdditionalCodesByKeyword]:
    'Chercher codes additionnels par mots clés',
  [tokens.extraction.basicValidations]: 'Validations de base',
  [tokens.extraction.showAnomalies]: 'Afficher les erreurs',
  [tokens.extraction.clickToViewValidationErrors]:
    'Cliquer pour voir les erreurs à corriger',
  [tokens.extraction.validationErrorsToFix]: '{{count}} erreur à corriger',
  [tokens.extraction.validationErrorsToFix_other]:
    '{{count}} erreurs à corriger',
  [tokens.extraction.goToValidationField]: 'Aller au champ « {{field}} »',
  [tokens.extraction.validationFieldError]: 'Erreur sur le champ « {{field}} »',
  [tokens.extraction.anomaliesBeforeSend]:
    '{{count}} erreur à corriger avant envoi',
  [tokens.extraction.anomaliesBeforeSend_other]:
    '{{count}} erreurs à corriger avant envoi',
  [tokens.extraction.validationSummary]:
    '{{validated}} / {{total}} champs validés · {{remaining}} champs requis restants :',
  [tokens.extraction.showErrorsOnlySections]: 'Afficher les erreurs',
  [tokens.extraction.clearErrorsOnlyFilter]: 'Tout afficher',
  [tokens.extraction.otherErrorFields]: 'Autres champs',
  [tokens.extraction.coherenceChecks]: 'Contrôles de cohérence',
  [tokens.extraction.tabHasNoData]:
    "Cette partie de la déclaration n'a aucune donnée associée, probablement suite à une incedent technique. Veuillez contacter notre service client en cliquant sur l'icône en bas à droit de votre écran.",
  [tokens.extraction.pressCtrlJToGoToNextCoherenceError]:
    'Appuyez sur Ctrl+J pour aller à l’erreur de cohérence suivante',
  [tokens.extraction.sendMessage]: 'Envoyer le message',
  [tokens.extraction.newMessage]: 'Nouveau message',
  [tokens.extraction.error]: 'Erreur',
  [tokens.extraction.countries]: 'Pays',
  [tokens.extraction.includedCountries]: 'Pays inclus',
  [tokens.extraction.excludedCountries]: 'Pays exclus',
  [tokens.extraction.renvois]: 'Renvois',
  [tokens.extraction.referenceAbbrev_tax]: 'TAX',
  [tokens.extraction.referenceAbbrev_certificate]: 'CRT',
  [tokens.extraction.referenceAbbrev_preference]: 'PRF',
  [tokens.extraction.referenceAbbrev_location]: 'LOC',
  [tokens.extraction.referenceAbbrev_additionalcode]: 'ADD',
  [tokens.extraction.internalErrorState]: 'Etat erreur interne',
  [tokens.common.noOptionAvailable]: 'Aucune option disponible',
  [tokens.extraction.taxCode]: 'Code taxe',
  [tokens.extraction.duty]: 'Droits',
  [tokens.extraction.setBatchImportError]: "Mettre le dossier en état d'erreur",
  [tokens.extraction
    .puttingThisDossierInErrorStateTellsExternalUsersNabuCannotProcessIt]:
    "Attention - mettre ce dossier en état d'erreur communique aux utilisateurs externes que Nabu ne peut pas le traiter",
  [tokens.extraction.tax]: 'Taxe',
  [tokens.extraction.prefTarif]: 'Pref tarif',
  [tokens.extraction.tariffProvision]: 'Disposition tarifaire particulière',
  [tokens.extraction.tariffProvision_short]: 'Dispo-tarif',
  [tokens.extraction.legalReferences]: 'Références légales',
  [tokens.extraction.unknown]: 'Inconnu',
  [tokens.extraction.consolidationOptions]: 'Options de consolidation',
  [tokens.extraction.hscode]: 'Nomenclature',
  [tokens.extraction.countryOfOrigin]: "Pays d'origine",
  [tokens.extraction.description]: 'Description',
  [tokens.extraction.thisDeclarationIsNotInAnErrorState]:
    "Cette déclaration n'est pas en état d'erreur",
  [tokens.extraction.numberOfUnits]: "Nombre d'unités",
  [tokens.extraction.numberOfPackages]: 'Nombre de colis',
  [tokens.extraction.noErrorState]: "Le dossier n'est pas en état d'erreur",
  [tokens.extraction.netWeight]: 'Poids net',
  [tokens.extraction.grossWeight]: 'Poids brut',
  [tokens.extraction.containerCode]: 'Référence containeur',
  [tokens.extraction.codeDescriptionNotFound]:
    'Description du code non trouvée',
  [tokens.extraction.noTablesWithMergeableColumns]:
    'Aucun tableau avec des colonnes possible de fusionner',
  [tokens.extraction.noCertificateRequired]: 'Aucun certificat requis',
  [tokens.extraction.informationAbout]:
    'Information sur {{ itemName }} : {{ code }}',
  [tokens.extraction.thisCodeHasMissingInformation]:
    'Ce code a des informations manquantes',
  [tokens.extraction.is]: 'est',
  [tokens.extraction.if]: 'si',
  [tokens.extraction.then]: 'alors',
  [tokens.extraction.shouldBe]: 'doit être',
  [tokens.extraction.equalTo]: 'égal à',
  [tokens.extraction.lessThan]: 'moins que',
  [tokens.extraction.lessThanOrEqualTo]: 'plus petit ou égal à',
  [tokens.extraction.notIn]: 'pas dans',
  [tokens.extraction.filled]: 'rempli',
  [tokens.extraction.greaterThan]: 'plus que',
  [tokens.extraction.greaterThanOrEqualTo]: 'plus grand ou égal à',
  [tokens.extraction.in]: 'dans',
  [tokens.extraction.notEqualTo]: 'différent de',
  [tokens.extraction.totalDocument]: 'total document',
  [tokens.extraction.calculatedDocument]: 'total calculé',
  [tokens.extraction.documentTotals]: 'Totaux du document',
  [tokens.extraction.amountTotal]: 'Montant total',
  [tokens.extraction.grossWeightTotal]: 'Poids brut total',
  [tokens.extraction.netWeightTotal]: 'Poids net total',
  [tokens.extraction.numberOfPosition]: 'Nombre de position',
  [tokens.extraction.spread]: 'Répartir',
  [tokens.extraction.spreadOverAllLines]: 'Répartir sur toutes les lignes',
  [tokens.extraction.spreadDialogTitle]: 'Répartir les valeurs pour {{name}}',
  [tokens.extraction.spreadDialogContent]:
    'Répartir la valeur {{value}} sur toutes les lignes du tableau des articles pour la colonne du {{name}}.',
  [tokens.extraction.spreadSuccess]: 'Répartition effectuée avec succès',
  [tokens.extraction.spreadError]:
    "La distribution des totaux n'a pas pu être appliquée.",
  [tokens.extraction.document]: 'Document',
  [tokens.extraction.totalNotFound]:
    "Le total <strong>{{label}}</strong> n'a pas été identifié parmi le ou les documents. La somme de la colonne est affichée.",
  [tokens.extraction.errorCells]:
    'Des informations dans les cellules du tableau des articles sont manquantes pour effectuer le total. Veuillez renseigner ces cellules pour afficher le total.',
  [tokens.extraction.errorMissingDocumentTitle]: 'Documents manquants',
  [tokens.extraction.errorMissingDocumentContent]:
    "Le dossier ne peut être traité en l'état : certains documents obligatoires sont absents (ex. : facture commerciale, packing list, certificat d’origine). Merci de fournir l’ensemble des pièces requises pour la déclaration en douane",
  [tokens.extraction.errorDocumentaryInconsistenciesTitle]:
    'Incohérence documentaires',
  [tokens.extraction.errorDocumentaryInconsistenciesContent]:
    'Des incohérences ont été relevées entre les documents fournis (ex. : différences entre les quantités, valeurs ou descriptions des marchandises). Merci de vérifier et de transmettre des documents alignés et cohérents',
  [tokens.extraction.errorNonCompliantDocumentTitle]:
    'Documents illisibles ou non conformes',
  [tokens.extraction.errorNonCompliantDocumentContent]:
    'Certains documents transmis sont illisibles, incomplets ou non conformes. Merci de fournir des versions lisibles, complètes et officielles pour permettre la bonne instruction du dossier',
  [tokens.extraction.errorGenericTitle]: 'Dossier en erreur',
  [tokens.extraction.errorGenericContent]:
    'Une erreur empêche le traitement de ce dossier. Merci de vérifier les fichiers transmis.<br>Si le problème persiste, vous pouvez contacter notre équipe support via <intercom>Intercom</intercom>.',
  [tokens.extraction.searchForAField]: 'Chercher une donnée',
  [tokens.extraction.keyboardShortcutTab]: 'Tab',
  [tokens.extraction.keyboardShortcutEnter]: 'Entrée',
  [tokens.extraction.keyboardShortcutNextField]: 'champ suivant',
  [tokens.extraction.keyboardShortcutValidate]: 'valider',
  [tokens.extraction.selectedField]: 'Champ sélectionné',
  [tokens.extraction.stepKeyboardShortcutTab]: 'Tab',
  [tokens.extraction.stepKeyboardShortcutEnter]: 'Entrée',
  [tokens.extraction.stepKeyboardShortcutNextField]: 'valider et champ suivant',
  [tokens.extraction.stepKeyboardShortcutValidate]: 'valider',
  [tokens.extraction.stepKeyboardShortcutEscape]: 'Esc',
  [tokens.extraction.stepKeyboardShortcutCancel]: 'annuler',
  [tokens.extraction.stepKeyboardShortcutSearch]: 'rechercher',
  [tokens.extraction.stepKeyboardShortcutQuickActions]: 'actions rapides',
  [tokens.extraction.summaryTableArticles]: 'Tableau des articles',
  [tokens.extraction.fieldsList]: 'Liste des champs',
  [tokens.extraction.runTableAutomations]:
    'Lancer les automatisations du tableau',
  [tokens.extraction.runReferentialAutomations]:
    "Lancer l'automatisation référentiel",
  [tokens.extraction.referentialAutomationDrawerTitle]:
    'Automatisation référentiel',
  [tokens.extraction.referentialAutomationDrawerSubtitle]:
    'Prévisualiser et appliquer une automatisation',
  [tokens.extraction.referentialAutomationPreviewHint]:
    "Aucune valeur n'est écrite tant que vous n'avez pas validé l'aperçu",
  [tokens.extraction.referentialAutomationSelectLabel]:
    'Automatisation à exécuter',
  [tokens.extraction.referentialAutomationSourceLabel]:
    'Référentiel : {{name}}',
  [tokens.extraction.referentialAutomationReadyTitle]: 'Prêt à comparer',
  [tokens.extraction.referentialAutomationReadyDescription]:
    "Lancez l'automatisation pour voir, ligne par ligne, les valeurs qui seront complétées ou remplacées depuis « {{name}} ».",
  [tokens.extraction.referentialAutomationLaunch]: "Lancer l'automatisation",
  [tokens.extraction.referentialAutomationApply]: 'Appliquer',
  [tokens.extraction.referentialAutomationApplySummary]:
    '{{count}} ligne(s) seront modifiées',
  [tokens.extraction.referentialAutomationApplySuccess]:
    'Automatisation appliquée avec succès',
  [tokens.extraction.referentialAutomationApplyError]:
    "Erreur lors de l'application de l'automatisation",
  [tokens.extraction.referentialAutomationRunError]:
    "Erreur lors de l'exécution de l'automatisation",
  [tokens.extraction.referentialAutomationNoReferentials]:
    'Aucune automatisation référentiel disponible pour cette déclaration',
  [tokens.extraction.referentialAutomationRowUpdateBadge]: 'À mettre à jour',
  [tokens.extraction.referentialAutomationWillChangeLabel]: 'vont changer',
  [tokens.extraction.referentialAutomationWillChangeLabel_one]: 'va changer',
  [tokens.extraction.referentialAutomationEmptyCell]: 'vide',
  [tokens.extraction.runMergeAutomations]:
    'Lancer les automatisations du fusion',
  [tokens.extraction.duplicateThisDossier]: 'Dupliquer ce dossier',
  [tokens.extraction.renameThisDossier]: 'Renommer ce dossier',
  [tokens.extraction.renameDossierTitle]: 'Renommer le dossier',
  [tokens.extraction.manageTags]: 'Gérer les tags',
  [tokens.extraction.bugTagDuplicateTitle]: 'Taguer comme BUG',
  [tokens.extraction.bugTagDuplicateMessage]:
    'Souhaitez-vous dupliquer ce dossier pour continuer la déclaration sur une copie ? Le dossier actuel sera conservé avec le tag BUG.',
  [tokens.extraction.bugTagDuplicateYes]: 'Oui, dupliquer',
  [tokens.extraction.bugTagDuplicateNo]: 'Non, taguer seulement',
  [tokens.extraction.duplicatingFolder]: 'Duplication du dossier en cours…',
  [tokens.extraction.folderDuplicatedSuccessfully]:
    'Le dossier a été dupliqué avec succès.',
  [tokens.extraction.openDuplicatedFolder]: 'Ouvrir le dossier dupliqué',
  [tokens.extraction.viewingDuplicatedFolder]:
    'Vous consultez maintenant le dossier dupliqué.',
  [tokens.extraction.editLockConflictTitle]: 'Dossier déjà en cours d’édition',
  [tokens.extraction.editLockConflictMessage]:
    '<bold>{{lockedBy}}</bold> édite ce dossier depuis {{lockedSince}}. Vous pouvez le consulter en lecture seule ou reprendre l’édition.',
  [tokens.extraction.editLockSinceToday]: '{{time}} aujourd’hui',
  [tokens.extraction.editLockSinceYesterday]: '{{time}} hier',
  [tokens.extraction.editLockSinceOnDate]: '{{time}} le {{date}}',
  [tokens.extraction.editLockReadOnlyBadgeHint]:
    'Cliquez pour reprendre l’édition',
  [tokens.extraction.editLockLostTitle]: 'Verrou d’édition perdu',
  [tokens.extraction.editLockLostMessage]:
    '<bold>{{takenOverBy}}</bold> a repris l’édition de ce dossier. Vos modifications ne peuvent plus être enregistrées.',
  [tokens.extraction.editLockLockRequiredTitle]: 'Verrou d’édition requis',
  [tokens.extraction.editLockLockRequiredMessage]:
    'Un verrou d’édition est nécessaire pour modifier ce dossier. Réessayez ou reprenez l’édition.',
  [tokens.extraction.editLockLockedBy]: 'Verrouillé par {{lockedBy}}',
  [tokens.extraction.editLockTakeOver]: 'Reprendre l’édition',
  [tokens.extraction.editLockBackToList]: 'Retour à la liste',
  [tokens.extraction.editLockUnknownUser]: 'un autre utilisateur',
  [tokens.extraction.editLockBadgeEditing]: 'Édition',
  [tokens.extraction.editLockBadgeReadOnly]: 'Lecture',
  [tokens.extraction.editLockBannerEditing]: 'Vous éditez ce dossier',
  [tokens.extraction.editLockBannerReadOnlyConflict]:
    'Lecture seule : {{lockedBy}} édite ce dossier',
  [tokens.extraction.editLockBannerReadOnlyLost]:
    'Lecture seule : {{takenOverBy}} a repris l’édition',
  [tokens.extraction.editLockEditorTooltip]: '{{name}} édite ce dossier',
  [tokens.extraction.createAModelFromThisDossier]:
    'Créer un modèle à partir de ce dossier',
  [tokens.extraction.createANewClientOrganizationFromThisDossier]:
    'Créer une nouvelle Organisation Client à partir de ce dossier',
  [tokens.extraction.tableAutomations]: 'Automatisations du tableau',
  [tokens.extraction.tableAutomationMatchesFound]:
    'Correspondances trouvées pour les automatisations',
  [tokens.extraction.payloads]: 'Payloads',
  [tokens.extraction.noTableAutomationsFound]:
    'Aucune automatisation de tableau trouvée',
  [tokens.extraction.noAutomationGroupsFound]:
    "Aucun groupe d'automatisation trouvé",
  [tokens.extraction.noTableInDocument]:
    "Nous n'avons pas pu définir un tableau d'articles dans le document. Veuillez définir manuellement le tableau d'articles.",
  [tokens.extraction.allFieldsValidated]:
    'Tous les champs de cette section on été validé',
  [tokens.extraction.fieldsInError]:
    '{{errorsCount}} champs en erreur dans cette section.',
  [tokens.extraction.fieldsValidationProgress]:
    '{{validatedFields}} champs validé sur un total de {{totalFields}} dans cette section.',
  [tokens.extraction.totalFieldsToValidate]:
    'Un total de {{totalFields}} champs a validé dans cette section.',
  [tokens.extraction.sectionCompleted]:
    'Tous les champs obligatoires de cette section sont remplis.',
  [tokens.extraction.sectionCompletionProgress]:
    '{{filledFields}}/{{totalFields}} champs obligatoires remplis dans cette section.',
  [tokens.extraction.dossierReferenceCopiedToClipboard]:
    'Référence du dossier copiée dans le presse-papiers',
  [tokens.extraction.comments]: 'Commentaires',
  [tokens.extraction.addAComment]: 'Ajouter un commentaire',
  [tokens.extraction.commentsForThisDeclaration]:
    'Commentaires pour cette déclaration',
  [tokens.extraction.downloadDeclarationOutputFile]:
    'Télécharger le fichier de sortie',
  [tokens.extraction.settingsDrawerTreatment]: 'Traitement',
  [tokens.extraction.settingsDrawerFolder]: 'Dossier',
  [tokens.extraction.settingsDrawerComments]: 'Commentaires',
  [tokens.extraction.settingsDrawerTags]: 'Tags',
  [tokens.extraction.settingsDrawerLayout]: 'Disposition',
  [tokens.extraction.settingsDrawerOpenComments]: 'Ouvrir les commentaires',
  [tokens.extraction.settingsDrawerInvertDocumentPanel]:
    'Inverser document / panneau',
  [tokens.extraction.settingsDrawerLayoutBalanced]: 'Équilibré',
  [tokens.extraction.settingsDrawerLayoutDocument]: 'Document',
  [tokens.extraction.settingsDrawerLayoutPanel]: 'Panneau',
  [tokens.extraction.settingsDrawerLayoutDocumentTable]: 'Document + Tableau',
  [tokens.extraction.relevanceScore]: 'Score de pertinence',
  [tokens.extraction.rossumExtraction]: 'Extraction Rossum',
  [tokens.extraction.rossumExtractionNoCompatibleLayer]:
    "Aucun mode d'extraction Rossum (external_rossum) disponible pour un ou plusieurs documents de ce dossier.",
  [tokens.extraction.rossumExtraction]: 'Extraction Rossum',
  [tokens.extraction.legacyExtractionModel]: "Ancien modèle d'extraction",
  [tokens.extraction.newExtractionModel]: "Nouveau modèle d'extraction",
  [tokens.extraction.rossumExtractionNoCompatibleLayer]:
    "Le modèle d'extraction demandé n'est pas disponible pour la facture commerciale.",
  [tokens.extraction.rossumExtraction]: 'Extraction Rossum',
  [tokens.extraction.legacyExtractionModel]: "Ancien modèle d'extraction",
  [tokens.extraction.newExtractionModel]: "Nouveau modèle d'extraction",
  [tokens.extraction.rossumExtractionNoCompatibleLayer]:
    "Le modèle d'extraction demandé n'est pas disponible pour la facture commerciale.",
  [tokens.extraction.updateExtractionModelTitle]: "Modèle d'extraction",
  [tokens.extraction.selectExtractionModel]: "Modèle d'extraction",
  [tokens.extraction.extractionModelRegenerateAlertToNew]:
    "Attention, vous êtes sur le point de regénérer l'extraction avec <bold>le nouveau modèle</bold>. Voulez-vous confirmer ?",
  [tokens.extraction.extractionModelRegenerateAlertToLegacy]:
    "Attention, vous êtes sur le point de regénérer l'extraction avec <bold>l'ancien modèle</bold>. Voulez-vous confirmer ?",
  [tokens.extraction.rossumExtraction]: 'Extraction Rossum',
  [tokens.extraction.legacyExtractionModel]: "Ancien modèle d'extraction",
  [tokens.extraction.newExtractionModel]: "Nouveau modèle d'extraction",
  [tokens.extraction.rossumExtractionNoCompatibleLayer]:
    "Le modèle d'extraction demandé n'est pas disponible pour la facture commerciale.",
  [tokens.extraction.updateExtractionModelTitle]: "Modèle d'extraction",
  [tokens.extraction.selectExtractionModel]: "Modèle d'extraction",
  [tokens.extraction.extractionModelRegenerateAlertToNew]:
    "Attention, vous êtes sur le point de regénérer l'extraction avec <bold>le nouveau modèle</bold>. Voulez-vous confirmer ?",
  [tokens.extraction.extractionModelRegenerateAlertToLegacy]:
    "Attention, vous êtes sur le point de regénérer l'extraction avec <bold>l'ancien modèle</bold>. Voulez-vous confirmer ?",
  [tokens.extraction.rossumExtraction]: 'Extraction Rossum',
  [tokens.extraction.legacyExtractionModel]: "Ancien modèle d'extraction",
  [tokens.extraction.newExtractionModel]: "Nouveau modèle d'extraction",
  [tokens.extraction.rossumExtractionNoCompatibleLayer]:
    "Le modèle d'extraction demandé n'est pas disponible pour la facture commerciale.",
  [tokens.extraction.updateExtractionModelTitle]: "Modèle d'extraction",
  [tokens.extraction.selectExtractionModel]: "Modèle d'extraction",
  [tokens.extraction.extractionModelRegenerateAlertToNew]:
    "Attention, vous êtes sur le point de regénérer l'extraction avec <bold>le nouveau modèle</bold>. Voulez-vous confirmer ?",
  [tokens.extraction.extractionModelRegenerateAlertToLegacy]:
    "Attention, vous êtes sur le point de regénérer l'extraction avec <bold>l'ancien modèle</bold>. Voulez-vous confirmer ?",
  [tokens.extraction.newInterfaceToggleLabel]: 'Nouvelle interface',
  [tokens.extraction.newInterfaceBetaBadge]: 'BETA',
  [tokens.extraction.newInterfacePlaceholder]:
    'La nouvelle interface sera bientôt disponible ici.',
  [tokens.extraction.betaStepHeadersTitle]: 'Entêtes',
  [tokens.extraction.betaStepHeadersSubtitle]: 'Identification & parties',
  [tokens.extraction.betaStepArticlesTitle]: 'Articles',
  [tokens.extraction.betaStepArticlesSubtitle]: 'Lignes de la déclaration',
  [tokens.extraction.betaStepDeliveryTitle]: 'Livraison & Transport',
  [tokens.extraction.betaStepDeliverySubtitle]: 'Colisage & masses',
  [tokens.extraction.betaStepRegulationTitle]: 'Réglementation & Douane',
  [tokens.extraction.betaStepRegulationSubtitle]: 'Régime & procédure',
  [tokens.extraction.betaStepControlTitle]: 'Contrôle & Envoi',
  [tokens.extraction.betaStepTotalsTitle]: 'Totaux',
  [tokens.extraction.betaStepControlSubtitle]: 'Facturation & valeur stat.',
  [tokens.extraction.betaActionAssistant]: 'Assistant',
  [tokens.extraction.betaActionAssistantTooltip]:
    'Posez une question sur cette déclaration ou demandez une correction de champs, un commentaire ou des tags, appliqués après votre confirmation.',
  [tokens.extraction.betaActionSourceDocument]: 'Document source',
  [tokens.extraction.betaActionSourceDocumentTooltip]:
    'Ouvre le document source pour le comparer à la déclaration.',
  [tokens.extraction.betaActionArticlesTable]: "Tableau d'articles",
  [tokens.extraction.betaActionStartReview]: 'Passer en revue',
  [tokens.extraction.betaActionStartReviewTooltip]:
    'Passer les anomalies et suggestions en revue une par une, avec mise au point automatique sur le champ concerné.',
  [tokens.extraction.betaStatusCritical]: 'Critiques',
  [tokens.extraction.betaStatusWarning]: 'Écarts',
  [tokens.extraction.betaStatusSuggestion]: 'Suggestions',
  [tokens.extraction.betaReviewProgress]: '{{current}}/{{total}} {{anomalyLabel}}',
  [tokens.extraction.betaReviewCounter]: '{{current}} / {{total}}',
  [tokens.extraction.betaReviewPrevious]: 'Anomalie précédente',
  [tokens.extraction.betaReviewNext]: 'Anomalie suivante',
  [tokens.extraction.betaReviewOpenTable]: 'Ouvrir le tableau',
  [tokens.extraction.betaReviewVerified]: 'Vérifié',
  [tokens.extraction.betaReviewClose]: 'Fermer la revue',
  [tokens.extraction.betaReviewNavigate]: 'Aller au champ',
  [tokens.extraction.betaReviewPanelTitle]: 'Revue de la déclaration',
  [tokens.extraction.betaReviewPanelSubtitle]:
    'Corrigez les anomalies, arbitrez les suggestions.',
  [tokens.extraction.betaReviewPanelStartReviewHint]:
    'Traiter {{count}} anomalie une par une',
  [tokens.extraction.betaReviewPanelStartReviewHint_other]:
    'Traiter les {{count}} anomalies une par une',
  [tokens.extraction.betaReviewPanelSectionBlocking]: "BLOQUANT POUR L'ENVOI",
  [tokens.extraction.betaReviewPanelSectionToVerify]: 'À VÉRIFIER',
  [tokens.extraction.betaReviewPanelExportBlockedFooter]:
    "L'envoi est bloqué tant qu'une anomalie critique n'est pas traitée.",
  [tokens.extraction.betaReviewPanelTabAnomalies]: 'Anomalies ({{count}})',
  [tokens.extraction.betaReviewPanelTabSuggestions]: 'Suggestions ({{count}})',
  [tokens.extraction.betaReviewPanelNoAnomalies]: 'Aucune anomalie restante.',
  [tokens.extraction.betaReviewPanelNoSuggestions]: 'Aucune suggestion IA pour le moment.',
  [tokens.extraction.betaStatusSummary]: '{{critical}} critiques · {{warning}} écarts',
  [tokens.extraction.betaStatusSuggestionCount]: '{{count}} suggestions',
  [tokens.extraction.betaExportBlockedTitle]: 'Anomalies critiques à corriger',
  [tokens.extraction.betaExportBlockedDescription]:
    '{{count}} incohérence critique empêche l’envoi de la déclaration.',
  [tokens.extraction.betaExportBlockedDescription_other]:
    '{{count}} incohérences critiques empêchent l’envoi de la déclaration.',
  [tokens.extraction.betaExportBlockedReview]: 'Voir les anomalies',
  [tokens.extraction.betaExportBlockedClose]: 'Masquer l’alerte',
  [tokens.extraction.betaSuggestionsBannerTitle]: 'Suggestions de l’IA',
  [tokens.extraction.betaSuggestionsBannerSubtitle]: 'à accepter ou ignorer',
  [tokens.extraction.betaSuggestionsBannerHide]: 'Masquer',
  [tokens.extraction.betaSuggestionAccept]: 'Accepter',
  [tokens.extraction.betaSuggestionIgnore]: 'Ignorer',
  [tokens.extraction.betaSuggestionConfidence_high]: 'Confiance élevée',
  [tokens.extraction.betaSuggestionConfidence_medium]: 'Confiance moyenne',
  [tokens.extraction.betaSuggestionConfidence_low]: 'Confiance faible',
  [tokens.extraction.betaStepArticlesPlaceholder]:
    "Le tableau d'articles s'ouvrira dans une fenêtre dédiée.",
  [tokens.extraction.betaStepControlPlaceholder]:
    'Les totaux et contrôles seront affichés ici.',
  [tokens.extraction.betaStepEmptyContent]:
    'Aucun contenu disponible pour cette étape.',
  [tokens.extraction.macroCheckAmount]: 'Montant',
  [tokens.extraction.macroCheckPackages]: 'Nombre de colis',
  [tokens.extraction.macroCheckGrossMass]: 'Masse brute',
  [tokens.extraction.macroCheckNetMass]: 'Masse nette',
  [tokens.extraction.macroCheckOk]: 'OK',
  [tokens.extraction.macroCheckLineSum]: 'Somme des lignes articles :',
  [tokens.extraction.macroCheckSourceUnavailable]: 'Non extrait',
  [tokens.extraction.macroCheckTooltipAmount]:
    'Compare la somme de la colonne Montant (toutes les lignes, y compris frais et remises) au montant facturé relevé sur les factures dont les lignes sont dans le tableau.',
  [tokens.extraction.macroCheckTooltipPackages]:
    'Compare la somme des colis ventilés sur les lignes au colisage déclaré sur les documents du même périmètre. Les lignes de frais ou de remise ne portent pas de colis.',
  [tokens.extraction.macroCheckTooltipGrossMass]:
    'Compare la somme des masses brutes ventilées à la masse brute relevée sur les documents du même périmètre. Les lignes de frais ou de remise ne portent pas de masse.',
  [tokens.extraction.macroCheckTooltipNetMass]:
    'Compare la somme des masses nettes ventilées à la masse nette relevée sur les documents du même périmètre. Les lignes de frais ou de remise ne portent pas de masse.',
  [tokens.extraction.macroCheckFilterAmount]: 'Lignes en anomalie de montant',
  [tokens.extraction.macroCheckFilterPackages]: 'Lignes sans colis',
  [tokens.extraction.macroCheckFilterGrossMass]: 'Lignes sans masse brute',
  [tokens.extraction.macroCheckFilterNetMass]: 'Lignes sans masse nette',
  [tokens.extraction.stepDocumentWindowTitle]: 'Document source',
  [tokens.extraction.stepArticlesWindowTitle]: "Tableau d'articles",
  [tokens.extraction.stepArticlesWindowOpenHint]:
    "Le tableau d'articles est ouvert dans une fenêtre flottante.",
  [tokens.extraction.stepSourceDocumentPin]: 'Épingler le document à la page',
  [tokens.extraction.stepSourceDocumentUnpin]: 'Détacher le document',
  [tokens.extraction.stepSourceDocumentFullscreen]: 'Afficher en plein écran',
  [tokens.extraction.stepSourceDocumentOpenInOtherWindow]:
    'Ouvrir le document source dans une autre fenêtre',
  [tokens.extraction.stepSourceDocumentOpenedInOtherWindow]:
    'Document source déjà ouvert dans une autre fenêtre',
  [tokens.extraction.stepSourceDocumentSecondScreenTitle]: 'Afficher le document sur votre 2ème écran',
  [tokens.extraction.stepSourceDocumentSecondScreenBody]:
    "Nabu peut ouvrir le document source directement sur votre autre écran. Votre navigateur va vous demander l'autorisation de « gérer les fenêtres sur tous vos écrans » : acceptez-la, elle ne vous sera plus demandée.",
  [tokens.extraction.stepSourceDocumentSecondScreenContinue]: 'Continuer',
  [tokens.extraction.stepSourceDocumentSecondScreenTab]: 'Ouvrir dans un onglet',
  [tokens.extraction.stepSourceDocumentExitFullscreen]: 'Quitter le plein écran',
  [tokens.extraction.stepSourceDocumentClose]: 'Fermer le document',
  [tokens.extraction.stepSourceDocumentResizeHandle]:
    'Redimensionner le panneau document source',
  [tokens.extraction.stepSourceDocumentTextCopied]: 'Texte copié',
  [tokens.extraction.stepSourceDocumentTextCopyFailed]:
    'Impossible de copier le texte',
  [tokens.extraction.stepArticlesValuesPasted]: 'Valeurs collées',
  [tokens.extraction.stepArticlesValuesPasteFailed]:
    'Impossible de coller les valeurs',
  [tokens.extraction.stepSourceDocumentPdfCopyHint]:
    'Sélectionner la zone à copier, puis collez-le ({{command}}).',
  [tokens.extraction.stepSourceDocumentExcelCopyHint]:
    'Sélectionnez une ou plusieurs cellules, puis copiez ({{command}}).',
  [tokens.extraction.stepAssistantWindowTitle]: 'Assistant Nabu',
  [tokens.extraction.stepAssistantHeading]: 'Que faut-il faire sur ce dossier ?',
  [tokens.extraction.stepAssistantDescription]:
    'Posez vos questions sur le dossier : blocages, totaux, champs manquants, provenance d’une valeur. Je peux aussi corriger des champs, ajouter un commentaire ou des tags, toujours après votre confirmation.',
  [tokens.extraction.stepAssistantSuggestedActionsLabel]: 'SUGGESTIONS',
  [tokens.extraction.stepAssistantPlaceholder]:
    "Bonjour, je suis votre assistant de déclaration. Posez-moi une question ou choisissez une suggestion pour avancer dans votre saisie.",
  [tokens.extraction.stepAssistantInputPlaceholder]:
    'Posez une question ou demandez une correction…',
  [tokens.extraction.stepAssistantSend]: 'Envoyer',
  [tokens.extraction.stepAssistantAddAttachment]: 'Ajouter une pièce jointe',
  [tokens.extraction.stepAssistantVoiceInput]: 'Saisie vocale',
  [tokens.extraction.stepAssistantVoiceStop]: 'Arrêter la dictée',
  [tokens.extraction.stepAssistantVoiceTranscribing]:
    'Transcription…',
  [tokens.extraction.stepAssistantVoiceMicrophoneDenied]:
    'Le micro n’est pas accessible. Autorisez-le dans votre navigateur.',
  [tokens.extraction.stepAssistantVoiceTooLong]:
    'Dictée trop longue : elle a été arrêtée et transcrite jusque-là.',
  [tokens.extraction.stepAssistantVoiceFailed]:
    'La dictée n’a pas pu être transcrite. Réessayez.',
  [tokens.extraction.stepAssistantRefresh]: 'Réinitialiser la conversation',
  [tokens.extraction.stepAssistantPin]: "Épingler l'assistant à la page",
  [tokens.extraction.stepAssistantUnpin]: "Détacher l'assistant",
  [tokens.extraction.stepAssistantClose]: "Fermer l'assistant",
  [tokens.extraction.stepAssistantResizeHandle]:
    "Redimensionner le panneau assistant",
  [tokens.extraction.stepAssistantSuggestedActionBlocked]:
    'Pourquoi la déclaration est-elle bloquée ?',
  [tokens.extraction.stepAssistantSuggestedActionTotals]:
    'Vérifie les totaux de la déclaration',
  [tokens.extraction.stepAssistantSuggestedActionMissing]:
    'Quels champs obligatoires manquent ?',
  [tokens.extraction.stepAssistantSuggestedActionHistory]:
    "Résume l'historique du dossier",
  [tokens.extraction.stepAssistantSkillsLabel]: 'INSTRUCTIONS',
  [tokens.extraction.stepAssistantNoSkillsPrefix]: 'Aucune instruction pour l’instant.',
  [tokens.extraction.stepAssistantCreateSkill]: 'Créer une instruction',
  [tokens.extraction.stepAssistantAddSkill]: 'Activer une instruction',
  [tokens.extraction.stepAssistantSendTooltip]: 'Envoyer · Entrée',
  [tokens.extraction.stepAssistantRemoveSkill]: 'Retirer {{name}}',
  [tokens.extraction.stepAssistantSkillsHint]: 'Les instructions actives guident l’Assistant Nabu dans vos prochains messages.',
  [tokens.extraction.stepAssistantApprove]: 'Confirmer',
  [tokens.extraction.stepAssistantDeny]: 'Refuser',
  [tokens.extraction.stepAssistantToolDone]: '{{action}} : effectué',
  [tokens.extraction.stepAssistantToolDenied]: '{{action}} : refusé',
  [tokens.extraction.stepAssistantToolFailed]: '{{action}} : échec',
  [tokens.extraction.stepAssistantToolPartial]:
    '{{action}} : appliqué en partie',
  [tokens.extraction.stepAssistantToolNotApplied]:
    '{{action}} : rien n’a été modifié',
  [tokens.extraction.stepAssistantToolInProgress]: '{{action}} : en cours',
  [tokens.extraction.stepAssistantToolAddComment]:
    'Ajouter un commentaire au dossier',
  [tokens.extraction.stepAssistantToolSetTags]: 'Remplacer les tags du dossier',
  [tokens.extraction.stepAssistantToolUpdateFields]:
    'Modifier des champs de la déclaration',
  [tokens.extraction.stepAssistantToolAddLines]:
    'Ajouter des articles à la déclaration',
  [tokens.extraction.stepAssistantToolGetDossier]: 'Consulter le dossier',
  [tokens.extraction.stepAssistantToolGetDossierDocuments]:
    'Consulter les documents du dossier',
  [tokens.extraction.stepAssistantToolGetDossierProgress]:
    'Consulter la progression du dossier',
  [tokens.extraction.stepAssistantToolGetDossierHistory]:
    'Consulter l’historique du dossier',
  [tokens.extraction.stepAssistantToolGetDossierErrorStatus]:
    'Consulter les erreurs du dossier',
  [tokens.extraction.stepAssistantToolGetDeclaration]:
    'Consulter la déclaration',
  [tokens.extraction.stepAssistantToolGetDeclarationValidation]:
    'Consulter la validation de la déclaration',
  [tokens.extraction.stepAssistantToolGetDeclarationContent]:
    'Consulter le contenu de la déclaration',
  [tokens.extraction.stepAssistantToolUnknown]: "Outil de l'assistant",
  [tokens.extraction.stepAssistantToolGetTags]: 'Consulter les tags',
  [tokens.extraction.stepAssistantToolGetDocumentFacts]:
    'Consulter les données d’un document',
  [tokens.extraction.stepAssistantToolGetPageText]:
    'Consulter le texte d’une page',
  [tokens.extraction.stepAssistantToolGetSpreadsheet]:
    'Consulter la feuille Excel',
  [tokens.extraction.stepAssistantToolCompareDocuments]:
    'Comparer les documents et la déclaration',
  [tokens.extraction.stepAssistantToolGetDeclarationGestures]:
    'Consulter l’historique de la déclaration',
  [tokens.extraction.stepAssistantToolGetExchangeRates]:
    'Consulter les taux de change',
  [tokens.extraction.stepAssistantToolLookupCatalog]:
    'Consulter les valeurs d’un catalogue',
  [tokens.extraction.stepAssistantToolGetDeclarationFields]:
    'Consulter les champs du formulaire',
  [tokens.extraction.stepAssistantToolExplainFieldValue]:
    'Chercher l’origine d’une valeur',
  [tokens.extraction.stepAssistantToolFindClientHistory]:
    'Consulter l’historique du client',
  [tokens.extraction.stepAssistantToolCalculate]: 'Calculer',
  [tokens.extraction.stepAssistantToolListInstructions]: 'Consulter les instructions',
  [tokens.extraction.stepAssistantToolUpdateInstructionText]: 'Modifier le texte d’une instruction',
  [tokens.extraction.stepAssistantToolSetInstructionAutomatic]: 'Changer le mode d’une instruction',
  [tokens.extraction.stepAssistantInstructionName]: 'Instruction « {{name}} »',
  [tokens.extraction.stepAssistantInstructionTextBefore]: 'Avant : {{text}}',
  [tokens.extraction.stepAssistantInstructionTextAfter]: 'Après : {{text}}',
  [tokens.extraction.stepAssistantInstructionBecomesAutomatic]: 'Passe en automatique : elle peut entrer dans une routine.',
  [tokens.extraction.stepAssistantInstructionBecomesOnDemand]: 'Passe à la demande : elle ne s’utilise que depuis l’Assistant.',
  [tokens.extraction.stepAssistantApprovalShowAll]: 'Tout afficher ({{count}})',
  [tokens.extraction.stepAssistantApprovalShowLess]: 'Réduire',
  [tokens.extraction.stepAssistantWaitingForReply]:
    'En attente de la réponse de l’assistant',
  [tokens.extraction.stepAssistantHistoryLoadError]:
    'Impossible de charger l’historique de la conversation.',
  [tokens.extraction.stepAssistantHistoryRetry]: 'Réessayer',
  [tokens.extraction.stepAssistantMessageTimeYesterday]: 'Hier, {{time}}',
  [tokens.extraction.stepAssistantMessageTimeOnDate]: '{{date}}, {{time}}',
  [tokens.extraction.stepAssistantReplyError]: 'L’assistant n’a pas pu répondre.',
  [tokens.extraction.stepAssistantQuotaReached]:
    'Votre quota a été atteint ce mois-ci. Veuillez contacter un administrateur.',
  [tokens.extraction.stepAssistantDisabled]:
    'L’assistant Nabu est désactivé pour votre organisation. Veuillez contacter un administrateur.',
  [tokens.extraction.stepAssistantThinking]: 'L’Assistant Nabu réfléchit…',
  [tokens.extraction.stepAssistantStepsOne]: '1 étape',
  [tokens.extraction.stepAssistantStepsOther]: '{{count}} étapes',
  [tokens.extraction.stepAssistantStepWrite]: 'Modification',
  [tokens.extraction.stepFieldNotIdentified]: 'Non identifié',
  [tokens.extraction.stepControlEnter]: 'Saisir',
  [tokens.extraction.stepControlEmptyValue]: 'À saisir',
  [tokens.extraction.stepControlPanelValidation]: 'Contrôle',
  [tokens.extraction.stepControlNoIssues]: 'Aucune anomalie détectée.',
  [tokens.extraction.stepControlSeverityCritical]: 'CRITIQUE',
  [tokens.extraction.stepControlSeverityGap]: 'ÉCART',
  [tokens.extraction.stepControlAddTransportFees]: '+ Frais de transport',
  [tokens.extraction.stepControlAdditionsDeductions]: '+ Ajouts & déductions',
  [tokens.extraction.stepControlTotalsPanelInfoTooltip]:
    "Le total relevé sur les documents fait référence. La somme des lignes d'articles doit s'y aligner.",
  [tokens.extraction.stepControlTotalsCardTotalOfDocument]: 'Total du document',
  [tokens.extraction.stepControlTotalsCardLineSum]: 'Somme des lignes articles :',
  [tokens.extraction.stepControlTotalsCardIdentical]: 'Identique',
  [tokens.extraction.stepControlTotalsCardToFill]: '{{count}} à saisir',
  [tokens.extraction.stepControlTotalsCardSourceCountInvoices_one]:
    'Σ {{count}} facture',
  [tokens.extraction.stepControlTotalsCardSourceCountInvoices_other]:
    'Σ {{count}} factures',
  [tokens.extraction.stepControlTotalsCardSourceCountPackingLists_one]:
    'Σ {{count}} liste de colisage',
  [tokens.extraction.stepControlTotalsCardSourceCountPackingLists_other]:
    'Σ {{count}} listes de colisage',
  [tokens.extraction.stepControlTotalsCardSumHint]:
    'La valeur ci-dessus additionne ces documents.',
  [tokens.extraction.stepControlTotalsCardDocTypeInvoice]: 'Facture',
  [tokens.extraction.stepControlTotalsCardDocTypePackingList]: 'Liste de colisage',
  [tokens.extraction.stepControlTotalsCardTooltipOk]:
    'Extrait du document source : {{value}} {{unit}}, identique à la somme des lignes articles.',
  [tokens.extraction.stepControlTotalsCardTooltipGap]:
    'Extrait du document source : {{value}} {{unit}}. La somme des lignes articles vaut {{lineValue}} {{unit}}.',
  [tokens.extraction.stepControlTotalsCardTooltipMissing]:
    'Aucune valeur extraite de ce document. Cliquez pour la saisir.',

  [tokens.extractionSteps['run-export']]: 'Export en cours',
  [tokens.extractionSteps['start-work']]: 'Début du travail',
  [tokens.extractionSteps['apply-specific-data']]:
    'Application des données spécifiques',
  [tokens.extractionSteps['publishing-page-messages']]:
    'Publication des messages de page',
  [tokens.extractionSteps['start-extraction']]: 'Début de l’extraction',
  [tokens.extractionSteps['apply-post-process']]: 'Application du post-process',
  [tokens.extractionSteps['batch-import-status-to-done']]:
    'Statut d’importation par lot à terminé',
  [tokens.extractionSteps['parsing-ocr']]: 'Analyse OCR',
  [tokens.extractionSteps['get-fast-track-option']]:
    'Obtention de l’option de fast track',
  [tokens.extractionSteps['handle-ocr']]: 'Gestion de l’OCR',
  [tokens.extractionSteps['collecting-configurations']]:
    'Collecte des configurations',
  [tokens.extractionSteps['starting-work']]: 'Début du travail',
  [tokens.extractionSteps['save-export-data']]:
    'Sauvegarde des données d’export',
  [tokens.extractionSteps['update-batch-import-status']]:
    'Mise à jour du statut d’importation par lot',
  [tokens.extractionSteps['canceled-iteration']]: 'Itération annulée',
  [tokens.extractionSteps['classification-done']]: 'Classification terminée',
  [tokens.extractionSteps['saving-pages']]: 'Sauvegarde des pages',
  [tokens.extractionSteps['end-validation-work']]:
    'Fin du travail de validation',
  [tokens.extractionSteps['end-mapping-work']]: 'Fin du travail de mapping',
  [tokens.extractionSteps['start-ocr-work']]: 'Début du travail OCR',
  [tokens.extractionSteps['create-files-in-database']]:
    'Création de fichiers dans la base de données',
  [tokens.extractionSteps['generate-export']]: 'Génération de l’export',
  [tokens.extractionSteps['start-mapping-work']]: 'Début du travail de mapping',
  [tokens.extractionSteps['segmentation-done']]: 'Segmentation',
  [tokens.extractionSteps['apply-segmentations']]:
    'Application des segmentations',
  [tokens.extractionSteps['fetching-file']]: 'Récupération du fichier',
  [tokens.extractionSteps['deskew']]: 'Ajustement de l’orientation du document',

  [tokens.flows.sender]: 'Expéditeur',
  [tokens.flows.receiver]: 'Destinataire',
  [tokens.flows.modelType]: 'Type de modèle',
  [tokens.flows.exportContext]: 'Contexte export',

  [tokens.segmentation.finishSegmentationStep]: 'Valider la segmentation',
  [tokens.segmentation.merge]: 'Fusionner',
  [tokens.segmentation.cut]: 'Couper',
  [tokens.segmentation.deletePage]: 'Supprimer la page',
  [tokens.segmentation.keep]: 'Garder',

  [tokens.settings.noDocumentsFound]: 'Aucun document trouvé',
  [tokens.settings.docTitleProfile]: 'Profil',
  [tokens.settings.docTitleNotifications]: 'Notifications',
  [tokens.settings.docTitleSecurity]: 'Sécurité',
  [tokens.settings.docTitleOrg]: 'Organisation',
  [tokens.settings.docTitleFormCustomization]: 'Formulaires',
  [tokens.settings.formCustomizationPageTitle]: 'Formulaires',
  [tokens.settings.formCustomizationPageSubtitle]:
    'Réduisez le formulaire Import à ce que vos déclarants utilisent, dans le vocabulaire de votre logiciel douane.',
  [tokens.settings.formCustomizationLoadError]:
    'Impossible de charger la personnalisation du formulaire.',
  [tokens.settings.formCustomizationMissingSchema]:
    'Aucun schéma Import n’est disponible pour cette organisation.',
  [tokens.settings.formCustomizationConexTitle]: 'Conex',
  [tokens.settings.formCustomizationConexSubtitle]: 'Transfer In v4.0',
  [tokens.settings.formCustomizationConexDescription]:
    'Libellés au vocabulaire Conex, sections ordonnées comme le fichier Transfer In, champs non transmis masqués.',
  [tokens.settings.formCustomizationAkaneaTitle]: 'Akanéa',
  [tokens.settings.formCustomizationAkaneaSubtitle]: 'Douane .NET',
  [tokens.settings.formCustomizationAkaneaDescription]:
    'Libellés au vocabulaire Akanéa, regroupement des parties en tête de formulaire, blocs douane repliés en fin de saisie.',
  [tokens.settings.formCustomizationLayoutName]: 'Disposition {{name}}',
  [tokens.settings.formCustomizationApplyLayout]: 'Appliquer ce modèle',
  [tokens.settings.formCustomizationAppliedBadge]: 'Appliqué',
  [tokens.settings.formCustomizationStartingModel]: 'Modèle de départ',
  [tokens.settings.formCustomizationStartingModelSubtitle]:
    'Alignez la saisie sur votre logiciel douane. Vous pourrez ensuite tout réorganiser à votre goût.',
  [tokens.settings.formCustomizationNabuModelTitle]: 'Modèle standard Nabu',
  [tokens.settings.formCustomizationNabuModelSubtitle]:
    'Tous les champs du schéma Import, dans l’ordre et le vocabulaire Nabu.',
  [tokens.settings.formCustomizationResetNabu]: 'Réinitialiser au standard',
  [tokens.settings.formCustomizationTabsContent]: 'Contenu des onglets',
  [tokens.settings.formCustomizationCollapseAll]: 'Tout replier',
  [tokens.settings.formCustomizationExpandAll]: 'Tout déplier',
  [tokens.settings.formCustomizationEdit]: 'Éditer',
  [tokens.settings.formCustomizationTabTitleLabel]: 'Titre de l’onglet',
  [tokens.settings.formCustomizationAddFieldAction]: 'Ajouter',
  [tokens.settings.formCustomizationApplyConfirm]:
    'Cette disposition remplace la personnalisation en cours (libellés, ordre, visibilités, champs obligatoires). Continuer ?',
  [tokens.settings.formCustomizationApplyModalTitle]:
    'Disposition {{name}} (les trois onglets)',
  [tokens.settings.formCustomizationApplyModalConfirm]: 'Appliquer la disposition',
  [tokens.settings.formCustomizationResetConfirm]:
    'Le formulaire d’origine Nabu sera restauré. Continuer ?',
  [tokens.settings.formCustomizationTabHeaders]: 'Entêtes',
  [tokens.settings.formCustomizationTabDelivery]: 'Livraison & Transport',
  [tokens.settings.formCustomizationTabRegulation]: 'Réglementation & Douane',
  [tokens.settings.formCustomizationVisibleSections]:
    '{{count}} section(s) visible(s)',
  [tokens.settings.formCustomizationRenameTab]: 'Renommer l’onglet',
  [tokens.settings.formCustomizationSearchPlaceholder]:
    'Rechercher un champ...',
  [tokens.settings.formCustomizationFilterVisibility]: 'Visibilité',
  [tokens.settings.formCustomizationFilterRequired]: 'Obligatoire',
  [tokens.settings.formCustomizationFilterAll]: 'Tous',
  [tokens.settings.formCustomizationFilterVisible]: 'Visibles',
  [tokens.settings.formCustomizationFilterHidden]: 'Masqués',
  [tokens.settings.formCustomizationFilterRequiredOnly]: 'Requis',
  [tokens.settings.formCustomizationFilterOptional]: 'Optionnels',
  [tokens.settings.formCustomizationShowRequiredBadge]: 'Mention REQUIS',
  [tokens.settings.formCustomizationPreview]: 'Aperçu',
  [tokens.settings.formCustomizationFieldsCount]: '{{visible}}/{{total}} champs',
  [tokens.settings.formCustomizationMoveSection]: 'Déplacer vers',
  [tokens.settings.formCustomizationSection]: 'Section',
  [tokens.settings.formCustomizationMoveField]: 'Déplacer vers',
  [tokens.settings.formCustomizationAddField]:
    '+ Ajouter un champ du modèle de données...',
  [tokens.settings.formCustomizationRequired]: 'Obligatoire',
  [tokens.settings.formCustomizationDefaultValue]: 'Valeur par défaut',
  [tokens.settings.formCustomizationBehavior]: 'Comportement',
  [tokens.settings.formCustomizationBehaviorPrefilled]:
    'Préremplie, modifiable',
  [tokens.settings.formCustomizationBehaviorLocked]: 'Verrouillée',
  [tokens.settings.formCustomizationBehaviorSuggested]: 'Suggérée',
  [tokens.settings.formCustomizationDuplicate]: 'Dupliquer',
  [tokens.settings.formCustomizationRemove]: 'Retirer',
  [tokens.settings.formCustomizationHide]: 'Masquer',
  [tokens.settings.formCustomizationShow]: 'Afficher',
  [tokens.settings.formCustomizationRequiredBadge]: 'REQUIS',
  [tokens.settings.formCustomizationPreviewSelectPlaceholder]: 'Sélectionner…',
  [tokens.settings.formCustomizationLockedBadge]: 'Verrouillé',
  [tokens.settings.formCustomizationSuggestedHint]: 'Suggestion : {{value}}',
  [tokens.settings.settingsUnsavedChanges]: 'Modifications non enregistrées',
  [tokens.settings.settingsLeaveUnsavedTitle]: 'Quitter sans enregistrer ?',
  [tokens.settings.settingsLeaveUnsavedMessage]:
    "Vos modifications n'ont pas été enregistrées. Si vous quittez cette page, elles seront perdues.",
  [tokens.settings.settingsLeaveUnsavedConfirm]: 'Quitter sans enregistrer',
  [tokens.settings.formCustomizationSaved]: 'Personnalisation enregistrée',
  [tokens.settings.formCustomizationSaveError]:
    'Impossible d’enregistrer la personnalisation.',
  [tokens.settings.formCustomizationAnomalyHiddenRequired]:
    '{{count}} champ(s) obligatoire(s) masqué(s) : la saisie sera bloquée sans valeur',
  [tokens.settings.formCustomizationAnomalyEmptySection]:
    'Section visible mais aucun champ affiché',
  [tokens.settings.formCustomizationAnomalyLockedNoDefault]:
    'Champ verrouillé sans valeur par défaut',
  [tokens.settings.formCustomizationNoSections]:
    'Aucune section ne correspond aux filtres.',
  [tokens.settings.docTitleAgencies]: 'Agences',
  [tokens.settings.docTitleAgencyDetail]: 'Agence',
  [tokens.settings.docTitleMembers]: 'Utilisateurs',
  [tokens.settings.docTitleMemberDetail]: 'Utilisateur',
  [tokens.settings.docTitleRoles]: 'Rôles et permissions',
  [tokens.settings.docTitleEmailTemplates]: "Modèles d'e-mail",
  [tokens.settings.docTitleHelp]: "Centre d'aide",
  [tokens.settings.docTitleAiAgents]: 'Assistant Nabu',
  [tokens.settings.docTitleSubscription]: 'Abonnement',
  [tokens.settings.docTitleBilling]: 'Facturation',
  [tokens.settings.sidebarKicker]: 'Paramètres',
  [tokens.settings.back]: 'Retour',
  [tokens.settings.groupYourAccount]: 'Votre compte',
  [tokens.settings.groupOrganization]: 'Organisation',
  [tokens.settings.groupModules]: 'Modules',
  [tokens.settings.groupSupport]: 'Support',
  [tokens.settings.navProfile]: 'Profil',
  [tokens.settings.navNotifications]: 'Notifications',
  [tokens.settings.navSecurity]: 'Sécurité',
  [tokens.settings.navOrganization]: 'Organisation',
  [tokens.settings.navAgencies]: 'Agences',
  [tokens.settings.navMembers]: 'Utilisateurs',
  [tokens.settings.navFormCustomization]: 'Formulaires',
  [tokens.settings.navRoles]: 'Rôles et permissions',
  [tokens.settings.navEmailTemplates]: "Modèles d'e-mail",
  [tokens.settings.navAiAgents]: 'Assistant Nabu',
  [tokens.settings.navSubscription]: 'Abonnement',
  [tokens.settings.navBilling]: 'Facturation',
  [tokens.settings.navHelpCenter]: "Centre d'aide",
  [tokens.settings.helpBoxTitle]: "Besoin d'aide ?",
  [tokens.settings.helpBoxBody]:
    'Consultez la documentation Nabu ou contactez le support.',
  [tokens.settings.helpDocumentationLink]: 'Documentation',
  [tokens.settings.aiAgentsPageTitle]: 'Assistant Nabu',
  [tokens.settings.aiAgentsPageSubtitle]:
    'Les instructions que l’Assistant Nabu applique pour votre organisation.',
  [tokens.settings.aiAgentsLoadError]:
    'Impossible de charger les paramètres IA pour le moment.',
  [tokens.settings.aiAgentsSkillsSectionTitle]: 'Instructions',
  [tokens.settings.aiAgentsSkillsSectionDescription]:
    'Définissez des méthodes de travail. L’Assistant Nabu les consulte pour guider ses réponses et ses actions.',
  [tokens.settings.aiAgentsNewSkillButton]: 'Nouvelle instruction',
  [tokens.settings.aiAgentsCreateFirstSkillButton]: 'Créer ma première instruction',
  [tokens.settings.aiAgentsSkillsEmptyTitle]: 'Aucune instruction définie',
  [tokens.settings.aiAgentsSkillsEmptyDescription]:
    'Ajoutez vos premières méthodes de travail pour que l’Assistant Nabu les utilise dans ses réponses.',
  [tokens.settings.aiAgentsCreateSkillTitle]: 'Nouvelle instruction',
  [tokens.settings.aiAgentsCreateSkillSubtitle]: 'L’Assistant Nabu applique cette méthode quand vous l’activez dans une conversation.',
  [tokens.settings.aiAgentsEditSkillTitle]: 'Modifier l’instruction',
  [tokens.settings.aiAgentsSkillNameLabel]: 'Nom de l’instruction',
  [tokens.settings.aiAgentsSkillNameRequired]: 'Le nom de l’instruction est obligatoire',
  [tokens.settings.aiAgentsSkillDescriptionLabel]: 'Description',
  [tokens.settings.aiAgentsSkillDescriptionPlaceholder]: 'À quoi sert cette instruction ?',
  [tokens.settings.aiAgentsSkillIconLabel]: 'Icône',
  [tokens.settings.aiAgentsSkillWorkMethodLabel]: 'Méthode de travail',
  [tokens.settings.aiAgentsSkillWorkMethodPlaceholder]:
    'Décris étape par étape comment l’Assistant Nabu doit procéder…',
  [tokens.settings.aiAgentsSkillWorkMethodTooltip]:
    'Décrivez la marche à suivre étape par étape : plus c’est précis, plus l’Assistant Nabu est fiable. Ex. : contrôler la NDP, vérifier la cohérence des poids et de la valeur statistique.',
  [tokens.settings.aiAgentsCreateSkillSubmit]: 'Créer l’instruction',
  [tokens.settings.aiAgentsDeleteSkillTitle]: 'Supprimer l’instruction',
  [tokens.settings.aiAgentsDeleteSkillDescription]:
    'Voulez-vous vraiment supprimer l’instruction « {{name}} » ?',
  [tokens.settings.aiAgentsSkillNabuBadge]: 'Nabu',
  [tokens.settings.aiAgentsSkillNabuTooltip]:
    'Proposée par Nabu : utilisable dans le chat, non modifiable.',
  [tokens.settings.aiAgentsSkillDecTypesLabel]: 'Types de déclaration',
  [tokens.settings.aiAgentsSkillDecTypesHelper]:
    'Aucun coché : l’instruction vaut pour tous les types.',
  [tokens.settings.aiAgentsSkillDecTypesAll]: 'Tous les types',
  [tokens.settings.aiAgentsSkillAutomaticLabel]: 'Automatique',
  [tokens.settings.aiAgentsSkillAutomaticHelper]:
    'Une instruction automatique peut entrer dans une routine. Sinon, elle ne s’utilise que depuis l’Assistant.',
  [tokens.settings.aiAgentsSkillAutomaticBadge]: 'Auto',
  [tokens.settings.aiAgentsRoutinesSectionTitle]: 'Routines',
  [tokens.settings.aiAgentsRoutinesSectionDescription]: 'Une routine applique des instructions automatiques, dans l’ordre, aux déclarations d’un client et d’un type, juste après la préparation intelligente.',
  [tokens.settings.aiAgentsNewRoutineButton]: 'Nouvelle routine',
  [tokens.settings.aiAgentsRoutinesEmptyTitle]: 'Aucune routine',
  [tokens.settings.aiAgentsRoutinesEmptyDescription]: 'Créez une routine pour appliquer vos instructions automatiques à chaque déclaration d’un client.',
  [tokens.settings.aiAgentsRoutinesLoadError]: 'Impossible de charger les routines pour le moment.',
  [tokens.settings.aiAgentsCreateRoutineTitle]: 'Nouvelle routine',
  [tokens.settings.aiAgentsEditRoutineTitle]: 'Modifier la routine',
  [tokens.settings.aiAgentsRoutineSubtitle]: 'Ses instructions s’appliquent dans l’ordre, après la préparation intelligente, avant que la déclaration s’affiche.',
  [tokens.settings.aiAgentsRoutineNameLabel]: 'Nom de la routine',
  [tokens.settings.aiAgentsRoutineClientLabel]: 'Client',
  [tokens.settings.aiAgentsRoutineClientHelper]: 'Vide : la routine vaut pour tous les clients.',
  [tokens.settings.aiAgentsRoutineAllClients]: 'Tous les clients',
  [tokens.settings.aiAgentsRoutineDecTypeLabel]: 'Type de déclaration',
  [tokens.settings.aiAgentsRoutineInstructionsLabel]: 'Instructions',
  [tokens.settings.aiAgentsRoutineInstructionsHelper]: 'Seules les instructions automatiques entrent dans une routine. Glissez-les pour changer leur ordre.',
  [tokens.settings.aiAgentsRoutineAddInstruction]: 'Ajouter une instruction',
  [tokens.settings.aiAgentsRoutineNoInstructionLeft]: 'Aucune autre instruction automatique ne vaut pour ce type.',
  [tokens.settings.aiAgentsRoutineInstructionOtherType]: 'Ne s’applique pas à ce type de déclaration : retirez-la.',
  [tokens.settings.aiAgentsRoutineInstructionUnavailable]: 'N’est plus disponible : retirez-la.',
  [tokens.settings.aiAgentsRoutineDragInstruction]: 'Déplacer « {{name}} »',
  [tokens.settings.aiAgentsRoutineRemoveInstruction]: 'Retirer de la routine',
  [tokens.settings.aiAgentsRoutineInstructionsCount]: '{{count}} instruction',
  [tokens.settings.aiAgentsRoutineInstructionsCount_other]: '{{count}} instructions',
  [tokens.settings.aiAgentsRoutineActive]: 'Active',
  [tokens.settings.aiAgentsRoutineInactive]: 'Inactive',
  [tokens.settings.aiAgentsCreateRoutineSubmit]: 'Créer la routine',
  [tokens.settings.aiAgentsDeleteRoutineTitle]: 'Supprimer la routine',
  [tokens.settings.aiAgentsDeleteRoutineDescription]: 'Voulez-vous vraiment supprimer la routine « {{name}} » ? Ses instructions restent.',
  [tokens.settings.aiAgentsToastRoutineCreated]: 'Routine créée',
  [tokens.settings.aiAgentsToastRoutineUpdated]: 'Routine mise à jour',
  [tokens.settings.aiAgentsToastRoutineDeleted]: 'Routine supprimée',
  [tokens.settings.aiAgentsRoutineConditionsTaken]: 'La routine « {{names}} » s’applique déjà à ce client et à ce type : désactivez-la, ou changez de client ou de type.',
  [tokens.settings.aiAgentsToastSkillInRoutine]: 'Retirez d’abord cette instruction de ses routines : {{names}}.',
  [tokens.settings.aiAgentsBlockedByNabu]: 'Bloquée par Nabu',
  [tokens.settings.aiAgentsBlockedByNabuTooltip]: 'Nabu l’a bloquée : elle ne s’applique plus. Contactez le support pour la débloquer.',
  [tokens.settings.aiAgentsToastBlockedByNabu]: 'Bloquée par Nabu : contactez le support pour la modifier.',
  [tokens.settings.aiAgentsSkillScopeLabel]: 'Portée',
  [tokens.settings.aiAgentsSkillScopeHelper]:
    "Une instruction d'agence vaut pour elle, et pour ses sous-agences si vous les incluez ; les autres agences ne la voient pas.",
  [tokens.settings.aiAgentsSkillAgencySubAgencies]: 'et ses sous-agences',
  [tokens.settings.aiAgentsSkillIconBook]: 'Livre',
  [tokens.settings.aiAgentsSkillIconLightning]: 'Éclair',
  [tokens.settings.aiAgentsSkillIconGrid]: 'Grille',
  [tokens.settings.aiAgentsSkillIconDocument]: 'Document',
  [tokens.settings.aiAgentsSkillIconSearch]: 'Recherche',
  [tokens.settings.aiAgentsSkillIconLayers]: 'Couches',
  [tokens.settings.aiAgentsSkillIconShield]: 'Bouclier',
  [tokens.settings.aiAgentsSkillIconShuffle]: 'Mélange',
  [tokens.settings.aiAgentsToastSkillCreated]: 'Instruction créée',
  [tokens.settings.aiAgentsToastSkillUpdated]: 'Instruction mise à jour',
  [tokens.settings.aiAgentsToastSkillDeleted]: 'Instruction supprimée',
  [tokens.settings.aiAgentsToastSaveError]: 'Enregistrement impossible',
  [tokens.settings.previewNoticeLocalOnly]:
    'Ces interrupteurs ne sont enregistrés que dans cette session. La persistance côté serveur arrivera dans une prochaine version.',
  [tokens.settings.previewNoticeInviteSoon]:
    "L'invitation d'utilisateurs depuis cet écran n'est pas encore disponible.",
  [tokens.settings.previewNoticeAgencyCreateSoon]:
    "La création d'agence depuis cet écran n'est pas encore disponible.",
  [tokens.settings.previewNoticeRolesReadOnly]:
    "La matrice des permissions est informative : l'édition arrivera avec l'API dédiée.",
  [tokens.settings.previewNoticeEmailTemplatesSoon]:
    "L'édition des modèles d'e-mail n'est pas encore disponible.",
  [tokens.settings.previewNoticeHelpLinksSoon]:
    "Les liens d'aide et de contact seront branchés prochainement.",
  [tokens.settings.previewNoticeOrgConfigDemo]:
    "Cet onglet illustre la structure des champs : l'enregistrement ne modifie pas encore les paramètres d'organisation côté serveur.",
  [tokens.settings.orgConfigDemoSaved]:
    'Enregistré localement (maquette, non synchronisé avec le serveur).',
  [tokens.settings.profilePageTitle]: 'Mon compte',
  [tokens.settings.profilePageSubtitle]:
    'Gérez vos informations personnelles, préférences et configuration de déclaration.',
  [tokens.settings.profileSectionPersonal]: 'Informations personnelles',
  [tokens.settings.profileSectionPersonalSubtitle]:
    'Ces informations sont visibles par les autres utilisateurs de votre organisation.',
  [tokens.settings.profileSectionPrefs]: 'Langue & thème',
  [tokens.settings.profileSectionPrefsSubtitle]:
    "Langue et apparence de l'interface.",
  [tokens.settings.profileSectionDeclaration]: 'Configuration de déclaration',
  [tokens.settings.profileTabGeneral]: 'Général',
  [tokens.settings.profileTabPreferences]: 'Préférences',
  [tokens.settings.profileTabConfiguration]: 'Configuration',
  [tokens.settings.profilePreferencesInterface]: 'Interface',
  [tokens.settings.profilePreferencesPreparation]: 'Préparation des dossiers',
  [tokens.settings.profilePreferencesPreparationClassic]: 'Préparation classique',
  [tokens.settings.profilePreferencesPreparationIntelligent]: 'Préparation intelligente',
  [tokens.settings.profilePreferencesBetaViews]:
    "Disposition de l'interface beta - Préparation intelligente",
  [tokens.settings.profilePreferencesBetaViewsSubtitle]:
    "Ces réglages de disposition s'appliquent uniquement à l'interface beta, à l'ouverture de chaque dossier en Préparation intelligente.",
  [tokens.settings.profilePreferencesSmartView]: 'Vue préférentielle - Préparation intelligente',
  [tokens.settings.profilePreferencesSmartViewSubtitle]:
    "Version de l'interface et disposition appliquée à l'ouverture de chaque dossier en Préparation intelligente.",
  [tokens.settings.profilePreferencesSourceDocument]: 'Document source',
  [tokens.settings.profilePreferencesSourceDocumentDesc]:
    'Fenêtre de lecture des pièces du dossier.',
  [tokens.settings.profilePreferencesControlPanel]: 'Vérifications',
  [tokens.settings.profilePreferencesControlPanelDesc]:
    'Écarts, anomalies et informations avant envoi.',
  [tokens.settings.profilePreferencesAssistant]: 'Assistant Nabu',
  [tokens.settings.profilePreferencesAssistantDesc]:
    "Conversation avec l’Assistant Nabu dans l’éditeur.",
  [tokens.settings.profilePreferencesHomeTab]: "Onglet d'accueil",
  [tokens.settings.profilePreferencesHomeTabDesc]:
    "Onglet affiché à l'ouverture d'un dossier.",
  [tokens.settings.profilePreferencesLoadState]: 'État au chargement',
  [tokens.settings.profilePreferencesPlacementHidden]: 'Fermé (par défaut)',
  [tokens.settings.profilePreferencesPlacementFloating]: 'Fenêtre flottante',
  [tokens.settings.profilePreferencesPlacementLeft]: 'Épinglé à gauche',
  [tokens.settings.profilePreferencesPlacementRight]: 'Épinglé à droite',
  [tokens.settings.profileSectionWorkMode]: 'Mode de travail',
  [tokens.settings.profileSectionWorkModeSubtitle]: 'Méthode de préparation des dossiers.',
  [tokens.settings.profilePreferencesPreparationClassicDesc]:
    'Saisie et contrôle manuels des champs de la déclaration.',
  [tokens.settings.profilePreferencesPreparationIntelligentDesc]:
    'Nabu AI pré-remplit la déclaration à partir des documents joints.',
  [tokens.settings.profilePreferencesInterfaceStandard]: 'Interface standard',
  [tokens.settings.profilePreferencesInterfaceBeta]: 'Interface',
  [tokens.settings.profilePreferencesInterfaceStandardDesc]: 'Interface actuelle.',
  [tokens.settings.profilePreferencesInterfaceBetaDesc]:
    'Accès anticipé aux nouvelles fonctionnalités. Choisissez la disposition ci-dessous.',
  [tokens.settings.profilePreferencesBetaBadge]: 'BETA',
  [tokens.settings.profilePreferencesPlacementClosed]: 'Fermé',
  [tokens.settings.profilePreferencesDefaultTab]: 'Onglet par défaut',
  [tokens.settings.profilePreferencesSaved]: 'Préférences enregistrées',
  [tokens.settings.profileUserConfigCardTitle]: 'Ma configuration',
  [tokens.settings.profileUserConfigCardSubtitle]:
    "Valeurs héritées de la configuration de l'organisation. Désactivez le toggle ci-dessus pour les surcharger.",
  [tokens.settings.profileUserConfigInheritanceTitle]:
    "Conserver la configuration de l'organisation",
  [tokens.settings.profileUserConfigInheritanceDescription]:
    'Vos déclarations utilisent les valeurs définies au niveau de votre organisation. Désactivez pour pouvoir surcharger des champs spécifiquement pour votre compte.',
  [tokens.settings.profileConfigurationSectionSubtitle]:
    'Réglages par défaut appliqués à vos déclarations.',
  [tokens.settings.profileConfigurationTabPlaceholder]:
    'Les options détaillées de configuration de déclaration seront disponibles prochainement.',
  [tokens.settings.profileEmailLabel]: 'Adresse e-mail',
  [tokens.settings.themeLabel]: 'Thème',
  [tokens.settings.themeLight]: 'Clair',
  [tokens.settings.themeLightDesc]: 'Fond blanc, interface lumineuse',
  [tokens.settings.themeDark]: 'Sombre',
  [tokens.settings.themeDarkDesc]: 'Fond foncé, moins fatiguant le soir',
  [tokens.settings.themeSystem]: 'Système',
  [tokens.settings.themeSystemDesc]:
    'Suit automatiquement les préférences de votre appareil',
  [tokens.settings.toastProfileUpdated]: 'Profil mis à jour',
  [tokens.settings.toastProfileError]: 'Une erreur est survenue',
  [tokens.settings.validationRequired]: 'Requis',
  [tokens.settings.notificationsPageTitle]: 'Notifications',
  [tokens.settings.notificationsPageSubtitle]:
    'Choisissez quand et comment Nabu vous contacte.',
  [tokens.settings.notificationsSectionEmail]: 'E-mail',
  [tokens.settings.notificationsMasterTitle]: 'Toutes les notifications e-mail',
  [tokens.settings.notificationsMasterDesc]:
    "Activez ou désactivez d'un coup toutes les alertes listées ci-dessous.",
  [tokens.settings.notifAck]: 'Accusé de réception',
  [tokens.settings.notifAckDesc]: "Dès qu'une déclaration est prise en charge.",
  [tokens.settings.notifFinalized]: 'Finalisation',
  [tokens.settings.notifFinalizedDesc]: "Lorsqu'une déclaration est clôturée.",
  [tokens.settings.notifDeclErr]: 'Erreur de déclaration',
  [tokens.settings.notifDeclErrDesc]: 'Rejet ou anomalie administrative.',
  [tokens.settings.notifPipelineErr]: 'Erreur pipeline',
  [tokens.settings.notifPipelineErrDesc]: "Échec d'ingestion ou de traitement.",
  [tokens.settings.notifMasterStateAllOn]:
    'Toutes les notifications ci-dessous sont activées.',
  [tokens.settings.notifMasterStatePartial]:
    'Certaines notifications sont désactivées. Activez tout en un clic.',
  [tokens.settings.notifMasterStateAllOff]:
    'Toutes les notifications sont désactivées.',
  [tokens.settings.notifPipelineRowTitle]:
    "Alerte d'erreur (pipeline_file_error, manual_file_error)",
  [tokens.settings.notifPipelineRowDesc]:
    "Notification en cas d'échec d'ingestion automatique ou de traitement manuel d'un fichier.",
  [tokens.settings.securityPageTitle]: 'Sécurité',
  [tokens.settings.securityPageSubtitle]:
    'Protégez votre compte et contrôlez les accès.',
  [tokens.settings.securitySectionPasswordSubtitle]:
    'Changez votre mot de passe. Utilisez entre 8 et 16 caractères avec majuscules, minuscules, chiffres et caractères spéciaux.',
  [tokens.settings.securityPasswordAside]:
    'Pour votre sécurité, choisissez un mot de passe long, unique et qui combine lettres, chiffres et caractères spéciaux. Nabu ne stocke jamais votre mot de passe en clair.',
  [tokens.settings.securityUpdatePasswordButton]:
    'Mettre à jour le mot de passe',
  [tokens.settings.orgPageTitle]: 'Organisation',
  [tokens.settings.orgPageSubtitle]:
    'Paramètres généraux, configuration et automatisations de votre organisation.',
  [tokens.settings.orgTabGeneral]: 'Général',
  [tokens.settings.orgTabConfiguration]: 'Configuration',
  [tokens.settings.orgTabPreferences]: 'Préférences',
  [tokens.settings.orgGeneralTitle]: 'Informations générales',
  [tokens.settings.orgGeneralSubtitle]:
    'Informations de votre organisation sur la plateforme Nabu.',
  [tokens.settings.orgFieldOrgName]: "Nom de l'organisation",
  [tokens.settings.orgFieldIdentifier]: 'Identifiant',
  [tokens.settings.orgLoading]: 'Chargement…',
  [tokens.settings.orgSaveDisabledHint]:
    "La modification du nom d'organisation passe par le support Nabu.",
  [tokens.settings.orgConfigChooseAgency]: 'Choisir une agence',
  [tokens.settings.orgConfigChooseConfig]: 'Choisir une configuration',
  [tokens.settings.orgConfigPlaceholder]:
    'Veuillez choisir une agence et une configuration',
  [tokens.settings.orgConfigSectionTitle]: "Configuration de l'organisation",
  [tokens.settings.orgConfigSectionSubtitle]:
    'Renseignez-y les valeurs envoyées par défaut pour cette configuration. Modifiables au cas par cas dans chaque déclaration.',
  [tokens.settings.orgPreferencesCardTitle]: 'Préférences',
  [tokens.settings.orgPreferencesCardSubtitle]:
    "Règles appliquées à l'ensemble de l'organisation.",
  [tokens.settings.orgPreferencesLimitAgencyLabel]:
    'Limiter un utilisateur aux dossiers clients de son agence',
  [tokens.settings.orgPreferencesLimitAgencyDescription]:
    "Lorsque cette option est activée, un utilisateur ne peut accéder qu'aux dossiers des clients rattachés à son agence. Sans cette restriction, il accède à tous les dossiers de l'organisation selon son rôle.",
  [tokens.settings.agenciesPageTitle]: 'Agences',
  [tokens.settings.agenciesPageSubtitle]:
    'Les entités rattachées à votre organisation. Chaque agence regroupe ses utilisateurs, configurations et automatisations.',
  [tokens.settings.agenciesChipAllLabel]: 'Toutes les agences',
  [tokens.settings.orgPreferencesSoon]: 'Préférences — bientôt disponible',
  [tokens.settings.agenciesPageTitle]: 'Agences',
  [tokens.settings.agenciesPageSubtitle]:
    'Les entités rattachées à votre organisation. Chaque agence regroupe ses utilisateurs, configurations et automatisations.',
  [tokens.settings.agenciesNewButton]: 'Nouvelle agence',
  [tokens.settings.agenciesSearchPlaceholder]: 'Rechercher une agence…',
  [tokens.settings.agenciesLoading]: 'Chargement…',
  [tokens.settings.agenciesEmpty]: 'Aucune agence trouvée.',
  [tokens.settings.agenciesEmptySearch]:
    'Aucune agence ne correspond à votre recherche.',
  [tokens.settings.agenciesEmptyOrgOnlyHint]:
    'Votre organisation n’a pas encore d’agence enfant. Les configurations de déclaration et les adresses e-mail d’ingestion se gèrent au niveau organisation.',
  [tokens.settings.agenciesEmptyOrgConfigurationLink]:
    'Ouvrir la configuration organisation',
  [tokens.settings.agenciesEmptyOrgEmailLink]:
    'Ouvrir les e-mails d’ingestion',
  [tokens.settings.agenciesMembersLabel]: 'Membres',
  [tokens.settings.agenciesColType]: 'Type',
  [tokens.settings.agenciesColAgency]: 'Agence',
  [tokens.settings.agenciesColMembers]: 'Membres',
  [tokens.settings.agenciesColAdministrator]: 'Administrateur',
  [tokens.settings.agenciesAdministratorLabel]: 'Administrateur',
  [tokens.settings.agenciesAdministratorUnassigned]: 'Non assigné',
  [tokens.settings.agenciesInfoPopoverTitle]:
    'Pourquoi structurer en agences ?',
  [tokens.settings.agenciesInfoPopoverBody]:
    "Une agence isole les configurations douanières, les utilisateurs et les dossiers d'un site ou d'une entité juridique. Utile si vous avez plusieurs bureaux ou plusieurs marques sous un même compte Nabu.",
  [tokens.settings.agenciesInfoHelpLink]:
    "En savoir plus dans le Centre d'aide",
  [tokens.settings.agenciesViewGrid]: 'Affichage en grille',
  [tokens.settings.agenciesViewList]: 'Affichage en liste',
  [tokens.settings.agenciesAttachedTo]: 'Rattaché à {{name}}',
  [tokens.settings.agenciesAttachedToUnknown]: 'Rattaché à une agence parente',
  [tokens.settings.agenciesChildBadge]: 'Sous agence',
  [tokens.settings.agenciesChildTooltip]: 'Agence mère : {{name}}',
  [tokens.settings.agenciesTypeService]: 'Service',
  [tokens.settings.agenciesTypeTeam]: 'Équipe',
  [tokens.settings.agenciesTypeOffice]: 'Bureau',
  [tokens.settings.agenciesTypeOrganization]: 'Organisation',
  [tokens.settings.agenciesTypeUndefined]: 'Non défini',
  [tokens.settings.agencyDetailBackToList]: 'Retour aux agences',
  [tokens.settings.agencyDetailSubtitleLead]: 'Agence de',
  [tokens.settings.agencyDetailTabGeneral]: 'Général',
  [tokens.settings.agencyDetailTabMembers]: 'Utilisateurs',
  [tokens.settings.agencyDetailTabClients]: 'Clients',
  [tokens.settings.agencyDetailTabConfiguration]: 'Configuration',
  [tokens.settings.agencyDetailTabEmail]: 'Boîtes de réception',
  [tokens.settings.agencyDetailTabTableAutomations]: 'Automatisations tableaux',
  [tokens.settings.agencyDetailTabApi]: 'Gestion API',
  [tokens.settings.agencyDetailTabMetrics]: 'Métriques',
  [tokens.settings.agencyDetailGeneralIntro]:
    "Informations de base de l'agence. Elles apparaissent dans les déclarations et les échanges administratifs.",
  [tokens.settings.agencyDetailLegalNameLabel]: 'Raison sociale',
  [tokens.settings.agencyDetailLegalNameRequired]:
    'La raison sociale est obligatoire',
  [tokens.settings.agencyDetailSaveSuccess]: 'Agence mise à jour',
  [tokens.settings.agencyDetailSettingsKeysInfo]:
    'Les paramètres d’intégration choisis ici s’appliquent à cette agence.',
  [tokens.settings.agencyDetailConfigSectionTitle]: 'Configuration',
  [tokens.settings.agencyDetailConfigSectionSubtitle]:
    'Paramètres de configuration liés aux déclarations pour cette agence.',
  [tokens.settings.agencyDetailMembersCountLine]:
    '{{count}} utilisateurs rattachés à cette agence.',
  [tokens.settings.agencyDetailRoleOwnerBadge]: 'Propriétaire',
  [tokens.settings.membersPageTitle]: 'Utilisateurs',
  [tokens.settings.membersPageSubtitle]:
    'Tous les utilisateurs de l’organisation, leurs rôles et leurs rattachements.',
  [tokens.settings.membersPageTitle]: 'Utilisateurs',
  [tokens.settings.membersPageSubtitle]:
    'Gérez les membres de votre organisation.',
  [tokens.settings.membersInvite]: 'Inviter',
  [tokens.settings.membersSearchPlaceholder]: 'Rechercher un utilisateur…',
  [tokens.settings.membersLoading]: 'Chargement…',
  [tokens.settings.membersEmpty]: 'Aucun utilisateur trouvé',
  [tokens.settings.membersColUser]: 'Utilisateur',
  [tokens.settings.membersColEmail]: 'E-mail',
  [tokens.settings.membersColRole]: 'Rôle',
  [tokens.settings.membersYouBadge]: 'Vous',
  [tokens.settings.membersInfoPopoverTitle]: 'À propos des utilisateurs',
  [tokens.settings.membersInfoPopoverBody]:
    'Gérer les utilisateurs de votre organisation. Invitez de nouveaux collaborateurs, attribuez-leur un rôle et rattachez-les à une ou plusieurs agences. Les utilisateurs voient uniquement les dossiers de leurs agences.',
  [tokens.settings.membersSeatSummary]:
    '{{used}} / {{max}} sièges utilisés · {{plan}}',
  [tokens.settings.membersSeatLimitHint]:
    'Limite atteinte : désactivez un utilisateur ou augmentez votre plan pour en ajouter.',
  [tokens.settings.membersSeatPlanScale]: 'Plan Scale',
  [tokens.settings.membersRequestSeats]: 'Demander plus de sièges',
  [tokens.settings.membersBillingMailSubject]:
    "Demande d'ajout de sièges — Nabu",
  [tokens.settings.membersBillingMailBody]:
    'Bonjour,\n\nNous souhaitons ajouter des sièges supplémentaires à notre plan Nabu (actuellement : {{used}}/{{max}}).\n\nMerci.',
  [tokens.settings.membersFilterAllRoles]: 'Tous les rôles',
  [tokens.settings.membersFilterAllStatuses]: 'Tous les statuts',
  [tokens.settings.membersFilterStatusActive]: 'Actif',
  [tokens.settings.membersFilterStatusInactive]: 'Inactifs',
  [tokens.settings.membersColAgencies]: 'Agences',
  [tokens.settings.membersColAffiliation]: 'Appartenance',
  [tokens.settings.membersAffiliationOrganization]: 'Organisation',
  [tokens.settings.membersColStatus]: 'Statut',
  [tokens.settings.membersColEnabled]: 'Activé',
  [tokens.settings.membersStatusActive]: 'Actif',
  [tokens.settings.membersStatusInactive]: 'Inactif',
  [tokens.settings.membersAddUser]: 'Ajouter un utilisateur',
  [tokens.settings.membersViewList]: 'Vue liste',
  [tokens.settings.membersViewGrid]: 'Vue grille',
  [tokens.settings.membersAgencyNone]: '—',
  [tokens.settings.organizationMembersGroup]: 'Organisation · {{name}}',
  [tokens.settings.membersMenuViewProfile]: 'Voir le profil',
  [tokens.settings.membersMenuEdit]: 'Modifier',
  [tokens.settings.membersMenuDeactivate]: 'Désactiver',
  [tokens.settings.membersMenuReactivate]: 'Réactiver',
  [tokens.settings.membersDeactivateTitle]: 'Désactiver {{name}}',
  [tokens.settings.membersDeactivateBody]:
    "{{name}} ne pourra plus se connecter. Ses accès restent en place : ils reviennent s'il est réactivé.",
  [tokens.settings.membersReactivateTitle]: 'Réactiver {{name}}',
  [tokens.settings.membersReactivateBody]:
    "{{name}} pourra de nouveau se connecter, avec les accès qu'il avait.",
  [tokens.settings.membersDeactivateSuccess]: 'Membre désactivé.',
  [tokens.settings.membersReactivateSuccess]: 'Membre réactivé.',
  [tokens.settings.membersSetActiveForbidden]:
    "Vos accès ne vous permettent pas de changer l'activation de ce membre.",
  [tokens.settings.membersSetActiveError]: "L'activation de ce membre n'a pas pu être changée.",
  [tokens.settings.membersMenuTransferAgency]: "Transférer d'agence",
  [tokens.settings.membersMenuManageAgencies]: "Gérer l'agence",
  [tokens.settings.manageAgenciesDialogTitle]: "Gérer l'agence",
  [tokens.settings.manageAgenciesDialogDescription]:
    "Sélectionnez l'agence à laquelle {{name}} doit être rattaché(e).",
  [tokens.settings.manageAgenciesSearchPlaceholder]: 'Rechercher une agence…',
  [tokens.settings.manageAgenciesSave]: 'Enregistrer',
  [tokens.settings.manageAgenciesMinOneAgency]:
    'Une agence doit être sélectionnée.',
  [tokens.settings.manageAgenciesSuccess]:
    "Rattachement à l'agence mis à jour.",
  [tokens.settings.manageAgenciesAlreadyMember]:
    'Cet utilisateur est déjà membre de cette agence.',
  [tokens.settings.manageAgenciesNoAgencies]:
    'Aucune agence disponible dans cette organisation.',
  [tokens.settings.manageAgenciesNoSearchResults]: 'Aucune agence trouvée.',
  [tokens.settings.manageAgenciesErrorForbidden]:
    'Vous n’avez pas les droits pour modifier ce rattachement.',
  [tokens.settings.manageAgenciesErrorInvalid]:
    'Les agences sélectionnées ne sont pas valides pour cette organisation.',
  [tokens.settings.manageAgenciesErrorGeneric]:
    "Impossible de mettre à jour le rattachement à l'agence.",
  [tokens.settings.memberDetailAgencyFilterAll]: 'Toutes les agences',
  [tokens.settings.memberDetailAgencyFilterLabel]: 'Filtrer par agence',
  [tokens.settings.membersMenuDelete]: 'Supprimer',
  [tokens.settings.memberDetailBackToList]: 'Retour aux utilisateurs',
  [tokens.settings.memberDetailStatLastConnection]: 'Dernière connexion',
  [tokens.settings.memberDetailStatMemberSince]: 'Membre depuis',
  [tokens.settings.memberDetailStatDeclarations]: 'Nb de déclarations',
  [tokens.settings.memberDetailNotAvailable]: 'Non disponible',
  [tokens.settings.memberDetailTabInfo]: 'Informations',
  [tokens.settings.memberDetailTabReports]: 'Rapports',
  [tokens.settings.memberDetailReportsTitle]: 'Historique des déclarations',
  [tokens.settings.memberDetailReportsSubtitle]:
    '{{count}} déclarations effectuées par {{user}}',
  [tokens.settings.memberDetailReportsSeeDocuments]: 'Voir les déclarations',
  [tokens.settings.memberDetailOverviewTitle]: "Vue d'ensemble",
  [tokens.settings.memberDetailOverviewSubtitle]:
    'Synthèse des déclarations effectuées par cet utilisateur.',
  [tokens.settings.memberDetailOverviewDeclarationsLabel]: 'Déclarations',
  [tokens.settings.memberDetailPeriodLast7Days]: '7 derniers jours',
  [tokens.settings.memberDetailPeriodLast30Days]: '30 derniers jours',
  [tokens.settings.memberDetailPeriodLast90Days]: '90 derniers jours',
  [tokens.settings.memberDetailPeriodLast12Months]: '12 derniers mois',
  [tokens.settings.memberDetailPeriodAll]: "Tout l'historique",
  [tokens.settings.memberDetailPeriodCustom]: 'Période personnalisée',
  [tokens.settings.memberDetailStatusValidated]: 'Validées',
  [tokens.settings.memberDetailStatusPending]: 'En attente',
  [tokens.settings.memberDetailStatusError]: 'En erreur',
  [tokens.settings.memberDetailStatusAbandoned]: 'Abandonnées',
  [tokens.settings.memberDetailStatusUnknown]: 'Inconnu',
  [tokens.settings.memberDetailColReference]: 'Référence',
  [tokens.settings.memberDetailSectionIdentity]: 'Identité',
  [tokens.settings.memberDetailSectionIdentitySubtitle]:
    'Informations personnelles et contacts.',
  [tokens.settings.memberDetailSectionAttachment]: 'Rattachement & rôle',
  [tokens.settings.memberDetailSectionAttachmentSubtitle]:
    'Agences et permissions de cet utilisateur.',
  [tokens.settings.memberDetailLabelFullName]: 'Nom complet',
  [tokens.settings.memberDetailLabelEmail]: 'E-mail',
  [tokens.settings.memberDetailLabelPhone]: 'Téléphone',
  [tokens.settings.memberDetailLabelPosition]: 'Fonction',
  [tokens.settings.memberDetailLabelRole]: 'Rôle',
  [tokens.settings.memberDetailLabelAgencies]: 'Agences rattachées',
  [tokens.settings.memberDetailToolbarEdit]: 'Modifier',
  [tokens.settings.memberDetailToolbarMail]: 'Envoyer un e-mail',
  [tokens.settings.rolesPageTitle]: 'Rôles et permissions',
  [tokens.settings.rolesPageSubtitle]:
    "Définissez les droits d'accès pour chaque rôle au sein de votre organisation.",
  [tokens.settings.rolesColPermission]: 'Permission',
  [tokens.settings.roleLabelAdmin]: 'Admin',
  [tokens.settings.roleLabelManager]: 'Manager',
  [tokens.settings.roleLabelOperator]: 'Opérateur',
  [tokens.settings.roleLabelReader]: 'Lecteur',
  [tokens.settings.roleLabelGuest]: 'Invité',
  [tokens.settings.roleLabelSuperadmin]: 'Super admin',
  [tokens.settings.roleLabelAgent]: 'Agent',
  [tokens.settings.roleLabelDeclarative]: 'Déclarant',
  [tokens.settings.emailTemplatesPageTitle]: "Modèles d'e-mail",
  [tokens.settings.emailTemplatesPageSubtitle]:
    'Personnalisez les e-mails automatiques envoyés par Nabu à votre équipe et à vos clients.',
  [tokens.settings.emailTemplatesModify]: 'Modifier',
  [tokens.settings.emailTemplatesFootnote]:
    "Les modèles harmonisent vos communications. L'éditeur avancé arrive bientôt.",
  [tokens.settings.emailTplAckTitle]: 'Accusé de réception',
  [tokens.settings.emailTplAckDesc]:
    "Envoyé automatiquement dès qu'une déclaration est prise en charge par l'administration douanière.",
  [tokens.settings.emailTplFinalizedTitle]: 'Confirmation de finalisation',
  [tokens.settings.emailTplFinalizedDesc]:
    "Notifie l'équipe lorsqu'une déclaration est acceptée et clôturée.",
  [tokens.settings.emailTplDeclErrTitle]: "Alerte d'erreur déclaration",
  [tokens.settings.emailTplDeclErrDesc]:
    "Alerte immédiate en cas de rejet ou d'anomalie administrative.",
  [tokens.settings.emailTplPipelineErrTitle]: "Alerte d'erreur pipeline",
  [tokens.settings.emailTplPipelineErrDesc]:
    "Notification en cas d'échec d'ingestion automatique ou de traitement manuel d'un fichier.",
  [tokens.settings.emailTplInviteTitle]: 'Invitation utilisateur',
  [tokens.settings.emailTplInviteDesc]:
    "E-mail envoyé lors de l'invitation d'un nouvel utilisateur dans l'organisation.",
  [tokens.settings.helpPageTitle]: "Centre d'aide",
  [tokens.settings.helpPageSubtitle]:
    'Retrouvez toutes les ressources pour utiliser Nabu efficacement.',
  [tokens.settings.helpCardDocTitle]: 'Documentation',
  [tokens.settings.helpCardDocDesc]:
    'Guides complets sur toutes les fonctionnalités de Nabu.',
  [tokens.settings.helpCardDocAction]: 'Accéder',
  [tokens.settings.helpCardVideoTitle]: 'Tutoriels vidéo',
  [tokens.settings.helpCardVideoDesc]:
    'Apprenez à utiliser Nabu avec nos vidéos pas à pas.',
  [tokens.settings.helpCardVideoAction]: 'Voir les vidéos',
  [tokens.settings.helpCardChatTitle]: 'Chat support',
  [tokens.settings.helpCardChatDesc]:
    'Posez vos questions à notre équipe support en direct.',
  [tokens.settings.helpCardChatAction]: 'Démarrer',
  [tokens.settings.helpCardMailTitle]: 'E-mail support',
  [tokens.settings.helpCardMailDesc]:
    'Envoyez-nous un message et nous répondrons sous 24h.',
  [tokens.settings.helpCardMailAction]: 'Nous contacter',
  [tokens.settings.helpSearchPlaceholder]: 'Rechercher un article…',
  [tokens.settings.helpHeroTitle]: 'Comment pouvons-nous vous aider ?',
  [tokens.settings.helpHeroSubtitle]:
    'Trouvez des réponses, suivez des tutoriels ou contactez notre équipe support.',
  [tokens.settings.helpFrequentSearches]: 'Recherches fréquentes',
  [tokens.settings.helpPopularTitle]: 'Articles populaires',
  [tokens.settings.helpBrowseByTheme]: 'Parcourir par thème',
  [tokens.settings.helpSearchResultsTitle]: 'Résultats de recherche',
  [tokens.settings.helpArticlesCountLink]: '{{count}} article >',
  [tokens.settings.helpArticlesCountLink_other]: '{{count}} articles >',
  [tokens.settings.helpSupportCta]:
    'Vous ne trouvez pas votre réponse ? Notre équipe vous répond en moins de 2h les jours ouvrés.',
  [tokens.settings.helpSupportEmail]: 'Envoyer un email',
  [tokens.settings.helpSupportChat]: 'Démarrer un chat',
  [tokens.settings.helpCategoryAll]: 'Toutes',
  [tokens.settings.helpCategoryDeclarationDouaniere]: 'Déclaration douanière',
  [tokens.settings.helpCategoryDeclarationDouaniereDesc]:
    'Créer, valider et transmettre vos déclarations douanières.',
  [tokens.settings.helpCategoryExtractionDonnee]: 'Extraction de la donnée',
  [tokens.settings.helpCategoryExtractionDonneeDesc]:
    'Comment Nabu extrait les données de vos documents.',
  [tokens.settings.helpCategoryDocumentsDossiers]: 'Documents & dossiers',
  [tokens.settings.helpCategoryDocumentsDossiersDesc]:
    'Gérer vos documents et dossiers dans Nabu.',
  [tokens.settings.helpCategoryClassificationDocumentaire]:
    'Classification documentaire',
  [tokens.settings.helpCategoryClassificationDocumentaireDesc]:
    'Classer automatiquement vos documents.',
  [tokens.settings.helpCategoryAutomatisationMetier]: 'Automatisation métier',
  [tokens.settings.helpCategoryAutomatisationMetierDesc]:
    'Automatiser vos processus métier avec Nabu.',
  [tokens.settings.helpCategoryIntegrations]: 'Intégrations',
  [tokens.settings.helpCategoryIntegrationsDesc]:
    'Connecter Nabu à vos outils et systèmes externes.',
  [tokens.settings.helpArticlesCount]: '{{count}} article',
  [tokens.settings.helpArticlesCount_other]: '{{count}} articles',
  [tokens.settings.helpArticlesEmpty]: 'Aucun article trouvé.',
  [tokens.settings.helpArticlesLoadError]:
    'Impossible de charger les articles d’aide.',
  [tokens.settings.helpArticleLoadError]: 'Impossible de charger cet article.',
  [tokens.settings.helpBackToList]: 'Retour',
  [tokens.settings.helpBackToCategories]: 'Retour aux catégories',
  [tokens.settings.helpPopularBadge]: 'Populaire',
  [tokens.settings.helpFrequentSearchBadge]: 'Recherche fréquente',
  [tokens.settings.helpFrequentSearchBadgeAria]: 'Rechercher « {{term}} »',
  [tokens.settings.helpReadingTime]: '{{minutes}} min de lecture',
  [tokens.settings.helpReadingMinutesShort]: '{{minutes}} min',
  [tokens.settings.helpArticleViews]: '{{count}} vues',
  [tokens.settings.helpArticleFeedbackQuestion]:
    'Cet article vous a-t-il été utile ?',
  [tokens.settings.helpArticleFeedbackYes]: 'Oui',
  [tokens.settings.helpArticleFeedbackNo]: 'Non',
  [tokens.settings.helpArticleFeedbackContactSupport]: 'Contacter le support',
  [tokens.settings.helpExpandArticle]: 'Agrandir',
  [tokens.settings.helpCollapseArticle]: 'Réduire',
  [tokens.settings.helpBugTitle]: 'Vous avez trouvé un bug ?',
  [tokens.settings.helpBugDesc]:
    'Signalez-nous tout comportement inattendu. Votre retour nous aide à améliorer Nabu.',
  [tokens.settings.helpBugAction]: 'Signaler un problème',
  [tokens.settings.permViewFolders]: 'Voir les dossiers',
  [tokens.settings.permCreateFolders]: 'Créer des dossiers',
  [tokens.settings.permSendDeclarations]: 'Envoyer des déclarations',
  [tokens.settings.permManageUsers]: 'Gérer les utilisateurs',
  [tokens.settings.permManageOrg]: "Gérer l'organisation",
  [tokens.settings.permManageIntegrations]: 'Gérer les intégrations',
  [tokens.settings.subscriptionPageTitle]: 'Abonnement',
  [tokens.settings.subscriptionPageSubtitle]:
    'Plan, cycle de facturation et crédits.',
  [tokens.settings.subscriptionLoadError]:
    'Impossible de charger les informations d’abonnement.',
  [tokens.settings.subscriptionPendingTitle]:
    'Choisissez votre abonnement pour activer votre enveloppe de crédits',
  [tokens.settings.subscriptionPendingBody]:
    'Votre organisation est prête. Sélectionnez un plan et un cycle, puis activez votre abonnement pour débloquer les crédits.',
  [tokens.settings.subscriptionPendingCta]: 'Activer mon abonnement',
  [tokens.settings.subscriptionPendingPaymentTitle]:
    'Ajoutez un moyen de paiement pour activer votre abonnement',
  [tokens.settings.subscriptionPendingPaymentBody]:
    'Une carte bancaire est requise avant l’activation. Vous pourrez ensuite finaliser votre abonnement et recevoir vos crédits.',
  [tokens.settings.subscriptionPendingPaymentCta]:
    'Ajouter un moyen de paiement',
  [tokens.settings.subscriptionEmptyManualTitle]: 'Facturation manuelle',
  [tokens.settings.subscriptionEmptyManualBody]:
    'Votre organisation est facturée manuellement. La gestion self-serve de l’abonnement n’est pas disponible. Contactez votre interlocuteur Nabu pour toute modification.',
  [tokens.settings.subscriptionEmptyNotConfiguredTitle]:
    'Abonnement non configuré',
  [tokens.settings.subscriptionEmptyNotConfiguredBody]:
    'Aucun abonnement n’est encore configuré pour votre organisation. Contactez Nabu pour activer votre plan.',
  [tokens.settings.subscriptionCreditsBannerLowTitle]:
    'Crédits bientôt épuisés',
  [tokens.settings.subscriptionCreditsBannerLowBody]:
    'Il ne vous reste que <strong>{{remaining}} crédits</strong>. Rechargez votre compte pour ne pas interrompre le traitement de vos déclarations.',
  [tokens.settings.subscriptionCreditsBannerExhaustedTitle]:
    'Crédits épuisés',
  [tokens.settings.subscriptionCreditsBannerExhaustedBody]:
    'Il ne vous reste que <strong>{{remaining}} crédits</strong>. Rechargez votre compte pour ne pas interrompre le traitement de vos déclarations.',
  [tokens.settings.subscriptionCreditsBannerRecharge]: 'Recharger mes crédits',
  [tokens.settings.subscriptionCreditsBannerLater]: 'Plus tard',
  [tokens.settings.subscriptionRecapTitle]: 'Récapitulatif',
  [tokens.settings.subscriptionRecapSubtitle]:
    'Ce qui sera prélevé à la prochaine échéance.',
  [tokens.settings.subscriptionRecapSubtitlePending]:
    'Aperçu basé sur le plan sélectionné, actif après activation.',
  [tokens.settings.subscriptionRecapAmountMonthly]: 'Montant mensuel',
  [tokens.settings.subscriptionRecapAmountAnnual]: 'Montant annuel',
  [tokens.settings.subscriptionRecapPlanName]: 'Plan {{plan}}',
  [tokens.settings.subscriptionRecapAnnualSavingsBadge]: '− {{percent}} %',
  [tokens.settings.subscriptionRecapAnnualSavingsAmount]:
    '{{amount}} d’économie / an',
  [tokens.settings.subscriptionCustomPricingBadge]: 'Tarif custom',
  [tokens.settings.subscriptionRecapCredits]: 'Crédits',
  [tokens.settings.subscriptionRecapCreditsUsed]: '{{percent}} % consommé',
  [tokens.settings.subscriptionRecapCreditsAvailable]: '{{remaining}} disponibles',
  [tokens.settings.subscriptionRecapCreditsExtraPurchased]:
    'dont {{count}} achetés',
  [tokens.settings.subscriptionRecapCreditsExtraGifted]:
    'dont {{count}} offerts',
  [tokens.settings.subscriptionRecapCreditsEnvelopeUsed]:
    '{{percent}} % enveloppe consommée',
  [tokens.settings.subscriptionRecapCreditsPending]: 'Non activée',
  [tokens.settings.subscriptionRecapCreditsPendingHint]:
    'L’enveloppe sera créditée à l’activation de l’abonnement.',
  [tokens.settings.subscriptionRecapNextBilling]: 'Prochaine échéance',
  [tokens.settings.subscriptionRecapNextBillingPending]: 'Après activation',
  [tokens.settings.subscriptionRecapNextBillingPendingHint]:
    'La date de prélèvement sera définie une fois l’abonnement activé.',
  [tokens.settings.subscriptionRecapAutoCharge]: 'Prélèvement automatique',
  [tokens.settings.subscriptionCreditsTitle]: 'Crédits',
  [tokens.settings.subscriptionCreditsSubtitle]:
    'Votre enveloppe se recharge à chaque échéance. Au-delà, les crédits supplémentaires sont facturés à l’usage.',
  [tokens.settings.subscriptionCreditsPendingTitle]:
    'Enveloppe non encore activée',
  [tokens.settings.subscriptionCreditsPendingBody]:
    'Activez votre abonnement pour recevoir votre enveloppe de crédits et commencer à traiter des déclarations.',
  [tokens.settings.subscriptionCreditsBuy]: '+ Acheter des crédits',
  [tokens.settings.subscriptionCreditsConsumedLabel]: 'crédits consommés',
  [tokens.settings.subscriptionCreditsAvailable]:
    '{{remaining}} crédits disponibles',
  [tokens.settings.subscriptionCreditsDeclarationsHint]:
    '≈ {{declarations}} déclarations ce mois-ci',
  [tokens.settings.subscriptionCreditsSourceSubscription]:
    'Abonnement · {{count}}',
  [tokens.settings.subscriptionCreditsSourcePurchased]: 'Achat · {{count}}',
  [tokens.settings.subscriptionCreditsSourceGifted]: 'Cadeau · {{count}}',
  [tokens.settings.subscriptionCreditsEnvelopeLabel]: 'Enveloppe du mois',
  [tokens.settings.subscriptionCreditsEnvelopeConsumed]:
    '{{consumed}} / {{envelope}} consommés',
  [tokens.settings.subscriptionCreditsThresholdLow]: 'Bientôt épuisée',
  [tokens.settings.subscriptionCreditsThresholdExhausted]: 'Épuisée',
  [tokens.settings.subscriptionCreditsRemainingHint]:
    '{{remaining}} crédits restants, soit environ {{declarations}} déclarations ce mois-ci.',
  [tokens.settings.subscriptionCreditsRateDeclaration]: '1 déclaration',
  [tokens.settings.subscriptionCreditsRateArticle]: '1 article',
  [tokens.settings.subscriptionCreditsRateRollover]: 'Report',
  [tokens.settings.subscriptionCreditsRateCredits]: '{{count}} crédits',
  [tokens.settings.subscriptionCreditsRolloverNone]: 'Aucun',
  [tokens.settings.subscriptionCreditsRolloverMonths]: 'Report {{count}} mois',
  [tokens.settings.subscriptionCycleTitle]: 'Cycle de facturation',
  [tokens.settings.subscriptionCycleSubtitle]:
    'Choisissez d’être prélevé chaque mois ou chaque année.',
  [tokens.settings.subscriptionCycleMonthly]: 'Mensuel',
  [tokens.settings.subscriptionCycleMonthlyLine1]:
    'Prélevé le 1er de chaque mois.',
  [tokens.settings.subscriptionCycleMonthlyLine2]:
    'Sans engagement, résiliable à tout moment.',
  [tokens.settings.subscriptionCycleAnnual]: 'Annuel',
  [tokens.settings.subscriptionCycleAnnualBadge]: '− {{percent}} %',
  [tokens.settings.subscriptionCycleAnnualLine1]: 'Prélevé une fois par an.',
  [tokens.settings.subscriptionCycleAnnualLine2]:
    'Deux mois offerts, soit {{percent}} % d’économie.',
  [tokens.settings.subscriptionCycleEffectiveHint]:
    'Le changement de cycle prend effet au prochain renouvellement (pas de prorata).',
  [tokens.settings.subscriptionPlansTitle]: 'Plan',
  [tokens.settings.subscriptionPlansSubtitle]:
    'Chaque plan inclut une enveloppe de crédits mensuelle. Une déclaration consomme des crédits selon le plan.',
  [tokens.settings.subscriptionPlansSubtitlePending]:
    'Sélectionnez le plan à activer. Enterprise nécessite un contact commercial.',
  [tokens.settings.subscriptionPlansCompare]: 'Comparer les plans',
  [tokens.settings.subscriptionPlanPerMonth]: '/ mois',
  [tokens.settings.subscriptionPlanPerYear]: '/ an',
  [tokens.settings.subscriptionPlanAnnualEquivalent]:
    'ou {{amount}} / mois en annuel',
  [tokens.settings.subscriptionPlanAnnualSavings]:
    '{{amount}} d’économie / an',
  [tokens.settings.subscriptionPlanEnvelopeBadge]:
    '{{credits}} crédits inclus / mois',
  [tokens.settings.subscriptionPlanCoverage]:
    '{{declarations}} déclarations ou {{articles}} articles',
  [tokens.settings.subscriptionPlanImportExport]: 'IMPORT / EXPORT',
  [tokens.settings.subscriptionPlanCoverageDeclarations]:
    '{{count}} déclarations',
  [tokens.settings.subscriptionPlanCoverageOr]: 'ou',
  [tokens.settings.subscriptionPlanCoverageArticles]: '{{count}} articles',
  [tokens.settings.subscriptionPlanRateDeclaration]:
    '1 déclaration = {{count}} crédits',
  [tokens.settings.subscriptionPlanRateArticle]:
    '1 article = {{count}} crédits',
  [tokens.settings.subscriptionPlanRateLine]:
    '1 déclaration = {{declaration}} crédits · 1 article = {{article}} crédits',
  [tokens.settings.subscriptionPlanExtraCredit]:
    'Crédits supplémentaires : {{price}}/crédit',
  [tokens.settings.subscriptionPlanMinGrowth]:
    'À partir de 500 déclarations / mois',
  [tokens.settings.subscriptionPlanMinEnterprise]:
    'À partir de 5K déclarations / mois',
  [tokens.settings.subscriptionPlanSetupFee]:
    'Mise en service unique : {{amount}}',
  [tokens.settings.subscriptionPlanCurrentBadge]: 'Plan actuel',
  [tokens.settings.subscriptionPlanRecommendedBadge]: 'Recommandé',
  [tokens.settings.subscriptionPlanSelectedBadge]: 'Sélectionné',
  [tokens.settings.subscriptionPlanCurrentCta]: 'Plan actuel',
  [tokens.settings.subscriptionPlanChooseCta]: 'Choisir ce plan',
  [tokens.settings.subscriptionPlanActivateCta]: 'Activer ce plan',
  [tokens.settings.subscriptionPlanContactCta]: 'Nous contacter',
  [tokens.settings.subscriptionPlanFeatureStarterUsers]:
    'Jusqu’à 3 utilisateurs',
  [tokens.settings.subscriptionPlanFeatureStarterEmail]: 'Support par e-mail',
  [tokens.settings.subscriptionPlanFeatureStarterOnboarding]:
    'Onboarding autonome',
  [tokens.settings.subscriptionPlanFeatureStarterArchive]: 'Archivage 1 an',
  [tokens.settings.subscriptionPlanFeatureStarterCsv]: 'Export CSV',
  [tokens.settings.subscriptionPlanFeatureStarterNoDashboard]:
    'Pas de dashboard de pilotage',
  [tokens.settings.subscriptionPlanFeatureStarterNoSla]:
    'Pas de SLA contractuel',
  [tokens.settings.subscriptionPlanFeatureStarterNoRollover]:
    'Report des crédits : aucun',
  [tokens.settings.subscriptionPlanFeatureGrowthIntro]: 'Tout Starter, plus :',
  [tokens.settings.subscriptionPlanFeatureGrowthUsers]:
    'Utilisateurs illimités',
  [tokens.settings.subscriptionPlanFeatureGrowthDashboard]:
    'Dashboard de pilotage',
  [tokens.settings.subscriptionPlanFeatureGrowthSla]: 'SLA 99,0 %',
  [tokens.settings.subscriptionPlanFeatureGrowthSupport]:
    'Support prioritaire e-mail + chat',
  [tokens.settings.subscriptionPlanFeatureGrowthOnboarding]:
    'Onboarding accompagné',
  [tokens.settings.subscriptionPlanFeatureGrowthArchive]: 'Archivage 5 ans',
  [tokens.settings.subscriptionPlanFeatureGrowthConnectors]:
    'Connecteurs ERP / TMS',
  [tokens.settings.subscriptionPlanFeatureGrowthApi]: 'Accès API',
  [tokens.settings.subscriptionPlanFeatureGrowthEdi]:
    'Contrôle EDI temps réel',
  [tokens.settings.subscriptionPlanFeatureGrowthRollover]:
    'Report des crédits : 1 mois',
  [tokens.settings.subscriptionPlanFeatureEnterpriseIntro]:
    'Tout Growth, plus :',
  [tokens.settings.subscriptionPlanFeatureEnterpriseDashboard]:
    'Dashboard avancé',
  [tokens.settings.subscriptionPlanFeatureEnterpriseSla]: 'SLA dédié 99,9 %',
  [tokens.settings.subscriptionPlanFeatureEnterpriseAm]:
    'Account manager dédié',
  [tokens.settings.subscriptionPlanFeatureEnterpriseOnboarding]:
    'Onboarding sur-mesure',
  [tokens.settings.subscriptionPlanFeatureEnterpriseSso]: 'SSO / SAML',
  [tokens.settings.subscriptionPlanFeatureEnterpriseCompliance]:
    'Conformité avancée (DGDDUI, RGPD+)',
  [tokens.settings.subscriptionPlanFeatureEnterpriseRouting]:
    'Routage multi-bureaux douane',
  [tokens.settings.subscriptionPlanFeatureEnterpriseWorkflows]:
    'Workflows custom',
  [tokens.settings.subscriptionPlanFeatureEnterpriseRollover]:
    'Report des crédits : 3 mois',
  [tokens.settings.subscriptionBuyCreditsTitle]: 'Acheter des crédits',
  [tokens.settings.subscriptionBuyCreditsSubtitle]:
    'Choisissez un pack ou saisissez une quantité libre. Les crédits sont ajoutés immédiatement à votre enveloppe.',
  [tokens.settings.subscriptionBuyCreditsPackLabel]: '{{credits}} crédits',
  [tokens.settings.subscriptionBuyCreditsPackDecls]:
    '≈ {{count}} déclarations',
  [tokens.settings.subscriptionBuyCreditsCustomLabel]: 'Quantité libre',
  [tokens.settings.subscriptionBuyCreditsCustomPlaceholder]:
    'Nombre de crédits',
  [tokens.settings.subscriptionBuyCreditsPreview]:
    '{{quantity}} crédits · {{amount}}',
  [tokens.settings.subscriptionBuyCreditsCancel]: 'Annuler',
  [tokens.settings.subscriptionBuyCreditsConfirm]: 'Confirmer l’achat',
  [tokens.settings.subscriptionToastCycleUpdated]:
    'Cycle de facturation mis à jour.',
  [tokens.settings.subscriptionToastPlanUpdated]:
    'Plan mis à jour.',
  [tokens.settings.subscriptionToastCreditsPurchased]:
    'Crédits achetés avec succès.',
  [tokens.settings.subscriptionToastActivated]:
    'Abonnement activé. Votre enveloppe de crédits est disponible.',
  [tokens.settings.subscriptionErrorGeneric]:
    'Une erreur est survenue. Réessayez.',
  [tokens.settings.subscriptionErrorContactRequired]:
    'Contactez l’équipe commerciale pour activer le plan Enterprise.',
  [tokens.settings.subscriptionErrorActivationRequired]:
    'Activez d’abord votre abonnement pour effectuer cette action.',
  [tokens.settings.subscriptionErrorPaymentMethodRequired]:
    'Ajoutez un moyen de paiement avant d’activer votre abonnement.',
  [tokens.settings.subscriptionContactMailSubject]:
    'Demande concernant mon abonnement Nabu',
  [tokens.settings.billingPageTitle]: 'Facturation',
  [tokens.settings.billingPageSubtitle]:
    'Moyens de paiement et historique de facturation.',
  [tokens.settings.billingPageSubtitleAddPayment]:
    'Ajoutez une carte pour pouvoir activer votre abonnement.',
  [tokens.settings.billingPageComingSoon]:
    'Cette page arrivera prochainement.',
  [tokens.settings.billingLoadError]:
    'Impossible de charger les informations de facturation.',
  [tokens.settings.billingAddPaymentTitle]: 'Moyen de paiement',
  [tokens.settings.billingAddPaymentBody]:
    'Enregistrez une carte bancaire. Une fois enregistrée, revenez à l’abonnement pour l’activer.',
  [tokens.settings.billingAddPaymentPlaceholder]:
    'Le formulaire de carte Hyperline sera intégré ici.',
  [tokens.settings.billingAddPaymentCancel]: 'Retour',
  [tokens.settings.billingAddPaymentDone]:
    'Carte ajoutée — retour à l’abonnement',
  [tokens.settings.billingAddPaymentBannerTitle]:
    'Ajoutez une carte pour activer votre abonnement',
  [tokens.settings.billingAddPaymentBannerBody]:
    'Après l’enregistrement de votre moyen de paiement, vous serez redirigé vers la page Abonnement pour finaliser l’activation.',
  [tokens.settings.billingPaymentMethodsTitle]: 'Moyens de paiement',
  [tokens.settings.billingPaymentMethodsSubtitle]:
    'La carte principale est débitée à chaque échéance.',
  [tokens.settings.billingInvoicesTitle]: 'Factures',
  [tokens.settings.billingInvoicesSubtitle]: 'Historique de facturation.',
  [tokens.settings.billingEmptyManualTitle]: 'Facturation manuelle',
  [tokens.settings.billingEmptyManualBody]:
    'Votre organisation est facturée manuellement. La gestion self-serve des moyens de paiement et des factures n’est pas disponible.',
  [tokens.settings.billingEmptyNotConfiguredTitle]:
    'Facturation non configurée',
  [tokens.settings.billingEmptyNotConfiguredBody]:
    'Aucun compte de facturation n’est configuré pour votre organisation. Consultez la page Abonnement ou contactez Nabu.',
  [tokens.settings.billingEmptyGoSubscription]: 'Voir l’abonnement',
  [tokens.settings.billingTokenDisabledTitle]: 'Facturation indisponible',
  [tokens.settings.billingTokenErrorTitle]:
    'Impossible de charger la facturation',
  [tokens.settings.billingTokenErrorBody]:
    'Réessayez dans un instant. Si le problème persiste, contactez le support.',
  [tokens.settings.billingTokenRetry]: 'Réessayer',
  [tokens.settings.billingToastPaymentCreated]:
    'Moyen de paiement ajouté.',
  [tokens.settings.billingToastPaymentDeleted]:
    'Moyen de paiement supprimé.',
  [tokens.settings.billingToastPaymentDefault]:
    'Carte principale mise à jour.',
  [tokens.settings.billingToastEmbedError]:
    'Le formulaire de carte a rencontré une erreur. Réessayez.',
  [tokens.settings.billingAddCardCta]: '+ Ajouter une carte',
  [tokens.settings.billingAddCardTitle]: 'Ajouter une carte',
  [tokens.settings.billingAddCardBody]:
    'Saisissez les informations de votre carte. Les données bancaires sont traitées de façon sécurisée.',
  [tokens.settings.billingAddCardError]:
    'Impossible d’ouvrir le formulaire d’ajout. Réessayez.',
  [tokens.settings.billingAddCardSubmit]: 'Enregistrer la carte',
  [tokens.settings.billingAddCardConfirmError]:
    'Impossible d’enregistrer la carte. Vérifiez les informations et réessayez.',
  [tokens.settings.billingCardPrimaryBadge]: 'Principale',
  [tokens.settings.billingCardExpiry]: 'Expire {{exp}}',
  [tokens.settings.billingCardExpiryWithHolder]:
    '{{holder}} · expire {{exp}}',
  [tokens.settings.billingCardSetDefault]: 'Définir principale',
  [tokens.settings.billingCardDelete]: 'Supprimer la carte',
  [tokens.settings.billingDeleteCardTitle]: 'Supprimer cette carte ?',
  [tokens.settings.billingDeleteCardBody]:
    'La carte •••• {{last4}} sera retirée de vos moyens de paiement.',
  [tokens.settings.billingDeleteCardConfirm]: 'Supprimer',
  [tokens.settings.billingPaymentMethodsLoadError]:
    'Impossible de charger les moyens de paiement.',
  [tokens.settings.billingPaymentMethodsEmptyTitle]:
    'Aucun moyen de paiement',
  [tokens.settings.billingPaymentMethodsEmptyBody]:
    'Ajoutez une carte pour les prélèvements d’abonnement.',
  [tokens.settings.billingInvoicesLoadError]:
    'Impossible de charger les factures.',
  [tokens.settings.billingInvoicesEmpty]: 'Aucune facture pour le moment.',
  [tokens.settings.billingInvoiceColNumber]: 'N°',
  [tokens.settings.billingInvoiceColDate]: 'Date',
  [tokens.settings.billingInvoiceColPeriod]: 'Période',
  [tokens.settings.billingInvoiceColAmount]: 'Montant',
  [tokens.settings.billingInvoiceColStatus]: 'Statut',
  [tokens.settings.billingInvoiceColAction]: 'Action',
  [tokens.settings.billingInvoiceStatusPaid]: 'Payée',
  [tokens.settings.billingInvoiceStatusPending]: 'En attente',
  [tokens.settings.billingInvoiceStatusFailed]: 'Échec',
  [tokens.settings.billingInvoiceDownload]: 'Télécharger la facture',
  [tokens.settings.billingInvoiceDownloadSuccess]:
    'Facture ouverte dans un nouvel onglet.',
  [tokens.settings.billingInvoiceDownloadError]:
    'Impossible de télécharger la facture.',
  [tokens.settings.billingErrorGeneric]:
    'Une erreur est survenue. Réessayez.',
  [tokens.settings.billingErrorLastCardActive]:
    'Impossible de supprimer la dernière carte d’un abonnement actif.',
  [tokens.settings.authzRolesSubtitle]: "Quatre rôles Nabu, emboîtés du plus restreint au plus large. Créez les vôtres à partir de l'un d'eux, puis attribuez-les agence par agence.",
  [tokens.settings.authzNabuRolesTitle]: 'Rôles Nabu',
  [tokens.settings.authzCustomRolesTitle]: 'Vos rôles',
  [tokens.settings.authzCreateRole]: 'Créer un rôle',
  [tokens.settings.authzCreateRoleTitle]: 'Créer un rôle',
  [tokens.settings.authzCreateRoleHint]: "Un rôle part toujours d'un rôle Nabu. Vous ajustez ensuite ses capacités une à une.",
  [tokens.settings.authzCreateRoleName]: 'Nom du rôle',
  [tokens.settings.authzCreateRoleBase]: 'À partir de',
  [tokens.settings.authzRoleOriginNabu]: 'Rôle Nabu',
  [tokens.settings.authzMembersCount]: '{{count}} personnes',
  [tokens.settings.authzMembersCountOne]: '1 personne',
  [tokens.settings.authzRoleNotFound]: "Ce rôle n'existe pas ou a été supprimé.",
  [tokens.settings.authzRoleName]: 'Nom du rôle',
  [tokens.settings.authzRoleReadOnlyNotice]: "Les rôles Nabu ne se modifient pas : Nabu les maintient pour tout le monde. Dupliquez-le pour l'adapter à votre organisation.",
  [tokens.settings.authzImpactNone]: 'Aucun droit ne change.',
  [tokens.settings.authzSaveRole]: 'Enregistrer',
  [tokens.settings.authzDiscardChanges]: 'Annuler les modifications',
  [tokens.settings.authzDeleteRole]: 'Supprimer le rôle',
  [tokens.settings.authzDeleteRoleBlocked]: "Retirez d'abord ce rôle aux {{count}} personne(s) qui l'ont.",
  [tokens.settings.authzDeleteRoleConfirm]: 'Le rôle « {{role}} » sera supprimé définitivement.',
  [tokens.settings.authzRightMissing]: '« {{action}} » : vos accès ne le permettent pas ici.',
  [tokens.settings.authzRightAskPeople]: 'Demandez-le à {{names}}.',
  [tokens.settings.authzRightAskAdmin]: 'Demandez-le à un administrateur de votre organisation.',
  [tokens.settings.authzWhyMissing]: 'Il manque : {{actions}}.',
  [tokens.settings.authzWhyNotGranted]: 'Aucun de ses accès ici ne la donne.',
  [tokens.settings.authzWhyAccessesHere]: 'Ses accès ici : {{accesses}}.',
  [tokens.settings.authzWhyAccessInherited]: '{{role}}, hérité de {{agency}}',
  [tokens.settings.authzWhyNoAccessHere]: 'Aucun accès sur cette agence.',
  [tokens.settings.authzWhySmallestRole]: 'Rôle Nabu minimal qui la donne : {{role}}.',
  [tokens.settings.authzChangesPeople]: 'Qui gagne et qui perd :',
  [tokens.settings.authzEffectGains]: '{{name}} gagnera : {{actions}}.',
  [tokens.settings.authzEffectLoses]: '{{name}} perdra : {{actions}}.',
  [tokens.settings.authzEffectNone]: 'Ses droits ne changent pas : ses autres accès les lui donnent déjà.',
  [tokens.settings.authzChangeRoleTitle]: 'Changer le rôle',
  [tokens.settings.authzChangeRoleConfirm]: '{{name}} aura le rôle {{role}} sur tous ses accès.',
  [tokens.settings.memberDetailTabAccess]: 'Accès',
  [tokens.settings.authzAccessTitle]: 'Accès',
  [tokens.settings.authzAccessSubtitle]: "Chaque ligne donne un rôle sur une agence — et ses sous-agences si vous le souhaitez. Les droits s'additionnent, rien ne se retire par ailleurs.",
  [tokens.settings.authzAddAccess]: 'Ajouter un accès',
  [tokens.settings.authzNoAccess]: "{{name}} n'a aucun accès et ne voit rien dans cette organisation.",
  [tokens.settings.authzScopeWholeOrg]: "Toute l'organisation",
  [tokens.settings.authzScopeWithDescendants]: '{{name}} et ses sous-agences',
  [tokens.settings.authzScopeOnly]: '{{name}} uniquement',
  [tokens.settings.authzValidFrom]: 'à partir du {{date}}',
  [tokens.settings.authzValidUntil]: "jusqu'au {{date}}",
  [tokens.settings.authzValidBetween]: 'du {{from}} au {{until}}',
  [tokens.settings.authzExpired]: 'Expiré',
  [tokens.settings.authzScheduled]: 'À venir',
  [tokens.settings.authzOriginMigration]: "Repris de l'ancien rôle",
  [tokens.settings.authzOriginMigrationHint]: 'Créé automatiquement à la bascule, à partir du rôle et des agences de ce membre.',
  [tokens.settings.authzRemoveAccess]: 'Retirer cet accès',
  [tokens.settings.authzRemoveAccessConfirm]: '{{name}} perdra le rôle « {{role}} » sur {{scope}}.',
  [tokens.settings.authzRightsPreviewTitle]: 'Ce que {{name}} peut faire',
  [tokens.settings.authzRightsPreviewOn]: 'Sur',
  [tokens.settings.authzStateEnabled]: 'Accordé',
  [tokens.settings.authzStatePartial]: 'Partiel',
  [tokens.settings.authzStateDisabled]: 'Visible, grisé',
  [tokens.settings.authzStateHidden]: 'Caché',
  [tokens.settings.authzStateLegend]: "Grisé pour agir, caché pour détruire : un bouton d'action non accordé reste visible mais inactif, avec une explication ; supprimer et gérer les droits n'apparaissent pas du tout.",
  [tokens.settings.authzNoRightsHere]: 'Aucun droit sur cette agence.',
  [tokens.settings.authzAddAccessTitle]: 'Ajouter un accès pour {{name}}',
  [tokens.settings.authzAddAccessRole]: 'Rôle',
  [tokens.settings.authzRolesGroupNabu]: 'Rôles Nabu',
  [tokens.settings.authzRolesGroupCustom]: 'Vos rôles',
  [tokens.settings.authzAddAccessScope]: 'Portée',
  [tokens.settings.authzAddAccessScopeOrg]: "Toute l'organisation",
  [tokens.settings.authzAddAccessScopeAgencies]: 'Une ou plusieurs agences',
  [tokens.settings.authzAddAccessIncludeDescendants]: 'Inclure les sous-agences',
  [tokens.settings.authzAddAccessTemporary]: 'Accès temporaire',
  [tokens.settings.authzAddAccessFrom]: 'À partir du',
  [tokens.settings.authzAddAccessUntil]: "Jusqu'au",
  [tokens.settings.authzAddAccessDatesInvalid]: 'La date de fin précède la date de début.',
  [tokens.settings.authzAddAccessPreview]: '{{name}} aura le rôle « {{role}} » sur {{scope}}{{validity}}.',
  [tokens.settings.authzAddAccessPreviewAgencies]: '{{count}} agences',
  [tokens.settings.authzAddAccessPreviewAgenciesWithDescendants]: '{{count}} agences et leurs sous-agences',
  [tokens.settings.authzAddAccessSelectAtLeastOne]: 'Choisissez un rôle et au moins une agence.',
  [tokens.settings.authzAddAccessSave]: "Ajouter l'accès",
  [tokens.settings.authzLegacyRoleLine]: "Rôle appliqué aujourd'hui : {{role}} — le plus élevé de ses accès, tant que l'ancien contrôle d'accès est en place.",
  [tokens.settings.authzTabCompare]: 'Comparer les rôles',
  [tokens.settings.authzTabConfigure]: 'Configurer un rôle',
  [tokens.settings.authzTabAttribution]: 'Attribution par agence',
  [tokens.settings.authzCopyName]: 'Copie de {{role}}',
  [tokens.settings.authzCompareHint]: 'Chaque rôle Nabu fait tout ce que fait le précédent, plus ce qui est surligné. Ouvrez une ligne pour voir le détail des actions.',
  [tokens.settings.authzCompareCapacity]: 'Capacité',
  [tokens.settings.authzCompareLegendNew]: 'Ajouté par ce rôle',
  [tokens.settings.authzCompareLegendIncluded]: 'Inclus',
  [tokens.settings.authzCompareLegendPartial]: 'En partie, dans votre rôle',
  [tokens.settings.authzCompareLegendNone]: 'Non inclus',
  [tokens.settings.authzCompareRemoved]: 'retiré',
  [tokens.settings.authzCompareExpand]: 'Voir les actions de {{capacity}}',
  [tokens.settings.authzCompareTotals]: 'Capacités accordées',
  [tokens.settings.authzCompareTotalFull]: '{{count}} sur {{total}}',
  [tokens.settings.authzCompareTotalPartial]: '{{count}} + {{partial}} en partie',
  [tokens.settings.authzRoleKindCustom]: 'Votre rôle · de {{preset}}',
  [tokens.settings.authzDuplicate]: 'Dupliquer',
  [tokens.settings.authzEdit]: 'Modifier',
  [tokens.settings.authzCreateFromNabu]: "Créer un rôle à partir d'un rôle Nabu",
  [tokens.settings.authzCustomRolesUsage]: 'Vos rôles : {{count}} sur {{max}}',
  [tokens.settings.authzCustomRolesLimitReached]: 'Nombre maximal de rôles personnalisés atteint ({{max}}) : supprimez-en un pour en créer un autre.',
  [tokens.settings.authzLoadError]: "Impossible de lire les rôles et les accès de l'organisation. Rechargez la page.",
  [tokens.settings.authzToastRoleCreated]: 'Rôle créé.',
  [tokens.settings.authzToastRoleSaved]: 'Rôle enregistré.',
  [tokens.settings.authzToastRoleDeleted]: 'Rôle supprimé.',
  [tokens.settings.authzToastAccessGiven]: 'Accès donné.',
  [tokens.settings.authzToastAccessRemoved]: 'Accès retiré.',
  [tokens.settings.authzToastMemberRoleChanged]: 'Rôle du membre changé.',
  [tokens.settings.authzErrorRoleLimit]: 'Votre organisation a atteint le nombre maximal de rôles personnalisés : supprimez-en un pour en créer un autre.',
  [tokens.settings.authzErrorRoleInUse]: 'Des membres ont encore ce rôle : changez leur rôle avant de le supprimer.',
  [tokens.settings.authzErrorAccessAlreadyGranted]: 'Ce membre a déjà ce rôle sur cette agence.',
  [tokens.settings.authzErrorLastAdministrator]: 'Votre organisation doit garder au moins une personne qui gère les rôles.',
  [tokens.settings.authzErrorRoleInvalid]: "Ce rôle n'a pas pu être enregistré tel quel. Rechargez la page et réessayez.",
  [tokens.settings.authzErrorForbidden]: 'Vos accès ne vous permettent pas cette modification.',
  [tokens.settings.authzErrorGeneric]: "La modification n'a pas pu être enregistrée. Réessayez.",
  [tokens.settings.authzConfigureChipsHint]: 'Les rôles Nabu se consultent et restent à jour tout seuls. Vos rôles ({{count}} sur {{max}}) se règlent case par case.',
  [tokens.settings.authzNewRoleChip]: 'Nouveau rôle',
  [tokens.settings.authzNewRoleBadge]: 'Nouveau · à partir de {{preset}}',
  [tokens.settings.authzMatrixGranted]: '{{granted}} / {{total}} actions accordées',
  [tokens.settings.authzMatrixGaps]: '{{count}} écart(s) avec {{preset}}',
  [tokens.settings.authzMatrixRevert]: 'Revenir à {{preset}}',
  [tokens.settings.authzMatrixModule]: 'Module',
  [tokens.settings.authzMatrixRead]: 'Lire',
  [tokens.settings.authzMatrixCreate]: 'Créer',
  [tokens.settings.authzMatrixUpdate]: 'Modifier',
  [tokens.settings.authzMatrixDelete]: 'Supprimer',
  [tokens.settings.authzMatrixAccess]: 'Accès',
  [tokens.settings.authzMatrixNotApplicable]: 'Sans objet',
  [tokens.settings.authzMatrixDiffers]: 'Diffère de {{preset}}',
  [tokens.settings.authzMatrixCellHint]: '{{action}} · fait partie de « {{capacity}} »',
  [tokens.settings.authzMatrixCellOwnVersion]: '{{action}} · « {{capacity}} » : ce rôle en a sa propre version, qui ne suit plus les mises à jour de Nabu',
  [tokens.settings.authzMatrixOwnVersions]: 'Ce rôle a sa propre version de {{capacities}}. Ces cases ne suivent plus les mises à jour de Nabu ; recochez-les toutes pour revenir à la version Nabu.',
  [tokens.settings.authzCreateRoleSave]: 'Créer le rôle',
  [tokens.settings.authzGiveCopyTitle]: 'Donner « {{role}} » aux personnes qui ont {{preset}} ?',
  [tokens.settings.authzGiveCopyBody]: 'Les personnes cochées passent de {{preset}} à ce rôle, sur les mêmes agences et aux mêmes dates. Sans ça, le nouveau rôle ne sert à personne.',
  [tokens.settings.authzAttributionHint]: 'Qui a un rôle sur chaque agence : directement, ou par une agence parente avec ses sous-agences.',
  [tokens.settings.authzAttributionAgencies]: 'Agences',
  [tokens.settings.authzAttributionTitle]: 'Accès à {{agency}}',
  [tokens.settings.authzAttributionGive]: 'Donner un accès',
  [tokens.settings.authzAttributionEmpty]: "Personne n'a encore de rôle sur {{agency}}.",
  [tokens.settings.authzAttributionDirect]: 'Donné sur cette agence uniquement',
  [tokens.settings.authzAttributionDirectWithDescendants]: 'Donné sur cette agence et ses sous-agences',
  [tokens.settings.authzAttributionInherited]: 'Par {{agency}} et ses sous-agences',
  [tokens.settings.authzAttributionInheritedHint]: 'Donné sur {{agency}} : il se gère depuis {{agency}}',
  [tokens.settings.authzAttributionDialogTitle]: 'Donner un accès sur {{agency}}',
  [tokens.settings.authzAttributionMember]: 'Membre',
  [tokens.settings.authzAttributionNoMember]: 'Aucun membre que vous pouvez gérer',
  [tokens.settings.authzAttributionPickMember]: 'Choisissez un membre et un rôle.',
  [tokens.settings.authzGiveCopyCheckAll]: 'Tout cocher',
  [tokens.settings.authzGiveCopyUncheckAll]: 'Tout décocher',
  [tokens.settings.authzGiveCopyCount]: '{{count}} sur {{total}}',
  [tokens.settings.authzChangesCount]: 'action modifiée',
  [tokens.settings.authzChangesCount_other]: 'actions modifiées',
  [tokens.settings.authzChangesTouches]: 'Touche {{count}} personne',
  [tokens.settings.authzChangesTouches_other]: 'Touche {{count}} personnes',
  [tokens.settings.authzChangesNewRole]: 'Nouveau rôle à partir de {{preset}}',
  [tokens.settings.authzChangesDetail]: 'Ce qui change',
  [tokens.settings.inboxesIntro]: "Un e-mail envoyé à l'une de ces boîtes crée un dossier avec ses pièces jointes. Seuls les expéditeurs autorisés sont acceptés.",
  [tokens.settings.inboxNew]: 'Nouvelle boîte',
  [tokens.settings.inboxesListTitle]: 'Adresses de réception',
  [tokens.settings.inboxesActiveCount]: '{{count}} active sur {{total}}',
  [tokens.settings.inboxesActiveCount_other]: '{{count}} actives sur {{total}}',
  [tokens.settings.inboxesSearch]: 'Rechercher',
  [tokens.settings.inboxesColAddress]: 'Adresse',
  [tokens.settings.inboxesColCreates]: 'Dossier créé',
  [tokens.settings.inboxesColAssignee]: 'Attribué à',
  [tokens.settings.inboxesEmptyTitle]: "Aucune boîte de réception pour l'instant",
  [tokens.settings.inboxesNoMatch]: 'Aucune boîte ne correspond',
  [tokens.settings.inboxesEmptyHint]: 'Créez une boîte de réception et transmettez son adresse à vos clients.',
  [tokens.settings.inboxCopyAddress]: "Copier l'adresse",
  [tokens.settings.inboxCopy]: 'Copier',
  [tokens.settings.inboxActive]: 'Active',
  [tokens.settings.inboxPaused]: 'En pause',
  [tokens.settings.inboxToggle]: 'Activer ou mettre en pause',
  [tokens.settings.inboxUnassigned]: 'Non attribué',
  [tokens.settings.inboxClientFromDocuments]: 'le client lu dans les documents',
  [tokens.settings.allowedSendersTitle]: 'Expéditeurs autorisés',
  [tokens.settings.allowedSendersHint]: "Valable pour toutes les boîtes de l'agence.",
  [tokens.settings.allowedSendersPlaceholder]: 'nom@client.com',
  [tokens.settings.allowedSendersAdd]: 'Ajouter',
  [tokens.settings.allowedSendersInvalid]: 'Saisissez une adresse complète (nom@domaine.com).',
  [tokens.settings.allowedSendersDuplicate]: 'Déjà dans la liste.',
  [tokens.settings.allowedSendersAddresses]: 'Adresses',
  [tokens.settings.allowedSendersRemove]: 'Retirer',
  [tokens.settings.allowedSendersDefault]: 'Défaut',
  [tokens.settings.allowedSendersAgencyMembers]: "Membres de l'agence ({{count}})",
  [tokens.settings.allowedSendersDefaultHint]: "Les membres de l'agence sont autorisés par défaut.",
  [tokens.settings.allowedSendersOnlyMembers]: "Seuls les membres de l'agence peuvent écrire à ses boîtes.",
  [tokens.settings.allowedSendersAdded]: '{{email}} est autorisé',
  [tokens.settings.allowedSendersRemoved]: "{{email}} n'est plus autorisé",
  [tokens.settings.allowedSendersError]: 'Impossible de modifier la liste des expéditeurs.',
  [tokens.settings.inboxRejectedTitle]: 'Refusés récemment',
  [tokens.settings.inboxRejectedTo]: '{{date}} · vers {{inbox}}',
  [tokens.settings.inboxRejectedAllow]: 'Autoriser',
  [tokens.settings.inboxRejectedDismiss]: 'Ignorer',
  [tokens.settings.inboxRejectedCount]: '{{count}} e-mail',
  [tokens.settings.inboxRejectedCount_other]: '{{count}} e-mails',
  [tokens.settings.inboxRejectedPaused]: 'boîte en pause',
  [tokens.settings.inboxEditorNewTitle]: 'Nouvelle boîte de réception',
  [tokens.settings.inboxEditorEditTitle]: 'Modifier la boîte de réception',
  [tokens.settings.inboxEditorAddress]: 'Adresse de réception',
  [tokens.settings.inboxEditorPrefixHint]: "Lettres minuscules, chiffres et tirets. Seuls les expéditeurs autorisés de l'agence peuvent y écrire.",
  [tokens.settings.inboxEditorWhatItDoes]: 'Ce que fait cette adresse',
  [tokens.settings.inboxEditorNotify]: 'Notifier',
  [tokens.settings.inboxEditorNotifyHint]: 'Ces personnes reçoivent un e-mail à chaque dossier créé.',
  [tokens.settings.inboxEditorFieldType]: 'Type de dossier',
  [tokens.settings.inboxEditorFieldClient]: 'Client',
  [tokens.settings.inboxEditorFieldClientPlaceholder]: 'Lu dans les documents',
  [tokens.settings.inboxEditorFieldAssignee]: 'Attribué à',
  [tokens.settings.inboxEditorPreparation]: 'Préparation',
  [tokens.settings.inboxEditorPrepSmart]: 'Préparation intelligente',
  [tokens.settings.inboxEditorPrepClassic]: 'Préparation classique',
  [tokens.settings.inboxEditorDelete]: 'Supprimer',
  [tokens.settings.inboxEditorCancel]: 'Annuler',
  [tokens.settings.inboxEditorCreate]: 'Créer la boîte',
  [tokens.settings.inboxEditorSave]: 'Enregistrer',
  [tokens.settings.inboxEditorClose]: 'Fermer',
  [tokens.settings.inboxStepMailTitle]: 'Un e-mail arrive',
  [tokens.settings.inboxStepMailBody]: "avec ses pièces jointes, d'un expéditeur autorisé de l'agence",
  [tokens.settings.inboxStepFolderTitle]: 'Nabu crée un dossier',
  [tokens.settings.inboxStepFolderBody]: 'De type <type>{{type}}</type>, avec le flux <flow>{{flow}}</flow>, pour <client>{{client}}</client>',
  [tokens.settings.inboxStepPrepTitle]: 'Préparation',
  [tokens.settings.inboxStepPrepBody]: 'Ce dossier sera préparé avec <prep>{{prep}}</prep>',
  [tokens.settings.inboxPrepSmartPhrase]: 'la préparation intelligente',
  [tokens.settings.inboxPrepClassicPhrase]: 'la préparation classique',
  [tokens.settings.inboxStepAssignTitle]: 'Il est attribué',
  [tokens.settings.inboxStepAssignBody]: 'à <user>{{user}}</user>',
  [tokens.settings.inboxStepAssignNotified]: ', et {{count}} personne est notifiée',
  [tokens.settings.inboxStepAssignNotified_other]: ', et {{count}} personnes sont notifiées',
  [tokens.settings.inboxMissingType]: 'type à choisir',
  [tokens.settings.inboxMissingFlow]: 'flux à choisir',
  [tokens.settings.inboxMissingAssignee]: 'personne à choisir',
  [tokens.settings.inboxCreated]: 'Boîte créée',
  [tokens.settings.inboxSaved]: 'Boîte enregistrée',
  [tokens.settings.inboxDeleted]: 'Boîte supprimée',
  [tokens.settings.inboxSaveError]: "Impossible d'enregistrer la boîte.",
  [tokens.settings.inboxDeleteError]: 'Impossible de supprimer la boîte.',
  [tokens.settings.inboxPrefixTaken]: 'Ce préfixe est déjà utilisé par une autre boîte.',
  [tokens.settings.inboxDeleteConfirm]: 'Supprimer la boîte {{address}} ? Les e-mails envoyés à cette adresse ne créeront plus de dossier.',

  [tokens.floatinglabelform.save]: 'Sauvegarder',
  [tokens.floatinglabelform.apply]: 'Appliquer',
  [tokens.floatinglabelform.text]: 'Texte',

  [tokens.viewer.doYouWantToDeleteTheTable]: 'Voulez-vous supprimer la table',
  [tokens.viewer.apply]: 'Appliquer',
  [tokens.viewer.adjustTheDocument]: 'Ajuster le document',
  [tokens.viewer.selectedLabel]: 'Label séléctioné',
  [tokens.viewer.selectADocument]: 'Choisir un document',
  [tokens.viewer.applyAModel]: 'Appliquer modèle',
  [tokens.viewer.newColumn]: 'Nouvelle colonne',
  [tokens.viewer.selectColumnTooltip]:
    'Cliquer pour sélectionner toute la colonne afin de la déplacer. Maj+clic sur une cellule : même action.',
  [tokens.viewer.selectColumnTooltipExcel]:
    'Cliquer pour sélectionner toute la colonne afin de la déplacer.',
  [tokens.viewer.invoice]: 'Facture',

  [tokens.classification.layers]: 'Modèles documents',
  [tokens.classification.manualLayer]: 'Manuel',
  [tokens.classification.searchClassificationType]:
    'Chercher un type de classification',
  [tokens.classification.outOf]: 'sur',
  [tokens.classification.validate]: 'Valider',
  [tokens.classification.unknownDocument]: 'document inconnu',
  [tokens.classification.unknownDocuments]: 'documents inconnus',
  [tokens.classification.addExtractionMode]: "Ajouter un modèle d'extraction",
  [tokens.classification.ignoreDocument]: 'Ignorer ce document',
  [tokens.classification.fieldRequired]: 'Ce champ est requis',
  [tokens.classification.includeDocument]: 'Inclure ce document',
  [tokens.classification.selectExtractionMode]: "Mode d'extraction",
  [tokens.classification.onlyInvoicesAllowed]:
    'Seules les factures ou les DAE sont acceptées',
  [tokens.classification.noLeadDocument]:
    'Au moins un "document principal" à exporter est attendu(e)',
  [tokens.classification.someDocumentsWithoutClassification]:
    "Certains documents n'ont pas de classification",
  [tokens.classification.hasNoExportConfiguration]:
    'Le type de déclaration est manquant',
  [tokens.classification.document]: '{{count}} document',
  [tokens.classification.document_other]: '{{count}} documents',
  [tokens.classification.page]: '{{count}} page',
  [tokens.classification.page_other]: '{{count}} pages',
  [tokens.classification.MT700]: 'MT 700',
  [tokens.classification.weight_note]: 'Note de poids',
  [tokens.classification.exchange_bill]: 'Lettre de change',
  [tokens.classification.origin_certif]: "Certificat d'origine",
  [tokens.classification.multimodal_doc]: 'Document de transport multimodal',
  [tokens.classification.flight_letter]: 'Lettre de transport aérien',
  [tokens.classification.sea_waybill]: 'Connaissement maritime',
  [tokens.classification.road_document]: 'Document de transport routier',
  [tokens.classification.delivery_note]: 'Bon de livraison',
  [tokens.classification.insurance_policy]: "Police d'assurance",
  [tokens.classification.bill_of_lading]: 'Connaissement',
  [tokens.classification.single_administrative_document]: 'DAU',
  [tokens.classification.commercial_invoice]: 'Facture commerciale',
  [tokens.classification.customs_instructions]: 'Instructions douanières',
  [tokens.classification.packing_list]: 'Liste de colisage',
  [tokens.classification.hscodes_list]: 'Positions tarifaires',
  [tokens.classification.t1]: 'Transit T1',
  [tokens.classification.t2]: 'Transit T2',
  [tokens.classification.t2l]: 'T2L / T2LF',
  [tokens.classification.ata]: 'Carnet ATA',
  [tokens.classification.bae]: 'Bon à enlever',
  [tokens.classification.invoice_summary]: 'Résumé de factures',
  [tokens.classification.electronic_accompanying_document]: 'DAE',
  [tokens.classification.EAD]: 'Export accompaning document',
  [tokens.classification.conversation]: 'Conversation',
  [tokens.classification.terms_and_conditions]: 'Conditions générales',
  [tokens.classification.model]: 'Modèle appliqué',
  [tokens.classification.setting_keys]: 'Setting keys appliquées',
  [tokens.classification.MT700_short]: 'MT700',
  [tokens.classification.weight_note_short]: 'Note de poids',
  [tokens.classification.exchange_bill_short]: 'Lettre de change',
  [tokens.classification.origin_certif_short]: 'CO',
  [tokens.classification.multimodal_doc_short]: 'DTM',
  [tokens.classification.flight_letter_short]: 'LTA',
  [tokens.classification.sea_waybill_short]: 'Connaissement',
  [tokens.classification.road_document_short]: 'DTR',
  [tokens.classification.delivery_note_short]: 'Bon de livraison',
  [tokens.classification.insurance_policy_short]: "Police d'assurance",
  [tokens.classification.bill_of_lading_short]: 'Connaissement',
  [tokens.classification.single_administrative_document_short]: 'DAU',
  [tokens.classification.commercial_invoice_short]: 'Facture',
  [tokens.classification.customs_instructions_short]: 'Instru. douanières',
  [tokens.classification.packing_list_short]: 'Colisage',
  [tokens.classification.hscodes_list_short]: 'HS Codes',
  [tokens.classification.t1_short]: 'T1',
  [tokens.classification.t2_short]: 'T2',
  [tokens.classification.t2l_short]: 'T2L',
  [tokens.classification.ata_short]: 'ATA',
  [tokens.classification.bae_short]: 'BAE',
  [tokens.classification.invoice_summary_short]: 'Résumé factures',
  [tokens.classification.electronic_accompanying_document_short]: 'DAE',
  [tokens.classification.EAD_short]: 'DAE',
  [tokens.classification.conversation_short]: 'Conversation',
  [tokens.classification.email_short]: 'Mail',

  [tokens.connector.addConnector]: 'Ajouter un connecteur',

  [tokens.filter.sortBy]: 'Ordonner par',
  [tokens.filter.searchOrganization]: 'Rechercher une organisation',
  [tokens.filter.searchUser]: 'Rechercher un utilisateur',
  [tokens.filter.searchLayer]: 'Rechercher un modèle de document',
  [tokens.filter.lastUpdateNewest]: 'Dernière mise à jour (+ récent)',
  [tokens.filter.lastUpdateOldest]: 'Dernière mise à jour (-récent)',

  [tokens.customerFlow.customer]: 'Client',
  [tokens.customerFlow.model]: 'Modèle',
  [tokens.customerFlow.documentType]: 'Type de document',
  [tokens.customerFlow.removeCustomerTitle]: 'Supprimer un client',
  [tokens.customerFlow.removeCustomerText]:
    'Êtes vous sûr? Cette action est irréversible.',
  [tokens.customerFlow.customerHasBeenDeleted]: 'Le client a été supprimé',
  [tokens.customerFlow.customerHasNotBeenDeleted]:
    "Le client n'a pas été supprimé",
  [tokens.customerFlow.removeModelTitle]: 'Supprimer un modèle',
  [tokens.customerFlow.removeModelText]:
    'Êtes vous sûr? Cette action est irréversible.',
  [tokens.customerFlow.modelHasBeenDeleted]: 'Le modèle a été supprimé',
  [tokens.customerFlow.modelHasNotBeenDeleted]:
    "Le modèle n'a pas été supprimé",
  [tokens.customerFlow.settingKeyDeleted]:
    'La clé de paramètre a été supprimée',
  [tokens.customerFlow.actionFailed]: "L'action a échoué",
  [tokens.customerFlow.settingKeyCreated]: 'La clé de paramètre a été créée',
  [tokens.customerFlow.settingKeyUpdated]:
    'La clé de paramètre a été mise à jour',
  [tokens.customerFlow.sender]: 'Expéditeur',
  [tokens.customerFlow.modelType]: 'Type de modèle',
  [tokens.customerFlow.informations]: 'Informations',
  [tokens.customerFlow.documentModels]: 'Modèles de document',
  [tokens.customerFlow.nameOfModel]: 'Nom du modèle',
  [tokens.customerFlow.issuesSettingsOptions]: 'Erreur au chargement des clées',
  [tokens.customerFlow.noModelAvailable]: 'Aucun modèle disponible',
  [tokens.customerFlow.unknownUser]: 'Inconnu',
  [tokens.customerFlow.areYouSureYouWantToDeleteThisModel]:
    'Etes-vous sûr de vouloir supprimer ce modèle ?',
  [tokens.customerFlow.deleteThisModel]: 'Supprimer ce modèle',
  [tokens.customerFlow.deleteModelSuccess]: 'Suppression du modèle réussie',
  [tokens.customerFlow.deleteModelFailed]:
    'Erreur lors de la suppression du modèle',
  [tokens.customerFlow.duplicateThisModel]: 'Dupliquer ce modèle',
  [tokens.customerFlow.duplicateModelTitle]: 'Dupliquer le modèle',
  [tokens.customerFlow.duplicateModelText]:
    'Une copie de « {{name}} » sera créée dans votre agence. Les partages ne seront pas copiés.',
  [tokens.customerFlow.duplicateModelNamePlaceholder]:
    'Laisser vide pour un nom automatique (ex. « {{name}} - (1) »)',
  [tokens.customerFlow.duplicateModelNameTooShort]:
    'Le nom doit contenir au moins 3 caractères',
  [tokens.customerFlow.duplicateModelConfirm]: 'Dupliquer',
  [tokens.customerFlow.duplicateModelSuccess]: 'Modèle dupliqué avec succès',
  [tokens.customerFlow.duplicateModelFailed]:
    'Erreur lors de la duplication du modèle',
  [tokens.customerFlow.bulkSelectedCount]: 'modèle sélectionné',
  [tokens.customerFlow.bulkSelectedCount_other]: 'modèles sélectionnés',
  [tokens.customerFlow.bulkDuplicate]: 'Dupliquer',
  [tokens.customerFlow.bulkDelete]: 'Supprimer',
  [tokens.customerFlow.modelsDuplicated]: '{{count}} modèle dupliqué',
  [tokens.customerFlow.modelsDuplicated_other]: '{{count}} modèles dupliqués',
  [tokens.customerFlow.modelsNotDuplicated]:
    'Erreur lors de la duplication du modèle',
  [tokens.customerFlow.modelsNotDuplicated_other]:
    'Erreur lors de la duplication des modèles',

  [tokens.customerFlow.customersPageTitle]: 'Organisations clients',
  [tokens.customerFlow.customersPageSubtitle]:
    "Liste centralisée des clients de toutes les agences. Filtrez pour voir les clients d'une agence en particulier.",
  [tokens.customerFlow.customersInfoPopoverTitle]: 'Que sont les clients ?',
  [tokens.customerFlow.customersInfoPopoverBody]:
    'Vos clients sont les organisations pour lesquelles vous réalisez des déclarations. Vous pouvez les rattacher à une agence pour cloisonner les accès et automatiser les flux.',
  [tokens.customerFlow.customersInfoHelpLink]:
    "En savoir plus dans le Centre d'aide",
  [tokens.customerFlow.customersSearchPlaceholder]: 'Rechercher un client…',
  [tokens.customerFlow.allAgencies]: 'Toutes les agences',
  [tokens.customerFlow.customersCount]: '{{count}} clients',
  [tokens.customerFlow.addCustomer]: 'Ajouter un client',
  [tokens.customerFlow.addModel]: 'Créer un modèle',
  [tokens.customerFlow.addModelAgency]: 'Agence',
  [tokens.customerFlow.addModelDeclarationType]: 'Type de déclaration',
  [tokens.customerFlow.addModelSubtitle]: 'Un modèle pré-remplit les champs choisis dès qu’on l’applique à un dossier.',
  [tokens.customerFlow.addModelIdentification]: 'Identification',
  [tokens.customerFlow.addModelName]: 'Nom du modèle',
  [tokens.customerFlow.addModelNamePlaceholder]: 'Ex. Export Delta E — Le Havre route',
  [tokens.customerFlow.addModelDeclarationTypeHint]: 'Fixe les champs que le modèle peut régler.',
  [tokens.customerFlow.addModelDeclarationTypePlaceholder]: 'Choisir un type',
  [tokens.customerFlow.addModelNoDeclarationType]: 'Aucun type de déclaration n’est configuré pour cette agence : choisissez-en une autre.',
  [tokens.customerFlow.addModelNoDeclarationTypePlaceholder]: 'Aucun type disponible',
  [tokens.customerFlow.addModelFields]: 'Champs du modèle',
  [tokens.customerFlow.addModelFieldsCount]: 'Champs du modèle · {{count}}',
  [tokens.customerFlow.addModelChooseTypeFirst]: 'Choisissez un type de déclaration pour ajouter des champs.',
  [tokens.customerFlow.addModelSchemaError]: 'Les champs de ce type de déclaration n’ont pas pu être chargés.',
  [tokens.customerFlow.addModelAddField]: 'Ajouter un champ : incoterm, bureau de douane, transport…',
  [tokens.customerFlow.addModelNoFieldFound]: 'Aucun champ trouvé',
  [tokens.customerFlow.addModelEmptyTitle]: 'Aucun champ pour l’instant',
  [tokens.customerFlow.addModelEmptyBody]: 'Ajoutez les champs que ce modèle doit pré-remplir. Les autres resteront à remplir dans le dossier.',
  [tokens.customerFlow.addModelRemoveField]: 'Retirer le champ {{name}}',
  [tokens.customerFlow.addModelRemoveRow]: 'Retirer la ligne {{index}}',
  [tokens.customerFlow.addModelAddRow]: 'Ajouter une ligne',
  [tokens.customerFlow.addModelFieldRequired]: 'Renseignez une valeur ou retirez le champ.',
  [tokens.customerFlow.addModelMissingName]: 'Donnez un nom au modèle.',
  [tokens.customerFlow.addModelMissingDeclarationType]: 'Choisissez un type de déclaration.',
  [tokens.customerFlow.addModelMissingField]: 'Ajoutez au moins un champ.',
  [tokens.customerFlow.addModelEmptyFields]: '{{count}} champ sans valeur : renseignez-le ou retirez-le.',
  [tokens.customerFlow.addModelEmptyFields_other]: '{{count}} champs sans valeur : renseignez-les ou retirez-les.',
  [tokens.customerFlow.addModelSubmit]: 'Créer le modèle',
  [tokens.customerFlow.columnName]: 'Nom',
  [tokens.customerFlow.columnAddress]: 'Adresse',
  [tokens.customerFlow.columnContact]: 'Contact',
  [tokens.customerFlow.columnAgency]: 'Agence',
  [tokens.customerFlow.columnCreatedAt]: 'Date de création',
  [tokens.customerFlow.viewCustomerDetail]: 'Voir le détail',
  [tokens.customerFlow.agencyRequired]: "L'agence est requise",
  [tokens.customerFlow.customerNameRequired]: 'Le nom est requis',
  [tokens.customerFlow.backToCustomers]: 'Retour aux clients',
  [tokens.customerFlow.backToModels]: 'Retour aux modèles',
  [tokens.customerFlow.flowDetailDeclarationLabel]:
    'Type de déclaration : {{type}}',
  [tokens.customerFlow.flowDetailConfigSectionTitle]: 'Configuration du modèle',
  [tokens.customerFlow.flowDetailConfigSectionSubtitle]:
    'Définissez les valeurs par défaut appliquées lors de l’utilisation de ce modèle.',
  [tokens.customerFlow.tabGeneral]: 'Général',
  [tokens.customerFlow.tabConfiguration]: 'Configuration',
  [tokens.customerFlow.tabReferentials]: 'Référentiels',
  [tokens.customerFlow.noReferentialsForClient]:
    'Aucun référentiel rattaché à ce client',
  [tokens.customerFlow.customerDetailAgencyLabel]: 'Agence : {{name}}',
  [tokens.customerFlow.customerDetailNoAgency]:
    'Aucune agence associée à ce client.',
  [tokens.customerFlow.customerDetailConfigInfoAlert]:
    "Toutes les configurations pour cette organisation client seront appliquées à chaque demande de déclaration faite pour l'organisation client.",
  [tokens.customerFlow.customerDetailConfigSectionTitle]:
    'Configuration du client',
  [tokens.customerFlow.customerDetailConfigSectionSubtitle]:
    "Valeurs héritées de la configuration de l'agence ou de l'organisation. Désactivez le toggle pour surcharger ; vous pouvez aussi ajouter des champs spécifiques à ce client.",
  [tokens.customerFlow.customerDetailConfigInheritanceTitle]:
    "Conserver la configuration de l'agence",
  [tokens.customerFlow.customerDetailConfigInheritanceDescription]:
    "Ce client utilise les valeurs définies au niveau de l'agence ou de l'organisation. Désactivez pour définir des valeurs spécifiques à ce client.",
  [tokens.customerFlow.configSourceClient]: 'Client',
  [tokens.customerFlow.configSourceAgency]: 'Agence',
  [tokens.customerFlow.configSourceOrganization]: 'Organisation',

  [tokens.referentials.pageTitle]: 'Référentiels',
  [tokens.referentials.pageSubtitle]:
    "Une base de données métier persistante d'où partent la consultation, la mise à jour et les automatisations de vos déclarations.",
  [tokens.referentials.detailPageTitle]: 'Référentiel',
  [tokens.referentials.searchPlaceholder]: 'Rechercher un référentiel…',
  [tokens.referentials.allClients]: 'Tous les clients',
  [tokens.referentials.independentOnly]: 'Indépendants',
  [tokens.referentials.allStatuses]: 'Tous les statuts',
  [tokens.referentials.activeOnly]: 'Actifs',
  [tokens.referentials.inactiveOnly]: 'Inactifs',
  [tokens.referentials.resultsCount]: '{{count}} référentiel',
  [tokens.referentials.resultsCount_other]: '{{count}} référentiels',
  [tokens.referentials.newReferential]: 'Nouveau référentiel',
  [tokens.referentials.createModalTitle]: 'Nouveau référentiel',
  [tokens.referentials.createModalDescription]:
    'Importez un fichier pour démarrer, ou créez une base vide à remplir ensuite.',
  [tokens.referentials.fieldNameLabel]: 'Nom du référentiel',
  [tokens.referentials.fieldNamePlaceholder]:
    'Ex. Holdtrans, articles textile',
  [tokens.referentials.fieldDescriptionPlaceholder]:
    'À quoi sert ce référentiel ? (facultatif)',
  [tokens.referentials.fieldDataFileLabel]: 'Fichier de données',
  [tokens.referentials.uploadZoneTitle]:
    'Glissez un fichier ici, ou cliquez pour parcourir',
  [tokens.referentials.uploadZoneFormats]: '.xlsx · .xls · .csv · 20 Mo max',
  [tokens.referentials.fieldClientLabel]: 'Lier à un client',
  [tokens.referentials.clientIndependentOption]:
    'Indépendant (aucun client)',
  [tokens.referentials.fieldAgencyLabel]: 'Agence',
  [tokens.referentials.fieldAgencyTooltip]:
    "Rattachez à une agence afin d'associer les automatisations associées à ce référentiel à l'agence choisie.",
  [tokens.referentials.fieldConfigurationLabel]: 'Configuration',
  [tokens.referentials.fieldConfigurationTooltip]:
    'Servira de condition de matching pour les automatisations.',
  [tokens.referentials.fieldDataFileTooltip]:
    "Importez votre référentiel au format .xlsx, .xls et .csv. La 1ʳᵉ ligne de votre tableau correspondant à vos en-têtes de colonnes, lignes suivantes seront considérées comme vos données. Toutes les lignes seront prises en compte. Vous pourrez néanmoins les éditer manuellement ou mettre à jour l'ensemble de votre référentiel.",
  [tokens.referentials.fieldClientTooltip]:
    'Rattachez votre référentiel à un client.',
  [tokens.referentials.createReferentialButton]: 'Créer le référentiel',
  [tokens.referentials.createEmptyBaseLink]: 'Créer une base vide sans fichier',
  [tokens.referentials.emptyBaseSelected]: 'Base vide sélectionnée',
  [tokens.referentials.fileTooLarge]:
    'Le fichier dépasse la taille maximale de 20 Mo',
  [tokens.referentials.invalidFileType]:
    'Format non pris en charge. Utilisez .xlsx, .xls ou .csv',
  [tokens.referentials.columnReferential]: 'Référentiel',
  [tokens.referentials.columnDescription]: 'Description',
  [tokens.referentials.columnClient]: 'Client',
  [tokens.referentials.columnRows]: 'Lignes',
  [tokens.referentials.columnAutomations]: 'Autos',
  [tokens.referentials.columnUpdatedAt]: 'Mis à jour',
  [tokens.referentials.attachedToClient]: 'Rattaché client',
  [tokens.referentials.independent]: 'Indépendant',
  [tokens.referentials.noReferentialsFound]: 'Aucun référentiel trouvé',
  [tokens.referentials.referentialCreated]: 'Référentiel créé avec succès',
  [tokens.referentials.errorCreatingReferential]:
    'Erreur lors de la création du référentiel',
  [tokens.referentials.importFile]: 'Importer un fichier',
  [tokens.referentials.emptyBase]: 'Base vide',
  [tokens.referentials.nameRequired]: 'Le nom est requis',
  [tokens.referentials.configurationRequired]: 'La configuration est requise',
  [tokens.referentials.agencyRequired]: "L'agence est requise",
  [tokens.referentials.importOrEmptyRequired]:
    'Importez un fichier ou choisissez une base vide',
  [tokens.referentials.automationsTooltip]:
    '{{conditions}} condition(s) · {{actions}} action(s)',
  [tokens.referentials.automationsTooltipCondition]:
    'Condition · colonne {{column}}',
  [tokens.referentials.automationsTooltipAction]: 'Action · colonne {{column}}',
  [tokens.referentials.columnsTooltipTitle]:
    '{{count}} colonnes du référentiel',
  [tokens.referentials.automationsTooltipTitle]: '{{count}} automatisation(s)',
  [tokens.referentials.automationReplacesLabel]: 'Remplace : {{fields}}',
  [tokens.referentials.backToList]: 'Retour à la liste',
  [tokens.referentials.detailComingSoon]:
    'La vue détail éditable arrive dans la prochaine étape.',
  [tokens.referentials.conditionsCount]: 'conditions',
  [tokens.referentials.actionsCount]: 'actions',
  [tokens.referentials.rowsUnknown]: '—',
  [tokens.referentials.rowsLoaded]: '{{count}} lignes chargées',
  [tokens.referentials.openReferential]: 'Ouvrir',
  [tokens.referentials.deleteReferential]: 'Supprimer',
  [tokens.referentials.deleteReferentialConfirm]:
    'Supprimer le référentiel « {{name}} » ?',
  [tokens.referentials.referentialDeleted]: 'Référentiel supprimé',
  [tokens.referentials.errorDeletingReferential]:
    'Erreur lors de la suppression du référentiel',
  [tokens.referentials.backToAllReferentials]: 'Tous les référentiels',
  [tokens.referentials.refresh]: 'Actualiser',
  [tokens.referentials.exportXlsx]: 'Exporter (.xlsx)',
  [tokens.referentials.rowsCount]: '{{count}} lignes',
  [tokens.referentials.columnsCount]: '{{count}} colonnes',
  [tokens.referentials.lastUpdatedLabel]: 'Mis à jour le {{date}}',
  [tokens.referentials.editName]: 'Modifier le nom',
  [tokens.referentials.editDescription]: 'Modifier la description',
  [tokens.referentials.addDescription]: 'Ajouter une description',
  [tokens.referentials.searchRowsPlaceholder]: 'Rechercher un article…',
  [tokens.referentials.cellsFilledPercent]:
    '{{percent}} % de cellules remplies',
  [tokens.referentials.emptyCell]: 'vide',
  [tokens.referentials.emptyGridMessage]:
    'Ce référentiel ne contient pas encore de données.',
  [tokens.referentials.noAutomationYet]: 'Aucune automatisation configurée',
  [tokens.referentials.toggleActive]: 'Activer ou désactiver le référentiel',
  [tokens.referentials.referentialUpdated]: 'Référentiel mis à jour',
  [tokens.referentials.errorUpdatingReferential]:
    'Erreur lors de la mise à jour du référentiel',
  [tokens.referentials.errorExportingReferential]:
    "Erreur lors de l'export du référentiel",
  [tokens.referentials.columnUpdatedAt]: 'Mis à jour',
  [tokens.referentials.addRow]: 'Ajouter une ligne',
  [tokens.referentials.gridFooterHint]:
    "Cliquez une cellule pour l'éditer • cochez une ligne pour la dupliquer, l'insérer ou la supprimer • « + » à droite pour ajouter une colonne",
  [tokens.referentials.rowActions]: 'Actions',
  [tokens.referentials.selectedRowsCount]: '{{count}} ligne(s) sélectionnée(s)',
  [tokens.referentials.duplicateRow]: 'Dupliquer la ligne',
  [tokens.referentials.insertRowBelow]: 'Insérer une ligne en dessous',
  [tokens.referentials.insertRowAbove]: 'Insérer une ligne au-dessus',
  [tokens.referentials.deleteRow]: 'Supprimer la ligne',
  [tokens.referentials.clearRowSelection]: 'Désélectionner les lignes',
  [tokens.referentials.gridSaving]: 'Enregistrement…',
  [tokens.referentials.gridSaved]: 'Modifications enregistrées',
  [tokens.referentials.gridSaveError]: "Erreur lors de l'enregistrement",
  [tokens.referentials.gridMissingTitle]:
    'Le contenu du référentiel « {{name}} » est introuvable',
  [tokens.referentials.gridMissingDescription]:
    "Son fichier de données est absent : ce référentiel ne peut pas s'ouvrir. Supprimez-le depuis la liste, puis recréez-le à partir de votre fichier.",
  [tokens.referentials.columnLinkSaved]: 'Lien colonne enregistré',
  [tokens.referentials.columnLinkSaveError]:
    "Erreur lors de l'enregistrement du lien",
  [tokens.referentials.columnNameLabel]: 'Nom de la colonne',
  [tokens.referentials.columnLinkLabel]: 'Rattacher à une donnée',
  [tokens.referentials.columnLinkPlaceholder]: 'Choisir un champ…',
  [tokens.referentials.columnLinkNoResults]: 'Aucun champ trouvé',
  [tokens.referentials.columnLinkHelper]:
    'Les valeurs de cette colonne alimenteront le champ choisi lors des automatisations.',
  [tokens.referentials.removeColumn]: 'Retirer la colonne',
  [tokens.referentials.addColumn]: 'Ajouter une colonne',
  [tokens.referentials.addCardinalColumn]: 'Colonnes cardinales',
  [tokens.referentials.addCustomColumn]: 'Colonne personnalisée',
  [tokens.referentials.customColumnOption]: 'Nouvelle colonne libre',
  [tokens.referentials.allCardinalColumnsUsed]:
    'Toutes les colonnes cardinales sont utilisées',
  [tokens.referentials.cardinalColumnBadge]: 'Colonne cardinale',
  [tokens.referentials.untitledColumn]: 'Sans titre',
  [tokens.referentials.automationConditionsTitle]: 'Conditions de matching',
  [tokens.referentials.automationActionsTitle]: 'Actions sur la déclaration',
  [tokens.referentials.automationAddCondition]: '+ Ajouter une condition',
  [tokens.referentials.automationAddAction]: '+ Ajouter une action',
  [tokens.referentials.automationConditionsHelper]:
    "Les conditions sont évaluées dans l'ordre. L'enrichissement n'est appliqué que si toutes les conditions sont satisfaites.",
  [tokens.referentials.automationDeclarationColumnPlaceholder]:
    'Colonne déclaration',
  [tokens.referentials.automationReferentialColumnPlaceholder]:
    'Colonne référentiel',
  [tokens.referentials.automationRelationPlaceholder]: 'Relation',
  [tokens.referentials.automationRelationEq]: 'égal à',
  [tokens.referentials.automationRelationLt]: 'inférieur à',
  [tokens.referentials.automationRelationGt]: 'supérieur à',
  [tokens.referentials.automationRelationIncludes]: 'Inclut',
  [tokens.referentials.automationActionReplace]: 'Remplacer',
  [tokens.referentials.automationActionFillIfEmpty]: 'Remplir si vide',
  [tokens.referentials.automationRemoveCondition]: 'Supprimer la condition',
  [tokens.referentials.automationRemoveAction]: "Supprimer l'action",
  [tokens.referentials.automationSave]: 'Sauvegarder',
  [tokens.referentials.automationSaved]: 'Automatisation enregistrée',
  [tokens.referentials.automationSaveError]:
    "Erreur lors de l'enregistrement de l'automatisation",
  [tokens.referentials.deleteAutomation]: 'Supprimer',
  [tokens.referentials.deleteAutomationConfirm]:
    "Supprimer l'automatisation de ce référentiel ? Les conditions et actions seront effacées.",
  [tokens.referentials.automationDeleted]: 'Automatisation supprimée',
  [tokens.referentials.automationDeleteError]:
    "Erreur lors de la suppression de l'automatisation",
  [tokens.referentials.automationCreateSimplified]:
    '+ Créer une automatisation simplifiée',
  [tokens.referentials.automationAutoRunLabel]: 'Activer automatiquement',
  [tokens.referentials.automationAutoRunTooltip]:
    "Lancer l'automatisation dès la création d'une déclaration",
  [tokens.referentials.automationActiveLabel]: 'Disponible',
  [tokens.referentials.automationInactiveLabel]: 'Indisponible',
  [tokens.referentials.toggleAutomationAvailable]:
    "Rendre l'automatisation disponible ou indisponible sur les déclarations",
  [tokens.referentials.importModalTitle]: 'Mettre à jour par import',
  [tokens.referentials.importModalSubtitle]:
    'Importez un fichier Excel ou CSV pour actualiser ce référentiel.',
  [tokens.referentials.importClickOrDrag]: 'Cliquez ou glissez un fichier',
  [tokens.referentials.importModeComplete]: "Compléter l'existant",
  [tokens.referentials.importModeCompleteDesc]:
    "Ajoute au référentiel les nouvelles lignes sans toucher à l'existant.",
  [tokens.referentials.importModeReplace]: 'Remplacer tout',
  [tokens.referentials.importModeReplaceDesc]:
    'Vide le référentiel puis importe le fichier.',
  [tokens.referentials.importNext]: 'Suivant',
  [tokens.referentials.importBack]: 'Retour',
  [tokens.referentials.importConfirm]: 'Importer',
  [tokens.referentials.importDuplicateTitle]: 'Comment traiter les doublons ?',
  [tokens.referentials.importDuplicateHelper]:
    "Lorsqu'une ligne importée correspond à une ligne existante (même {{column}}).",
  [tokens.referentials.importDuplicateOverwrite]: 'Écraser les doublons',
  [tokens.referentials.importDuplicateOverwriteDesc]:
    'La ligne existante est remplacée par celle du fichier.',
  [tokens.referentials.importDuplicateIgnore]: 'Ignorer les doublons',
  [tokens.referentials.importDuplicateIgnoreDesc]:
    'La ligne existante est conservée, celle du fichier est ignorée.',
  [tokens.referentials.importDuplicateKeepBoth]: 'Conserver les deux',
  [tokens.referentials.importDuplicateKeepBothDesc]:
    'La ligne importée est ajoutée comme nouvelle entrée.',
  [tokens.referentials.importColumnMappingTitle]: 'Correspondance des colonnes',
  [tokens.referentials.importDuplicateKeyLabel]:
    'Identifier les doublons par la colonne :',
  [tokens.referentials.importFileSummary]:
    '{{rows}} lignes · {{columns}} colonnes détectées',
  [tokens.referentials.importEmptyFile]:
    'Le fichier ne contient aucune ligne de données.',
  [tokens.referentials.importInvalidFile]: 'Impossible de lire ce fichier.',
  [tokens.referentials.importSuccessTitle]: 'Importation réussie',
  [tokens.referentials.importSuccessSummary]:
    '{{count}} lignes ont été traitées avec succès.',
  [tokens.referentials.importStatsCreated]: '{{count}} lignes créées',
  [tokens.referentials.importStatsUpdated]: '{{count}} lignes mises à jour',
  [tokens.referentials.importStatsIgnored]: '{{count}} doublons ignorés',
  [tokens.referentials.importStatsKeptBoth]: '{{count}} doublons conservés',
  [tokens.referentials.importError]: "Erreur lors de l'import",
  [tokens.referentials.updateByImport]: 'Mettre à jour par import',
  [tokens.referentials.importSkipColumn]: 'Ignorer',

  [tokens.customer.addNew]: 'Ajouter un nouveau client',
  [tokens.customer.address]: 'Adresse',
  [tokens.customer.addressRequired]: "L'adresse est requise",
  [tokens.customer.basicInformation]: 'Informations de base',
  [tokens.customer.corporateName]: 'Raison sociale',
  [tokens.customer.corporateNameRequired]: 'La raison sociale est requise',
  [tokens.customer.city]: 'Ville',
  [tokens.customer.cityRequired]: 'La ville est requise',
  [tokens.customer.country]: 'Pays',
  [tokens.customer.countryRequired]: 'Le pays est requis',
  [tokens.customer.eoriNumber]: 'Numéro EORI',
  [tokens.customer.eoriNumberRequired]: 'Le numéro EORI est requis',
  [tokens.customer.identifiers]: 'Identifiants',
  [tokens.customer.postalCode]: 'Code postal',
  [tokens.customer.postalCodeRequired]: 'Le code postal est requis',
  [tokens.customer.rexNumber]: 'Numéro REX',
  [tokens.customer.rexNumberRequired]: 'Le numéro REX est requis',
  [tokens.customer.siretNumber]: 'Numéro SIRET',
  [tokens.customer.siretNumberRequired]: 'Le numéro SIRET est requis',
  [tokens.customer.societyType]: 'Type de société',
  [tokens.customer.societyTypeRequired]: 'Le type de société est requis',
  [tokens.customer.vatNumber]: 'Numéro TVA',
  [tokens.customer.vatNumberRequired]: 'Le numéro TVA est requis',
  [tokens.customer.otherSettings]: 'Autres paramètres',
  [tokens.customer.settingValueRequired]: 'Une valeur est requise',

  [tokens.managementConsole.managementConsole]: "Console d'administration",
  [tokens.managementConsole.allowedsenders]: 'Expéditeurs authorisés',
  [tokens.managementConsole.declarationType]: 'Type de déclaration',
  [tokens.managementConsole.userRequired]: 'Utilisateur requis',
  [tokens.managementConsole.settings]: 'Paramètres',
  [tokens.managementConsole.emailAutomation]: 'Automatisations e-mail',
  [tokens.managementConsole.allowedsenders]: 'Expéditeurs authorisés',
  [tokens.managementConsole.declarationType]: 'Type de déclaration',
  [tokens.managementConsole.targetUser]: 'Utilisateur cible',
  [tokens.managementConsole.emailAutomationTargetUser]:
    "Utilisateur cible pour l'automatisation",
  [tokens.managementConsole.emailAutomationIntelligentPreparation]:
    'Préparation intelligente',
  [tokens.managementConsole.emailAutomationIntelligentPreparationDescription]:
    'Les dossiers reçus sur cette adresse sont préparés par Nabu AI.',
  [tokens.managementConsole.areYouSureYouWantToDeleteThisAuthorizedSender]:
    'Etes-vous sûr de vouloir supprimer cet expéditeurs authorisé',
  [tokens.managementConsole.areYouSureYouWantToDeleteThisEmailAutomation]:
    'Etes-vous sûr de vouloir supprimer cette automatisation e-mail',
  [tokens.managementConsole.areYouSureYouWantToDeleteThisClientOrganization]:
    'Etes-vous sûr de vouloir supprimer cette Organisation client',
  [tokens.managementConsole.clientOrganizationsIntro]:
    'Les organisations clients vous permettent d’ajouter des automatisations pour toute déclaration associée à un client. Par exemple, vous pouvez ajouter un flux de travail ou préremplir des valeurs pour un client particulier.',
  [tokens.managementConsole.emailPrefixRequired]:
    "Préfix pour l'adresse mail requis",
  [tokens.managementConsole.allowedSenderEmailRemoveSuccess]:
    'Expéditeur authorisé a été supprimé',
  [tokens.managementConsole.allowedSenderEmailRemoveFailed]:
    "Erreur lors de la suppression de l'expéditeur authorisé",
  [tokens.managementConsole
    .theFollowingConfigurationWillBeAutomaticallyAppliedToAnyDeclarationRequestReceivedAt]:
    "Les configurations suivantes seront appliquées automatiquement à toute demande de déclaration reçue à l'adresse",
  [tokens.managementConsole
    .whitelistingAnEmailAddressAuthorizedThatEmailAccountToRequestDeclarationsOnBehalfOfYourGroup]:
    'L’ajout d’une adresse e-mail aux expéditeurs autorisés permet à ce compte e-mail de demander des déclarations au nom de votre agence.',
  [tokens.managementConsole.createEmailAutomation]:
    'Créer une automatisation e-mail',
  [tokens.managementConsole.emailAutomationUpdatedSuccessfully]:
    "Mise à jour de l'automatisation réussie",
  [tokens.managementConsole.apiManagement]: 'Gestion API',
  [tokens.managementConsole.unrecognizedFormat]: 'Format non-reconnu',
  [tokens.managementConsole.invalidKey]: 'Clé non valide',
  [tokens.managementConsole.apiKeyId]: 'ID du clé',
  [tokens.managementConsole.publicKeyRequired]: 'Clé publique requis',
  [tokens.managementConsole.apiKeyName]: 'Nom du clé',
  [tokens.managementConsole.apiKeyFingerprint]: 'Fingerprint du clé',
  [tokens.managementConsole.apiKeyCreated]: 'Clé API créé',
  [tokens.managementConsole.apiManagementIntro]:
    'Les clés API vous permettent d’envoyer des requêtes à notre API de manière sécurisée. Grâce à cette API, vous pouvez créer des déclarations et d’autres documents, consulter les données de configuration de votre agence, et effectuer d’autres opérations sans aucune interaction utilisateur. Consultez la <docsLink>documentation de l’API</docsLink> pour plus d’informations.',
  [tokens.managementConsole.keyDetected]: 'Clé detecté',
  [tokens.managementConsole.apiKeyNameRequired]: 'Nom du clé requis',
  [tokens.managementConsole.noApiKeysFound]: 'Aucun clé API trouvé',
  [tokens.managementConsole.createApiKey]: 'Créer un clé API',
  [tokens.managementConsole.createApiKeyFor]: 'Créer un clé API pour',
  [tokens.managementConsole.errorCreatingApiKey]:
    'Erreur lors de la création du clé API',
  [tokens.managementConsole.apiKeyPublicKey]: 'Clé publique',
  [tokens.managementConsole.creatingAnApiKey]:
    "Créer un clé API permet à votre infrastructure IT d'accéder directement à l'API de Nabu",
  [tokens.managementConsole.errorUpdatingEmailAutomation]:
    "Erreur lors de la mise à jour de l'automatisation",
  [tokens.managementConsole.emailAutomationRemoveSuccess]:
    "L'automatisation a été supprimée",
  [tokens.managementConsole.emailAutomationRemoveFailed]:
    "Erreur lors de la suppression de l'automatisation",
  [tokens.managementConsole.clientOrganizationRemoveSuccess]:
    "L'Organisation client a été supprimée",
  [tokens.managementConsole.clientOrganizationRemoveFailed]:
    "Erreur lors de la suppression de l'organisation client",
  [tokens.managementConsole.emailAutomationDestinationAddress]:
    "Adresse e-mail de l'automatisation",
  [tokens.managementConsole.createEmailAutomationFor]:
    'Créer une automatisation e-mail pour',
  [tokens.managementConsole.allowedSenderEmailAddress]:
    'Adresse mail expéditeur authorisé',
  [tokens.managementConsole.createAllowedSenderFor]:
    'Créer expéditeur authorisé pour',
  [tokens.managementConsole.createAllowedSender]: 'Créer expéditeur authorisé',
  [tokens.managementConsole.noAllowedSenderEmailAddressesFound]:
    'Aucun expéditeur authorisé trouvé',
  [tokens.managementConsole.noEmailAutomationsFound]:
    'Aucune automatisation e-mail trouvée',
  [tokens.managementConsole.emailAutomationAddress]:
    "Adresse destinataire de l'automatisation",
  [tokens.managementConsole.emailAutomationsIntro]:
    'Les automatisations via mail vous permettent de configurer l’attribution des données en fonction de l’adresse mail à laquelle une demande de déclaration est envoyée. Par exemple, l’envoi d’une demande de déclaration à l’adresse "mon-automatisation@email-api.nabu.io" peut appliquer automatiquement un workflow, associer la déclaration à un client ou définir le type de déclaration. Seuls les comptes expéditeurs figurant dans la liste « autorisée » des adresses e-mail sont habilités à envoyer des demandes de déclaration de cette manière.',
  [tokens.managementConsole.anyClientOrganizationSettingKeysWillBeApplied]:
    "Toutes les configurations pour cette Organisation Client seront appliquées à chaque demande de déclaration faite pour l'Organisation Client",
  [tokens.managementConsole.anyGroupSettingKeysWillBeApplied]:
    'Toutes les configurations pour cette agence seront appliquées à chaque demande de déclaration faite par cette agence',
  [tokens.managementConsole.noClientOrganizationsFound]:
    'Aucun organisation client trouvée',
  [tokens.managementConsole.clientOrganizations]: 'Organisations clients',
  [tokens.managementConsole.clientOrganization]: 'Organisation client',
  [tokens.managementConsole.clientOrganizationNotes]:
    'Note pour une Organisation client',
  [tokens.managementConsole.createClientOrganization]:
    'Créer une Organisation client',
  [tokens.managementConsole.createClientOrganizationFor]:
    'Créer une Organisation client pour',
  [tokens.managementConsole.clientOrganizationCreated]:
    'Client organization créée',
  [tokens.managementConsole.errorCreatingClientOrganization]:
    "Erreur lors de la création de l'Organisation Client",
  [tokens.managementConsole.clientOrganizationName]:
    "Nom de l'organisation client",
  [tokens.managementConsole.establishmentsAndGroups]: 'Etablissement & Agences',
  [tokens.managementConsole.metrics]: 'Suivi de performance',
  [tokens.managementConsole.member_one]: 'Membre',
  [tokens.managementConsole.member_other]: 'Membres',
  [tokens.managementConsole.members]: 'Membres',
  [tokens.managementConsole.general]: 'Général',
  [tokens.managementConsole.organizationSettings]: 'Paramètres',
  [tokens.managementConsole
    .creatingAClientOrganizationAllowsYouToAutomateActionsWhenRequestsForTheClientOrganizationAreReceived]:
    "Créer une Organisation Client vous permet de déclencher certaines automatisations lors de la réception d'une demande pour l'organisation client.",
  [tokens.managementConsole.clientOrganizationsAssociatedToTheGroup]:
    "Organisations clients associées à l'agence",
  //General section
  [tokens.managementConsole.companyInformation]: 'Information entreprise',
  [tokens.managementConsole.companyNameRequired]: 'Raison sociale requise',
  [tokens.managementConsole.registrationNumberRequired]: 'Numéro siret requis',
  [tokens.managementConsole.registrationNumberWarning]:
    "Le numéro d'enregistrement doit avoir au moins 6 chiffres",
  [tokens.managementConsole.registrationCountryRequired]: 'pays requis',
  [tokens.managementConsole.registrationCountryWarning]:
    'Le pays doit avoir exactement 3 lettres',
  [tokens.managementConsole.darkMode]: 'Mode sombre',
  [tokens.managementConsole.organizationUpdated]: 'Organisation mise à jour',
  [tokens.managementConsole.warningToSaveTitle]:
    'Voulez-vous enregistrer vos modifications ?',
  [tokens.managementConsole.warningToSaveConfirmButtonText]: 'Enregistrer',
  [tokens.managementConsole.warningToSaveCancelButtonText]:
    'Quitter sans enregistrer',
  //OrganizationSettings section
  [tokens.managementConsole.organizationSettingsUpdated]:
    "Paramètres de l'organisation mis à jour",
  [tokens.managementConsole
    .declarationsCreatedUsingThisEmailAutomationWillBeOwnedByTheTargetUser]:
    "Les déclarations créées avec cette automatisation seront attribuées par défaut à l'utilisateur cible",
  [tokens.managementConsole.issuesSettingsOptions]:
    'Erreur au chargement des clées',
  [tokens.managementConsole.generalSettings]: 'Paramètres généraux',
  [tokens.managementConsole.customsPreFilling]:
    'Pré-remplissage déclarations douanières',
  [tokens.managementConsole.lockedFieldTooltip]:
    'Information non modifiable par vos équipes',
  [tokens.managementConsole.unlockedFieldTooltip]:
    'Information modifiable par vos équipes',
  [tokens.managementConsole.inheritedFieldTooltip]:
    "Information héritée de l'agence",
  [tokens.managementConsole.establishmentAndGroup]: 'Etablissement et agence',
  [tokens.managementConsole.administrator]: 'Administrateur',
  //Establishment
  [tokens.managementConsole.establishment]: 'Établissement',
  [tokens.managementConsole.errorUpdatingSettings]:
    "Erreur à l'enregistrement des paramètres",
  [tokens.managementConsole.resetSettings]:
    'Les paramètres ont été réinitialisés',
  [tokens.managementConsole.settingsHasBeenUpdated]: 'Paramètres mis à jour',
  [tokens.managementConsole.impossibleToLockEmptyField]:
    'Impossible de bloquer un champ vide',
  [tokens.managementConsole.settingOfGroup]: "Paramètre de l'agence",
  [tokens.managementConsole.invalidEmailPrefix]: 'Préfixe email invalide',
  [tokens.managementConsole.mailhookCreated]: 'Mailhook créé',
  [tokens.managementConsole.mailhookDeleted]: 'Mailhook supprimé',
  [tokens.managementConsole.errorCreatingMailhook]:
    'Erreur lors de la création du mailhook',
  [tokens.managementConsole.errorDeletingMailhook]:
    'Erreur lors de la suppression du mailhook',
  [tokens.managementConsole.addMailhook]: 'Ajouter un mailhook',
  [tokens.managementConsole.emailPrefix]: 'Préfixe email',
  [tokens.managementConsole.noTargetPrefixesFound]: 'Aucun prefix cible trouvé',
  [tokens.managementConsole.targetPrefixes]: 'Prefix cibles',
  [tokens.managementConsole.invalidEmail]: 'Préfixe email invalide',
  [tokens.managementConsole.emailWhitelisted]: 'Mailhook créé',
  [tokens.managementConsole.emailRemoved]: 'Mailhook supprimé',
  [tokens.managementConsole.mailhookWhitelist]: 'Emails autorisés',
  [tokens.managementConsole.errorWhitelistingEmail]:
    'Erreur lors de la création du mailhook',
  [tokens.managementConsole.errorRemovingEmail]:
    'Erreur lors de la suppression du mailhook',
  [tokens.managementConsole.addEmail]: 'Ajouter un email à la whitelist',
  [tokens.managementConsole.noClient]: 'Aucun client trouvé?',
  [tokens.managementConsole.createClient]: 'Créer un client',
  [tokens.managementConsole.tableAutomation]: 'Automatisations tableaux',
  [tokens.managementConsole.tableAutomations]: 'Automatisations tableaux',
  [tokens.managementConsole.tableAutomationsIntro]:
    "Les automatisations tableau permettent de configurer l'attribution de données au niveau des lignes à partir d'informations fournies à l'avance. Par exemple, vous pouvez télécharger des tableaux Excel faisant correspondre des nomenclatures incomplets à des nomenclatures complets, indiquer des instructions pour renseigner les informations relatives au double usage, ou encore spécifier les measure components pour des nomenclatures particuliers.",
  [tokens.managementConsole.tableAutomationsRequiresNewSchema]:
    'Disponible uniquement pour les configurations utilisant le nouveau schéma de déclaration.',
  [tokens.managementConsole.tableAutomationsNewSchemaOnlyAlert]:
    "Les automatisations de tableaux ne sont pas compatibles avec les anciennes configurations. Seules les configurations utilisant le nouveau schéma de déclaration peuvent être utilisées.",
  [tokens.managementConsole.tableAutomationsEligibleConfigsOnly]:
    'Seules les configurations compatibles avec le nouveau schéma de déclaration sont proposées.',
  [tokens.managementConsole.createTableAutomationGroup]:
    "Créer un groupe d'automatisation",
  [tokens.managementConsole.sourceName]: 'Titre',
  [tokens.managementConsole.sourceType]: 'Type',
  [tokens.managementConsole
    .creatingATableAutomationGroupAllowsYouToAutomateComplexLineLevelTableDataEntry]:
    "Créer un groupe d'automatisation de tableau vous permet d'automatiser la saisie complexe de données au niveau des lignes d'un tableau.",
  [tokens.managementConsole.onlyExcelFilesAreAccepted]:
    'Uniquement des fichiers Excel avec extension .xlsx sont acceptés',
  [tokens.managementConsole.dropText]: 'Déposez un fichier Excel ici',
  [tokens.managementConsole.dropSubtext]:
    'Déposez un fichier Excel pour visualiser les contenus',
  [tokens.managementConsole.noTableAutomationGroupsFound]:
    "Aucun groupe d'automatisation de tableau trouvé",
  [tokens.managementConsole.tableAutomationGroupName]:
    "Nom du groupe d'automatisation de tableau",
  [tokens.managementConsole.tableAutomationGroupNameRequired]:
    "Nom du groupe d'automatisation de tableau requis",
  [tokens.managementConsole.enterAName]: 'Entrez un nom',
  [tokens.managementConsole.selectedConfiguration]: 'Configuration choisie',
  [tokens.managementConsole.templateRequired]: 'Template requis',
  [tokens.managementConsole.selectATemplate]: 'Choisir un template',
  [tokens.managementConsole.configuration]: 'Configuration',
  [tokens.managementConsole.fileToUpload]: 'Fichier à télécharger',
  [tokens.managementConsole.tableAutomationGroupParameters]:
    "Paramètres du groupe d'automatisation",
  [tokens.managementConsole.ruleBuilder]: 'Moteur de création de règles',
  [tokens.managementConsole.rule]: 'Regle',
  [tokens.managementConsole.lineProperty]: 'Propriété',
  [tokens.managementConsole.column]: 'Colonne',
  [tokens.managementConsole.addCondition]: 'Ajouter une condition',
  [tokens.managementConsole.IS]: 'EST',
  [tokens.managementConsole.IF]: 'SI',
  [tokens.managementConsole.THEN]: 'ALORS',
  [tokens.managementConsole.setReferenceRows]:
    'Sélectionner les lignes de référence',
  [tokens.managementConsole.removeAllRows]: 'Supprimer toutes les lignes',
  [tokens.managementConsole.removeSelectedRows]:
    'Supprimer toutes les lignes sélectionnés',
  [tokens.managementConsole.addToPayload]: 'Ajouter au payload',
  [tokens.managementConsole.payload]: 'Payload',
  [tokens.managementConsole.relations]: 'Rélations',
  [tokens.managementConsole.ifTheFollowingConditionsAreTrue]:
    'Si les conditions suivantes sont satisfaites',
  [tokens.managementConsole.thenTheFollowingValuesWillBeApplied]:
    'puis les valeurs suivantes seront appliquées',
  [tokens.managementConsole.validateRules]: 'Valider les règles',
  [tokens.managementConsole.createTheAutomationGroup]:
    "Créer le groupe d'automatisation",
  [tokens.managementConsole.automationGroupRules]:
    "Règles du groupe d'automatisation",
  [tokens.managementConsole.areYouSureYouWantToDeleteTheTableAutomationGroup]:
    'Etes-vous sûr de vouloir supprimer le groupe d\'automatisation "{{ name }}"',
  [tokens.managementConsole.tableAutomationGroupRemoveSuccess]:
    "Le groupe d'automatisation a été supprimé",
  [tokens.managementConsole.referenceRows]: 'Lignes de référence',
  [tokens.managementConsole.tableAutomationGroupCreated]:
    "Le groupe d'automatisation a été créé",
  [tokens.managementConsole.tableAutomationGroupUpdatedSuccessfully]:
    "Le groupe d'automatisation a été mis à jour",
  [tokens.managementConsole.errorCreatingTableAutomationGroup]:
    "Erreur lors de la création du groupe d'automatisation",

  [tokens.account.generalSettings]: 'Paramètres généraux',
  [tokens.account.customsPreFilling]: 'Pré-remplissage déclarations douanières',
  [tokens.account.settingsHasBeenUpdated]: 'Paramètres mis à jour',
  [tokens.account.errorUpdatingSettings]:
    "Erreur à l'enregistrement des paramètres",
  [tokens.account.resetSettings]: 'Les paramètres ont été réinitialisés',

  [tokens.store.anErrorOccurred]: 'Une erreur est survenue',
  [tokens.store.unableToUpdateBoundingRectangle]:
    'Impossible de mettre à jour le rectangle',
  [tokens.store.targetExportFieldIsNotEmpty]:
    'Le champ cible est déjà attribué',
  [tokens.store.targetExportFieldNotFound]: "Le champ cible n'a pas été trouvé",
  [tokens.store.unableToCreateColumnSomeCellsAreInvalid]:
    'Impossible de créer la colonne - des cellules ne sont pas valides',
  [tokens.store.unableToCreateColumnTableAndColumnRowsMustBeIdentical]:
    'Impossible de créer la colonne - nombre de rangées dans le tableau et la colonne doit être identiques',
  [tokens.store.cannotDeleteLastRowOfPage]:
    'C’est la dernière ligne du tableau sur cette page : elle ne peut pas être supprimée. Pour la retirer, supprimez le tableau sur cette page.',
  [tokens.store.thereIsAlreadyATableOnThisPage]:
    'Une grille articles existe déjà sur cette page du document.',
  [tokens.store.unableToProjectCellsOntoNewTable]:
    'Impossible de projeter des cellules existantes sur cette page',
  [tokens.store.unableToProjectEmptyRowOntoNewPage]:
    'Impossible de projeter une rangée vide sur une nouvelle page',
  [tokens.store.newTableIsTooSmallToProjectCellsFromExistingTable]:
    'Nouveau tableau est trop petit pour pouvoir projeter des cellules du tableau existant',
  [tokens.store.referenceRowCellsTouchSourceGridEdge]:
    "Des cellules touchent le bord de la grille existante. Décalez-les légèrement ou élargissez la grille avant d'ajouter une page",
  [tokens.store.tableHasNoRows]: "Tableau n'a aucune rangée",
  [tokens.store.unableToIdentifyTheCurrentRow]:
    "Impossible d'identifier la rangée du tableau où le souris est placé",
  [tokens.store.cannotDragTableCellIntoADifferentRow]:
    'Impossible de déplacer une cellule vers une autre rangée',
  [tokens.store.tableCellTooSmallOrInverted]:
    'Cellule du tableau est trop petite ou elle a été invertie',
  [tokens.store.tableCellCannotGoOutOfItsRowVertically]:
    'Cellule du tableau ne peut pas sortir de sa rangée au niveau vertical',
  [tokens.store.tableCellGoesOutOfTableOnTheLeft]:
    'Cellule du tableau sort de son tableau par la gauche',
  [tokens.store.tableCellGoesOutOfTableOnTheRight]:
    'Cellule du tableau sort de son tableau par la droite',
  [tokens.store.tableCellGoesOutOfTableOnTheTop]:
    'Cellule du tableau sort de son tableau par la haut',
  [tokens.store.tableCellGoesOutOfTableOnTheBottom]:
    'Cellule du tableau sort de son tableau par le bas',
  [tokens.store.missingMergeColumnsInSourceTable]:
    "Tableau source n'a pas toutes les colonnes selectionnées",
  [tokens.store.mergeKeysNotSpecificEnough]:
    "Plusieurs rangées dans le packing list correspondent au même rangée dans le tableau d'export",

  //Rich text
  [tokens.richText.bold]: 'Gras',
  [tokens.richText.italic]: 'Italique',
  [tokens.richText.underline]: 'Souligné',
  [tokens.richText.strikethrough]: 'Barré',
  [tokens.richText.subscript]: 'Indice',
  [tokens.richText.superscript]: 'Exposant',
  [tokens.richText.textColor]: 'Couleur du texte',
  [tokens.richText.highlightColor]: 'Couleur de surlignage',
  [tokens.richText.removeFormatting]: 'Supprimer la mise en forme',
  [tokens.richText.orderedList]: 'Liste numérotée',
  [tokens.richText.bulletedList]: 'Liste à puces',
  [tokens.richText.taskList]: 'Liste de tâches',
  [tokens.richText.undo]: 'Annuler',
  [tokens.richText.redo]: 'Rétablir',
  [tokens.richText.heading]: 'Titre',
  [tokens.richText.blockquote]: 'Citation',
  [tokens.richText.code]: 'Code en ligne',
  [tokens.richText.codeBlock]: 'Bloc de code',
  [tokens.richText.horizontalRule]: 'Ligne de séparation',
  [tokens.richText.addTable]: 'Insérer un tableau',
  [tokens.richText.editLink]: 'Modifier le lien',
  [tokens.richText.textAlign]: 'Alignement du texte',
  [tokens.richText.indent]: 'Augmenter le retrait',
  [tokens.richText.unindent]: 'Diminuer le retrait',
  [tokens.richText.fontFamily]: 'Police',
  [tokens.richText.fontSize]: 'Taille du texte',
  [tokens.richText.imageUpload]: 'Insérer une image',
  [tokens.richText.cancelButton]: 'Annuler',
  [tokens.richText.removeColorButton]: 'Réinitialiser',
  [tokens.richText.removeColorButtonTooltipTitle]: 'Retirer la couleur',
  [tokens.richText.empty]: 'Changer pour…',
  [tokens.richText.paragraph]: 'Texte normal',
  [tokens.richText.left]: 'Gauche',
  [tokens.richText.right]: 'Droite',
  [tokens.richText.center]: 'Centré',
  [tokens.richText.justify]: 'Justifié',

  [tokens.whatsNew.menuTitle]: 'Nouveautés',
  [tokens.whatsNew.newBadge]: 'NEW',
  [tokens.whatsNew.dialogSubtitle]:
    'Découvrez les dernières évolutions de Nabu',
  [tokens.whatsNew.footerQuestion]: 'Une question ?',
  [tokens.whatsNew.footerContact]: 'Contactez le support',
  [tokens.whatsNew.understood]: 'Compris',
  [tokens.whatsNew.carouselNewer]: 'Version plus récente',
  [tokens.whatsNew.carouselOlder]: 'Version plus ancienne',
  [tokens.whatsNew.latest]: 'Dernière',
  [tokens.whatsNew.releasePager]: '<bold>{{current}}</bold> / {{total}}',
  [tokens.whatsNew.goToVersion]: 'Aller à la version {{version}}',
  [tokens.whatsNew.versionPill]: 'Version',
  [tokens.whatsNew.sectionFeatures]: 'Nouveautés',
  [tokens.whatsNew.sectionFixes]: 'Correctifs',
  [tokens.whatsNew.featureCount]: '{{count}} nouveauté',
  [tokens.whatsNew.featureCount_other]: '{{count}} nouveautés',
  [tokens.whatsNew.fixCount]: '{{count}} correctif',
  [tokens.whatsNew.fixCount_other]: '{{count}} correctifs',
  [tokens.whatsNew.environmentPrefix]: 'Environnement\u00a0:',
  [tokens.whatsNew.emptyState]: 'Aucune nouveauté pour le moment.',

  [tokens.productTour.next]: 'Suivant',
  [tokens.productTour.previous]: 'Précédent',
  [tokens.productTour.finish]: 'Commencer',
  [tokens.productTour.stepCounter]: '{{current}} / {{total}}',
  [tokens.productTour.launcher]: 'Visite guidée',
  [tokens.productTour.eyebrow]: 'Visite guidée',
  [tokens.productTour.skip]: 'Passer la visite',
  [tokens.productTour.coachLabel]: 'Nabu vous guide',
  [tokens.productTour.close]: 'Fermer',
  [tokens.productTour.start]: 'Commencer',
  [tokens.productTour.introStepsCount]: '{{total}} étapes',
  [tokens.productTour.goToStep]: 'Aller à l’étape {{current}} sur {{total}}',

  [tokens.notifications.title]: 'Notifications',
  [tokens.notifications.menuTitle]: 'Notifications',
  [tokens.notifications.markAllRead]: 'Tout marquer comme lu',
  [tokens.notifications.clearAll]: 'Tout supprimer',
  [tokens.notifications.moreActions]: 'Plus d’actions',
  [tokens.notifications.group_today]: 'Aujourd’hui',
  [tokens.notifications.group_yesterday]: 'Hier',
  [tokens.notifications.group_earlier]: 'Plus tôt',
  [tokens.notifications.unreadCount]: '{{count}} non lues',
  [tokens.notifications.empty]: 'Aucune notification',
  [tokens.notifications.loadMore]: 'Charger plus',
  [tokens.notifications.dossier]: 'Dossier',
  [tokens.notifications.dossierUnnamed]: 'Dossier sans nom',
  [tokens.notifications.dossierNotFound]: 'Dossier introuvable',
  [tokens.notifications.types_declaration_status_changed]:
    'Statut de la déclaration mis à jour',
  [tokens.notifications.types_declaration_comment_added]:
    '{{actor}} a commenté le dossier',
  [tokens.notifications.types_declaration_sent_by_collaborator]:
    '{{actor}} a envoyé la déclaration',
  [tokens.notifications.types_declaration_returned_for_correction]:
    'Déclaration retournée pour correction',
  [tokens.notifications.types_app_update]:
    'Nouvelle version {{version}} disponible',
  [tokens.notifications.types_app_update_generic]: 'Nouvelle version disponible',
  [tokens.notifications.types_unknown]: 'Notification',
  [tokens.notifications.trackingMessage_toTreat]: 'Le dossier est à traiter.',
  [tokens.notifications.trackingMessage_exportFailed]:
    'L’envoi de la déclaration a échoué.',
  [tokens.notifications.trackingMessage_error]:
    'Le traitement du dossier a échoué.',
  [tokens.notifications.statusChanged_mareva]:
    'Statut Mareva passé de {{from}} à {{to}}',
  [tokens.notifications.status_unknown]: 'Statut inconnu',
  [tokens.notifications.status_mareva_accepted]: 'Acceptée',
  [tokens.notifications.status_mareva_processing]: 'En traitement',
  [tokens.notifications.status_mareva_rejected]: 'Rejetée',
  [tokens.notifications.systemActorCustoms]: 'Douane',
  [tokens.notifications.commentMessage]: 'a commenté : « {{preview}} »',
  [tokens.notifications.commentMessage_fallback]: 'a commenté le dossier',
  [tokens.notifications.sentMessage]: 'a envoyé la déclaration à la douane.',
  [tokens.notifications.invalidationRequestedMessage]:
    'a demandé à la douane l’invalidation de la déclaration.',
  [tokens.notifications.invalidationRequestedMessage_fallback]:
    'Invalidation de la déclaration demandée à la douane.',
  [tokens.notifications.statusMessage_mareva_accepted]:
    'Déclaration acceptée par la douane.',
  [tokens.notifications.statusMessage_mareva_processing]:
    'Déclaration en cours de traitement douanier.',
  [tokens.notifications.statusMessage_mareva_rejected]:
    'Déclaration rejetée par la douane.',

  [tokens.commandBar.searchPlaceholder]:
    'Rechercher un dossier, un client, un référentiel... ou une action',
  [tokens.commandBar.sectionOnDeclaration]: 'Sur cette déclaration',
  [tokens.commandBar.sectionQuickActions]: 'Actions rapides',
  [tokens.commandBar.sectionRecents]: 'Récents',
  [tokens.commandBar.sectionActions]: 'Actions',
  [tokens.commandBar.sectionDocuments]: 'Dossiers & déclarations',
  [tokens.commandBar.sectionClients]: 'Clients',
  [tokens.commandBar.sectionReferentials]: 'Référentiels',
  [tokens.commandBar.sectionFlux]: 'Modèles',
  [tokens.commandBar.noResults]: 'Aucun résultat',
  [tokens.commandBar.recentBadge]: 'Récent',
  [tokens.commandBar.footerSelect]: 'Sélectionner',
  [tokens.commandBar.footerOpen]: 'Ouvrir',
  [tokens.commandBar.footerClose]: 'Fermer',
  [tokens.commandBar.fieldAgency]: 'Agence',
  [tokens.commandBar.fieldConfiguration]: 'Configuration',
  [tokens.commandBar.actionApplyReferentialDeclaration]:
    'Ajouter un référentiel à la déclaration',
  [tokens.commandBar.actionRunAutomationDeclaration]:
    'Lancer une automatisation',
  [tokens.commandBar.actionChangeModelDeclaration]: 'Changer de modèle',
  [tokens.commandBar.actionDuplicateFolder]: 'Dupliquer le dossier',
  [tokens.commandBar.actionCreateFolder]: 'Créer un dossier',
  [tokens.commandBar.actionAddReferential]: 'Ajouter un référentiel',
  [tokens.commandBar.actionAddModel]: 'Ajouter un modèle',
  [tokens.commandBar.actionAddClient]: 'Ajouter un client',
  [tokens.commandBar.actionCreateAutomation]: 'Créer une automatisation',
  [tokens.commandBar.actionApplyAutomation]: 'Appliquer une automatisation',
  [tokens.commandBar.actionApplyModel]: 'Appliquer un modèle',
  [tokens.commandBar.actionGoDashboard]: 'Aller au tableau de bord',
  [tokens.commandBar.actionViewAllDocuments]: 'Voir tous les dossiers',
  [tokens.commandBar.actionOpenSettings]: 'Ouvrir les paramètres',
  [tokens.commandBar.triggerPlaceholder]: 'Rechercher',
  [tokens.commandBar.triggerTooltip]: 'Rechercher ({{shortcut}})',
  [tokens.mcpOAuth.title]: 'Autoriser un serveur MCP',
  [tokens.mcpOAuth.asksAccess]: 'demande l’accès à votre espace Nabu.',
  [tokens.mcpOAuth.afterConfirm]:
    'Après confirmation, vous serez redirigé vers le client MCP. Vous pourrez alors fermer cette fenêtre.',
  [tokens.mcpOAuth.allow]: 'Autoriser',
  [tokens.mcpOAuth.deny]: 'Refuser',
  [tokens.mcpOAuth.invalidRequest]: 'La demande d’autorisation est invalide.',
  [tokens.mcpOAuth.expired]: 'La demande OAuth a expiré ou est invalide.',
  [tokens.mcpOAuth.sessionExpired]:
    'Votre session Nabu a expiré. Connectez-vous à nouveau.',
  [tokens.mcpOAuth.cannotComplete]: 'Impossible de finaliser l’autorisation.',
  [tokens.mcpOAuth.invalidRedirect]:
    'La réponse OAuth ne contient pas de redirection valide.',
  [tokens.dauSheet.europeanCommunity]: 'COMMUNAUTE EUROPEENNE',
  [tokens.dauSheet.numberMark]: 'N°',
  [tokens.dauSheet.box1]: 'DECLARATION',
  [tokens.dauSheet.boxA]: 'A BUREAU D\'EXPEDITION/D\'EXPORTATION/ DE DESTINATION',
  [tokens.dauSheet.clearanceOffice]: 'Bureau de dédouanement :',
  [tokens.dauSheet.declarationOffice]: 'DCN - Bureau de déclaration :',
  [tokens.dauSheet.exportDeclaration]: 'DECLARATION D\'EXPORTATION',
  [tokens.dauSheet.box2]: 'Expéditeur/Exportateur',
  [tokens.dauSheet.box3]: 'formulaires',
  [tokens.dauSheet.box4]: 'List. chargem',
  [tokens.dauSheet.box5]: 'Articles',
  [tokens.dauSheet.box6]: 'Total des colis',
  [tokens.dauSheet.box7]: 'Numéro de référence',
  [tokens.dauSheet.box8]: 'Destinataire',
  [tokens.dauSheet.foreignConsignee]: 'ETRANGER',
  [tokens.dauSheet.box9]: 'Responsable financier',
  [tokens.dauSheet.box10]: 'Pays p.',
  [tokens.dauSheet.box10Sub]: 'dest. d.prov',
  [tokens.dauSheet.box11]: 'Pays trans-',
  [tokens.dauSheet.box11Sub]: '/prod-',
  [tokens.dauSheet.box12]: 'Elements de la valeur',
  [tokens.dauSheet.box13]: 'P.A.C',
  [tokens.dauSheet.box14]: 'Déclarant/Représentant',
  [tokens.dauSheet.representationMode]: 'Mode de représentation',
  [tokens.dauSheet.approvalNumber]: 'N° agrément',
  [tokens.dauSheet.box15]: 'Pays d\'expédition/d\'exportation',
  [tokens.dauSheet.box15Code]: 'Code P. expéd;/expor.',
  [tokens.dauSheet.box17Code]: 'Code P. destination',
  [tokens.dauSheet.box16]: 'Pays d\'origine',
  [tokens.dauSheet.box17]: 'Pays de destination',
  [tokens.dauSheet.box20]: 'Conditions de livraison',
  [tokens.dauSheet.box18]: 'Identité et nationalité du moyen de transport au depart / à l\'arrivée',
  [tokens.dauSheet.box19]: 'Ctr.',
  [tokens.dauSheet.box21]: 'Identité et nationalité du moyen de transport actif franchissant la frontière',
  [tokens.dauSheet.box22]: 'Monnaie et montant total facturé',
  [tokens.dauSheet.box23]: 'Taux de change',
  [tokens.dauSheet.box24]: 'Nature de la transaction',
  [tokens.dauSheet.box25]: 'Mode transport à',
  [tokens.dauSheet.box25Sub]: 'la frontière',
  [tokens.dauSheet.box26]: 'Mode transport',
  [tokens.dauSheet.box26Sub]: 'intérieur',
  [tokens.dauSheet.box27]: 'Lieu de chargement/déchargement',
  [tokens.dauSheet.box28]: 'Données financières et bancaires',
  [tokens.dauSheet.box29]: 'Bureau de sortie/d\'entrée',
  [tokens.dauSheet.box30]: 'Localisation des marchandises',
  [tokens.dauSheet.box31]: 'Colis et désignation',
  [tokens.dauSheet.box31Sub]: 'des marchandises',
  [tokens.dauSheet.box31Header]: 'Marque et numéro - No(s) conteneur(s) - Nombre et nature',
  [tokens.dauSheet.numberAndKind]: 'Nombre et nature :',
  [tokens.dauSheet.marksAndNumbers]: 'Marques et numéro :',
  [tokens.dauSheet.containerNumber]: 'N° conteneur :',
  [tokens.dauSheet.box32]: 'Article',
  [tokens.dauSheet.box33]: 'Code des marchandises',
  [tokens.dauSheet.firstAdditionalCode]: '1er caco',
  [tokens.dauSheet.secondAdditionalCode]: '2ème caco',
  [tokens.dauSheet.box34]: 'Code P. origine',
  [tokens.dauSheet.box35]: 'Masse brute(kg)',
  [tokens.dauSheet.box36]: 'Préférence',
  [tokens.dauSheet.box37]: 'régime',
  [tokens.dauSheet.box38]: 'Masse nette (kg)',
  [tokens.dauSheet.box39]: 'Contingent',
  [tokens.dauSheet.box40]: 'Déclaration sommaire/Document précédent',
  [tokens.dauSheet.box41]: 'Unités supplémentaires',
  [tokens.dauSheet.box42]: 'Prix de l\'article',
  [tokens.dauSheet.box43]: 'Code M.E.',
  [tokens.dauSheet.additionalInformationCode]: 'Code M.S.',
  [tokens.dauSheet.box44]: 'Mentions',
  [tokens.dauSheet.box44Sub]: 'spéciales/Documents\nproduits/Certificats et\nautorisations',
  [tokens.dauSheet.nationalAdditionalCodes]: 'CANA(s) :',
  [tokens.dauSheet.attachedDocuments]: 'Document(s) joint(s):',
  [tokens.dauSheet.box45]: 'Ajustement',
  [tokens.dauSheet.box46]: 'Valeur statistique',
  [tokens.dauSheet.box47]: 'Calculs des',
  [tokens.dauSheet.box47Sub]: 'impositions',
  [tokens.dauSheet.box47Full]: 'Calcul des impositions',
  [tokens.dauSheet.totalFirstItem]: 'Total premier article :',
  [tokens.dauSheet.totalSecondItem]: 'Total deuxième article :',
  [tokens.dauSheet.totalThirdItem]: 'Total troisième article :',
  [tokens.dauSheet.box48]: 'Report de paiement',
  [tokens.dauSheet.box49]: 'Identification de l\'entrepôt',
  [tokens.dauSheet.boxB]: 'B DONNEES COMPTABLES',
  [tokens.dauSheet.guaranteedRisk]: 'Risque garanti',
  [tokens.dauSheet.totalAmountPayable]: 'Montant Total à payer (risque garanti sur CE)',
  [tokens.dauSheet.amountUsedEc]: 'Montant utilisé CE :',
  [tokens.dauSheet.guaranteed]: 'cautionné (C) :',
  [tokens.dauSheet.notGuaranteed]: 'non cautionné (NC) :',
  [tokens.dauSheet.controlByOffice]: 'CONTROLE PAR LE BUREAU DE DEPART/ DE DESTINATION',
  [tokens.dauSheet.stamp]: 'Cachet :',
  [tokens.dauSheet.controlResult]: 'résultat :',
  [tokens.dauSheet.sealsAffixed]: 'Scellés apposés :',
  [tokens.dauSheet.sealMarks]: 'marques:',
  [tokens.dauSheet.timeLimit]: 'Délai (date limite):',
  [tokens.dauSheet.signature]: 'Signature:',
  [tokens.dauSheet.box54]: 'lieu et date:',
  [tokens.dauSheet.editionDate]: 'Date d\'édition:',
  [tokens.dauSheet.validationDate]: 'Date de validation :',
  [tokens.dauSheet.declarationStatus]: 'Etat de la déclaration :',
  [tokens.dauSheet.procedureType]: 'Type de la procédure :',
  [tokens.dauSheet.declarantSignature]: 'signature et nom du déclarant/représentant',
  [tokens.dauSheet.statusShort]: 'Etat :',
  [tokens.dauSheet.printedOn]: 'Edité le {{date}} · C BUREAU DE DEPART',
}
